webpackJsonp([1],Array(29).concat([
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var CryptoJS = __webpack_require__(51);
__webpack_require__(616);
__webpack_require__(620);

function parse(str) {
  return CryptoJS.enc.Utf8.parse(str);
}
var KEY = '';
var IV = '';

function Decrypt(word) {
  var ext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var key = parse(ext.key || KEY);
  var iv = parse(ext.iv || IV);
  var encryptedHexStr = CryptoJS.enc.Hex.parse(word);
  var srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  var decrypt = CryptoJS.AES.decrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  });
  var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}

function Encrypt(word) {
  var ext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var key = parse(ext.key || KEY);
  var iv = parse(ext.iv || IV);
  var srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  });

  var baseStr = CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
  return baseStr;
}

function obj() {
  return {
    key: 'KCr@AvIXMbDnWTBV',
    iv: '1234567890123456'
  };
}


/* harmony default export */ __webpack_exports__["default"] = ({
  Decrypt: Decrypt,
  Encrypt: Encrypt,
  obj: obj
});

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_vue__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main_vue__);



var ToastConstructor = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_1__main_vue___default.a);

var instance = void 0;
var instances = [];
var seed = 1;

var Toast = function Toast(options) {
  Toast.closeAll();
  if (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$isServer) return;
  options = options || {};
  if (typeof options === 'string') {
    options = {
      content: options
    };
  }

  var id = 'toast_' + seed++;

  instance = new ToastConstructor({
    data: options
  });
  instance.id = id;

  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.vm.visible = true;
  instance.dom = instance.vm.$el;

  instances.push(instance);
  return instance.vm;
};

Toast.closeAll = function () {
  for (var i = instances.length - 1; i >= 0; i--) {
    instances[i].close();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Toast);

/***/ }),
/* 81 */,
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getQiniuUploadImageToken;
/* harmony export (immutable) */ __webpack_exports__["d"] = getInsuranceInfo;
/* harmony export (immutable) */ __webpack_exports__["e"] = getInsuranceQueryInfo;
/* harmony export (immutable) */ __webpack_exports__["f"] = commitInsurance;
/* harmony export (immutable) */ __webpack_exports__["b"] = commitClam;
/* harmony export (immutable) */ __webpack_exports__["a"] = commitClamList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pids__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_request__ = __webpack_require__(193);



function getQiniuUploadImageToken(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_request__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__pids__["a" /* GET_QINIU_IMAGE_UPLOAD_TOKEN */], data);
}

function getInsuranceInfo(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_request__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__pids__["b" /* GET_INSURANCE_INFO */], data);
}

function getInsuranceQueryInfo(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_request__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__pids__["c" /* GET_INSURANCE_QUERY_INFO */], data);
}

function commitInsurance(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_request__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__pids__["d" /* COMMIT_INSURANCE */], data);
}

function commitClam(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_request__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__pids__["e" /* COMMIT_CLAIM */], data);
}

function commitClamList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_request__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__pids__["f" /* COMMIT_CLAIM_LIST */], data);
}

/***/ }),
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner.63826a6.png";

/***/ }),
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(629)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(815),
  /* scopeId */
  "data-v-28e2d350",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0.6574965.jpeg";

/***/ }),
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trace", function() { return trace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enterTrace", function() { return enterTrace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enterTraceDone", function() { return enterTraceDone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tracker_js__ = __webpack_require__(192);


var trace = function trace(eventId, obj) {
    __WEBPACK_IMPORTED_MODULE_0__Tracker_js__["a" /* default */].send({
        data: {
            type: eventId,
            data: obj || {}
        }
    });
};

var enterTrace = function enterTrace(obj) {
    __WEBPACK_IMPORTED_MODULE_0__Tracker_js__["a" /* default */].send({
        data: {
            type: 'ins_in',
            data: obj || {}
        }
    });
};

var enterTraceDone = function enterTraceDone(obj) {
    __WEBPACK_IMPORTED_MODULE_0__Tracker_js__["a" /* default */].send({
        data: {
            type: 'ins_done',
            data: obj || {}
        }
    });
};

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Log__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__wifikey_wkb__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__wifikey_wkb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__wifikey_wkb__);



__WEBPACK_IMPORTED_MODULE_2__Log__["a" /* default */].prefix = 'Tracker';


var defaultURL = 'https://wifiapi02.51y5.net/wifiapi/rd.do',
    defaultParams = {},
    getParams = function getParams(o) {
    if (!!defaultParams.u) return defaultParams;
    o = o || {};
    var data = {
        'a': o.appid || '',
        'v': o.vcode || '',
        'c': o.chanid || '',
        'd': o.dhid || '',
        'u': o.uhid || '',
        'ssid': o.ssid || '',
        'bssid': o.bssid || ''
    };
    defaultParams = data;
    return data;
},
    getDefaultParams = function getDefaultParams(callback) {
    if (__WEBPACK_IMPORTED_MODULE_3__wifikey_wkb___default.a.isWKBrowser && !defaultParams.u) {
        __WEBPACK_IMPORTED_MODULE_3__wifikey_wkb___default.a.call('getAppInfo', {
            success: function success(o) {
                var data = getParams(o);
                if (callback) callback(data);
            }
        });
    } else {
        var data = getParams();
        if (callback) callback(data);
    }
},
    splice = function splice(url, data) {
    var str = '';
    for (var k in data) {
        str += k + '=' + encodeURIComponent(data[k]) + '&';
    }
    if (str) {
        str += '_t=' + +new Date();
        str = url.indexOf('?') > -1 ? '&' + str : str = '?' + str;
    }
    return url + str;
},
    getURL = function getURL(cfg) {
    cfg = cfg || {};
    var url = cfg.url || defaultURL;

    getDefaultParams(function (data) {
        for (var i in cfg.data) {
            data[i] = cfg.data[i];
        }

        var _url = splice(url, data);
        if (cfg.callback) cfg.callback(_url, cfg);
    });
},
    request = function request(url, cfg) {
    if (cfg.data.rurl) {
        location.href = url;
    } else {
        var img = new Image(),
            trackerId = "trackerId_" + +new Date() + '.r' + Math.floor(Math.random() * 1000);
        window[trackerId] = img;
        img.onload = img.onerror = img.onabort = function () {
            img.onload = img.onerror = img.onabort = null;
            img = window[trackerId] = null;
            if (cfg.callback) cfg.callback();
        };
        img.src = url;
    }
},
    appTrace = function appTrace(val) {
    console.log('客户端打点', val);
    var cmd;
    if (__WEBPACK_IMPORTED_MODULE_3__wifikey_wkb___default.a.isWKBrowser === 'android') {
        var _data = val.data;

        if ((typeof _data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_data)) === 'object') {
            _data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_data);
        }

        cmd = '__jsi:' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
            service: 'wifikey',
            method: 'traceV2',
            param: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                type: val.type,
                data: _data
            })
        });
        window.console.log('call native>', cmd);
        window.prompt(cmd);
    }
    if (__WEBPACK_IMPORTED_MODULE_3__wifikey_wkb___default.a.isWKBrowser === 'ios') {
        __WEBPACK_IMPORTED_MODULE_3__wifikey_wkb___default.a.call('eventTrack', {
            funId: val.type,
            desc: val.data
        });
    }
},
    init = function init() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Log__["a" /* default */])('init');
    getDefaultParams();
};
init();
var _obj = {
    send: function send(cfg) {
        cfg = cfg || {};
        if (!cfg.data) return;

        cfg.data.f = ((this.namespace ? this.namespace + '_' : '') + cfg.data.f).replace(/-/g, '_');
        cfg.data.b = ('' + cfg.data.b).replace(/-/g, '_');

        appTrace(cfg.data);
    },
    getURL: getURL,
    namespace: __webpack_require__.i({"NODE_ENV":"production","API_ROOT":"//alps.51y5.net","WK_IMG_URL":"https://local.51y5.net/region/fastdfs/img.do?url=","QINIU_IMG_URL":"https://filex.51y5.net/","PAGE_URL":"//a.lianwifi.com"}).tracker_namespace || ''
};

/* harmony default export */ __webpack_exports__["a"] = (_obj);

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__wifikey_wkb__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__wifikey_wkb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__wifikey_wkb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__wifikey_wkr__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__wifikey_wkr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__wifikey_wkr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_toast__ = __webpack_require__(80);







var encryptParams = {
  key: '3nEG#zJ1P%mOx7q@',
  iv: 'nMu*hzF9@8Tr#z&J'
};

var PID_LIST = ['66644001', '66644002', '66644021', '66644022'];
__WEBPACK_IMPORTED_MODULE_4__wifikey_wkr___default.a.init({
  baseURL: "//alps.51y5.net"
});

var url = '';
var nonAppParams = {};

if (__WEBPACK_IMPORTED_MODULE_3__wifikey_wkb___default.a.isWKBrowser) {
  url = '/alps/fa.sec';
} else {
  url = '/alps/fa.ss';

  nonAppParams = {
    appId: 'AH0001' || 'A0013' || 'ZMVIP01', platform: 'h5', uhid: 'ff808081444a1f3201444a46472f0904', mapSP: 'b'
  };
}

var request = function request(pid, data) {
  var requestData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, nonAppParams, data, { pid: pid });

  try {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(requestData).forEach(function (key) {
      if (typeof requestData[key] !== 'string') {
        requestData[key] = String(requestData[key]);
      }
    });
  } catch (error) {}

  var baseURL = void 0;
  PID_LIST.map(function (res) {
    if (pid === res) {
      baseURL = __webpack_require__.i({"NODE_ENV":"production","API_ROOT":"//alps.51y5.net","WK_IMG_URL":"https://local.51y5.net/region/fastdfs/img.do?url=","QINIU_IMG_URL":"https://filex.51y5.net/","PAGE_URL":"//a.lianwifi.com"}).API_RIGHTS_ROOT;
    }
  });

  console.log('[\uD83D\uDC46\uD83C\uDFFB] Request of pid ' + pid + ' with data:', requestData);
  return __WEBPACK_IMPORTED_MODULE_4__wifikey_wkr___default.a.request({
    baseURL: baseURL,
    url: url,
    method: 'post',
    data: requestData
  }, encryptParams).then(function (res) {
    if (!res || String(res.retCd) === '0') {
      console.log('[\uD83D\uDC47\uD83C\uDFFB] Response of pid ' + pid + ' with data:', res);
      return res;
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res);
  }).catch(function (error) {
    var retCd = error.retCd;

    if (retCd == 'API_ERROR_-109') {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__components_toast__["a" /* default */])('服务异常，请稍后重试');
    }

    console.log('[\uD83D\uDC4E\uD83C\uDFFB] Request failed of pid ' + pid + ' with error:', error);

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (request);

/***/ }),
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAABEtJREFUWAnNWE1IVFEU9r0ZZUwXzkZwwPZBu2rhlLuEgqAimIgBwcGfVVIpLdKltigs1JU/KAiDJEgGQQuFFta4qNZtamOg0MYBNQcdx77vec/1+sZ5vtEavHDnnnvu+fnu33n3jFVWZEkmk+HNzc1bULuOeh41sre3F6EZy7JW0LAuoy5UVVW9j8fja6B9F8uv5Ojo6F04fgj5RtSgT70s5BYBdLi9vf2tH51jAY2Pj1/N5XIvACbqx2AhGYBK2bb9tLW19XMhGfILApqZmQmsra29gkyny0AO/RTqHBx8A9CVmpoablNZOp2OwHEEE7iE7h1UTsJG1QXjg5DvisViu5ppEEcCmpycrNnZ2ZmBsyaRhaEM6KFQKDTQ3Nz8W/he7dTUVG0mk+mCTCdshUQWtubLy8tjLS0taeFJmwdIgUnBwAUtZFmzwWDwcSKR+CW8YtqJiYn6bDb7GjbviR5AfQeoqBvUIUDcJiz7B1kZKO2h9ra1tT0XQ6dpx8bGnsF2H6rjlyuF7btpbt+h26LOjLNNCswDgHnjBWJkZOQcZOOUgaNkR0fHn0LynBhA/cT4NEGhNmEBBtB/JDp6hXibdnd3P8kADmzPcSujVnQJhq9QD8C+YMYN5ozFntlypXDw+4UXCASuye3TNwBgXooADM8eB4ay6+vrFwUM+6TJI+1VaJs+RIZhRWgHEIMeGA1kQjDDAywCXi0O5Srkt0WGNHnS92rpg74og4lEFYb9GAEGI7CUIb+3SV3/BAyvsMJAwm9IUD6GxKlgsPht2tjYYFzhAc9VVlbW+TUqxk7aMk5tbW1xRblT2erq6lpbfSjltqVKBYaTUL4Y9VmCxEJkOhqDnuNIKQu2+p3hr4krUy8MfpuE9tMiBvXDYDf2vwLtNtobiEMf/eiKDPS+Qk+69Vwh5y1DDgacj6SM+mj5japQugTV7UPnkIjLZ8QGQwOSr/YhDe8Ob4n+asPWD2/x/FHTJ7HYmJVeLwQ1HbnzVfM52J4ecPuMkaJeh9QzfRILt0wHMkTrOsN4SUiXz1UC0ucGCPX2lQQNnLh8rhCQfuOol16psDh+cG4uGw6XCWjeYPDZWdICQLcNhws2UxUwmB2wRBnO98n//6t8RZWnLLHYKm9aVExbvYF9oWFghGCvIdyreAarMKl8cZdYFonF6eBgDe/znN9OvoGNvhfJjCRgCJB2ZynG8AGpfGhZweAAUkncEsWxpyE+yA9UPakhGNoWCUXrJ4Xwj2rVo9/JRKCXkkRSB8KTPGGPcuSH5+sJq960enZYqT4o3vfjoBgZ2qRt0cHqDMp7mjw5UM54OBx+AgEnDECJWcE0ZyPKp21pizZpm7boC98yJpK66C0TzplKFF2gzkYqLaDO1J8NAoqtun3M2Zw0yRwrhubVPtXfMW5nzJtwGJkuNaJKUuAWc/f//R9Wbg/GX3pMDhjRj/pLjy+I+ZP8pfcXLoE9TWklHBcAAAAASUVORK5CYII="

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/index_top.267bb44.png";

/***/ }),
/* 251 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_za.6bbb1ad.png";

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shop_top.7e4d315.jpeg";

/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(647)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(833),
  /* scopeId */
  "data-v-68d87fc2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 293 */,
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wifikey_wkb__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wifikey_wkb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__wifikey_wkb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tracker__ = __webpack_require__(192);



window.wkb = __WEBPACK_IMPORTED_MODULE_0__wifikey_wkb___default.a;
var Utils = {
    Bridge: __WEBPACK_IMPORTED_MODULE_0__wifikey_wkb___default.a,
    Tracker: __WEBPACK_IMPORTED_MODULE_1__Tracker__["a" /* default */]
};
window.Utils = Utils;

/***/ }),
/* 295 */
/***/ (function(module, exports) {


jQuery.extend({

    handleError: function handleError(s, xhr, status, e) {
        if (s.error) {
            s.error.call(s.context || s, xhr, status, e);
        }

        if (s.global) {
            (s.context ? jQuery(s.context) : jQuery.event).trigger("ajaxError", [xhr, s, e]);
        }
    },
    createUploadIframe: function createUploadIframe(id, uri) {
        var frameId = 'jUploadFrame' + id;
        var iframeHtml = '<iframe id="' + frameId + '" name="' + frameId + '" style="position:absolute; top:-9999px; left:-9999px"';
        if (window.ActiveXObject) {
            if (typeof uri == 'boolean') {
                iframeHtml += ' src="' + 'javascript:false' + '"';
            } else if (typeof uri == 'string') {
                iframeHtml += ' src="' + uri + '"';
            }
        }
        iframeHtml += ' />';
        jQuery(iframeHtml).appendTo(document.body);

        return jQuery('#' + frameId).get(0);
    },
    createUploadForm: function createUploadForm(id, fileElementId) {
        var formId = 'jUploadForm' + id;
        var fileId = 'jUploadFile' + id;
        var form = jQuery('<form  action="" method="POST" name="' + formId + '" id="' + formId + '" enctype="multipart/form-data"></form>');
        var oldElement = jQuery('#' + fileElementId);
        var newElement = jQuery(oldElement).clone();
        jQuery(oldElement).attr('id', fileId);
        jQuery(oldElement).before(newElement);
        jQuery(oldElement).appendTo(form);

        jQuery(form).css('position', 'absolute');
        jQuery(form).css('top', '-1200px');
        jQuery(form).css('left', '-1200px');
        jQuery(form).appendTo('body');
        return form;
    },

    ajaxFileUpload: function ajaxFileUpload(s) {
        s = jQuery.extend({}, jQuery.ajaxSettings, s);
        var id = new Date().getTime();
        var form = jQuery.createUploadForm(id, s.fileElementId);
        var io = jQuery.createUploadIframe(id, s.secureuri);
        var frameId = 'jUploadFrame' + id;
        var formId = 'jUploadForm' + id;

        if (s.global && !jQuery.active++) {
            jQuery.event.trigger("ajaxStart");
        }
        var requestDone = false;

        var xml = {};
        if (s.global) jQuery.event.trigger("ajaxSend", [xml, s]);

        var uploadCallback = function uploadCallback(isTimeout) {
            var io = document.getElementById(frameId);
            try {
                if (io.contentWindow) {
                    xml.responseText = io.contentWindow.document.body ? io.contentWindow.document.body.innerHTML : null;
                    xml.responseXML = io.contentWindow.document.XMLDocument ? io.contentWindow.document.XMLDocument : io.contentWindow.document;
                } else if (io.contentDocument) {
                    xml.responseText = io.contentDocument.document.body ? io.contentDocument.document.body.innerHTML : null;
                    xml.responseXML = io.contentDocument.document.XMLDocument ? io.contentDocument.document.XMLDocument : io.contentDocument.document;
                }
            } catch (e) {
                jQuery.handleError(s, xml, null, e);
            }
            if (xml || isTimeout == "timeout") {
                requestDone = true;
                var status;
                try {
                    status = isTimeout != "timeout" ? "success" : "error";

                    if (status != "error") {
                        var data = jQuery.uploadHttpData(xml, s.dataType);

                        if (s.success) s.success(data, status);

                        if (s.global) jQuery.event.trigger("ajaxSuccess", [xml, s]);
                    } else jQuery.handleError(s, xml, status);
                } catch (e) {
                    status = "error";
                    jQuery.handleError(s, xml, status, e);
                }

                if (s.global) jQuery.event.trigger("ajaxComplete", [xml, s]);

                if (s.global && ! --jQuery.active) jQuery.event.trigger("ajaxStop");

                if (s.complete) s.complete(xml, status);

                jQuery(io).unbind();

                setTimeout(function () {
                    try {
                        jQuery(io).remove();
                        jQuery(form).remove();
                    } catch (e) {
                        jQuery.handleError(s, xml, null, e);
                    }
                }, 100);

                xml = null;
            }
        };

        if (s.timeout > 0) {
            setTimeout(function () {
                if (!requestDone) uploadCallback("timeout");
            }, s.timeout);
        }
        try {

            var form = jQuery('#' + formId);
            jQuery(form).attr('action', s.url);
            jQuery(form).attr('method', 'POST');
            jQuery(form).attr('target', frameId);
            if (form.encoding) {
                jQuery(form).attr('encoding', 'multipart/form-data');
            } else {
                jQuery(form).attr('enctype', 'multipart/form-data');
            }
            jQuery(form).submit();
        } catch (e) {
            jQuery.handleError(s, xml, null, e);
        }

        jQuery('#' + frameId).load(uploadCallback);
        return { abort: function abort() {} };
    },

    uploadHttpData: function uploadHttpData(r, type) {
        var data = !type;
        data = type == "xml" || data ? r.responseXML : r.responseText;

        if (type == "script") jQuery.globalEval(data);

        if (type == "json") eval("data = " + data);

        if (type == "html") jQuery("<div>").html(data).evalScripts();

        return data;
    }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);


!function (e, t) {
  function n(e) {
    var t = e.length,
        n = ue.type(e);return !ue.isWindow(e) && (!(1 !== e.nodeType || !t) || "array" === n || "function" !== n && (0 === t || "number" == typeof t && t > 0 && t - 1 in e));
  }function r(e) {
    var t = Ne[e] = {};return ue.each(e.match(ce) || [], function (e, n) {
      t[n] = !0;
    }), t;
  }function i(e, n, r, i) {
    if (ue.acceptData(e)) {
      var o,
          a,
          s = ue.expando,
          u = "string" == typeof n,
          l = e.nodeType,
          c = l ? ue.cache : e,
          f = l ? e[s] : e[s] && s;if (f && c[f] && (i || c[f].data) || !u || r !== t) return f || (l ? e[s] = f = Z.pop() || ue.guid++ : f = s), c[f] || (c[f] = {}, l || (c[f].toJSON = ue.noop)), ("object" == (typeof n === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(n)) || "function" == typeof n) && (i ? c[f] = ue.extend(c[f], n) : c[f].data = ue.extend(c[f].data, n)), o = c[f], i || (o.data || (o.data = {}), o = o.data), r !== t && (o[ue.camelCase(n)] = r), u ? (a = o[n], null == a && (a = o[ue.camelCase(n)])) : a = o, a;
    }
  }function o(e, t, n) {
    if (ue.acceptData(e)) {
      var r,
          i,
          o,
          a = e.nodeType,
          u = a ? ue.cache : e,
          l = a ? e[ue.expando] : ue.expando;if (u[l]) {
        if (t && (o = n ? u[l] : u[l].data)) {
          ue.isArray(t) ? t = t.concat(ue.map(t, ue.camelCase)) : t in o ? t = [t] : (t = ue.camelCase(t), t = t in o ? [t] : t.split(" "));for (r = 0, i = t.length; i > r; r++) {
            delete o[t[r]];
          }if (!(n ? s : ue.isEmptyObject)(o)) return;
        }(n || (delete u[l].data, s(u[l]))) && (a ? ue.cleanData([e], !0) : ue.support.deleteExpando || u != u.window ? delete u[l] : u[l] = null);
      }
    }
  }function a(e, n, r) {
    if (r === t && 1 === e.nodeType) {
      var i = "data-" + n.replace(ke, "-$1").toLowerCase();if (r = e.getAttribute(i), "string" == typeof r) {
        try {
          r = "true" === r || "false" !== r && ("null" === r ? null : +r + "" === r ? +r : Ce.test(r) ? ue.parseJSON(r) : r);
        } catch (e) {}ue.data(e, n, r);
      } else r = t;
    }return r;
  }function s(e) {
    var t;for (t in e) {
      if (("data" !== t || !ue.isEmptyObject(e[t])) && "toJSON" !== t) return !1;
    }return !0;
  }function u() {
    return !0;
  }function l() {
    return !1;
  }function c(e, t) {
    do {
      e = e[t];
    } while (e && 1 !== e.nodeType);return e;
  }function f(e, t, n) {
    if (t = t || 0, ue.isFunction(t)) return ue.grep(e, function (e, r) {
      var i = !!t.call(e, r, e);return i === n;
    });if (t.nodeType) return ue.grep(e, function (e) {
      return e === t === n;
    });if ("string" == typeof t) {
      var r = ue.grep(e, function (e) {
        return 1 === e.nodeType;
      });if (Ie.test(t)) return ue.filter(t, r, !n);t = ue.filter(t, r);
    }return ue.grep(e, function (e) {
      return ue.inArray(e, t) >= 0 === n;
    });
  }function p(e) {
    var t = Ue.split("|"),
        n = e.createDocumentFragment();if (n.createElement) for (; t.length;) {
      n.createElement(t.pop());
    }return n;
  }function d(e, t) {
    return e.getElementsByTagName(t)[0] || e.appendChild(e.ownerDocument.createElement(t));
  }function h(e) {
    var t = e.getAttributeNode("type");return e.type = (t && t.specified) + "/" + e.type, e;
  }function g(e) {
    var t = it.exec(e.type);return t ? e.type = t[1] : e.removeAttribute("type"), e;
  }function m(e, t) {
    for (var n, r = 0; null != (n = e[r]); r++) {
      ue._data(n, "globalEval", !t || ue._data(t[r], "globalEval"));
    }
  }function y(e, t) {
    if (1 === t.nodeType && ue.hasData(e)) {
      var n,
          r,
          i,
          o = ue._data(e),
          a = ue._data(t, o),
          s = o.events;if (s) {
        delete a.handle, a.events = {};for (n in s) {
          for (r = 0, i = s[n].length; i > r; r++) {
            ue.event.add(t, n, s[n][r]);
          }
        }
      }a.data && (a.data = ue.extend({}, a.data));
    }
  }function v(e, t) {
    var n, r, i;if (1 === t.nodeType) {
      if (n = t.nodeName.toLowerCase(), !ue.support.noCloneEvent && t[ue.expando]) {
        i = ue._data(t);for (r in i.events) {
          ue.removeEvent(t, r, i.handle);
        }t.removeAttribute(ue.expando);
      }"script" === n && t.text !== e.text ? (h(t).text = e.text, g(t)) : "object" === n ? (t.parentNode && (t.outerHTML = e.outerHTML), ue.support.html5Clone && e.innerHTML && !ue.trim(t.innerHTML) && (t.innerHTML = e.innerHTML)) : "input" === n && tt.test(e.type) ? (t.defaultChecked = t.checked = e.checked, t.value !== e.value && (t.value = e.value)) : "option" === n ? t.defaultSelected = t.selected = e.defaultSelected : ("input" === n || "textarea" === n) && (t.defaultValue = e.defaultValue);
    }
  }function b(e, n) {
    var r,
        i,
        o = 0,
        a = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(e.getElementsByTagName) !== V ? e.getElementsByTagName(n || "*") : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(e.querySelectorAll) !== V ? e.querySelectorAll(n || "*") : t;if (!a) for (a = [], r = e.childNodes || e; null != (i = r[o]); o++) {
      !n || ue.nodeName(i, n) ? a.push(i) : ue.merge(a, b(i, n));
    }return n === t || n && ue.nodeName(e, n) ? ue.merge([e], a) : a;
  }function x(e) {
    tt.test(e.type) && (e.defaultChecked = e.checked);
  }function T(e, t) {
    if (t in e) return t;for (var n = t.charAt(0).toUpperCase() + t.slice(1), r = t, i = Ct.length; i--;) {
      if (t = Ct[i] + n, t in e) return t;
    }return r;
  }function w(e, t) {
    return e = t || e, "none" === ue.css(e, "display") || !ue.contains(e.ownerDocument, e);
  }function N(e, t) {
    for (var n, r, i, o = [], a = 0, s = e.length; s > a; a++) {
      r = e[a], r.style && (o[a] = ue._data(r, "olddisplay"), n = r.style.display, t ? (o[a] || "none" !== n || (r.style.display = ""), "" === r.style.display && w(r) && (o[a] = ue._data(r, "olddisplay", S(r.nodeName)))) : o[a] || (i = w(r), (n && "none" !== n || !i) && ue._data(r, "olddisplay", i ? n : ue.css(r, "display"))));
    }for (a = 0; s > a; a++) {
      r = e[a], r.style && (t && "none" !== r.style.display && "" !== r.style.display || (r.style.display = t ? o[a] || "" : "none"));
    }return e;
  }function C(e, t, n) {
    var r = yt.exec(t);return r ? Math.max(0, r[1] - (n || 0)) + (r[2] || "px") : t;
  }function k(e, t, n, r, i) {
    for (var o = n === (r ? "border" : "content") ? 4 : "width" === t ? 1 : 0, a = 0; 4 > o; o += 2) {
      "margin" === n && (a += ue.css(e, n + Nt[o], !0, i)), r ? ("content" === n && (a -= ue.css(e, "padding" + Nt[o], !0, i)), "margin" !== n && (a -= ue.css(e, "border" + Nt[o] + "Width", !0, i))) : (a += ue.css(e, "padding" + Nt[o], !0, i), "padding" !== n && (a += ue.css(e, "border" + Nt[o] + "Width", !0, i)));
    }return a;
  }function E(e, t, n) {
    var r = !0,
        i = "width" === t ? e.offsetWidth : e.offsetHeight,
        o = ct(e),
        a = ue.support.boxSizing && "border-box" === ue.css(e, "boxSizing", !1, o);if (0 >= i || null == i) {
      if (i = ft(e, t, o), (0 > i || null == i) && (i = e.style[t]), vt.test(i)) return i;r = a && (ue.support.boxSizingReliable || i === e.style[t]), i = parseFloat(i) || 0;
    }return i + k(e, t, n || (a ? "border" : "content"), r, o) + "px";
  }function S(e) {
    var t = Y,
        n = xt[e];return n || (n = A(e, t), "none" !== n && n || (lt = (lt || ue("<iframe frameborder='0' width='0' height='0'/>").css("cssText", "display:block !important")).appendTo(t.documentElement), t = (lt[0].contentWindow || lt[0].contentDocument).document, t.write("<!doctype html><html><body>"), t.close(), n = A(e, t), lt.detach()), xt[e] = n), n;
  }function A(e, t) {
    var n = ue(t.createElement(e)).appendTo(t.body),
        r = ue.css(n[0], "display");return n.remove(), r;
  }function j(e, t, n, r) {
    var i;if (ue.isArray(t)) ue.each(t, function (t, i) {
      n || Et.test(e) ? r(e, i) : j(e + "[" + ("object" == (typeof i === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(i)) ? t : "") + "]", i, n, r);
    });else if (n || "object" !== ue.type(t)) r(e, t);else for (i in t) {
      j(e + "[" + i + "]", t[i], n, r);
    }
  }function D(e) {
    return function (t, n) {
      "string" != typeof t && (n = t, t = "*");var r,
          i = 0,
          o = t.toLowerCase().match(ce) || [];if (ue.isFunction(n)) for (; r = o[i++];) {
        "+" === r[0] ? (r = r.slice(1) || "*", (e[r] = e[r] || []).unshift(n)) : (e[r] = e[r] || []).push(n);
      }
    };
  }function L(e, n, r, i) {
    function o(u) {
      var l;return a[u] = !0, ue.each(e[u] || [], function (e, u) {
        var c = u(n, r, i);return "string" != typeof c || s || a[c] ? s ? !(l = c) : t : (n.dataTypes.unshift(c), o(c), !1);
      }), l;
    }var a = {},
        s = e === It;return o(n.dataTypes[0]) || !a["*"] && o("*");
  }function H(e, n) {
    var r,
        i,
        o = ue.ajaxSettings.flatOptions || {};for (i in n) {
      n[i] !== t && ((o[i] ? e : r || (r = {}))[i] = n[i]);
    }return r && ue.extend(!0, e, r), e;
  }function q(e, n, r) {
    var i,
        o,
        a,
        s,
        u = e.contents,
        l = e.dataTypes,
        c = e.responseFields;for (s in c) {
      s in r && (n[c[s]] = r[s]);
    }for (; "*" === l[0];) {
      l.shift(), o === t && (o = e.mimeType || n.getResponseHeader("Content-Type"));
    }if (o) for (s in u) {
      if (u[s] && u[s].test(o)) {
        l.unshift(s);break;
      }
    }if (l[0] in r) a = l[0];else {
      for (s in r) {
        if (!l[0] || e.converters[s + " " + l[0]]) {
          a = s;break;
        }i || (i = s);
      }a = a || i;
    }return a ? (a !== l[0] && l.unshift(a), r[a]) : t;
  }function M(e, t) {
    var n,
        r,
        i,
        o,
        a = {},
        s = 0,
        u = e.dataTypes.slice(),
        l = u[0];if (e.dataFilter && (t = e.dataFilter(t, e.dataType)), u[1]) for (i in e.converters) {
      a[i.toLowerCase()] = e.converters[i];
    }for (; r = u[++s];) {
      if ("*" !== r) {
        if ("*" !== l && l !== r) {
          if (i = a[l + " " + r] || a["* " + r], !i) for (n in a) {
            if (o = n.split(" "), o[1] === r && (i = a[l + " " + o[0]] || a["* " + o[0]])) {
              i === !0 ? i = a[n] : a[n] !== !0 && (r = o[0], u.splice(s--, 0, r));break;
            }
          }if (i !== !0) if (i && e.throws) t = i(t);else try {
            t = i(t);
          } catch (e) {
            return { state: "parsererror", error: i ? e : "No conversion from " + l + " to " + r };
          }
        }l = r;
      }
    }return { state: "success", data: t };
  }function _() {
    try {
      return new e.XMLHttpRequest();
    } catch (e) {}
  }function F() {
    try {
      return new e.ActiveXObject("Microsoft.XMLHTTP");
    } catch (e) {}
  }function O() {
    return setTimeout(function () {
      Qt = t;
    }), Qt = ue.now();
  }function B(e, t) {
    ue.each(t, function (t, n) {
      for (var r = (rn[t] || []).concat(rn["*"]), i = 0, o = r.length; o > i; i++) {
        if (r[i].call(e, t, n)) return;
      }
    });
  }function P(e, t, n) {
    var r,
        i,
        o = 0,
        a = nn.length,
        s = ue.Deferred().always(function () {
      delete u.elem;
    }),
        u = function u() {
      if (i) return !1;for (var t = Qt || O(), n = Math.max(0, l.startTime + l.duration - t), r = n / l.duration || 0, o = 1 - r, a = 0, u = l.tweens.length; u > a; a++) {
        l.tweens[a].run(o);
      }return s.notifyWith(e, [l, o, n]), 1 > o && u ? n : (s.resolveWith(e, [l]), !1);
    },
        l = s.promise({ elem: e, props: ue.extend({}, t), opts: ue.extend(!0, { specialEasing: {} }, n), originalProperties: t, originalOptions: n, startTime: Qt || O(), duration: n.duration, tweens: [], createTween: function createTween(t, n) {
        var r = ue.Tween(e, l.opts, t, n, l.opts.specialEasing[t] || l.opts.easing);return l.tweens.push(r), r;
      }, stop: function stop(t) {
        var n = 0,
            r = t ? l.tweens.length : 0;if (i) return this;for (i = !0; r > n; n++) {
          l.tweens[n].run(1);
        }return t ? s.resolveWith(e, [l, t]) : s.rejectWith(e, [l, t]), this;
      } }),
        c = l.props;for (R(c, l.opts.specialEasing); a > o; o++) {
      if (r = nn[o].call(l, e, c, l.opts)) return r;
    }return B(l, c), ue.isFunction(l.opts.start) && l.opts.start.call(e, l), ue.fx.timer(ue.extend(u, { elem: e, anim: l, queue: l.opts.queue })), l.progress(l.opts.progress).done(l.opts.done, l.opts.complete).fail(l.opts.fail).always(l.opts.always);
  }function R(e, t) {
    var n, r, i, o, a;for (i in e) {
      if (r = ue.camelCase(i), o = t[r], n = e[i], ue.isArray(n) && (o = n[1], n = e[i] = n[0]), i !== r && (e[r] = n, delete e[i]), a = ue.cssHooks[r], a && "expand" in a) {
        n = a.expand(n), delete e[r];for (i in n) {
          i in e || (e[i] = n[i], t[i] = o);
        }
      } else t[r] = o;
    }
  }function W(e, t, n) {
    var r,
        i,
        o,
        a,
        s,
        u,
        l,
        c,
        f,
        p = this,
        d = e.style,
        h = {},
        g = [],
        m = e.nodeType && w(e);n.queue || (c = ue._queueHooks(e, "fx"), null == c.unqueued && (c.unqueued = 0, f = c.empty.fire, c.empty.fire = function () {
      c.unqueued || f();
    }), c.unqueued++, p.always(function () {
      p.always(function () {
        c.unqueued--, ue.queue(e, "fx").length || c.empty.fire();
      });
    })), 1 === e.nodeType && ("height" in t || "width" in t) && (n.overflow = [d.overflow, d.overflowX, d.overflowY], "inline" === ue.css(e, "display") && "none" === ue.css(e, "float") && (ue.support.inlineBlockNeedsLayout && "inline" !== S(e.nodeName) ? d.zoom = 1 : d.display = "inline-block")), n.overflow && (d.overflow = "hidden", ue.support.shrinkWrapBlocks || p.always(function () {
      d.overflow = n.overflow[0], d.overflowX = n.overflow[1], d.overflowY = n.overflow[2];
    }));for (i in t) {
      if (a = t[i], Zt.exec(a)) {
        if (delete t[i], u = u || "toggle" === a, a === (m ? "hide" : "show")) continue;g.push(i);
      }
    }if (o = g.length) {
      s = ue._data(e, "fxshow") || ue._data(e, "fxshow", {}), "hidden" in s && (m = s.hidden), u && (s.hidden = !m), m ? ue(e).show() : p.done(function () {
        ue(e).hide();
      }), p.done(function () {
        var t;ue._removeData(e, "fxshow");for (t in h) {
          ue.style(e, t, h[t]);
        }
      });for (i = 0; o > i; i++) {
        r = g[i], l = p.createTween(r, m ? s[r] : 0), h[r] = s[r] || ue.style(e, r), r in s || (s[r] = l.start, m && (l.end = l.start, l.start = "width" === r || "height" === r ? 1 : 0));
      }
    }
  }function $(e, t, n, r, i) {
    return new $.prototype.init(e, t, n, r, i);
  }function I(e, t) {
    var n,
        r = { height: e },
        i = 0;for (t = t ? 1 : 0; 4 > i; i += 2 - t) {
      n = Nt[i], r["margin" + n] = r["padding" + n] = e;
    }return t && (r.opacity = r.width = e), r;
  }function z(e) {
    return ue.isWindow(e) ? e : 9 === e.nodeType && (e.defaultView || e.parentWindow);
  }var X,
      U,
      V = typeof t === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(t),
      Y = e.document,
      J = e.location,
      G = e.jQuery,
      Q = e.$,
      K = {},
      Z = [],
      ee = "1.9.1",
      te = Z.concat,
      ne = Z.push,
      re = Z.slice,
      ie = Z.indexOf,
      oe = K.toString,
      ae = K.hasOwnProperty,
      se = ee.trim,
      ue = function ue(e, t) {
    return new ue.fn.init(e, t, U);
  },
      le = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
      ce = /\S+/g,
      fe = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
      pe = /^(?:(<[\w\W]+>)[^>]*|#([\w-]*))$/,
      de = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
      he = /^[\],:{}\s]*$/,
      ge = /(?:^|:|,)(?:\s*\[)+/g,
      me = /\\(?:["\\\/bfnrt]|u[\da-fA-F]{4})/g,
      ye = /"[^"\\\r\n]*"|true|false|null|-?(?:\d+\.|)\d+(?:[eE][+-]?\d+|)/g,
      ve = /^-ms-/,
      be = /-([\da-z])/gi,
      xe = function xe(e, t) {
    return t.toUpperCase();
  },
      Te = function Te(e) {
    (Y.addEventListener || "load" === e.type || "complete" === Y.readyState) && (we(), ue.ready());
  },
      we = function we() {
    Y.addEventListener ? (Y.removeEventListener("DOMContentLoaded", Te, !1), e.removeEventListener("load", Te, !1)) : (Y.detachEvent("onreadystatechange", Te), e.detachEvent("onload", Te));
  };ue.fn = ue.prototype = { jquery: ee, constructor: ue, init: function init(e, n, r) {
      var i, o;if (!e) return this;if ("string" == typeof e) {
        if (i = "<" === e.charAt(0) && ">" === e.charAt(e.length - 1) && e.length >= 3 ? [null, e, null] : pe.exec(e), !i || !i[1] && n) return !n || n.jquery ? (n || r).find(e) : this.constructor(n).find(e);if (i[1]) {
          if (n = n instanceof ue ? n[0] : n, ue.merge(this, ue.parseHTML(i[1], n && n.nodeType ? n.ownerDocument || n : Y, !0)), de.test(i[1]) && ue.isPlainObject(n)) for (i in n) {
            ue.isFunction(this[i]) ? this[i](n[i]) : this.attr(i, n[i]);
          }return this;
        }if (o = Y.getElementById(i[2]), o && o.parentNode) {
          if (o.id !== i[2]) return r.find(e);this.length = 1, this[0] = o;
        }return this.context = Y, this.selector = e, this;
      }return e.nodeType ? (this.context = this[0] = e, this.length = 1, this) : ue.isFunction(e) ? r.ready(e) : (e.selector !== t && (this.selector = e.selector, this.context = e.context), ue.makeArray(e, this));
    }, selector: "", length: 0, size: function size() {
      return this.length;
    }, toArray: function toArray() {
      return re.call(this);
    }, get: function get(e) {
      return null == e ? this.toArray() : 0 > e ? this[this.length + e] : this[e];
    }, pushStack: function pushStack(e) {
      var t = ue.merge(this.constructor(), e);return t.prevObject = this, t.context = this.context, t;
    }, each: function each(e, t) {
      return ue.each(this, e, t);
    }, ready: function ready(e) {
      return ue.ready.promise().done(e), this;
    }, slice: function slice() {
      return this.pushStack(re.apply(this, arguments));
    }, first: function first() {
      return this.eq(0);
    }, last: function last() {
      return this.eq(-1);
    }, eq: function eq(e) {
      var t = this.length,
          n = +e + (0 > e ? t : 0);return this.pushStack(n >= 0 && t > n ? [this[n]] : []);
    }, map: function map(e) {
      return this.pushStack(ue.map(this, function (t, n) {
        return e.call(t, n, t);
      }));
    }, end: function end() {
      return this.prevObject || this.constructor(null);
    }, push: ne, sort: [].sort, splice: [].splice }, ue.fn.init.prototype = ue.fn, ue.extend = ue.fn.extend = function () {
    var e,
        n,
        r,
        i,
        o,
        a,
        s = arguments[0] || {},
        u = 1,
        l = arguments.length,
        c = !1;for ("boolean" == typeof s && (c = s, s = arguments[1] || {}, u = 2), "object" == (typeof s === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(s)) || ue.isFunction(s) || (s = {}), l === u && (s = this, --u); l > u; u++) {
      if (null != (o = arguments[u])) for (i in o) {
        e = s[i], r = o[i], s !== r && (c && r && (ue.isPlainObject(r) || (n = ue.isArray(r))) ? (n ? (n = !1, a = e && ue.isArray(e) ? e : []) : a = e && ue.isPlainObject(e) ? e : {}, s[i] = ue.extend(c, a, r)) : r !== t && (s[i] = r));
      }
    }return s;
  }, ue.extend({ noConflict: function noConflict(t) {
      return e.$ === ue && (e.$ = Q), t && e.jQuery === ue && (e.jQuery = G), ue;
    }, isReady: !1, readyWait: 1, holdReady: function holdReady(e) {
      e ? ue.readyWait++ : ue.ready(!0);
    }, ready: function ready(e) {
      if (e === !0 ? ! --ue.readyWait : !ue.isReady) {
        if (!Y.body) return setTimeout(ue.ready);ue.isReady = !0, e !== !0 && --ue.readyWait > 0 || (X.resolveWith(Y, [ue]), ue.fn.trigger && ue(Y).trigger("ready").off("ready"));
      }
    }, isFunction: function isFunction(e) {
      return "function" === ue.type(e);
    }, isArray: Array.isArray || function (e) {
      return "array" === ue.type(e);
    }, isWindow: function isWindow(e) {
      return null != e && e == e.window;
    }, isNumeric: function isNumeric(e) {
      return !isNaN(parseFloat(e)) && isFinite(e);
    }, type: function type(e) {
      return null == e ? e + "" : "object" == (typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(e)) || "function" == typeof e ? K[oe.call(e)] || "object" : typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(e);
    }, isPlainObject: function isPlainObject(e) {
      if (!e || "object" !== ue.type(e) || e.nodeType || ue.isWindow(e)) return !1;try {
        if (e.constructor && !ae.call(e, "constructor") && !ae.call(e.constructor.prototype, "isPrototypeOf")) return !1;
      } catch (e) {
        return !1;
      }var n;for (n in e) {}return n === t || ae.call(e, n);
    }, isEmptyObject: function isEmptyObject(e) {
      var t;for (t in e) {
        return !1;
      }return !0;
    }, error: function error(e) {
      throw Error(e);
    }, parseHTML: function parseHTML(e, t, n) {
      if (!e || "string" != typeof e) return null;"boolean" == typeof t && (n = t, t = !1), t = t || Y;var r = de.exec(e),
          i = !n && [];return r ? [t.createElement(r[1])] : (r = ue.buildFragment([e], t, i), i && ue(i).remove(), ue.merge([], r.childNodes));
    }, parseJSON: function parseJSON(n) {
      return e.JSON && e.JSON.parse ? e.JSON.parse(n) : null === n ? n : "string" == typeof n && (n = ue.trim(n), n && he.test(n.replace(me, "@").replace(ye, "]").replace(ge, ""))) ? Function("return " + n)() : (ue.error("Invalid JSON: " + n), t);
    }, parseXML: function parseXML(n) {
      var r, i;if (!n || "string" != typeof n) return null;try {
        e.DOMParser ? (i = new DOMParser(), r = i.parseFromString(n, "text/xml")) : (r = new ActiveXObject("Microsoft.XMLDOM"), r.async = "false", r.loadXML(n));
      } catch (e) {
        r = t;
      }return r && r.documentElement && !r.getElementsByTagName("parsererror").length || ue.error("Invalid XML: " + n), r;
    }, noop: function noop() {}, globalEval: function globalEval(t) {
      t && ue.trim(t) && (e.execScript || function (t) {
        e.eval.call(e, t);
      })(t);
    }, camelCase: function camelCase(e) {
      return e.replace(ve, "ms-").replace(be, xe);
    }, nodeName: function nodeName(e, t) {
      return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
    }, each: function each(e, t, r) {
      var i,
          o = 0,
          a = e.length,
          s = n(e);if (r) {
        if (s) for (; a > o && (i = t.apply(e[o], r), i !== !1); o++) {} else for (o in e) {
          if (i = t.apply(e[o], r), i === !1) break;
        }
      } else if (s) for (; a > o && (i = t.call(e[o], o, e[o]), i !== !1); o++) {} else for (o in e) {
        if (i = t.call(e[o], o, e[o]), i === !1) break;
      }return e;
    }, trim: se && !se.call("\uFEFF\xA0") ? function (e) {
      return null == e ? "" : se.call(e);
    } : function (e) {
      return null == e ? "" : (e + "").replace(fe, "");
    }, makeArray: function makeArray(e, t) {
      var r = t || [];return null != e && (n(Object(e)) ? ue.merge(r, "string" == typeof e ? [e] : e) : ne.call(r, e)), r;
    }, inArray: function inArray(e, t, n) {
      var r;if (t) {
        if (ie) return ie.call(t, e, n);for (r = t.length, n = n ? 0 > n ? Math.max(0, r + n) : n : 0; r > n; n++) {
          if (n in t && t[n] === e) return n;
        }
      }return -1;
    }, merge: function merge(e, n) {
      var r = n.length,
          i = e.length,
          o = 0;if ("number" == typeof r) for (; r > o; o++) {
        e[i++] = n[o];
      } else for (; n[o] !== t;) {
        e[i++] = n[o++];
      }return e.length = i, e;
    }, grep: function grep(e, t, n) {
      var r,
          i = [],
          o = 0,
          a = e.length;for (n = !!n; a > o; o++) {
        r = !!t(e[o], o), n !== r && i.push(e[o]);
      }return i;
    }, map: function map(e, t, r) {
      var i,
          o = 0,
          a = e.length,
          s = n(e),
          u = [];if (s) for (; a > o; o++) {
        i = t(e[o], o, r), null != i && (u[u.length] = i);
      } else for (o in e) {
        i = t(e[o], o, r), null != i && (u[u.length] = i);
      }return te.apply([], u);
    }, guid: 1, proxy: function proxy(e, n) {
      var r, i, o;return "string" == typeof n && (o = e[n], n = e, e = o), ue.isFunction(e) ? (r = re.call(arguments, 2), i = function i() {
        return e.apply(n || this, r.concat(re.call(arguments)));
      }, i.guid = e.guid = e.guid || ue.guid++, i) : t;
    }, access: function access(e, n, r, i, o, a, s) {
      var u = 0,
          l = e.length,
          c = null == r;if ("object" === ue.type(r)) {
        o = !0;for (u in r) {
          ue.access(e, n, u, r[u], !0, a, s);
        }
      } else if (i !== t && (o = !0, ue.isFunction(i) || (s = !0), c && (s ? (n.call(e, i), n = null) : (c = n, n = function n(e, t, _n) {
        return c.call(ue(e), _n);
      })), n)) for (; l > u; u++) {
        n(e[u], r, s ? i : i.call(e[u], u, n(e[u], r)));
      }return o ? e : c ? n.call(e) : l ? n(e[0], r) : a;
    }, now: function now() {
      return new Date().getTime();
    } }), ue.ready.promise = function (t) {
    if (!X) if (X = ue.Deferred(), "complete" === Y.readyState) setTimeout(ue.ready);else if (Y.addEventListener) Y.addEventListener("DOMContentLoaded", Te, !1), e.addEventListener("load", Te, !1);else {
      Y.attachEvent("onreadystatechange", Te), e.attachEvent("onload", Te);var n = !1;try {
        n = null == e.frameElement && Y.documentElement;
      } catch (e) {}n && n.doScroll && function e() {
        if (!ue.isReady) {
          try {
            n.doScroll("left");
          } catch (t) {
            return setTimeout(e, 50);
          }we(), ue.ready();
        }
      }();
    }return X.promise(t);
  }, ue.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function (e, t) {
    K["[object " + t + "]"] = t.toLowerCase();
  }), U = ue(Y);var Ne = {};ue.Callbacks = function (e) {
    e = "string" == typeof e ? Ne[e] || r(e) : ue.extend({}, e);var n,
        i,
        o,
        a,
        s,
        u,
        l = [],
        c = !e.once && [],
        f = function f(t) {
      for (i = e.memory && t, o = !0, s = u || 0, u = 0, a = l.length, n = !0; l && a > s; s++) {
        if (l[s].apply(t[0], t[1]) === !1 && e.stopOnFalse) {
          i = !1;break;
        }
      }n = !1, l && (c ? c.length && f(c.shift()) : i ? l = [] : p.disable());
    },
        p = { add: function add() {
        if (l) {
          var t = l.length;!function t(n) {
            ue.each(n, function (n, r) {
              var i = ue.type(r);"function" === i ? e.unique && p.has(r) || l.push(r) : r && r.length && "string" !== i && t(r);
            });
          }(arguments), n ? a = l.length : i && (u = t, f(i));
        }return this;
      }, remove: function remove() {
        return l && ue.each(arguments, function (e, t) {
          for (var r; (r = ue.inArray(t, l, r)) > -1;) {
            l.splice(r, 1), n && (a >= r && a--, s >= r && s--);
          }
        }), this;
      }, has: function has(e) {
        return e ? ue.inArray(e, l) > -1 : !(!l || !l.length);
      }, empty: function empty() {
        return l = [], this;
      }, disable: function disable() {
        return l = c = i = t, this;
      }, disabled: function disabled() {
        return !l;
      }, lock: function lock() {
        return c = t, i || p.disable(), this;
      }, locked: function locked() {
        return !c;
      }, fireWith: function fireWith(e, t) {
        return t = t || [], t = [e, t.slice ? t.slice() : t], !l || o && !c || (n ? c.push(t) : f(t)), this;
      }, fire: function fire() {
        return p.fireWith(this, arguments), this;
      }, fired: function fired() {
        return !!o;
      } };return p;
  }, ue.extend({ Deferred: function Deferred(e) {
      var t = [["resolve", "done", ue.Callbacks("once memory"), "resolved"], ["reject", "fail", ue.Callbacks("once memory"), "rejected"], ["notify", "progress", ue.Callbacks("memory")]],
          n = "pending",
          r = { state: function state() {
          return n;
        }, always: function always() {
          return i.done(arguments).fail(arguments), this;
        }, then: function then() {
          var e = arguments;return ue.Deferred(function (n) {
            ue.each(t, function (t, o) {
              var a = o[0],
                  s = ue.isFunction(e[t]) && e[t];i[o[1]](function () {
                var e = s && s.apply(this, arguments);e && ue.isFunction(e.promise) ? e.promise().done(n.resolve).fail(n.reject).progress(n.notify) : n[a + "With"](this === r ? n.promise() : this, s ? [e] : arguments);
              });
            }), e = null;
          }).promise();
        }, promise: function promise(e) {
          return null != e ? ue.extend(e, r) : r;
        } },
          i = {};return r.pipe = r.then, ue.each(t, function (e, o) {
        var a = o[2],
            s = o[3];r[o[1]] = a.add, s && a.add(function () {
          n = s;
        }, t[1 ^ e][2].disable, t[2][2].lock), i[o[0]] = function () {
          return i[o[0] + "With"](this === i ? r : this, arguments), this;
        }, i[o[0] + "With"] = a.fireWith;
      }), r.promise(i), e && e.call(i, i), i;
    }, when: function when(e) {
      var t,
          n,
          r,
          i = 0,
          o = re.call(arguments),
          a = o.length,
          s = 1 !== a || e && ue.isFunction(e.promise) ? a : 0,
          u = 1 === s ? e : ue.Deferred(),
          l = function l(e, n, r) {
        return function (i) {
          n[e] = this, r[e] = arguments.length > 1 ? re.call(arguments) : i, r === t ? u.notifyWith(n, r) : --s || u.resolveWith(n, r);
        };
      };if (a > 1) for (t = Array(a), n = Array(a), r = Array(a); a > i; i++) {
        o[i] && ue.isFunction(o[i].promise) ? o[i].promise().done(l(i, r, o)).fail(u.reject).progress(l(i, n, t)) : --s;
      }return s || u.resolveWith(r, o), u.promise();
    } }), ue.support = function () {
    var t,
        n,
        r,
        i,
        o,
        a,
        s,
        u,
        l,
        c,
        f = Y.createElement("div");if (f.setAttribute("className", "t"), f.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", n = f.getElementsByTagName("*"), r = f.getElementsByTagName("a")[0], !n || !r || !n.length) return {};o = Y.createElement("select"), s = o.appendChild(Y.createElement("option")), i = f.getElementsByTagName("input")[0], r.style.cssText = "top:1px;float:left;opacity:.5", t = { getSetAttribute: "t" !== f.className, leadingWhitespace: 3 === f.firstChild.nodeType, tbody: !f.getElementsByTagName("tbody").length, htmlSerialize: !!f.getElementsByTagName("link").length, style: /top/.test(r.getAttribute("style")), hrefNormalized: "/a" === r.getAttribute("href"), opacity: /^0.5/.test(r.style.opacity), cssFloat: !!r.style.cssFloat, checkOn: !!i.value, optSelected: s.selected, enctype: !!Y.createElement("form").enctype, html5Clone: "<:nav></:nav>" !== Y.createElement("nav").cloneNode(!0).outerHTML, boxModel: "CSS1Compat" === Y.compatMode, deleteExpando: !0, noCloneEvent: !0, inlineBlockNeedsLayout: !1, shrinkWrapBlocks: !1, reliableMarginRight: !0, boxSizingReliable: !0, pixelPosition: !1 }, i.checked = !0, t.noCloneChecked = i.cloneNode(!0).checked, o.disabled = !0, t.optDisabled = !s.disabled;try {
      delete f.test;
    } catch (e) {
      t.deleteExpando = !1;
    }i = Y.createElement("input"), i.setAttribute("value", ""), t.input = "" === i.getAttribute("value"), i.value = "t", i.setAttribute("type", "radio"), t.radioValue = "t" === i.value, i.setAttribute("checked", "t"), i.setAttribute("name", "t"), a = Y.createDocumentFragment(), a.appendChild(i), t.appendChecked = i.checked, t.checkClone = a.cloneNode(!0).cloneNode(!0).lastChild.checked, f.attachEvent && (f.attachEvent("onclick", function () {
      t.noCloneEvent = !1;
    }), f.cloneNode(!0).click());for (c in { submit: !0, change: !0, focusin: !0 }) {
      f.setAttribute(u = "on" + c, "t"), t[c + "Bubbles"] = u in e || f.attributes[u].expando === !1;
    }return f.style.backgroundClip = "content-box", f.cloneNode(!0).style.backgroundClip = "", t.clearCloneStyle = "content-box" === f.style.backgroundClip, ue(function () {
      var n,
          r,
          i,
          o = "padding:0;margin:0;border:0;display:block;box-sizing:content-box;-moz-box-sizing:content-box;-webkit-box-sizing:content-box;",
          a = Y.getElementsByTagName("body")[0];a && (n = Y.createElement("div"), n.style.cssText = "border:0;width:0;height:0;position:absolute;top:0;left:-9999px;margin-top:1px", a.appendChild(n).appendChild(f), f.innerHTML = "<table><tr><td></td><td>t</td></tr></table>", i = f.getElementsByTagName("td"), i[0].style.cssText = "padding:0;margin:0;border:0;display:none", l = 0 === i[0].offsetHeight, i[0].style.display = "", i[1].style.display = "none", t.reliableHiddenOffsets = l && 0 === i[0].offsetHeight, f.innerHTML = "", f.style.cssText = "box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;padding:1px;border:1px;display:block;width:4px;margin-top:1%;position:absolute;top:1%;", t.boxSizing = 4 === f.offsetWidth, t.doesNotIncludeMarginInBodyOffset = 1 !== a.offsetTop, e.getComputedStyle && (t.pixelPosition = "1%" !== (e.getComputedStyle(f, null) || {}).top, t.boxSizingReliable = "4px" === (e.getComputedStyle(f, null) || { width: "4px" }).width, r = f.appendChild(Y.createElement("div")), r.style.cssText = f.style.cssText = o, r.style.marginRight = r.style.width = "0", f.style.width = "1px", t.reliableMarginRight = !parseFloat((e.getComputedStyle(r, null) || {}).marginRight)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(f.style.zoom) !== V && (f.innerHTML = "", f.style.cssText = o + "width:1px;padding:1px;display:inline;zoom:1", t.inlineBlockNeedsLayout = 3 === f.offsetWidth, f.style.display = "block", f.innerHTML = "<div></div>", f.firstChild.style.width = "5px", t.shrinkWrapBlocks = 3 !== f.offsetWidth, t.inlineBlockNeedsLayout && (a.style.zoom = 1)), a.removeChild(n), n = f = i = r = null);
    }), n = o = a = s = r = i = null, t;
  }();var Ce = /(?:\{[\s\S]*\}|\[[\s\S]*\])$/,
      ke = /([A-Z])/g;ue.extend({ cache: {}, expando: "jQuery" + (ee + Math.random()).replace(/\D/g, ""), noData: { embed: !0, object: "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000", applet: !0 }, hasData: function hasData(e) {
      return e = e.nodeType ? ue.cache[e[ue.expando]] : e[ue.expando], !!e && !s(e);
    }, data: function data(e, t, n) {
      return i(e, t, n);
    }, removeData: function removeData(e, t) {
      return o(e, t);
    }, _data: function _data(e, t, n) {
      return i(e, t, n, !0);
    }, _removeData: function _removeData(e, t) {
      return o(e, t, !0);
    }, acceptData: function acceptData(e) {
      if (e.nodeType && 1 !== e.nodeType && 9 !== e.nodeType) return !1;var t = e.nodeName && ue.noData[e.nodeName.toLowerCase()];return !t || t !== !0 && e.getAttribute("classid") === t;
    } }), ue.fn.extend({ data: function data(e, n) {
      var r,
          i,
          o = this[0],
          s = 0,
          u = null;if (e === t) {
        if (this.length && (u = ue.data(o), 1 === o.nodeType && !ue._data(o, "parsedAttrs"))) {
          for (r = o.attributes; r.length > s; s++) {
            i = r[s].name, i.indexOf("data-") || (i = ue.camelCase(i.slice(5)), a(o, i, u[i]));
          }ue._data(o, "parsedAttrs", !0);
        }return u;
      }return "object" == (typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(e)) ? this.each(function () {
        ue.data(this, e);
      }) : ue.access(this, function (n) {
        return n === t ? o ? a(o, e, ue.data(o, e)) : null : (this.each(function () {
          ue.data(this, e, n);
        }), t);
      }, null, n, arguments.length > 1, null, !0);
    }, removeData: function removeData(e) {
      return this.each(function () {
        ue.removeData(this, e);
      });
    } }), ue.extend({ queue: function queue(e, n, r) {
      var i;return e ? (n = (n || "fx") + "queue", i = ue._data(e, n), r && (!i || ue.isArray(r) ? i = ue._data(e, n, ue.makeArray(r)) : i.push(r)), i || []) : t;
    }, dequeue: function dequeue(e, t) {
      t = t || "fx";var n = ue.queue(e, t),
          r = n.length,
          i = n.shift(),
          o = ue._queueHooks(e, t),
          a = function a() {
        ue.dequeue(e, t);
      };"inprogress" === i && (i = n.shift(), r--), o.cur = i, i && ("fx" === t && n.unshift("inprogress"), delete o.stop, i.call(e, a, o)), !r && o && o.empty.fire();
    }, _queueHooks: function _queueHooks(e, t) {
      var n = t + "queueHooks";return ue._data(e, n) || ue._data(e, n, { empty: ue.Callbacks("once memory").add(function () {
          ue._removeData(e, t + "queue"), ue._removeData(e, n);
        }) });
    } }), ue.fn.extend({ queue: function queue(e, n) {
      var r = 2;return "string" != typeof e && (n = e, e = "fx", r--), r > arguments.length ? ue.queue(this[0], e) : n === t ? this : this.each(function () {
        var t = ue.queue(this, e, n);ue._queueHooks(this, e), "fx" === e && "inprogress" !== t[0] && ue.dequeue(this, e);
      });
    }, dequeue: function dequeue(e) {
      return this.each(function () {
        ue.dequeue(this, e);
      });
    }, delay: function delay(e, t) {
      return e = ue.fx ? ue.fx.speeds[e] || e : e, t = t || "fx", this.queue(t, function (t, n) {
        var r = setTimeout(t, e);n.stop = function () {
          clearTimeout(r);
        };
      });
    }, clearQueue: function clearQueue(e) {
      return this.queue(e || "fx", []);
    }, promise: function promise(e, n) {
      var r,
          i = 1,
          o = ue.Deferred(),
          a = this,
          s = this.length,
          u = function u() {
        --i || o.resolveWith(a, [a]);
      };for ("string" != typeof e && (n = e, e = t), e = e || "fx"; s--;) {
        r = ue._data(a[s], e + "queueHooks"), r && r.empty && (i++, r.empty.add(u));
      }return u(), o.promise(n);
    } });var Ee,
      Se,
      Ae = /[\t\r\n]/g,
      je = /\r/g,
      De = /^(?:input|select|textarea|button|object)$/i,
      Le = /^(?:a|area)$/i,
      He = /^(?:checked|selected|autofocus|autoplay|async|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped)$/i,
      qe = /^(?:checked|selected)$/i,
      Me = ue.support.getSetAttribute,
      _e = ue.support.input;ue.fn.extend({ attr: function attr(e, t) {
      return ue.access(this, ue.attr, e, t, arguments.length > 1);
    }, removeAttr: function removeAttr(e) {
      return this.each(function () {
        ue.removeAttr(this, e);
      });
    }, prop: function prop(e, t) {
      return ue.access(this, ue.prop, e, t, arguments.length > 1);
    }, removeProp: function removeProp(e) {
      return e = ue.propFix[e] || e, this.each(function () {
        try {
          this[e] = t, delete this[e];
        } catch (e) {}
      });
    }, addClass: function addClass(e) {
      var t,
          n,
          r,
          i,
          o,
          a = 0,
          s = this.length,
          u = "string" == typeof e && e;if (ue.isFunction(e)) return this.each(function (t) {
        ue(this).addClass(e.call(this, t, this.className));
      });if (u) for (t = (e || "").match(ce) || []; s > a; a++) {
        if (n = this[a], r = 1 === n.nodeType && (n.className ? (" " + n.className + " ").replace(Ae, " ") : " ")) {
          for (o = 0; i = t[o++];) {
            0 > r.indexOf(" " + i + " ") && (r += i + " ");
          }n.className = ue.trim(r);
        }
      }return this;
    }, removeClass: function removeClass(e) {
      var t,
          n,
          r,
          i,
          o,
          a = 0,
          s = this.length,
          u = 0 === arguments.length || "string" == typeof e && e;if (ue.isFunction(e)) return this.each(function (t) {
        ue(this).removeClass(e.call(this, t, this.className));
      });if (u) for (t = (e || "").match(ce) || []; s > a; a++) {
        if (n = this[a], r = 1 === n.nodeType && (n.className ? (" " + n.className + " ").replace(Ae, " ") : "")) {
          for (o = 0; i = t[o++];) {
            for (; r.indexOf(" " + i + " ") >= 0;) {
              r = r.replace(" " + i + " ", " ");
            }
          }n.className = e ? ue.trim(r) : "";
        }
      }return this;
    }, toggleClass: function toggleClass(e, t) {
      var n = typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(e),
          r = "boolean" == typeof t;return ue.isFunction(e) ? this.each(function (n) {
        ue(this).toggleClass(e.call(this, n, this.className, t), t);
      }) : this.each(function () {
        if ("string" === n) for (var i, o = 0, a = ue(this), s = t, u = e.match(ce) || []; i = u[o++];) {
          s = r ? s : !a.hasClass(i), a[s ? "addClass" : "removeClass"](i);
        } else (n === V || "boolean" === n) && (this.className && ue._data(this, "__className__", this.className), this.className = this.className || e === !1 ? "" : ue._data(this, "__className__") || "");
      });
    }, hasClass: function hasClass(e) {
      for (var t = " " + e + " ", n = 0, r = this.length; r > n; n++) {
        if (1 === this[n].nodeType && (" " + this[n].className + " ").replace(Ae, " ").indexOf(t) >= 0) return !0;
      }return !1;
    }, val: function val(e) {
      var n,
          r,
          i,
          o = this[0];return arguments.length ? (i = ue.isFunction(e), this.each(function (n) {
        var o,
            a = ue(this);1 === this.nodeType && (o = i ? e.call(this, n, a.val()) : e, null == o ? o = "" : "number" == typeof o ? o += "" : ue.isArray(o) && (o = ue.map(o, function (e) {
          return null == e ? "" : e + "";
        })), r = ue.valHooks[this.type] || ue.valHooks[this.nodeName.toLowerCase()], r && "set" in r && r.set(this, o, "value") !== t || (this.value = o));
      })) : o ? (r = ue.valHooks[o.type] || ue.valHooks[o.nodeName.toLowerCase()], r && "get" in r && (n = r.get(o, "value")) !== t ? n : (n = o.value, "string" == typeof n ? n.replace(je, "") : null == n ? "" : n)) : void 0;
    } }), ue.extend({ valHooks: { option: { get: function get(e) {
          var t = e.attributes.value;return !t || t.specified ? e.value : e.text;
        } }, select: { get: function get(e) {
          for (var t, n, r = e.options, i = e.selectedIndex, o = "select-one" === e.type || 0 > i, a = o ? null : [], s = o ? i + 1 : r.length, u = 0 > i ? s : o ? i : 0; s > u; u++) {
            if (n = r[u], !(!n.selected && u !== i || (ue.support.optDisabled ? n.disabled : null !== n.getAttribute("disabled")) || n.parentNode.disabled && ue.nodeName(n.parentNode, "optgroup"))) {
              if (t = ue(n).val(), o) return t;a.push(t);
            }
          }return a;
        }, set: function set(e, t) {
          var n = ue.makeArray(t);return ue(e).find("option").each(function () {
            this.selected = ue.inArray(ue(this).val(), n) >= 0;
          }), n.length || (e.selectedIndex = -1), n;
        } } }, attr: function attr(e, n, r) {
      var i,
          o,
          a,
          s = e.nodeType;if (e && 3 !== s && 8 !== s && 2 !== s) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(e.getAttribute) === V ? ue.prop(e, n, r) : (o = 1 !== s || !ue.isXMLDoc(e), o && (n = n.toLowerCase(), i = ue.attrHooks[n] || (He.test(n) ? Se : Ee)), r === t ? i && o && "get" in i && null !== (a = i.get(e, n)) ? a : (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(e.getAttribute) !== V && (a = e.getAttribute(n)), null == a ? t : a) : null !== r ? i && o && "set" in i && (a = i.set(e, r, n)) !== t ? a : (e.setAttribute(n, r + ""), r) : (ue.removeAttr(e, n), t));
    }, removeAttr: function removeAttr(e, t) {
      var n,
          r,
          i = 0,
          o = t && t.match(ce);if (o && 1 === e.nodeType) for (; n = o[i++];) {
        r = ue.propFix[n] || n, He.test(n) ? !Me && qe.test(n) ? e[ue.camelCase("default-" + n)] = e[r] = !1 : e[r] = !1 : ue.attr(e, n, ""), e.removeAttribute(Me ? n : r);
      }
    }, attrHooks: { type: { set: function set(e, t) {
          if (!ue.support.radioValue && "radio" === t && ue.nodeName(e, "input")) {
            var n = e.value;return e.setAttribute("type", t), n && (e.value = n), t;
          }
        } } }, propFix: { tabindex: "tabIndex", readonly: "readOnly", for: "htmlFor", class: "className", maxlength: "maxLength", cellspacing: "cellSpacing", cellpadding: "cellPadding", rowspan: "rowSpan", colspan: "colSpan", usemap: "useMap", frameborder: "frameBorder", contenteditable: "contentEditable" }, prop: function prop(e, n, r) {
      var i,
          o,
          a,
          s = e.nodeType;if (e && 3 !== s && 8 !== s && 2 !== s) return a = 1 !== s || !ue.isXMLDoc(e), a && (n = ue.propFix[n] || n, o = ue.propHooks[n]), r !== t ? o && "set" in o && (i = o.set(e, r, n)) !== t ? i : e[n] = r : o && "get" in o && null !== (i = o.get(e, n)) ? i : e[n];
    }, propHooks: { tabIndex: { get: function get(e) {
          var n = e.getAttributeNode("tabindex");return n && n.specified ? parseInt(n.value, 10) : De.test(e.nodeName) || Le.test(e.nodeName) && e.href ? 0 : t;
        } } } }), Se = { get: function get(e, n) {
      var r = ue.prop(e, n),
          i = "boolean" == typeof r && e.getAttribute(n),
          o = "boolean" == typeof r ? _e && Me ? null != i : qe.test(n) ? e[ue.camelCase("default-" + n)] : !!i : e.getAttributeNode(n);return o && o.value !== !1 ? n.toLowerCase() : t;
    }, set: function set(e, t, n) {
      return t === !1 ? ue.removeAttr(e, n) : _e && Me || !qe.test(n) ? e.setAttribute(!Me && ue.propFix[n] || n, n) : e[ue.camelCase("default-" + n)] = e[n] = !0, n;
    } }, _e && Me || (ue.attrHooks.value = { get: function get(e, n) {
      var r = e.getAttributeNode(n);return ue.nodeName(e, "input") ? e.defaultValue : r && r.specified ? r.value : t;
    }, set: function set(e, n, r) {
      return ue.nodeName(e, "input") ? (e.defaultValue = n, t) : Ee && Ee.set(e, n, r);
    } }), Me || (Ee = ue.valHooks.button = { get: function get(e, n) {
      var r = e.getAttributeNode(n);return r && ("id" === n || "name" === n || "coords" === n ? "" !== r.value : r.specified) ? r.value : t;
    }, set: function set(e, n, r) {
      var i = e.getAttributeNode(r);return i || e.setAttributeNode(i = e.ownerDocument.createAttribute(r)), i.value = n += "", "value" === r || n === e.getAttribute(r) ? n : t;
    } }, ue.attrHooks.contenteditable = { get: Ee.get, set: function set(e, t, n) {
      Ee.set(e, "" !== t && t, n);
    } }, ue.each(["width", "height"], function (e, n) {
    ue.attrHooks[n] = ue.extend(ue.attrHooks[n], { set: function set(e, r) {
        return "" === r ? (e.setAttribute(n, "auto"), r) : t;
      } });
  })), ue.support.hrefNormalized || (ue.each(["href", "src", "width", "height"], function (e, n) {
    ue.attrHooks[n] = ue.extend(ue.attrHooks[n], { get: function get(e) {
        var r = e.getAttribute(n, 2);return null == r ? t : r;
      } });
  }), ue.each(["href", "src"], function (e, t) {
    ue.propHooks[t] = { get: function get(e) {
        return e.getAttribute(t, 4);
      } };
  })), ue.support.style || (ue.attrHooks.style = { get: function get(e) {
      return e.style.cssText || t;
    }, set: function set(e, t) {
      return e.style.cssText = t + "";
    } }), ue.support.optSelected || (ue.propHooks.selected = ue.extend(ue.propHooks.selected, { get: function get(e) {
      var t = e.parentNode;return t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex), null;
    } })), ue.support.enctype || (ue.propFix.enctype = "encoding"), ue.support.checkOn || ue.each(["radio", "checkbox"], function () {
    ue.valHooks[this] = { get: function get(e) {
        return null === e.getAttribute("value") ? "on" : e.value;
      } };
  }), ue.each(["radio", "checkbox"], function () {
    ue.valHooks[this] = ue.extend(ue.valHooks[this], { set: function set(e, n) {
        return ue.isArray(n) ? e.checked = ue.inArray(ue(e).val(), n) >= 0 : t;
      } });
  });var Fe = /^(?:input|select|textarea)$/i,
      Oe = /^key/,
      Be = /^(?:mouse|contextmenu)|click/,
      Pe = /^(?:focusinfocus|focusoutblur)$/,
      Re = /^([^.]*)(?:\.(.+)|)$/;ue.event = { global: {}, add: function add(e, n, r, i, o) {
      var a,
          s,
          u,
          l,
          c,
          f,
          p,
          d,
          h,
          g,
          m,
          y = ue._data(e);if (y) {
        for (r.handler && (l = r, r = l.handler, o = l.selector), r.guid || (r.guid = ue.guid++), (s = y.events) || (s = y.events = {}), (f = y.handle) || (f = y.handle = function (e) {
          return (typeof ue === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(ue)) === V || e && ue.event.triggered === e.type ? t : ue.event.dispatch.apply(f.elem, arguments);
        }, f.elem = e), n = (n || "").match(ce) || [""], u = n.length; u--;) {
          a = Re.exec(n[u]) || [], h = m = a[1], g = (a[2] || "").split(".").sort(), c = ue.event.special[h] || {}, h = (o ? c.delegateType : c.bindType) || h, c = ue.event.special[h] || {}, p = ue.extend({ type: h, origType: m, data: i, handler: r, guid: r.guid, selector: o, needsContext: o && ue.expr.match.needsContext.test(o), namespace: g.join(".") }, l), (d = s[h]) || (d = s[h] = [], d.delegateCount = 0, c.setup && c.setup.call(e, i, g, f) !== !1 || (e.addEventListener ? e.addEventListener(h, f, !1) : e.attachEvent && e.attachEvent("on" + h, f))), c.add && (c.add.call(e, p), p.handler.guid || (p.handler.guid = r.guid)), o ? d.splice(d.delegateCount++, 0, p) : d.push(p), ue.event.global[h] = !0;
        }e = null;
      }
    }, remove: function remove(e, t, n, r, i) {
      var o,
          a,
          s,
          u,
          l,
          c,
          f,
          p,
          d,
          h,
          g,
          m = ue.hasData(e) && ue._data(e);if (m && (c = m.events)) {
        for (t = (t || "").match(ce) || [""], l = t.length; l--;) {
          if (s = Re.exec(t[l]) || [], d = g = s[1], h = (s[2] || "").split(".").sort(), d) {
            for (f = ue.event.special[d] || {}, d = (r ? f.delegateType : f.bindType) || d, p = c[d] || [], s = s[2] && RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"), u = o = p.length; o--;) {
              a = p[o], !i && g !== a.origType || n && n.guid !== a.guid || s && !s.test(a.namespace) || r && r !== a.selector && ("**" !== r || !a.selector) || (p.splice(o, 1), a.selector && p.delegateCount--, f.remove && f.remove.call(e, a));
            }u && !p.length && (f.teardown && f.teardown.call(e, h, m.handle) !== !1 || ue.removeEvent(e, d, m.handle), delete c[d]);
          } else for (d in c) {
            ue.event.remove(e, d + t[l], n, r, !0);
          }
        }ue.isEmptyObject(c) && (delete m.handle, ue._removeData(e, "events"));
      }
    }, trigger: function trigger(n, r, i, o) {
      var a,
          s,
          u,
          l,
          c,
          f,
          p,
          d = [i || Y],
          h = ae.call(n, "type") ? n.type : n,
          g = ae.call(n, "namespace") ? n.namespace.split(".") : [];if (u = f = i = i || Y, 3 !== i.nodeType && 8 !== i.nodeType && !Pe.test(h + ue.event.triggered) && (h.indexOf(".") >= 0 && (g = h.split("."), h = g.shift(), g.sort()), s = 0 > h.indexOf(":") && "on" + h, n = n[ue.expando] ? n : new ue.Event(h, "object" == (typeof n === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(n)) && n), n.isTrigger = !0, n.namespace = g.join("."), n.namespace_re = n.namespace ? RegExp("(^|\\.)" + g.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, n.result = t, n.target || (n.target = i), r = null == r ? [n] : ue.makeArray(r, [n]), c = ue.event.special[h] || {}, o || !c.trigger || c.trigger.apply(i, r) !== !1)) {
        if (!o && !c.noBubble && !ue.isWindow(i)) {
          for (l = c.delegateType || h, Pe.test(l + h) || (u = u.parentNode); u; u = u.parentNode) {
            d.push(u), f = u;
          }f === (i.ownerDocument || Y) && d.push(f.defaultView || f.parentWindow || e);
        }for (p = 0; (u = d[p++]) && !n.isPropagationStopped();) {
          n.type = p > 1 ? l : c.bindType || h, a = (ue._data(u, "events") || {})[n.type] && ue._data(u, "handle"), a && a.apply(u, r), a = s && u[s], a && ue.acceptData(u) && a.apply && a.apply(u, r) === !1 && n.preventDefault();
        }if (n.type = h, !(o || n.isDefaultPrevented() || c._default && c._default.apply(i.ownerDocument, r) !== !1 || "click" === h && ue.nodeName(i, "a") || !ue.acceptData(i) || !s || !i[h] || ue.isWindow(i))) {
          f = i[s], f && (i[s] = null), ue.event.triggered = h;try {
            i[h]();
          } catch (e) {}ue.event.triggered = t, f && (i[s] = f);
        }return n.result;
      }
    }, dispatch: function dispatch(e) {
      e = ue.event.fix(e);var n,
          r,
          i,
          o,
          a,
          s = [],
          u = re.call(arguments),
          l = (ue._data(this, "events") || {})[e.type] || [],
          c = ue.event.special[e.type] || {};if (u[0] = e, e.delegateTarget = this, !c.preDispatch || c.preDispatch.call(this, e) !== !1) {
        for (s = ue.event.handlers.call(this, e, l), n = 0; (o = s[n++]) && !e.isPropagationStopped();) {
          for (e.currentTarget = o.elem, a = 0; (i = o.handlers[a++]) && !e.isImmediatePropagationStopped();) {
            (!e.namespace_re || e.namespace_re.test(i.namespace)) && (e.handleObj = i, e.data = i.data, r = ((ue.event.special[i.origType] || {}).handle || i.handler).apply(o.elem, u), r !== t && (e.result = r) === !1 && (e.preventDefault(), e.stopPropagation()));
          }
        }return c.postDispatch && c.postDispatch.call(this, e), e.result;
      }
    }, handlers: function handlers(e, n) {
      var r,
          i,
          o,
          a,
          s = [],
          u = n.delegateCount,
          l = e.target;if (u && l.nodeType && (!e.button || "click" !== e.type)) for (; l != this; l = l.parentNode || this) {
        if (1 === l.nodeType && (l.disabled !== !0 || "click" !== e.type)) {
          for (o = [], a = 0; u > a; a++) {
            i = n[a], r = i.selector + " ", o[r] === t && (o[r] = i.needsContext ? ue(r, this).index(l) >= 0 : ue.find(r, this, null, [l]).length), o[r] && o.push(i);
          }o.length && s.push({ elem: l, handlers: o });
        }
      }return n.length > u && s.push({ elem: this, handlers: n.slice(u) }), s;
    }, fix: function fix(e) {
      if (e[ue.expando]) return e;var t,
          n,
          r,
          i = e.type,
          o = e,
          a = this.fixHooks[i];for (a || (this.fixHooks[i] = a = Be.test(i) ? this.mouseHooks : Oe.test(i) ? this.keyHooks : {}), r = a.props ? this.props.concat(a.props) : this.props, e = new ue.Event(o), t = r.length; t--;) {
        n = r[t], e[n] = o[n];
      }return e.target || (e.target = o.srcElement || Y), 3 === e.target.nodeType && (e.target = e.target.parentNode), e.metaKey = !!e.metaKey, a.filter ? a.filter(e, o) : e;
    }, props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "), fixHooks: {}, keyHooks: { props: "char charCode key keyCode".split(" "), filter: function filter(e, t) {
        return null == e.which && (e.which = null != t.charCode ? t.charCode : t.keyCode), e;
      } }, mouseHooks: { props: "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "), filter: function filter(e, n) {
        var r,
            i,
            o,
            a = n.button,
            s = n.fromElement;return null == e.pageX && null != n.clientX && (i = e.target.ownerDocument || Y, o = i.documentElement, r = i.body, e.pageX = n.clientX + (o && o.scrollLeft || r && r.scrollLeft || 0) - (o && o.clientLeft || r && r.clientLeft || 0), e.pageY = n.clientY + (o && o.scrollTop || r && r.scrollTop || 0) - (o && o.clientTop || r && r.clientTop || 0)), !e.relatedTarget && s && (e.relatedTarget = s === e.target ? n.toElement : s), e.which || a === t || (e.which = 1 & a ? 1 : 2 & a ? 3 : 4 & a ? 2 : 0), e;
      } }, special: { load: { noBubble: !0 }, click: { trigger: function trigger() {
          return ue.nodeName(this, "input") && "checkbox" === this.type && this.click ? (this.click(), !1) : t;
        } }, focus: { trigger: function trigger() {
          if (this !== Y.activeElement && this.focus) try {
            return this.focus(), !1;
          } catch (e) {}
        }, delegateType: "focusin" }, blur: { trigger: function trigger() {
          return this === Y.activeElement && this.blur ? (this.blur(), !1) : t;
        }, delegateType: "focusout" }, beforeunload: { postDispatch: function postDispatch(e) {
          e.result !== t && (e.originalEvent.returnValue = e.result);
        } } }, simulate: function simulate(e, t, n, r) {
      var i = ue.extend(new ue.Event(), n, { type: e, isSimulated: !0, originalEvent: {} });r ? ue.event.trigger(i, null, t) : ue.event.dispatch.call(t, i), i.isDefaultPrevented() && n.preventDefault();
    } }, ue.removeEvent = Y.removeEventListener ? function (e, t, n) {
    e.removeEventListener && e.removeEventListener(t, n, !1);
  } : function (e, t, n) {
    var r = "on" + t;e.detachEvent && (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(e[r]) === V && (e[r] = null), e.detachEvent(r, n));
  }, ue.Event = function (e, n) {
    return this instanceof ue.Event ? (e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || e.returnValue === !1 || e.getPreventDefault && e.getPreventDefault() ? u : l) : this.type = e, n && ue.extend(this, n), this.timeStamp = e && e.timeStamp || ue.now(), this[ue.expando] = !0, t) : new ue.Event(e, n);
  }, ue.Event.prototype = { isDefaultPrevented: l, isPropagationStopped: l, isImmediatePropagationStopped: l, preventDefault: function preventDefault() {
      var e = this.originalEvent;this.isDefaultPrevented = u, e && (e.preventDefault ? e.preventDefault() : e.returnValue = !1);
    }, stopPropagation: function stopPropagation() {
      var e = this.originalEvent;this.isPropagationStopped = u, e && (e.stopPropagation && e.stopPropagation(), e.cancelBubble = !0);
    }, stopImmediatePropagation: function stopImmediatePropagation() {
      this.isImmediatePropagationStopped = u, this.stopPropagation();
    } }, ue.each({ mouseenter: "mouseover", mouseleave: "mouseout" }, function (e, t) {
    ue.event.special[e] = { delegateType: t, bindType: t, handle: function handle(e) {
        var n,
            r = this,
            i = e.relatedTarget,
            o = e.handleObj;return (!i || i !== r && !ue.contains(r, i)) && (e.type = o.origType, n = o.handler.apply(this, arguments), e.type = t), n;
      } };
  }), ue.support.submitBubbles || (ue.event.special.submit = { setup: function setup() {
      return !ue.nodeName(this, "form") && (ue.event.add(this, "click._submit keypress._submit", function (e) {
        var n = e.target,
            r = ue.nodeName(n, "input") || ue.nodeName(n, "button") ? n.form : t;r && !ue._data(r, "submitBubbles") && (ue.event.add(r, "submit._submit", function (e) {
          e._submit_bubble = !0;
        }), ue._data(r, "submitBubbles", !0));
      }), t);
    }, postDispatch: function postDispatch(e) {
      e._submit_bubble && (delete e._submit_bubble, this.parentNode && !e.isTrigger && ue.event.simulate("submit", this.parentNode, e, !0));
    }, teardown: function teardown() {
      return !ue.nodeName(this, "form") && (ue.event.remove(this, "._submit"), t);
    } }), ue.support.changeBubbles || (ue.event.special.change = { setup: function setup() {
      return Fe.test(this.nodeName) ? (("checkbox" === this.type || "radio" === this.type) && (ue.event.add(this, "propertychange._change", function (e) {
        "checked" === e.originalEvent.propertyName && (this._just_changed = !0);
      }), ue.event.add(this, "click._change", function (e) {
        this._just_changed && !e.isTrigger && (this._just_changed = !1), ue.event.simulate("change", this, e, !0);
      })), !1) : (ue.event.add(this, "beforeactivate._change", function (e) {
        var t = e.target;Fe.test(t.nodeName) && !ue._data(t, "changeBubbles") && (ue.event.add(t, "change._change", function (e) {
          !this.parentNode || e.isSimulated || e.isTrigger || ue.event.simulate("change", this.parentNode, e, !0);
        }), ue._data(t, "changeBubbles", !0));
      }), t);
    }, handle: function handle(e) {
      var n = e.target;return this !== n || e.isSimulated || e.isTrigger || "radio" !== n.type && "checkbox" !== n.type ? e.handleObj.handler.apply(this, arguments) : t;
    }, teardown: function teardown() {
      return ue.event.remove(this, "._change"), !Fe.test(this.nodeName);
    } }), ue.support.focusinBubbles || ue.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
    var n = 0,
        r = function r(e) {
      ue.event.simulate(t, e.target, ue.event.fix(e), !0);
    };ue.event.special[t] = { setup: function setup() {
        0 === n++ && Y.addEventListener(e, r, !0);
      }, teardown: function teardown() {
        0 === --n && Y.removeEventListener(e, r, !0);
      } };
  }), ue.fn.extend({ on: function on(e, n, r, i, o) {
      var a, s;if ("object" == (typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(e))) {
        "string" != typeof n && (r = r || n, n = t);for (a in e) {
          this.on(a, n, r, e[a], o);
        }return this;
      }if (null == r && null == i ? (i = n, r = n = t) : null == i && ("string" == typeof n ? (i = r, r = t) : (i = r, r = n, n = t)), i === !1) i = l;else if (!i) return this;return 1 === o && (s = i, i = function i(e) {
        return ue().off(e), s.apply(this, arguments);
      }, i.guid = s.guid || (s.guid = ue.guid++)), this.each(function () {
        ue.event.add(this, e, i, r, n);
      });
    }, one: function one(e, t, n, r) {
      return this.on(e, t, n, r, 1);
    }, off: function off(e, n, r) {
      var i, o;if (e && e.preventDefault && e.handleObj) return i = e.handleObj, ue(e.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), this;if ("object" == (typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(e))) {
        for (o in e) {
          this.off(o, n, e[o]);
        }return this;
      }return (n === !1 || "function" == typeof n) && (r = n, n = t), r === !1 && (r = l), this.each(function () {
        ue.event.remove(this, e, r, n);
      });
    }, bind: function bind(e, t, n) {
      return this.on(e, null, t, n);
    }, unbind: function unbind(e, t) {
      return this.off(e, null, t);
    }, delegate: function delegate(e, t, n, r) {
      return this.on(t, e, n, r);
    }, undelegate: function undelegate(e, t, n) {
      return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
    }, trigger: function trigger(e, t) {
      return this.each(function () {
        ue.event.trigger(e, t, this);
      });
    }, triggerHandler: function triggerHandler(e, n) {
      var r = this[0];return r ? ue.event.trigger(e, n, r, !0) : t;
    } }), function (e, t) {
    function n(e) {
      return he.test(e + "");
    }function r() {
      var _e2,
          t = [];return _e2 = function e(n, r) {
        return t.push(n += " ") > C.cacheLength && delete _e2[t.shift()], _e2[n] = r;
      };
    }function i(e) {
      return e[P] = !0, e;
    }function o(e) {
      var t = L.createElement("div");try {
        return e(t);
      } catch (e) {
        return !1;
      } finally {
        t = null;
      }
    }function a(e, t, n, r) {
      var i, o, a, s, u, l, c, d, h, g;if ((t ? t.ownerDocument || t : R) !== L && D(t), t = t || L, n = n || [], !e || "string" != typeof e) return n;if (1 !== (s = t.nodeType) && 9 !== s) return [];if (!q && !r) {
        if (i = ge.exec(e)) if (a = i[1]) {
          if (9 === s) {
            if (o = t.getElementById(a), !o || !o.parentNode) return n;if (o.id === a) return n.push(o), n;
          } else if (t.ownerDocument && (o = t.ownerDocument.getElementById(a)) && O(t, o) && o.id === a) return n.push(o), n;
        } else {
          if (i[2]) return Q.apply(n, K.call(t.getElementsByTagName(e), 0)), n;if ((a = i[3]) && W.getByClassName && t.getElementsByClassName) return Q.apply(n, K.call(t.getElementsByClassName(a), 0)), n;
        }if (W.qsa && !M.test(e)) {
          if (c = !0, d = P, h = t, g = 9 === s && e, 1 === s && "object" !== t.nodeName.toLowerCase()) {
            for (l = f(e), (c = t.getAttribute("id")) ? d = c.replace(ve, "\\$&") : t.setAttribute("id", d), d = "[id='" + d + "'] ", u = l.length; u--;) {
              l[u] = d + p(l[u]);
            }h = de.test(e) && t.parentNode || t, g = l.join(",");
          }if (g) try {
            return Q.apply(n, K.call(h.querySelectorAll(g), 0)), n;
          } catch (e) {} finally {
            c || t.removeAttribute("id");
          }
        }
      }return x(e.replace(ae, "$1"), t, n, r);
    }function s(e, t) {
      var n = t && e,
          r = n && (~t.sourceIndex || Y) - (~e.sourceIndex || Y);if (r) return r;if (n) for (; n = n.nextSibling;) {
        if (n === t) return -1;
      }return e ? 1 : -1;
    }function u(e) {
      return function (t) {
        var n = t.nodeName.toLowerCase();return "input" === n && t.type === e;
      };
    }function l(e) {
      return function (t) {
        var n = t.nodeName.toLowerCase();return ("input" === n || "button" === n) && t.type === e;
      };
    }function c(e) {
      return i(function (t) {
        return t = +t, i(function (n, r) {
          for (var i, o = e([], n.length, t), a = o.length; a--;) {
            n[i = o[a]] && (n[i] = !(r[i] = n[i]));
          }
        });
      });
    }function f(e, t) {
      var n,
          r,
          i,
          o,
          s,
          u,
          l,
          c = X[e + " "];if (c) return t ? 0 : c.slice(0);for (s = e, u = [], l = C.preFilter; s;) {
        (!n || (r = se.exec(s))) && (r && (s = s.slice(r[0].length) || s), u.push(i = [])), n = !1, (r = le.exec(s)) && (n = r.shift(), i.push({ value: n, type: r[0].replace(ae, " ") }), s = s.slice(n.length));for (o in C.filter) {
          !(r = pe[o].exec(s)) || l[o] && !(r = l[o](r)) || (n = r.shift(), i.push({ value: n, type: o, matches: r }), s = s.slice(n.length));
        }if (!n) break;
      }return t ? s.length : s ? a.error(e) : X(e, u).slice(0);
    }function p(e) {
      for (var t = 0, n = e.length, r = ""; n > t; t++) {
        r += e[t].value;
      }return r;
    }function d(e, t, n) {
      var r = t.dir,
          i = n && "parentNode" === r,
          o = I++;return t.first ? function (t, n, o) {
        for (; t = t[r];) {
          if (1 === t.nodeType || i) return e(t, n, o);
        }
      } : function (t, n, a) {
        var s,
            u,
            l,
            c = $ + " " + o;if (a) {
          for (; t = t[r];) {
            if ((1 === t.nodeType || i) && e(t, n, a)) return !0;
          }
        } else for (; t = t[r];) {
          if (1 === t.nodeType || i) if (l = t[P] || (t[P] = {}), (u = l[r]) && u[0] === c) {
            if ((s = u[1]) === !0 || s === N) return s === !0;
          } else if (u = l[r] = [c], u[1] = e(t, n, a) || N, u[1] === !0) return !0;
        }
      };
    }function h(e) {
      return e.length > 1 ? function (t, n, r) {
        for (var i = e.length; i--;) {
          if (!e[i](t, n, r)) return !1;
        }return !0;
      } : e[0];
    }function g(e, t, n, r, i) {
      for (var o, a = [], s = 0, u = e.length, l = null != t; u > s; s++) {
        (o = e[s]) && (!n || n(o, r, i)) && (a.push(o), l && t.push(s));
      }return a;
    }function m(e, t, n, r, o, a) {
      return r && !r[P] && (r = m(r)), o && !o[P] && (o = m(o, a)), i(function (i, a, s, u) {
        var l,
            c,
            f,
            p = [],
            d = [],
            h = a.length,
            m = i || b(t || "*", s.nodeType ? [s] : s, []),
            y = !e || !i && t ? m : g(m, p, e, s, u),
            v = n ? o || (i ? e : h || r) ? [] : a : y;if (n && n(y, v, s, u), r) for (l = g(v, d), r(l, [], s, u), c = l.length; c--;) {
          (f = l[c]) && (v[d[c]] = !(y[d[c]] = f));
        }if (i) {
          if (o || e) {
            if (o) {
              for (l = [], c = v.length; c--;) {
                (f = v[c]) && l.push(y[c] = f);
              }o(null, v = [], l, u);
            }for (c = v.length; c--;) {
              (f = v[c]) && (l = o ? Z.call(i, f) : p[c]) > -1 && (i[l] = !(a[l] = f));
            }
          }
        } else v = g(v === a ? v.splice(h, v.length) : v), o ? o(null, a, v, u) : Q.apply(a, v);
      });
    }function y(e) {
      for (var t, n, r, i = e.length, o = C.relative[e[0].type], a = o || C.relative[" "], s = o ? 1 : 0, u = d(function (e) {
        return e === t;
      }, a, !0), l = d(function (e) {
        return Z.call(t, e) > -1;
      }, a, !0), c = [function (e, n, r) {
        return !o && (r || n !== j) || ((t = n).nodeType ? u(e, n, r) : l(e, n, r));
      }]; i > s; s++) {
        if (n = C.relative[e[s].type]) c = [d(h(c), n)];else {
          if (n = C.filter[e[s].type].apply(null, e[s].matches), n[P]) {
            for (r = ++s; i > r && !C.relative[e[r].type]; r++) {}return m(s > 1 && h(c), s > 1 && p(e.slice(0, s - 1)).replace(ae, "$1"), n, r > s && y(e.slice(s, r)), i > r && y(e = e.slice(r)), i > r && p(e));
          }c.push(n);
        }
      }return h(c);
    }function v(e, t) {
      var n = 0,
          r = t.length > 0,
          o = e.length > 0,
          s = function s(i, _s, u, l, c) {
        var f,
            p,
            d,
            h = [],
            m = 0,
            y = "0",
            v = i && [],
            b = null != c,
            x = j,
            T = i || o && C.find.TAG("*", c && _s.parentNode || _s),
            w = $ += null == x ? 1 : Math.random() || .1;for (b && (j = _s !== L && _s, N = n); null != (f = T[y]); y++) {
          if (o && f) {
            for (p = 0; d = e[p++];) {
              if (d(f, _s, u)) {
                l.push(f);break;
              }
            }b && ($ = w, N = ++n);
          }r && ((f = !d && f) && m--, i && v.push(f));
        }if (m += y, r && y !== m) {
          for (p = 0; d = t[p++];) {
            d(v, h, _s, u);
          }if (i) {
            if (m > 0) for (; y--;) {
              v[y] || h[y] || (h[y] = G.call(l));
            }h = g(h);
          }Q.apply(l, h), b && !i && h.length > 0 && m + t.length > 1 && a.uniqueSort(l);
        }return b && ($ = w, j = x), v;
      };return r ? i(s) : s;
    }function b(e, t, n) {
      for (var r = 0, i = t.length; i > r; r++) {
        a(e, t[r], n);
      }return n;
    }function x(e, t, n, r) {
      var i,
          o,
          a,
          s,
          u,
          l = f(e);if (!r && 1 === l.length) {
        if (o = l[0] = l[0].slice(0), o.length > 2 && "ID" === (a = o[0]).type && 9 === t.nodeType && !q && C.relative[o[1].type]) {
          if (t = C.find.ID(a.matches[0].replace(xe, Te), t)[0], !t) return n;e = e.slice(o.shift().value.length);
        }for (i = pe.needsContext.test(e) ? 0 : o.length; i-- && (a = o[i], !C.relative[s = a.type]);) {
          if ((u = C.find[s]) && (r = u(a.matches[0].replace(xe, Te), de.test(o[0].type) && t.parentNode || t))) {
            if (o.splice(i, 1), e = r.length && p(o), !e) return Q.apply(n, K.call(r, 0)), n;break;
          }
        }
      }return S(e, l)(r, t, q, n, de.test(e)), n;
    }function T() {}var w,
        N,
        C,
        k,
        E,
        S,
        A,
        j,
        D,
        L,
        H,
        q,
        M,
        _,
        F,
        O,
        B,
        P = "sizzle" + -new Date(),
        R = e.document,
        W = {},
        $ = 0,
        I = 0,
        z = r(),
        X = r(),
        U = r(),
        V = typeof t === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(t),
        Y = 1 << 31,
        J = [],
        G = J.pop,
        Q = J.push,
        K = J.slice,
        Z = J.indexOf || function (e) {
      for (var t = 0, n = this.length; n > t; t++) {
        if (this[t] === e) return t;
      }return -1;
    },
        ee = "[\\x20\\t\\r\\n\\f]",
        te = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
        ne = te.replace("w", "w#"),
        re = "([*^$|!~]?=)",
        ie = "\\[" + ee + "*(" + te + ")" + ee + "*(?:" + re + ee + "*(?:(['\"])((?:\\\\.|[^\\\\])*?)\\3|(" + ne + ")|)|)" + ee + "*\\]",
        oe = ":(" + te + ")(?:\\(((['\"])((?:\\\\.|[^\\\\])*?)\\3|((?:\\\\.|[^\\\\()[\\]]|" + ie.replace(3, 8) + ")*)|.*)\\)|)",
        ae = RegExp("^" + ee + "+|((?:^|[^\\\\])(?:\\\\.)*)" + ee + "+$", "g"),
        se = RegExp("^" + ee + "*," + ee + "*"),
        le = RegExp("^" + ee + "*([\\x20\\t\\r\\n\\f>+~])" + ee + "*"),
        ce = RegExp(oe),
        fe = RegExp("^" + ne + "$"),
        pe = { ID: RegExp("^#(" + te + ")"), CLASS: RegExp("^\\.(" + te + ")"), NAME: RegExp("^\\[name=['\"]?(" + te + ")['\"]?\\]"), TAG: RegExp("^(" + te.replace("w", "w*") + ")"), ATTR: RegExp("^" + ie), PSEUDO: RegExp("^" + oe), CHILD: RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + ee + "*(even|odd|(([+-]|)(\\d*)n|)" + ee + "*(?:([+-]|)" + ee + "*(\\d+)|))" + ee + "*\\)|)", "i"), needsContext: RegExp("^" + ee + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + ee + "*((?:-\\d)?\\d*)" + ee + "*\\)|)(?=[^-]|$)", "i") },
        de = /[\x20\t\r\n\f]*[+~]/,
        he = /^[^{]+\{\s*\[native code/,
        ge = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
        me = /^(?:input|select|textarea|button)$/i,
        ye = /^h\d$/i,
        ve = /'|\\/g,
        be = /\=[\x20\t\r\n\f]*([^'"\]]*)[\x20\t\r\n\f]*\]/g,
        xe = /\\([\da-fA-F]{1,6}[\x20\t\r\n\f]?|.)/g,
        Te = function Te(e, t) {
      var n = "0x" + t - 65536;return n !== n ? t : 0 > n ? String.fromCharCode(n + 65536) : String.fromCharCode(55296 | n >> 10, 56320 | 1023 & n);
    };try {
      K.call(R.documentElement.childNodes, 0)[0].nodeType;
    } catch (e) {
      K = function K(e) {
        for (var t, n = []; t = this[e++];) {
          n.push(t);
        }return n;
      };
    }E = a.isXML = function (e) {
      var t = e && (e.ownerDocument || e).documentElement;return !!t && "HTML" !== t.nodeName;
    }, D = a.setDocument = function (e) {
      var r = e ? e.ownerDocument || e : R;return r !== L && 9 === r.nodeType && r.documentElement ? (L = r, H = r.documentElement, q = E(r), W.tagNameNoComments = o(function (e) {
        return e.appendChild(r.createComment("")), !e.getElementsByTagName("*").length;
      }), W.attributes = o(function (e) {
        e.innerHTML = "<select></select>";var t = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(e.lastChild.getAttribute("multiple"));return "boolean" !== t && "string" !== t;
      }), W.getByClassName = o(function (e) {
        return e.innerHTML = "<div class='hidden e'></div><div class='hidden'></div>", !(!e.getElementsByClassName || !e.getElementsByClassName("e").length) && (e.lastChild.className = "e", 2 === e.getElementsByClassName("e").length);
      }), W.getByName = o(function (e) {
        e.id = P + 0, e.innerHTML = "<a name='" + P + "'></a><div name='" + P + "'></div>", H.insertBefore(e, H.firstChild);var t = r.getElementsByName && r.getElementsByName(P).length === 2 + r.getElementsByName(P + 0).length;return W.getIdNotName = !r.getElementById(P), H.removeChild(e), t;
      }), C.attrHandle = o(function (e) {
        return e.innerHTML = "<a href='#'></a>", e.firstChild && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(e.firstChild.getAttribute) !== V && "#" === e.firstChild.getAttribute("href");
      }) ? {} : { href: function href(e) {
          return e.getAttribute("href", 2);
        }, type: function type(e) {
          return e.getAttribute("type");
        } }, W.getIdNotName ? (C.find.ID = function (e, t) {
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(t.getElementById) !== V && !q) {
          var n = t.getElementById(e);return n && n.parentNode ? [n] : [];
        }
      }, C.filter.ID = function (e) {
        var t = e.replace(xe, Te);return function (e) {
          return e.getAttribute("id") === t;
        };
      }) : (C.find.ID = function (e, n) {
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(n.getElementById) !== V && !q) {
          var r = n.getElementById(e);return r ? r.id === e || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(r.getAttributeNode) !== V && r.getAttributeNode("id").value === e ? [r] : t : [];
        }
      }, C.filter.ID = function (e) {
        var t = e.replace(xe, Te);return function (e) {
          var n = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(e.getAttributeNode) !== V && e.getAttributeNode("id");return n && n.value === t;
        };
      }), C.find.TAG = W.tagNameNoComments ? function (e, n) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(n.getElementsByTagName) !== V ? n.getElementsByTagName(e) : t;
      } : function (e, t) {
        var n,
            r = [],
            i = 0,
            o = t.getElementsByTagName(e);if ("*" === e) {
          for (; n = o[i++];) {
            1 === n.nodeType && r.push(n);
          }return r;
        }return o;
      }, C.find.NAME = W.getByName && function (e, n) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(n.getElementsByName) !== V ? n.getElementsByName(name) : t;
      }, C.find.CLASS = W.getByClassName && function (e, n) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(n.getElementsByClassName) === V || q ? t : n.getElementsByClassName(e);
      }, _ = [], M = [":focus"], (W.qsa = n(r.querySelectorAll)) && (o(function (e) {
        e.innerHTML = "<select><option selected=''></option></select>", e.querySelectorAll("[selected]").length || M.push("\\[" + ee + "*(?:checked|disabled|ismap|multiple|readonly|selected|value)"), e.querySelectorAll(":checked").length || M.push(":checked");
      }), o(function (e) {
        e.innerHTML = "<input type='hidden' i=''/>", e.querySelectorAll("[i^='']").length && M.push("[*^$]=" + ee + "*(?:\"\"|'')"), e.querySelectorAll(":enabled").length || M.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), M.push(",.*:");
      })), (W.matchesSelector = n(F = H.matchesSelector || H.mozMatchesSelector || H.webkitMatchesSelector || H.oMatchesSelector || H.msMatchesSelector)) && o(function (e) {
        W.disconnectedMatch = F.call(e, "div"), F.call(e, "[s!='']:x"), _.push("!=", oe);
      }), M = RegExp(M.join("|")), _ = RegExp(_.join("|")), O = n(H.contains) || H.compareDocumentPosition ? function (e, t) {
        var n = 9 === e.nodeType ? e.documentElement : e,
            r = t && t.parentNode;return e === r || !(!r || 1 !== r.nodeType || !(n.contains ? n.contains(r) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(r)));
      } : function (e, t) {
        if (t) for (; t = t.parentNode;) {
          if (t === e) return !0;
        }return !1;
      }, B = H.compareDocumentPosition ? function (e, t) {
        var n;return e === t ? (A = !0, 0) : (n = t.compareDocumentPosition && e.compareDocumentPosition && e.compareDocumentPosition(t)) ? 1 & n || e.parentNode && 11 === e.parentNode.nodeType ? e === r || O(R, e) ? -1 : t === r || O(R, t) ? 1 : 0 : 4 & n ? -1 : 1 : e.compareDocumentPosition ? -1 : 1;
      } : function (e, t) {
        var n,
            i = 0,
            o = e.parentNode,
            a = t.parentNode,
            u = [e],
            l = [t];if (e === t) return A = !0, 0;if (!o || !a) return e === r ? -1 : t === r ? 1 : o ? -1 : a ? 1 : 0;if (o === a) return s(e, t);for (n = e; n = n.parentNode;) {
          u.unshift(n);
        }for (n = t; n = n.parentNode;) {
          l.unshift(n);
        }for (; u[i] === l[i];) {
          i++;
        }return i ? s(u[i], l[i]) : u[i] === R ? -1 : l[i] === R ? 1 : 0;
      }, A = !1, [0, 0].sort(B), W.detectDuplicates = A, L) : L;
    }, a.matches = function (e, t) {
      return a(e, null, null, t);
    }, a.matchesSelector = function (e, t) {
      if ((e.ownerDocument || e) !== L && D(e), t = t.replace(be, "='$1']"), !(!W.matchesSelector || q || _ && _.test(t) || M.test(t))) try {
        var n = F.call(e, t);if (n || W.disconnectedMatch || e.document && 11 !== e.document.nodeType) return n;
      } catch (e) {}return a(t, L, null, [e]).length > 0;
    }, a.contains = function (e, t) {
      return (e.ownerDocument || e) !== L && D(e), O(e, t);
    }, a.attr = function (e, t) {
      var n;return (e.ownerDocument || e) !== L && D(e), q || (t = t.toLowerCase()), (n = C.attrHandle[t]) ? n(e) : q || W.attributes ? e.getAttribute(t) : ((n = e.getAttributeNode(t)) || e.getAttribute(t)) && e[t] === !0 ? t : n && n.specified ? n.value : null;
    }, a.error = function (e) {
      throw Error("Syntax error, unrecognized expression: " + e);
    }, a.uniqueSort = function (e) {
      var t,
          n = [],
          r = 1,
          i = 0;if (A = !W.detectDuplicates, e.sort(B), A) {
        for (; t = e[r]; r++) {
          t === e[r - 1] && (i = n.push(r));
        }for (; i--;) {
          e.splice(n[i], 1);
        }
      }return e;
    }, k = a.getText = function (e) {
      var t,
          n = "",
          r = 0,
          i = e.nodeType;if (i) {
        if (1 === i || 9 === i || 11 === i) {
          if ("string" == typeof e.textContent) return e.textContent;for (e = e.firstChild; e; e = e.nextSibling) {
            n += k(e);
          }
        } else if (3 === i || 4 === i) return e.nodeValue;
      } else for (; t = e[r]; r++) {
        n += k(t);
      }return n;
    }, C = a.selectors = { cacheLength: 50, createPseudo: i, match: pe, find: {}, relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } }, preFilter: { ATTR: function ATTR(e) {
          return e[1] = e[1].replace(xe, Te), e[3] = (e[4] || e[5] || "").replace(xe, Te), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4);
        }, CHILD: function CHILD(e) {
          return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || a.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && a.error(e[0]), e;
        }, PSEUDO: function PSEUDO(e) {
          var t,
              n = !e[5] && e[2];return pe.CHILD.test(e[0]) ? null : (e[4] ? e[2] = e[4] : n && ce.test(n) && (t = f(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t), e[2] = n.slice(0, t)), e.slice(0, 3));
        } }, filter: { TAG: function TAG(e) {
          return "*" === e ? function () {
            return !0;
          } : (e = e.replace(xe, Te).toLowerCase(), function (t) {
            return t.nodeName && t.nodeName.toLowerCase() === e;
          });
        }, CLASS: function CLASS(e) {
          var t = z[e + " "];return t || (t = RegExp("(^|" + ee + ")" + e + "(" + ee + "|$)")) && z(e, function (e) {
            return t.test(e.className || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(e.getAttribute) !== V && e.getAttribute("class") || "");
          });
        }, ATTR: function ATTR(e, t, n) {
          return function (r) {
            var i = a.attr(r, e);return null == i ? "!=" === t : !t || (i += "", "=" === t ? i === n : "!=" === t ? i !== n : "^=" === t ? n && 0 === i.indexOf(n) : "*=" === t ? n && i.indexOf(n) > -1 : "$=" === t ? n && i.slice(-n.length) === n : "~=" === t ? (" " + i + " ").indexOf(n) > -1 : "|=" === t && (i === n || i.slice(0, n.length + 1) === n + "-"));
          };
        }, CHILD: function CHILD(e, t, n, r, i) {
          var o = "nth" !== e.slice(0, 3),
              a = "last" !== e.slice(-4),
              s = "of-type" === t;return 1 === r && 0 === i ? function (e) {
            return !!e.parentNode;
          } : function (t, n, u) {
            var l,
                c,
                f,
                p,
                d,
                h,
                g = o !== a ? "nextSibling" : "previousSibling",
                m = t.parentNode,
                y = s && t.nodeName.toLowerCase(),
                v = !u && !s;if (m) {
              if (o) {
                for (; g;) {
                  for (f = t; f = f[g];) {
                    if (s ? f.nodeName.toLowerCase() === y : 1 === f.nodeType) return !1;
                  }h = g = "only" === e && !h && "nextSibling";
                }return !0;
              }if (h = [a ? m.firstChild : m.lastChild], a && v) {
                for (c = m[P] || (m[P] = {}), l = c[e] || [], d = l[0] === $ && l[1], p = l[0] === $ && l[2], f = d && m.childNodes[d]; f = ++d && f && f[g] || (p = d = 0) || h.pop();) {
                  if (1 === f.nodeType && ++p && f === t) {
                    c[e] = [$, d, p];break;
                  }
                }
              } else if (v && (l = (t[P] || (t[P] = {}))[e]) && l[0] === $) p = l[1];else for (; (f = ++d && f && f[g] || (p = d = 0) || h.pop()) && ((s ? f.nodeName.toLowerCase() !== y : 1 !== f.nodeType) || !++p || (v && ((f[P] || (f[P] = {}))[e] = [$, p]), f !== t));) {}return p -= i, p === r || 0 === p % r && p / r >= 0;
            }
          };
        }, PSEUDO: function PSEUDO(e, t) {
          var n,
              r = C.pseudos[e] || C.setFilters[e.toLowerCase()] || a.error("unsupported pseudo: " + e);return r[P] ? r(t) : r.length > 1 ? (n = [e, e, "", t], C.setFilters.hasOwnProperty(e.toLowerCase()) ? i(function (e, n) {
            for (var i, o = r(e, t), a = o.length; a--;) {
              i = Z.call(e, o[a]), e[i] = !(n[i] = o[a]);
            }
          }) : function (e) {
            return r(e, 0, n);
          }) : r;
        } }, pseudos: { not: i(function (e) {
          var t = [],
              n = [],
              r = S(e.replace(ae, "$1"));return r[P] ? i(function (e, t, n, i) {
            for (var o, a = r(e, null, i, []), s = e.length; s--;) {
              (o = a[s]) && (e[s] = !(t[s] = o));
            }
          }) : function (e, i, o) {
            return t[0] = e, r(t, null, o, n), !n.pop();
          };
        }), has: i(function (e) {
          return function (t) {
            return a(e, t).length > 0;
          };
        }), contains: i(function (e) {
          return function (t) {
            return (t.textContent || t.innerText || k(t)).indexOf(e) > -1;
          };
        }), lang: i(function (e) {
          return fe.test(e || "") || a.error("unsupported lang: " + e), e = e.replace(xe, Te).toLowerCase(), function (t) {
            var n;do {
              if (n = q ? t.getAttribute("xml:lang") || t.getAttribute("lang") : t.lang) return n = n.toLowerCase(), n === e || 0 === n.indexOf(e + "-");
            } while ((t = t.parentNode) && 1 === t.nodeType);return !1;
          };
        }), target: function target(t) {
          var n = e.location && e.location.hash;return n && n.slice(1) === t.id;
        }, root: function root(e) {
          return e === H;
        }, focus: function focus(e) {
          return e === L.activeElement && (!L.hasFocus || L.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
        }, enabled: function enabled(e) {
          return e.disabled === !1;
        }, disabled: function disabled(e) {
          return e.disabled === !0;
        }, checked: function checked(e) {
          var t = e.nodeName.toLowerCase();return "input" === t && !!e.checked || "option" === t && !!e.selected;
        }, selected: function selected(e) {
          return e.parentNode && e.parentNode.selectedIndex, e.selected === !0;
        }, empty: function empty(e) {
          for (e = e.firstChild; e; e = e.nextSibling) {
            if (e.nodeName > "@" || 3 === e.nodeType || 4 === e.nodeType) return !1;
          }return !0;
        }, parent: function parent(e) {
          return !C.pseudos.empty(e);
        }, header: function header(e) {
          return ye.test(e.nodeName);
        }, input: function input(e) {
          return me.test(e.nodeName);
        }, button: function button(e) {
          var t = e.nodeName.toLowerCase();return "input" === t && "button" === e.type || "button" === t;
        }, text: function text(e) {
          var t;return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || t.toLowerCase() === e.type);
        }, first: c(function () {
          return [0];
        }), last: c(function (e, t) {
          return [t - 1];
        }), eq: c(function (e, t, n) {
          return [0 > n ? n + t : n];
        }), even: c(function (e, t) {
          for (var n = 0; t > n; n += 2) {
            e.push(n);
          }return e;
        }), odd: c(function (e, t) {
          for (var n = 1; t > n; n += 2) {
            e.push(n);
          }return e;
        }), lt: c(function (e, t, n) {
          for (var r = 0 > n ? n + t : n; --r >= 0;) {
            e.push(r);
          }return e;
        }), gt: c(function (e, t, n) {
          for (var r = 0 > n ? n + t : n; t > ++r;) {
            e.push(r);
          }return e;
        }) } };for (w in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }) {
      C.pseudos[w] = u(w);
    }for (w in { submit: !0, reset: !0 }) {
      C.pseudos[w] = l(w);
    }S = a.compile = function (e, t) {
      var n,
          r = [],
          i = [],
          o = U[e + " "];if (!o) {
        for (t || (t = f(e)), n = t.length; n--;) {
          o = y(t[n]), o[P] ? r.push(o) : i.push(o);
        }o = U(e, v(i, r));
      }return o;
    }, C.pseudos.nth = C.pseudos.eq, C.filters = T.prototype = C.pseudos, C.setFilters = new T(), D(), a.attr = ue.attr, ue.find = a, ue.expr = a.selectors, ue.expr[":"] = ue.expr.pseudos, ue.unique = a.uniqueSort, ue.text = a.getText, ue.isXMLDoc = a.isXML, ue.contains = a.contains;
  }(e);var We = /Until$/,
      $e = /^(?:parents|prev(?:Until|All))/,
      Ie = /^.[^:#\[\.,]*$/,
      ze = ue.expr.match.needsContext,
      Xe = { children: !0, contents: !0, next: !0, prev: !0 };ue.fn.extend({ find: function find(e) {
      var t,
          n,
          r,
          i = this.length;if ("string" != typeof e) return r = this, this.pushStack(ue(e).filter(function () {
        for (t = 0; i > t; t++) {
          if (ue.contains(r[t], this)) return !0;
        }
      }));for (n = [], t = 0; i > t; t++) {
        ue.find(e, this[t], n);
      }return n = this.pushStack(i > 1 ? ue.unique(n) : n), n.selector = (this.selector ? this.selector + " " : "") + e, n;
    }, has: function has(e) {
      var t,
          n = ue(e, this),
          r = n.length;return this.filter(function () {
        for (t = 0; r > t; t++) {
          if (ue.contains(this, n[t])) return !0;
        }
      });
    }, not: function not(e) {
      return this.pushStack(f(this, e, !1));
    }, filter: function filter(e) {
      return this.pushStack(f(this, e, !0));
    }, is: function is(e) {
      return !!e && ("string" == typeof e ? ze.test(e) ? ue(e, this.context).index(this[0]) >= 0 : ue.filter(e, this).length > 0 : this.filter(e).length > 0);
    }, closest: function closest(e, t) {
      for (var n, r = 0, i = this.length, o = [], a = ze.test(e) || "string" != typeof e ? ue(e, t || this.context) : 0; i > r; r++) {
        for (n = this[r]; n && n.ownerDocument && n !== t && 11 !== n.nodeType;) {
          if (a ? a.index(n) > -1 : ue.find.matchesSelector(n, e)) {
            o.push(n);break;
          }n = n.parentNode;
        }
      }return this.pushStack(o.length > 1 ? ue.unique(o) : o);
    }, index: function index(e) {
      return e ? "string" == typeof e ? ue.inArray(this[0], ue(e)) : ue.inArray(e.jquery ? e[0] : e, this) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
    }, add: function add(e, t) {
      var n = "string" == typeof e ? ue(e, t) : ue.makeArray(e && e.nodeType ? [e] : e),
          r = ue.merge(this.get(), n);return this.pushStack(ue.unique(r));
    }, addBack: function addBack(e) {
      return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
    } }), ue.fn.andSelf = ue.fn.addBack, ue.each({ parent: function parent(e) {
      var t = e.parentNode;return t && 11 !== t.nodeType ? t : null;
    }, parents: function parents(e) {
      return ue.dir(e, "parentNode");
    }, parentsUntil: function parentsUntil(e, t, n) {
      return ue.dir(e, "parentNode", n);
    }, next: function next(e) {
      return c(e, "nextSibling");
    }, prev: function prev(e) {
      return c(e, "previousSibling");
    }, nextAll: function nextAll(e) {
      return ue.dir(e, "nextSibling");
    }, prevAll: function prevAll(e) {
      return ue.dir(e, "previousSibling");
    }, nextUntil: function nextUntil(e, t, n) {
      return ue.dir(e, "nextSibling", n);
    }, prevUntil: function prevUntil(e, t, n) {
      return ue.dir(e, "previousSibling", n);
    }, siblings: function siblings(e) {
      return ue.sibling((e.parentNode || {}).firstChild, e);
    }, children: function children(e) {
      return ue.sibling(e.firstChild);
    }, contents: function contents(e) {
      return ue.nodeName(e, "iframe") ? e.contentDocument || e.contentWindow.document : ue.merge([], e.childNodes);
    } }, function (e, t) {
    ue.fn[e] = function (n, r) {
      var i = ue.map(this, t, n);return We.test(e) || (r = n), r && "string" == typeof r && (i = ue.filter(r, i)), i = this.length > 1 && !Xe[e] ? ue.unique(i) : i, this.length > 1 && $e.test(e) && (i = i.reverse()), this.pushStack(i);
    };
  }), ue.extend({ filter: function filter(e, t, n) {
      return n && (e = ":not(" + e + ")"), 1 === t.length ? ue.find.matchesSelector(t[0], e) ? [t[0]] : [] : ue.find.matches(e, t);
    }, dir: function dir(e, n, r) {
      for (var i = [], o = e[n]; o && 9 !== o.nodeType && (r === t || 1 !== o.nodeType || !ue(o).is(r));) {
        1 === o.nodeType && i.push(o), o = o[n];
      }return i;
    }, sibling: function sibling(e, t) {
      for (var n = []; e; e = e.nextSibling) {
        1 === e.nodeType && e !== t && n.push(e);
      }return n;
    } });var Ue = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",
      Ve = / jQuery\d+="(?:null|\d+)"/g,
      Ye = RegExp("<(?:" + Ue + ")[\\s/>]", "i"),
      Je = /^\s+/,
      Ge = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
      Qe = /<([\w:]+)/,
      Ke = /<tbody/i,
      Ze = /<|&#?\w+;/,
      et = /<(?:script|style|link)/i,
      tt = /^(?:checkbox|radio)$/i,
      nt = /checked\s*(?:[^=]|=\s*.checked.)/i,
      rt = /^$|\/(?:java|ecma)script/i,
      it = /^true\/(.*)/,
      ot = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
      at = { option: [1, "<select multiple='multiple'>", "</select>"], legend: [1, "<fieldset>", "</fieldset>"], area: [1, "<map>", "</map>"], param: [1, "<object>", "</object>"], thead: [1, "<table>", "</table>"], tr: [2, "<table><tbody>", "</tbody></table>"], col: [2, "<table><tbody></tbody><colgroup>", "</colgroup></table>"], td: [3, "<table><tbody><tr>", "</tr></tbody></table>"], _default: ue.support.htmlSerialize ? [0, "", ""] : [1, "X<div>", "</div>"] },
      st = p(Y),
      ut = st.appendChild(Y.createElement("div"));at.optgroup = at.option, at.tbody = at.tfoot = at.colgroup = at.caption = at.thead, at.th = at.td, ue.fn.extend({ text: function text(e) {
      return ue.access(this, function (e) {
        return e === t ? ue.text(this) : this.empty().append((this[0] && this[0].ownerDocument || Y).createTextNode(e));
      }, null, e, arguments.length);
    }, wrapAll: function wrapAll(e) {
      if (ue.isFunction(e)) return this.each(function (t) {
        ue(this).wrapAll(e.call(this, t));
      });if (this[0]) {
        var t = ue(e, this[0].ownerDocument).eq(0).clone(!0);this[0].parentNode && t.insertBefore(this[0]), t.map(function () {
          for (var e = this; e.firstChild && 1 === e.firstChild.nodeType;) {
            e = e.firstChild;
          }return e;
        }).append(this);
      }return this;
    }, wrapInner: function wrapInner(e) {
      return ue.isFunction(e) ? this.each(function (t) {
        ue(this).wrapInner(e.call(this, t));
      }) : this.each(function () {
        var t = ue(this),
            n = t.contents();n.length ? n.wrapAll(e) : t.append(e);
      });
    }, wrap: function wrap(e) {
      var t = ue.isFunction(e);return this.each(function (n) {
        ue(this).wrapAll(t ? e.call(this, n) : e);
      });
    }, unwrap: function unwrap() {
      return this.parent().each(function () {
        ue.nodeName(this, "body") || ue(this).replaceWith(this.childNodes);
      }).end();
    }, append: function append() {
      return this.domManip(arguments, !0, function (e) {
        (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) && this.appendChild(e);
      });
    }, prepend: function prepend() {
      return this.domManip(arguments, !0, function (e) {
        (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) && this.insertBefore(e, this.firstChild);
      });
    }, before: function before() {
      return this.domManip(arguments, !1, function (e) {
        this.parentNode && this.parentNode.insertBefore(e, this);
      });
    }, after: function after() {
      return this.domManip(arguments, !1, function (e) {
        this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
      });
    }, remove: function remove(e, t) {
      for (var n, r = 0; null != (n = this[r]); r++) {
        (!e || ue.filter(e, [n]).length > 0) && (t || 1 !== n.nodeType || ue.cleanData(b(n)), n.parentNode && (t && ue.contains(n.ownerDocument, n) && m(b(n, "script")), n.parentNode.removeChild(n)));
      }return this;
    }, empty: function empty() {
      for (var e, t = 0; null != (e = this[t]); t++) {
        for (1 === e.nodeType && ue.cleanData(b(e, !1)); e.firstChild;) {
          e.removeChild(e.firstChild);
        }e.options && ue.nodeName(e, "select") && (e.options.length = 0);
      }return this;
    }, clone: function clone(e, t) {
      return e = null != e && e, t = null == t ? e : t, this.map(function () {
        return ue.clone(this, e, t);
      });
    }, html: function html(e) {
      return ue.access(this, function (e) {
        var n = this[0] || {},
            r = 0,
            i = this.length;if (e === t) return 1 === n.nodeType ? n.innerHTML.replace(Ve, "") : t;if (!("string" != typeof e || et.test(e) || !ue.support.htmlSerialize && Ye.test(e) || !ue.support.leadingWhitespace && Je.test(e) || at[(Qe.exec(e) || ["", ""])[1].toLowerCase()])) {
          e = e.replace(Ge, "<$1></$2>");try {
            for (; i > r; r++) {
              n = this[r] || {}, 1 === n.nodeType && (ue.cleanData(b(n, !1)), n.innerHTML = e);
            }n = 0;
          } catch (e) {}
        }n && this.empty().append(e);
      }, null, e, arguments.length);
    }, replaceWith: function replaceWith(e) {
      var t = ue.isFunction(e);return t || "string" == typeof e || (e = ue(e).not(this).detach()), this.domManip([e], !0, function (e) {
        var t = this.nextSibling,
            n = this.parentNode;n && (ue(this).remove(), n.insertBefore(e, t));
      });
    }, detach: function detach(e) {
      return this.remove(e, !0);
    }, domManip: function domManip(e, n, r) {
      e = te.apply([], e);var i,
          o,
          a,
          s,
          u,
          l,
          c = 0,
          f = this.length,
          p = this,
          m = f - 1,
          y = e[0],
          v = ue.isFunction(y);if (v || !(1 >= f || "string" != typeof y || ue.support.checkClone) && nt.test(y)) return this.each(function (i) {
        var o = p.eq(i);v && (e[0] = y.call(this, i, n ? o.html() : t)), o.domManip(e, n, r);
      });if (f && (l = ue.buildFragment(e, this[0].ownerDocument, !1, this), i = l.firstChild, 1 === l.childNodes.length && (l = i), i)) {
        for (n = n && ue.nodeName(i, "tr"), s = ue.map(b(l, "script"), h), a = s.length; f > c; c++) {
          o = l, c !== m && (o = ue.clone(o, !0, !0), a && ue.merge(s, b(o, "script"))), r.call(n && ue.nodeName(this[c], "table") ? d(this[c], "tbody") : this[c], o, c);
        }if (a) for (u = s[s.length - 1].ownerDocument, ue.map(s, g), c = 0; a > c; c++) {
          o = s[c], rt.test(o.type || "") && !ue._data(o, "globalEval") && ue.contains(u, o) && (o.src ? ue.ajax({ url: o.src, type: "GET", dataType: "script", async: !1, global: !1, throws: !0 }) : ue.globalEval((o.text || o.textContent || o.innerHTML || "").replace(ot, "")));
        }l = i = null;
      }return this;
    } }), ue.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function (e, t) {
    ue.fn[e] = function (e) {
      for (var n, r = 0, i = [], o = ue(e), a = o.length - 1; a >= r; r++) {
        n = r === a ? this : this.clone(!0), ue(o[r])[t](n), ne.apply(i, n.get());
      }return this.pushStack(i);
    };
  }), ue.extend({ clone: function clone(e, t, n) {
      var r,
          i,
          o,
          a,
          s,
          u = ue.contains(e.ownerDocument, e);if (ue.support.html5Clone || ue.isXMLDoc(e) || !Ye.test("<" + e.nodeName + ">") ? o = e.cloneNode(!0) : (ut.innerHTML = e.outerHTML, ut.removeChild(o = ut.firstChild)), !(ue.support.noCloneEvent && ue.support.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || ue.isXMLDoc(e))) for (r = b(o), s = b(e), a = 0; null != (i = s[a]); ++a) {
        r[a] && v(i, r[a]);
      }if (t) if (n) for (s = s || b(e), r = r || b(o), a = 0; null != (i = s[a]); a++) {
        y(i, r[a]);
      } else y(e, o);return r = b(o, "script"), r.length > 0 && m(r, !u && b(e, "script")), r = s = i = null, o;
    }, buildFragment: function buildFragment(e, t, n, r) {
      for (var i, o, a, s, u, l, c, f = e.length, d = p(t), h = [], g = 0; f > g; g++) {
        if (o = e[g], o || 0 === o) if ("object" === ue.type(o)) ue.merge(h, o.nodeType ? [o] : o);else if (Ze.test(o)) {
          for (s = s || d.appendChild(t.createElement("div")), u = (Qe.exec(o) || ["", ""])[1].toLowerCase(), c = at[u] || at._default, s.innerHTML = c[1] + o.replace(Ge, "<$1></$2>") + c[2], i = c[0]; i--;) {
            s = s.lastChild;
          }if (!ue.support.leadingWhitespace && Je.test(o) && h.push(t.createTextNode(Je.exec(o)[0])), !ue.support.tbody) for (o = "table" !== u || Ke.test(o) ? "<table>" !== c[1] || Ke.test(o) ? 0 : s : s.firstChild, i = o && o.childNodes.length; i--;) {
            ue.nodeName(l = o.childNodes[i], "tbody") && !l.childNodes.length && o.removeChild(l);
          }for (ue.merge(h, s.childNodes), s.textContent = ""; s.firstChild;) {
            s.removeChild(s.firstChild);
          }s = d.lastChild;
        } else h.push(t.createTextNode(o));
      }for (s && d.removeChild(s), ue.support.appendChecked || ue.grep(b(h, "input"), x), g = 0; o = h[g++];) {
        if ((!r || -1 === ue.inArray(o, r)) && (a = ue.contains(o.ownerDocument, o), s = b(d.appendChild(o), "script"), a && m(s), n)) for (i = 0; o = s[i++];) {
          rt.test(o.type || "") && n.push(o);
        }
      }return s = null, d;
    }, cleanData: function cleanData(e, t) {
      for (var n, r, i, o, a = 0, s = ue.expando, u = ue.cache, l = ue.support.deleteExpando, c = ue.event.special; null != (n = e[a]); a++) {
        if ((t || ue.acceptData(n)) && (i = n[s], o = i && u[i])) {
          if (o.events) for (r in o.events) {
            c[r] ? ue.event.remove(n, r) : ue.removeEvent(n, r, o.handle);
          }u[i] && (delete u[i], l ? delete n[s] : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(n.removeAttribute) !== V ? n.removeAttribute(s) : n[s] = null, Z.push(i));
        }
      }
    } });var lt,
      ct,
      ft,
      pt = /alpha\([^)]*\)/i,
      dt = /opacity\s*=\s*([^)]*)/,
      ht = /^(top|right|bottom|left)$/,
      gt = /^(none|table(?!-c[ea]).+)/,
      mt = /^margin/,
      yt = RegExp("^(" + le + ")(.*)$", "i"),
      vt = RegExp("^(" + le + ")(?!px)[a-z%]+$", "i"),
      bt = RegExp("^([+-])=(" + le + ")", "i"),
      xt = { BODY: "block" },
      Tt = { position: "absolute", visibility: "hidden", display: "block" },
      wt = { letterSpacing: 0, fontWeight: 400 },
      Nt = ["Top", "Right", "Bottom", "Left"],
      Ct = ["Webkit", "O", "Moz", "ms"];ue.fn.extend({ css: function css(e, n) {
      return ue.access(this, function (e, n, r) {
        var i,
            o,
            a = {},
            s = 0;if (ue.isArray(n)) {
          for (o = ct(e), i = n.length; i > s; s++) {
            a[n[s]] = ue.css(e, n[s], !1, o);
          }return a;
        }return r !== t ? ue.style(e, n, r) : ue.css(e, n);
      }, e, n, arguments.length > 1);
    }, show: function show() {
      return N(this, !0);
    }, hide: function hide() {
      return N(this);
    }, toggle: function toggle(e) {
      var t = "boolean" == typeof e;return this.each(function () {
        (t ? e : w(this)) ? ue(this).show() : ue(this).hide();
      });
    } }), ue.extend({ cssHooks: { opacity: { get: function get(e, t) {
          if (t) {
            var n = ft(e, "opacity");return "" === n ? "1" : n;
          }
        } } }, cssNumber: { columnCount: !0, fillOpacity: !0, fontWeight: !0, lineHeight: !0, opacity: !0, orphans: !0, widows: !0, zIndex: !0, zoom: !0 }, cssProps: { float: ue.support.cssFloat ? "cssFloat" : "styleFloat" }, style: function style(e, n, r, i) {
      if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
        var o,
            a,
            s,
            u = ue.camelCase(n),
            l = e.style;if (n = ue.cssProps[u] || (ue.cssProps[u] = T(l, u)), s = ue.cssHooks[n] || ue.cssHooks[u], r === t) return s && "get" in s && (o = s.get(e, !1, i)) !== t ? o : l[n];if (a = typeof r === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(r), "string" === a && (o = bt.exec(r)) && (r = (o[1] + 1) * o[2] + parseFloat(ue.css(e, n)), a = "number"), !(null == r || "number" === a && isNaN(r) || ("number" !== a || ue.cssNumber[u] || (r += "px"), ue.support.clearCloneStyle || "" !== r || 0 !== n.indexOf("background") || (l[n] = "inherit"), s && "set" in s && (r = s.set(e, r, i)) === t))) try {
          l[n] = r;
        } catch (e) {}
      }
    }, css: function css(e, n, r, i) {
      var o,
          a,
          s,
          u = ue.camelCase(n);return n = ue.cssProps[u] || (ue.cssProps[u] = T(e.style, u)), s = ue.cssHooks[n] || ue.cssHooks[u], s && "get" in s && (a = s.get(e, !0, r)), a === t && (a = ft(e, n, i)), "normal" === a && n in wt && (a = wt[n]), "" === r || r ? (o = parseFloat(a), r === !0 || ue.isNumeric(o) ? o || 0 : a) : a;
    }, swap: function swap(e, t, n, r) {
      var i,
          o,
          a = {};for (o in t) {
        a[o] = e.style[o], e.style[o] = t[o];
      }i = n.apply(e, r || []);for (o in t) {
        e.style[o] = a[o];
      }return i;
    } }), e.getComputedStyle ? (ct = function ct(t) {
    return e.getComputedStyle(t, null);
  }, ft = function ft(e, n, r) {
    var i,
        o,
        a,
        s = r || ct(e),
        u = s ? s.getPropertyValue(n) || s[n] : t,
        l = e.style;return s && ("" !== u || ue.contains(e.ownerDocument, e) || (u = ue.style(e, n)), vt.test(u) && mt.test(n) && (i = l.width, o = l.minWidth, a = l.maxWidth, l.minWidth = l.maxWidth = l.width = u, u = s.width, l.width = i, l.minWidth = o, l.maxWidth = a)), u;
  }) : Y.documentElement.currentStyle && (ct = function ct(e) {
    return e.currentStyle;
  }, ft = function ft(e, n, r) {
    var i,
        o,
        a,
        s = r || ct(e),
        u = s ? s[n] : t,
        l = e.style;return null == u && l && l[n] && (u = l[n]), vt.test(u) && !ht.test(n) && (i = l.left, o = e.runtimeStyle, a = o && o.left, a && (o.left = e.currentStyle.left), l.left = "fontSize" === n ? "1em" : u, u = l.pixelLeft + "px", l.left = i, a && (o.left = a)), "" === u ? "auto" : u;
  }), ue.each(["height", "width"], function (e, n) {
    ue.cssHooks[n] = { get: function get(e, r, i) {
        return r ? 0 === e.offsetWidth && gt.test(ue.css(e, "display")) ? ue.swap(e, Tt, function () {
          return E(e, n, i);
        }) : E(e, n, i) : t;
      }, set: function set(e, t, r) {
        var i = r && ct(e);return C(e, t, r ? k(e, n, r, ue.support.boxSizing && "border-box" === ue.css(e, "boxSizing", !1, i), i) : 0);
      } };
  }), ue.support.opacity || (ue.cssHooks.opacity = { get: function get(e, t) {
      return dt.test((t && e.currentStyle ? e.currentStyle.filter : e.style.filter) || "") ? .01 * parseFloat(RegExp.$1) + "" : t ? "1" : "";
    }, set: function set(e, t) {
      var n = e.style,
          r = e.currentStyle,
          i = ue.isNumeric(t) ? "alpha(opacity=" + 100 * t + ")" : "",
          o = r && r.filter || n.filter || "";n.zoom = 1, (t >= 1 || "" === t) && "" === ue.trim(o.replace(pt, "")) && n.removeAttribute && (n.removeAttribute("filter"), "" === t || r && !r.filter) || (n.filter = pt.test(o) ? o.replace(pt, i) : o + " " + i);
    } }), ue(function () {
    ue.support.reliableMarginRight || (ue.cssHooks.marginRight = { get: function get(e, n) {
        return n ? ue.swap(e, { display: "inline-block" }, ft, [e, "marginRight"]) : t;
      } }), !ue.support.pixelPosition && ue.fn.position && ue.each(["top", "left"], function (e, n) {
      ue.cssHooks[n] = { get: function get(e, r) {
          return r ? (r = ft(e, n), vt.test(r) ? ue(e).position()[n] + "px" : r) : t;
        } };
    });
  }), ue.expr && ue.expr.filters && (ue.expr.filters.hidden = function (e) {
    return 0 >= e.offsetWidth && 0 >= e.offsetHeight || !ue.support.reliableHiddenOffsets && "none" === (e.style && e.style.display || ue.css(e, "display"));
  }, ue.expr.filters.visible = function (e) {
    return !ue.expr.filters.hidden(e);
  }), ue.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
    ue.cssHooks[e + t] = { expand: function expand(n) {
        for (var r = 0, i = {}, o = "string" == typeof n ? n.split(" ") : [n]; 4 > r; r++) {
          i[e + Nt[r] + t] = o[r] || o[r - 2] || o[0];
        }return i;
      } }, mt.test(e) || (ue.cssHooks[e + t].set = C);
  });var kt = /%20/g,
      Et = /\[\]$/,
      St = /\r?\n/g,
      At = /^(?:submit|button|image|reset|file)$/i,
      jt = /^(?:input|select|textarea|keygen)/i;ue.fn.extend({ serialize: function serialize() {
      return ue.param(this.serializeArray());
    }, serializeArray: function serializeArray() {
      return this.map(function () {
        var e = ue.prop(this, "elements");return e ? ue.makeArray(e) : this;
      }).filter(function () {
        var e = this.type;return this.name && !ue(this).is(":disabled") && jt.test(this.nodeName) && !At.test(e) && (this.checked || !tt.test(e));
      }).map(function (e, t) {
        var n = ue(this).val();return null == n ? null : ue.isArray(n) ? ue.map(n, function (e) {
          return { name: t.name, value: e.replace(St, "\r\n") };
        }) : { name: t.name, value: n.replace(St, "\r\n") };
      }).get();
    } }), ue.param = function (e, n) {
    var r,
        i = [],
        o = function o(e, t) {
      t = ue.isFunction(t) ? t() : null == t ? "" : t, i[i.length] = encodeURIComponent(e) + "=" + encodeURIComponent(t);
    };if (n === t && (n = ue.ajaxSettings && ue.ajaxSettings.traditional), ue.isArray(e) || e.jquery && !ue.isPlainObject(e)) ue.each(e, function () {
      o(this.name, this.value);
    });else for (r in e) {
      j(r, e[r], n, o);
    }return i.join("&").replace(kt, "+");
  }, ue.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function (e, t) {
    ue.fn[t] = function (e, n) {
      return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t);
    };
  }), ue.fn.hover = function (e, t) {
    return this.mouseenter(e).mouseleave(t || e);
  };var Dt,
      Lt,
      Ht = ue.now(),
      qt = /\?/,
      Mt = /#.*$/,
      _t = /([?&])_=[^&]*/,
      Ft = /^(.*?):[ \t]*([^\r\n]*)\r?$/gm,
      Ot = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
      Bt = /^(?:GET|HEAD)$/,
      Pt = /^\/\//,
      Rt = /^([\w.+-]+:)(?:\/\/([^\/?#:]*)(?::(\d+)|)|)/,
      Wt = ue.fn.load,
      $t = {},
      It = {},
      zt = "*/".concat("*");try {
    Lt = J.href;
  } catch (e) {
    Lt = Y.createElement("a"), Lt.href = "", Lt = Lt.href;
  }Dt = Rt.exec(Lt.toLowerCase()) || [], ue.fn.load = function (e, n, r) {
    if ("string" != typeof e && Wt) return Wt.apply(this, arguments);var i,
        o,
        a,
        s = this,
        u = e.indexOf(" ");return u >= 0 && (i = e.slice(u, e.length), e = e.slice(0, u)), ue.isFunction(n) ? (r = n, n = t) : n && "object" == (typeof n === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(n)) && (a = "POST"), s.length > 0 && ue.ajax({ url: e, type: a, dataType: "html", data: n }).done(function (e) {
      o = arguments, s.html(i ? ue("<div>").append(ue.parseHTML(e)).find(i) : e);
    }).complete(r && function (e, t) {
      s.each(r, o || [e.responseText, t, e]);
    }), this;
  }, ue.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
    ue.fn[t] = function (e) {
      return this.on(t, e);
    };
  }), ue.each(["get", "post"], function (e, n) {
    ue[n] = function (e, r, i, o) {
      return ue.isFunction(r) && (o = o || i, i = r, r = t), ue.ajax({ url: e, type: n, dataType: o, data: r, success: i });
    };
  }), ue.extend({ active: 0, lastModified: {}, etag: {}, ajaxSettings: { url: Lt, type: "GET", isLocal: Ot.test(Dt[1]), global: !0, processData: !0, async: !0, contentType: "application/x-www-form-urlencoded; charset=UTF-8", accepts: { "*": zt, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" }, contents: { xml: /xml/, html: /html/, json: /json/ }, responseFields: { xml: "responseXML", text: "responseText" }, converters: { "* text": e.String, "text html": !0, "text json": ue.parseJSON, "text xml": ue.parseXML }, flatOptions: { url: !0, context: !0 } }, ajaxSetup: function ajaxSetup(e, t) {
      return t ? H(H(e, ue.ajaxSettings), t) : H(ue.ajaxSettings, e);
    }, ajaxPrefilter: D($t), ajaxTransport: D(It), ajax: function ajax(e, n) {
      function r(e, n, r, i) {
        var o,
            f,
            v,
            b,
            T,
            N = n;2 !== x && (x = 2, u && clearTimeout(u), c = t, s = i || "", w.readyState = e > 0 ? 4 : 0, r && (b = q(p, w, r)), e >= 200 && 300 > e || 304 === e ? (p.ifModified && (T = w.getResponseHeader("Last-Modified"), T && (ue.lastModified[a] = T), T = w.getResponseHeader("etag"), T && (ue.etag[a] = T)), 204 === e ? (o = !0, N = "nocontent") : 304 === e ? (o = !0, N = "notmodified") : (o = M(p, b), N = o.state, f = o.data, v = o.error, o = !v)) : (v = N, (e || !N) && (N = "error", 0 > e && (e = 0))), w.status = e, w.statusText = (n || N) + "", o ? g.resolveWith(d, [f, N, w]) : g.rejectWith(d, [w, N, v]), w.statusCode(y), y = t, l && h.trigger(o ? "ajaxSuccess" : "ajaxError", [w, p, o ? f : v]), m.fireWith(d, [w, N]), l && (h.trigger("ajaxComplete", [w, p]), --ue.active || ue.event.trigger("ajaxStop")));
      }"object" == (typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(e)) && (n = e, e = t), n = n || {};var i,
          o,
          a,
          s,
          u,
          l,
          c,
          f,
          p = ue.ajaxSetup({}, n),
          d = p.context || p,
          h = p.context && (d.nodeType || d.jquery) ? ue(d) : ue.event,
          g = ue.Deferred(),
          m = ue.Callbacks("once memory"),
          y = p.statusCode || {},
          v = {},
          b = {},
          x = 0,
          T = "canceled",
          w = { readyState: 0, getResponseHeader: function getResponseHeader(e) {
          var t;if (2 === x) {
            if (!f) for (f = {}; t = Ft.exec(s);) {
              f[t[1].toLowerCase()] = t[2];
            }t = f[e.toLowerCase()];
          }return null == t ? null : t;
        }, getAllResponseHeaders: function getAllResponseHeaders() {
          return 2 === x ? s : null;
        }, setRequestHeader: function setRequestHeader(e, t) {
          var n = e.toLowerCase();return x || (e = b[n] = b[n] || e, v[e] = t), this;
        }, overrideMimeType: function overrideMimeType(e) {
          return x || (p.mimeType = e), this;
        }, statusCode: function statusCode(e) {
          var t;if (e) if (2 > x) for (t in e) {
            y[t] = [y[t], e[t]];
          } else w.always(e[w.status]);return this;
        }, abort: function abort(e) {
          var t = e || T;return c && c.abort(t), r(0, t), this;
        } };if (g.promise(w).complete = m.add, w.success = w.done, w.error = w.fail, p.url = ((e || p.url || Lt) + "").replace(Mt, "").replace(Pt, Dt[1] + "//"), p.type = n.method || n.type || p.method || p.type, p.dataTypes = ue.trim(p.dataType || "*").toLowerCase().match(ce) || [""], null == p.crossDomain && (i = Rt.exec(p.url.toLowerCase()), p.crossDomain = !(!i || i[1] === Dt[1] && i[2] === Dt[2] && (i[3] || ("http:" === i[1] ? 80 : 443)) == (Dt[3] || ("http:" === Dt[1] ? 80 : 443)))), p.data && p.processData && "string" != typeof p.data && (p.data = ue.param(p.data, p.traditional)), L($t, p, n, w), 2 === x) return w;l = p.global, l && 0 === ue.active++ && ue.event.trigger("ajaxStart"), p.type = p.type.toUpperCase(), p.hasContent = !Bt.test(p.type), a = p.url, p.hasContent || (p.data && (a = p.url += (qt.test(a) ? "&" : "?") + p.data, delete p.data), p.cache === !1 && (p.url = _t.test(a) ? a.replace(_t, "$1_=" + Ht++) : a + (qt.test(a) ? "&" : "?") + "_=" + Ht++)), p.ifModified && (ue.lastModified[a] && w.setRequestHeader("If-Modified-Since", ue.lastModified[a]), ue.etag[a] && w.setRequestHeader("If-None-Match", ue.etag[a])), (p.data && p.hasContent && p.contentType !== !1 || n.contentType) && w.setRequestHeader("Content-Type", p.contentType), w.setRequestHeader("Accept", p.dataTypes[0] && p.accepts[p.dataTypes[0]] ? p.accepts[p.dataTypes[0]] + ("*" !== p.dataTypes[0] ? ", " + zt + "; q=0.01" : "") : p.accepts["*"]);for (o in p.headers) {
        w.setRequestHeader(o, p.headers[o]);
      }if (p.beforeSend && (p.beforeSend.call(d, w, p) === !1 || 2 === x)) return w.abort();T = "abort";for (o in { success: 1, error: 1, complete: 1 }) {
        w[o](p[o]);
      }if (c = L(It, p, n, w)) {
        w.readyState = 1, l && h.trigger("ajaxSend", [w, p]), p.async && p.timeout > 0 && (u = setTimeout(function () {
          w.abort("timeout");
        }, p.timeout));try {
          x = 1, c.send(v, r);
        } catch (e) {
          if (!(2 > x)) throw e;r(-1, e);
        }
      } else r(-1, "No Transport");return w;
    }, getScript: function getScript(e, n) {
      return ue.get(e, t, n, "script");
    }, getJSON: function getJSON(e, t, n) {
      return ue.get(e, t, n, "json");
    } }), ue.ajaxSetup({ accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" }, contents: { script: /(?:java|ecma)script/ }, converters: { "text script": function textScript(e) {
        return ue.globalEval(e), e;
      } } }), ue.ajaxPrefilter("script", function (e) {
    e.cache === t && (e.cache = !1), e.crossDomain && (e.type = "GET", e.global = !1);
  }), ue.ajaxTransport("script", function (e) {
    if (e.crossDomain) {
      var n,
          r = Y.head || ue("head")[0] || Y.documentElement;return { send: function send(t, i) {
          n = Y.createElement("script"), n.async = !0, e.scriptCharset && (n.charset = e.scriptCharset), n.src = e.url, n.onload = n.onreadystatechange = function (e, t) {
            (t || !n.readyState || /loaded|complete/.test(n.readyState)) && (n.onload = n.onreadystatechange = null, n.parentNode && n.parentNode.removeChild(n), n = null, t || i(200, "success"));
          }, r.insertBefore(n, r.firstChild);
        }, abort: function abort() {
          n && n.onload(t, !0);
        } };
    }
  });var Xt = [],
      Ut = /(=)\?(?=&|$)|\?\?/;ue.ajaxSetup({ jsonp: "callback", jsonpCallback: function jsonpCallback() {
      var e = Xt.pop() || ue.expando + "_" + Ht++;return this[e] = !0, e;
    } }), ue.ajaxPrefilter("json jsonp", function (n, r, i) {
    var o,
        a,
        s,
        u = n.jsonp !== !1 && (Ut.test(n.url) ? "url" : "string" == typeof n.data && !(n.contentType || "").indexOf("application/x-www-form-urlencoded") && Ut.test(n.data) && "data");return u || "jsonp" === n.dataTypes[0] ? (o = n.jsonpCallback = ue.isFunction(n.jsonpCallback) ? n.jsonpCallback() : n.jsonpCallback, u ? n[u] = n[u].replace(Ut, "$1" + o) : n.jsonp !== !1 && (n.url += (qt.test(n.url) ? "&" : "?") + n.jsonp + "=" + o), n.converters["script json"] = function () {
      return s || ue.error(o + " was not called"), s[0];
    }, n.dataTypes[0] = "json", a = e[o], e[o] = function () {
      s = arguments;
    }, i.always(function () {
      e[o] = a, n[o] && (n.jsonpCallback = r.jsonpCallback, Xt.push(o)), s && ue.isFunction(a) && a(s[0]), s = a = t;
    }), "script") : t;
  });var Vt,
      Yt,
      Jt = 0,
      Gt = e.ActiveXObject && function () {
    var e;for (e in Vt) {
      Vt[e](t, !0);
    }
  };ue.ajaxSettings.xhr = e.ActiveXObject ? function () {
    return !this.isLocal && _() || F();
  } : _, Yt = ue.ajaxSettings.xhr(), ue.support.cors = !!Yt && "withCredentials" in Yt, Yt = ue.support.ajax = !!Yt, Yt && ue.ajaxTransport(function (n) {
    if (!n.crossDomain || ue.support.cors) {
      var _r;return { send: function send(i, o) {
          var a,
              s,
              u = n.xhr();if (n.username ? u.open(n.type, n.url, n.async, n.username, n.password) : u.open(n.type, n.url, n.async), n.xhrFields) for (s in n.xhrFields) {
            u[s] = n.xhrFields[s];
          }n.mimeType && u.overrideMimeType && u.overrideMimeType(n.mimeType), n.crossDomain || i["X-Requested-With"] || (i["X-Requested-With"] = "XMLHttpRequest");try {
            for (s in i) {
              u.setRequestHeader(s, i[s]);
            }
          } catch (e) {}u.send(n.hasContent && n.data || null), _r = function r(e, i) {
            var s, l, c, f;try {
              if (_r && (i || 4 === u.readyState)) if (_r = t, a && (u.onreadystatechange = ue.noop, Gt && delete Vt[a]), i) 4 !== u.readyState && u.abort();else {
                f = {}, s = u.status, l = u.getAllResponseHeaders(), "string" == typeof u.responseText && (f.text = u.responseText);try {
                  c = u.statusText;
                } catch (e) {
                  c = "";
                }s || !n.isLocal || n.crossDomain ? 1223 === s && (s = 204) : s = f.text ? 200 : 404;
              }
            } catch (e) {
              i || o(-1, e);
            }f && o(s, c, f, l);
          }, n.async ? 4 === u.readyState ? setTimeout(_r) : (a = ++Jt, Gt && (Vt || (Vt = {}, ue(e).unload(Gt)), Vt[a] = _r), u.onreadystatechange = _r) : _r();
        }, abort: function abort() {
          _r && _r(t, !0);
        } };
    }
  });var Qt,
      Kt,
      Zt = /^(?:toggle|show|hide)$/,
      en = RegExp("^(?:([+-])=|)(" + le + ")([a-z%]*)$", "i"),
      tn = /queueHooks$/,
      nn = [W],
      rn = { "*": [function (e, t) {
      var n,
          r,
          i = this.createTween(e, t),
          o = en.exec(t),
          a = i.cur(),
          s = +a || 0,
          u = 1,
          l = 20;if (o) {
        if (n = +o[2], r = o[3] || (ue.cssNumber[e] ? "" : "px"), "px" !== r && s) {
          s = ue.css(i.elem, e, !0) || n || 1;do {
            u = u || ".5", s /= u, ue.style(i.elem, e, s + r);
          } while (u !== (u = i.cur() / a) && 1 !== u && --l);
        }i.unit = r, i.start = s, i.end = o[1] ? s + (o[1] + 1) * n : n;
      }return i;
    }] };ue.Animation = ue.extend(P, { tweener: function tweener(e, t) {
      ue.isFunction(e) ? (t = e, e = ["*"]) : e = e.split(" ");for (var n, r = 0, i = e.length; i > r; r++) {
        n = e[r], rn[n] = rn[n] || [], rn[n].unshift(t);
      }
    }, prefilter: function prefilter(e, t) {
      t ? nn.unshift(e) : nn.push(e);
    } }), ue.Tween = $, $.prototype = { constructor: $, init: function init(e, t, n, r, i, o) {
      this.elem = e, this.prop = n, this.easing = i || "swing", this.options = t, this.start = this.now = this.cur(), this.end = r, this.unit = o || (ue.cssNumber[n] ? "" : "px");
    }, cur: function cur() {
      var e = $.propHooks[this.prop];return e && e.get ? e.get(this) : $.propHooks._default.get(this);
    }, run: function run(e) {
      var t,
          n = $.propHooks[this.prop];return this.pos = t = this.options.duration ? ue.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : $.propHooks._default.set(this), this;
    } }, $.prototype.init.prototype = $.prototype, $.propHooks = { _default: { get: function get(e) {
        var t;return null == e.elem[e.prop] || e.elem.style && null != e.elem.style[e.prop] ? (t = ue.css(e.elem, e.prop, ""), t && "auto" !== t ? t : 0) : e.elem[e.prop];
      }, set: function set(e) {
        ue.fx.step[e.prop] ? ue.fx.step[e.prop](e) : e.elem.style && (null != e.elem.style[ue.cssProps[e.prop]] || ue.cssHooks[e.prop]) ? ue.style(e.elem, e.prop, e.now + e.unit) : e.elem[e.prop] = e.now;
      } } }, $.propHooks.scrollTop = $.propHooks.scrollLeft = { set: function set(e) {
      e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
    } }, ue.each(["toggle", "show", "hide"], function (e, t) {
    var n = ue.fn[t];ue.fn[t] = function (e, r, i) {
      return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(I(t, !0), e, r, i);
    };
  }), ue.fn.extend({ fadeTo: function fadeTo(e, t, n, r) {
      return this.filter(w).css("opacity", 0).show().end().animate({ opacity: t }, e, n, r);
    }, animate: function animate(e, t, n, r) {
      var i = ue.isEmptyObject(e),
          o = ue.speed(t, n, r),
          a = function a() {
        var t = P(this, ue.extend({}, e), o);a.finish = function () {
          t.stop(!0);
        }, (i || ue._data(this, "finish")) && t.stop(!0);
      };return a.finish = a, i || o.queue === !1 ? this.each(a) : this.queue(o.queue, a);
    }, stop: function stop(e, n, r) {
      var i = function i(e) {
        var t = e.stop;delete e.stop, t(r);
      };return "string" != typeof e && (r = n, n = e, e = t), n && e !== !1 && this.queue(e || "fx", []), this.each(function () {
        var t = !0,
            n = null != e && e + "queueHooks",
            o = ue.timers,
            a = ue._data(this);if (n) a[n] && a[n].stop && i(a[n]);else for (n in a) {
          a[n] && a[n].stop && tn.test(n) && i(a[n]);
        }for (n = o.length; n--;) {
          o[n].elem !== this || null != e && o[n].queue !== e || (o[n].anim.stop(r), t = !1, o.splice(n, 1));
        }(t || !r) && ue.dequeue(this, e);
      });
    }, finish: function finish(e) {
      return e !== !1 && (e = e || "fx"), this.each(function () {
        var t,
            n = ue._data(this),
            r = n[e + "queue"],
            i = n[e + "queueHooks"],
            o = ue.timers,
            a = r ? r.length : 0;for (n.finish = !0, ue.queue(this, e, []), i && i.cur && i.cur.finish && i.cur.finish.call(this), t = o.length; t--;) {
          o[t].elem === this && o[t].queue === e && (o[t].anim.stop(!0), o.splice(t, 1));
        }for (t = 0; a > t; t++) {
          r[t] && r[t].finish && r[t].finish.call(this);
        }delete n.finish;
      });
    } }), ue.each({ slideDown: I("show"), slideUp: I("hide"), slideToggle: I("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function (e, t) {
    ue.fn[e] = function (e, n, r) {
      return this.animate(t, e, n, r);
    };
  }), ue.speed = function (e, t, n) {
    var r = e && "object" == (typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(e)) ? ue.extend({}, e) : { complete: n || !n && t || ue.isFunction(e) && e, duration: e, easing: n && t || t && !ue.isFunction(t) && t };return r.duration = ue.fx.off ? 0 : "number" == typeof r.duration ? r.duration : r.duration in ue.fx.speeds ? ue.fx.speeds[r.duration] : ue.fx.speeds._default, (null == r.queue || r.queue === !0) && (r.queue = "fx"), r.old = r.complete, r.complete = function () {
      ue.isFunction(r.old) && r.old.call(this), r.queue && ue.dequeue(this, r.queue);
    }, r;
  }, ue.easing = { linear: function linear(e) {
      return e;
    }, swing: function swing(e) {
      return .5 - Math.cos(e * Math.PI) / 2;
    } }, ue.timers = [], ue.fx = $.prototype.init, ue.fx.tick = function () {
    var e,
        n = ue.timers,
        r = 0;for (Qt = ue.now(); n.length > r; r++) {
      e = n[r], e() || n[r] !== e || n.splice(r--, 1);
    }n.length || ue.fx.stop(), Qt = t;
  }, ue.fx.timer = function (e) {
    e() && ue.timers.push(e) && ue.fx.start();
  }, ue.fx.interval = 13, ue.fx.start = function () {
    Kt || (Kt = setInterval(ue.fx.tick, ue.fx.interval));
  }, ue.fx.stop = function () {
    clearInterval(Kt), Kt = null;
  }, ue.fx.speeds = { slow: 600, fast: 200, _default: 400 }, ue.fx.step = {}, ue.expr && ue.expr.filters && (ue.expr.filters.animated = function (e) {
    return ue.grep(ue.timers, function (t) {
      return e === t.elem;
    }).length;
  }), ue.fn.offset = function (e) {
    if (arguments.length) return e === t ? this : this.each(function (t) {
      ue.offset.setOffset(this, e, t);
    });var n,
        r,
        i = { top: 0, left: 0 },
        o = this[0],
        a = o && o.ownerDocument;return a ? (n = a.documentElement, ue.contains(n, o) ? (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(o.getBoundingClientRect) !== V && (i = o.getBoundingClientRect()), r = z(a), { top: i.top + (r.pageYOffset || n.scrollTop) - (n.clientTop || 0), left: i.left + (r.pageXOffset || n.scrollLeft) - (n.clientLeft || 0) }) : i) : void 0;
  }, ue.offset = { setOffset: function setOffset(e, t, n) {
      var r = ue.css(e, "position");"static" === r && (e.style.position = "relative");var i,
          o,
          a = ue(e),
          s = a.offset(),
          u = ue.css(e, "top"),
          l = ue.css(e, "left"),
          c = ("absolute" === r || "fixed" === r) && ue.inArray("auto", [u, l]) > -1,
          f = {},
          p = {};c ? (p = a.position(), i = p.top, o = p.left) : (i = parseFloat(u) || 0, o = parseFloat(l) || 0), ue.isFunction(t) && (t = t.call(e, n, s)), null != t.top && (f.top = t.top - s.top + i), null != t.left && (f.left = t.left - s.left + o), "using" in t ? t.using.call(e, f) : a.css(f);
    } }, ue.fn.extend({ position: function position() {
      if (this[0]) {
        var e,
            t,
            n = { top: 0, left: 0 },
            r = this[0];return "fixed" === ue.css(r, "position") ? t = r.getBoundingClientRect() : (e = this.offsetParent(), t = this.offset(), ue.nodeName(e[0], "html") || (n = e.offset()), n.top += ue.css(e[0], "borderTopWidth", !0), n.left += ue.css(e[0], "borderLeftWidth", !0)), { top: t.top - n.top - ue.css(r, "marginTop", !0), left: t.left - n.left - ue.css(r, "marginLeft", !0) };
      }
    }, offsetParent: function offsetParent() {
      return this.map(function () {
        for (var e = this.offsetParent || Y.documentElement; e && !ue.nodeName(e, "html") && "static" === ue.css(e, "position");) {
          e = e.offsetParent;
        }return e || Y.documentElement;
      });
    } }), ue.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (e, n) {
    var r = /Y/.test(n);ue.fn[e] = function (i) {
      return ue.access(this, function (e, i, o) {
        var a = z(e);return o === t ? a ? n in a ? a[n] : a.document.documentElement[i] : e[i] : (a ? a.scrollTo(r ? ue(a).scrollLeft() : o, r ? o : ue(a).scrollTop()) : e[i] = o, t);
      }, e, i, arguments.length, null);
    };
  }), ue.each({ Height: "height", Width: "width" }, function (e, n) {
    ue.each({ padding: "inner" + e, content: n, "": "outer" + e }, function (r, i) {
      ue.fn[i] = function (i, o) {
        var a = arguments.length && (r || "boolean" != typeof i),
            s = r || (i === !0 || o === !0 ? "margin" : "border");return ue.access(this, function (n, r, i) {
          var o;return ue.isWindow(n) ? n.document.documentElement["client" + e] : 9 === n.nodeType ? (o = n.documentElement, Math.max(n.body["scroll" + e], o["scroll" + e], n.body["offset" + e], o["offset" + e], o["client" + e])) : i === t ? ue.css(n, r, s) : ue.style(n, r, i, s);
        }, n, a ? i : t, a, null);
      };
    });
  }), e.jQuery = e.$ = ue, "function" == typeof define && __webpack_require__(293) && __webpack_require__(293).jQuery && define("jquery", [], function () {
    return ue;
  });
}(window);

/***/ }),
/* 297 */
/***/ (function(module, exports) {

(function ($) {

    $.mobiscroll.themes.frame['android-holo-light'] = {
        baseTheme: 'android-holo',
        dateOrder: 'Mddyy',

        rows: 5,
        minWidth: 76,
        height: 36,
        showLabel: false,
        selectedLineHeight: true,
        selectedLineBorder: 2,
        useShortLabels: true,
        icon: {
            filled: 'star3',
            empty: 'star'
        },
        btnPlusClass: 'mbsc-ic mbsc-ic-arrow-down6',
        btnMinusClass: 'mbsc-ic mbsc-ic-arrow-up6'
    };

    $.mobiscroll.themes.listview['android-holo-light'] = {
        baseTheme: 'android-holo'
    };

    $.mobiscroll.themes.menustrip['android-holo-light'] = {
        baseTheme: 'android-holo'
    };

    $.mobiscroll.themes.form['android-holo-light'] = {
        baseTheme: 'android-holo'
    };

    $.mobiscroll.themes.progress['android-holo-light'] = {
        baseTheme: 'android-holo'
    };
})(jQuery);

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);


(function ($, undefined) {

    function testProps(props) {
        var i;
        for (i in props) {
            if (mod[props[i]] !== undefined) {
                return true;
            }
        }
        return false;
    }

    function testPrefix() {
        var prefixes = ['Webkit', 'Moz', 'O', 'ms'],
            p;

        for (p in prefixes) {
            if (testProps([prefixes[p] + 'Transform'])) {
                return '-' + prefixes[p].toLowerCase() + '-';
            }
        }
        return '';
    }

    function init(that, options, args) {
        var ret = that;

        if ((typeof options === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(options)) === 'object') {
            return that.each(function () {
                if (instances[this.id]) {
                    instances[this.id].destroy();
                }
                new $.mobiscroll.classes[options.component || 'Scroller'](this, options);
            });
        }

        if (typeof options === 'string') {
            that.each(function () {
                var r,
                    inst = instances[this.id];

                if (inst && inst[options]) {
                    r = inst[options].apply(this, Array.prototype.slice.call(args, 1));
                    if (r !== undefined) {
                        ret = r;
                        return false;
                    }
                }
            });
        }

        return ret;
    }

    var ms,
        id = +new Date(),
        instances = {},
        extend = $.extend,
        mod = document.createElement('modernizr').style,
        has3d = testProps(['perspectiveProperty', 'WebkitPerspective', 'MozPerspective', 'OPerspective', 'msPerspective']),
        hasFlex = testProps(['flex', 'msFlex', 'WebkitBoxDirection']),
        prefix = testPrefix(),
        pr = prefix.replace(/^\-/, '').replace(/\-$/, '').replace('moz', 'Moz');

    $.fn.mobiscroll = function (method) {
        extend(this, $.mobiscroll.components);
        return init(this, method, arguments);
    };

    ms = $.mobiscroll = $.mobiscroll || {
        version: '2.17.1',
        Utils: {
            prefix: prefix,
            jsPrefix: pr,
            has3d: has3d,
            hasFlex: hasFlex,
            isOldAndroid: /android [1-3]/i.test(navigator.userAgent),
            preventClick: function preventClick() {
                ms.tapped++;
                setTimeout(function () {
                    ms.tapped--;
                }, 500);
            },
            testTouch: function testTouch(e, elm) {
                if (e.type == 'touchstart') {
                    $(elm).attr('data-touch', '1');
                } else if ($(elm).attr('data-touch')) {
                    $(elm).removeAttr('data-touch');
                    return false;
                }
                return true;
            },
            objectToArray: function objectToArray(obj) {
                var arr = [],
                    i;

                for (i in obj) {
                    arr.push(obj[i]);
                }

                return arr;
            },
            arrayToObject: function arrayToObject(arr) {
                var obj = {},
                    i;

                if (arr) {
                    for (i = 0; i < arr.length; i++) {
                        obj[arr[i]] = arr[i];
                    }
                }

                return obj;
            },
            isNumeric: function isNumeric(a) {
                return a - parseFloat(a) >= 0;
            },
            isString: function isString(s) {
                return typeof s === 'string';
            },
            getCoord: function getCoord(e, c, page) {
                var ev = e.originalEvent || e,
                    prop = (page ? 'page' : 'client') + c;
                return ev.changedTouches ? ev.changedTouches[0][prop] : e[prop];
            },
            getPosition: function getPosition(t, vertical) {
                var style = window.getComputedStyle ? getComputedStyle(t[0]) : t[0].style,
                    matrix,
                    px;

                if (has3d) {
                    $.each(['t', 'webkitT', 'MozT', 'OT', 'msT'], function (i, v) {
                        if (style[v + 'ransform'] !== undefined) {
                            matrix = style[v + 'ransform'];
                            return false;
                        }
                    });
                    matrix = matrix.split(')')[0].split(', ');
                    px = vertical ? matrix[13] || matrix[5] : matrix[12] || matrix[4];
                } else {
                    px = vertical ? style.top.replace('px', '') : style.left.replace('px', '');
                }

                return px;
            },
            addIcon: function addIcon($control, ic) {
                var icons = {},
                    $parent = $control.parent(),
                    errorMsg = $parent.find('.mbsc-err-msg'),
                    align = $control.attr('data-icon-align') || 'left',
                    icon = $control.attr('data-icon');

                $('<span class="mbsc-input-wrap"></span>').insertAfter($control).append($control);

                if (errorMsg) {
                    $parent.find('.mbsc-input-wrap').append(errorMsg);
                }

                if (icon) {
                    if (icon.indexOf('{') !== -1) {
                        icons = JSON.parse(icon);
                    } else {
                        icons[align] = icon;
                    }

                    extend(icons, ic);

                    $parent.addClass((icons.right ? 'mbsc-ic-right ' : '') + (icons.left ? ' mbsc-ic-left' : '')).find('.mbsc-input-wrap').append(icons.left ? '<span class="mbsc-input-ic mbsc-left-ic mbsc-ic mbsc-ic-' + icons.left + '"></span>' : '').append(icons.right ? '<span class="mbsc-input-ic mbsc-right-ic mbsc-ic mbsc-ic-' + icons.right + '"></span>' : '');
                }
            },
            constrain: function constrain(val, min, max) {
                return Math.max(min, Math.min(val, max));
            },
            vibrate: function vibrate(time) {
                if ('vibrate' in navigator) {
                    navigator.vibrate(time || 50);
                }
            }
        },
        tapped: 0,
        autoTheme: 'mobiscroll',
        presets: {
            scroller: {},
            numpad: {},
            listview: {},
            menustrip: {}
        },
        themes: {
            form: {},
            frame: {},
            listview: {},
            menustrip: {},
            progress: {}
        },
        i18n: {},
        instances: instances,
        classes: {},
        components: {},
        defaults: {
            context: 'body',
            mousewheel: true,
            vibrate: true
        },
        setDefaults: function setDefaults(o) {
            extend(this.defaults, o);
        },
        presetShort: function presetShort(name, c, p) {
            this.components[name] = function (s) {
                return init(this, extend(s, {
                    component: c,
                    preset: p === false ? undefined : name
                }), arguments);
            };
        }
    };

    $.mobiscroll.classes.Base = function (el, settings) {

        var lang,
            preset,
            s,
            theme,
            themeName,
            defaults,
            ms = $.mobiscroll,
            Utils = ms.Utils,
            getCoord = Utils.getCoord,
            that = this;

        that.settings = {};

        that._presetLoad = function () {};

        that._init = function (ss) {
            s = that.settings;

            extend(settings, ss);

            if (that._hasDef) {
                defaults = ms.defaults;
            }

            extend(s, that._defaults, defaults, settings);

            if (that._hasTheme) {

                themeName = s.theme;

                if (themeName == 'auto' || !themeName) {
                    themeName = ms.autoTheme;
                }

                if (themeName == 'default') {
                    themeName = 'mobiscroll';
                }

                settings.theme = themeName;

                theme = ms.themes[that._class] ? ms.themes[that._class][themeName] : {};
            }

            if (that._hasLang) {
                lang = ms.i18n[s.lang];
            }

            if (that._hasTheme) {
                that.trigger('onThemeLoad', [lang, settings]);
            }

            extend(s, theme, lang, defaults, settings);

            if (that._hasPreset) {

                that._presetLoad(s);

                preset = ms.presets[that._class][s.preset];

                if (preset) {
                    preset = preset.call(el, that);
                    extend(s, preset, settings);
                }
            }
        };

        that._destroy = function () {
            that.trigger('onDestroy', []);

            delete instances[el.id];

            that = null;
        };

        that.tap = function (el, handler, prevent) {
            var startX, startY, target, moved;

            function onStart(ev) {
                if (!target) {
                    if (prevent) {
                        ev.preventDefault();
                    }
                    target = this;
                    startX = getCoord(ev, 'X');
                    startY = getCoord(ev, 'Y');
                    moved = false;

                    if (ev.type == 'pointerdown') {
                        $(document).on('pointermove', onMove).on('pointerup', onEnd);
                    }
                }
            }

            function onMove(ev) {
                if (target && !moved && Math.abs(getCoord(ev, 'X') - startX) > 9 || Math.abs(getCoord(ev, 'Y') - startY) > 9) {
                    moved = true;
                }
            }

            function onEnd(ev) {
                if (target) {
                    if (!moved) {
                        ev.preventDefault();
                        handler.call(target, ev, that);
                    }

                    if (ev.type == 'pointerup') {
                        $(document).off('pointermove', onMove).off('pointerup', onEnd);
                    }

                    target = false;

                    Utils.preventClick();
                }
            }

            function onCancel() {
                target = false;
            }

            if (s.tap) {
                el.on('touchstart.dw pointerdown.dw', onStart).on('touchcancel.dw pointercancel.dw', onCancel).on('touchmove.dw', onMove).on('touchend.dw', onEnd);
            }

            el.on('click.dw', function (ev) {
                ev.preventDefault();

                handler.call(this, ev, that);
            });
        };

        that.trigger = function (name, args) {
            var ret;
            args.push(that);
            $.each([defaults, theme, preset, settings], function (i, v) {
                if (v && v[name]) {
                    ret = v[name].apply(el, args);
                }
            });
            return ret;
        };

        that.option = function (opt, value) {
            var obj = {};
            if ((typeof opt === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(opt)) === 'object') {
                obj = opt;
            } else {
                obj[opt] = value;
            }
            that.init(obj);
        };

        that.getInst = function () {
            return that;
        };

        settings = settings || {};

        $(el).addClass('mbsc-comp');

        if (!el.id) {
            el.id = 'mobiscroll' + ++id;
        }

        instances[el.id] = that;
    };

    function preventClick(ev) {
        if (ms.tapped && !ev.tap && !(ev.target.nodeName == 'TEXTAREA' && ev.type == 'mousedown')) {
            ev.stopPropagation();
            ev.preventDefault();
            return false;
        }
    }

    if (document.addEventListener) {
        $.each(['mouseover', 'mousedown', 'mouseup', 'click'], function (i, ev) {
            document.addEventListener(ev, preventClick, true);
        });
    }
})(jQuery);

/***/ }),
/* 299 */
/***/ (function(module, exports) {

(function ($) {
    var themes = $.mobiscroll.themes.frame,
        theme = {
        dateOrder: 'Mddyy',

        rows: 5,
        minWidth: 76,
        height: 36,
        showLabel: false,
        selectedLineHeight: true,
        selectedLineBorder: 2,
        useShortLabels: true,
        icon: { filled: 'star3', empty: 'star' },
        btnPlusClass: 'mbsc-ic mbsc-ic-arrow-down6',
        btnMinusClass: 'mbsc-ic mbsc-ic-arrow-up6',

        onThemeLoad: function onThemeLoad(lang, s) {
            if (s.theme) {
                s.theme = s.theme.replace('android-ics', 'android-holo');
            }
        },

        onMarkupReady: function onMarkupReady(markup) {
            markup.addClass('mbsc-android-holo');
        }
    };

    themes['android-holo'] = theme;
    themes['android-holo-light'] = theme;

    themes['android-ics'] = theme;
    themes['android-ics light'] = theme;
    themes['android-holo light'] = theme;
})(jQuery);

/***/ }),
/* 300 */
/***/ (function(module, exports) {

(function ($, window, document, undefined) {
    var $activeElm,
        preventShow,
        ms = $.mobiscroll,
        Utils = ms.Utils,
        pr = Utils.jsPrefix,
        has3d = Utils.has3d,
        constrain = Utils.constrain,
        isString = Utils.isString,
        isOldAndroid = Utils.isOldAndroid,
        isIOS8 = /(iphone|ipod|ipad).* os 8_/i.test(navigator.userAgent),
        animEnd = 'webkitAnimationEnd animationend',
        empty = function empty() {},
        prevdef = function prevdef(ev) {
        ev.preventDefault();
    };

    ms.classes.Frame = function (el, settings, inherit) {
        var $ariaDiv,
            $ctx,
            $header,
            $markup,
            $overlay,
            $persp,
            $popup,
            $wnd,
            $wrapper,
            buttons,
            btn,
            doAnim,
            event,
            hasButtons,
            isModal,
            modalWidth,
            modalHeight,
            posEvents,
            preventPos,
            s,
            scrollLock,
            setReadOnly,
            wndWidth,
            wndHeight,
            that = this,
            $elm = $(el),
            elmList = [],
            posDebounce = {};

        function onBtnStart(ev) {
            if (btn) {
                btn.removeClass('dwb-a');
            }

            btn = $(this);

            if (!btn.hasClass('dwb-d') && !btn.hasClass('dwb-nhl')) {
                btn.addClass('dwb-a');
            }

            if (ev.type === 'mousedown') {
                $(document).on('mouseup', onBtnEnd);
            } else if (ev.type === 'pointerdown') {
                $(document).on('pointerup', onBtnEnd);
            }
        }

        function onBtnEnd(ev) {
            if (btn) {
                btn.removeClass('dwb-a');
                btn = null;
            }

            if (ev.type === 'mouseup') {
                $(document).off('mouseup', onBtnEnd);
            } else if (ev.type === 'pointerup') {
                $(document).off('pointerup', onBtnEnd);
            }
        }

        function onWndKeyDown(ev) {
            if (ev.keyCode == 13) {
                that.select();
            } else if (ev.keyCode == 27) {
                that.cancel();
            }
        }

        function onShow(prevFocus) {
            if (!prevFocus) {
                $popup.focus();
            }
            that.ariaMessage(s.ariaMessage);
        }

        function onHide(prevAnim) {
            var activeEl,
                value,
                type,
                focus = s.focusOnClose;

            that._markupRemove();

            $markup.remove();

            if ($activeElm && !prevAnim) {
                setTimeout(function () {
                    if (focus === undefined || focus === true) {
                        preventShow = true;
                        activeEl = $activeElm[0];
                        type = activeEl.type;
                        value = activeEl.value;
                        try {
                            activeEl.type = 'button';
                        } catch (ex) {}
                        $activeElm.focus();
                        activeEl.type = type;
                        activeEl.value = value;
                    } else if (focus) {
                        $(focus).focus();
                    }
                }, 200);
            }

            that._isVisible = false;

            event('onHide', []);
        }

        function onPosition(ev) {
            clearTimeout(posDebounce[ev.type]);
            posDebounce[ev.type] = setTimeout(function () {
                var isScroll = ev.type == 'scroll';
                if (isScroll && !scrollLock) {
                    return;
                }
                that.position(!isScroll);
            }, 200);
        }

        function onFocus(ev) {
            if (ev.target.nodeType && !$popup[0].contains(ev.target)) {
                $popup.focus();
            }
        }

        function onBlur() {
            $(this).off('blur', onBlur);
            setTimeout(function () {
                that.position();
            }, 100);
        }

        function show(beforeShow, $elm) {
            if (beforeShow) {
                beforeShow();
            }

            if ($(document.activeElement).is('input,textarea')) {
                $(document.activeElement).blur();
            }

            if (that.show() !== false) {
                $activeElm = $elm;

                setTimeout(function () {
                    preventShow = false;
                }, 300);
            }
        }

        function set() {
            that._fillValue();
            event('onSelect', [that._value]);
        }

        function cancel() {
            event('onCancel', [that._value]);
        }

        function clear() {
            that.setVal(null, true);
        }

        ms.classes.Base.call(this, el, settings, true);

        that.position = function (check) {
            var w,
                l,
                t,
                anchor,
                aw,
                ah,
                ap,
                at,
                al,
                arr,
                arrw,
                arrl,
                dh,
                scroll,
                sl,
                st,
                totalw = 0,
                minw = 0,
                css = {},
                nw = Math.min($wnd[0].innerWidth || $wnd.innerWidth(), $persp.width()),
                nh = $wnd[0].innerHeight || $wnd.innerHeight(),
                $focused = $(document.activeElement);

            if ($focused.is('input,textarea') && !/(button|submit|checkbox|radio)/.test($focused.attr('type'))) {
                $focused.on('blur', onBlur);
                return;
            }

            if (wndWidth === nw && wndHeight === nh && check || preventPos) {
                return;
            }

            if (that._isFullScreen || /top|bottom/.test(s.display)) {
                $popup.width(nw);
            }

            if (event('onPosition', [$markup, nw, nh]) === false || !isModal) {
                return;
            }

            sl = $wnd.scrollLeft();
            st = $wnd.scrollTop();
            anchor = s.anchor === undefined ? $elm : $(s.anchor);

            if (that._isLiquid && s.layout !== 'liquid') {
                if (nw < 400) {
                    $markup.addClass('dw-liq');
                } else {
                    $markup.removeClass('dw-liq');
                }
            }

            if (!that._isFullScreen && /modal|bubble/.test(s.display)) {
                $wrapper.width('');
                $('.mbsc-w-p', $markup).each(function () {
                    w = $(this).outerWidth(true);
                    totalw += w;
                    minw = w > minw ? w : minw;
                });
                w = totalw > nw ? minw : totalw;
                $wrapper.width(w + 1).css('white-space', totalw > nw ? '' : 'nowrap');
            }

            modalWidth = $popup.outerWidth();
            modalHeight = $popup.outerHeight(true);
            scrollLock = modalHeight <= nh && modalWidth <= nw;

            that.scrollLock = scrollLock;

            if (scrollLock) {
                $ctx.addClass('mbsc-fr-lock');
            } else {
                $ctx.removeClass('mbsc-fr-lock');
            }

            if (s.display == 'modal') {
                l = Math.max(0, sl + (nw - modalWidth) / 2);
                t = st + (nh - modalHeight) / 2;
            } else if (s.display == 'bubble') {
                scroll = wndWidth !== nw;
                arr = $('.dw-arrw-i', $markup);
                ap = anchor.offset();
                at = Math.abs($ctx.offset().top - ap.top);
                al = Math.abs($ctx.offset().left - ap.left);

                aw = anchor.outerWidth();
                ah = anchor.outerHeight();
                l = constrain(al - ($popup.outerWidth(true) - aw) / 2, sl + 3, sl + nw - modalWidth - 3);

                t = at - modalHeight;
                if (t < st || at > st + nh) {
                    $popup.removeClass('dw-bubble-top').addClass('dw-bubble-bottom');
                    t = at + ah;
                } else {
                    $popup.removeClass('dw-bubble-bottom').addClass('dw-bubble-top');
                }

                arrw = arr.outerWidth();
                arrl = constrain(al + aw / 2 - (l + (modalWidth - arrw) / 2), 0, arrw);

                $('.dw-arr', $markup).css({
                    left: arrl
                });
            } else {
                l = sl;
                if (s.display == 'top') {
                    t = st;
                } else if (s.display == 'bottom') {
                    t = st + nh - modalHeight;
                }
            }

            t = t < 0 ? 0 : t;

            css.top = t;
            css.left = l;
            $popup.css(css);

            $persp.height(0);
            dh = Math.max(t + modalHeight, s.context == 'body' ? $(document).height() : $ctx[0].scrollHeight);
            $persp.css({
                height: dh
            });

            if (scroll && (t + modalHeight > st + nh || at > st + nh)) {
                preventPos = true;
                setTimeout(function () {
                    preventPos = false;
                }, 300);
                $wnd.scrollTop(Math.min(at, t + modalHeight - nh, dh - nh));
            }

            wndWidth = nw;
            wndHeight = nh;

            $('.mbsc-comp', $markup).each(function () {
                var inst = $(this).mobiscroll('getInst');
                if (inst !== that && inst.position) {
                    inst.position();
                }
            });
        };

        that.attachShow = function ($elm, beforeShow) {
            elmList.push({
                readOnly: $elm.prop('readonly'),
                el: $elm
            });
            if (s.display !== 'inline') {
                if (setReadOnly && $elm.is('input')) {
                    $elm.prop('readonly', true).on('mousedown.dw', function (ev) {
                        ev.preventDefault();
                    });
                }

                if (s.showOnFocus) {
                    $elm.on('focus.dw', function () {
                        if (!preventShow) {
                            show(beforeShow, $elm);
                        }
                    });
                }

                if (s.showOnTap) {
                    $elm.on('keydown.dw', function (ev) {
                        if (ev.keyCode == 32 || ev.keyCode == 13) {
                            ev.preventDefault();
                            ev.stopPropagation();
                            show(beforeShow, $elm);
                        }
                    });

                    that.tap($elm, function () {
                        show(beforeShow, $elm);
                    });
                }
            }
        };

        that.select = function () {
            if (isModal) {
                that.hide(false, 'set', false, set);
            } else {
                set();
            }
        };

        that.cancel = function () {
            if (isModal) {
                that.hide(false, 'cancel', false, cancel);
            } else {
                set();
            }
        };

        that.clear = function () {
            event('onClear', [$markup]);
            if (isModal && that._isVisible && !that.live) {
                that.hide(false, 'clear', false, clear);
            } else {
                clear();
            }
        };

        that.enable = function () {
            s.disabled = false;
            if (that._isInput) {
                $elm.prop('disabled', false);
            }
        };

        that.disable = function () {
            s.disabled = true;
            if (that._isInput) {
                $elm.prop('disabled', true);
            }
        };

        that.show = function (prevAnim, prevFocus) {
            var html;

            if (s.disabled || that._isVisible) {
                return;
            }

            that._readValue();

            if (event('onBeforeShow', []) === false) {
                return false;
            }

            doAnim = isOldAndroid ? false : s.animate;

            if (doAnim !== false) {
                if (s.display == 'top') {
                    doAnim = 'slidedown';
                }
                if (s.display == 'bottom') {
                    doAnim = 'slideup';
                }
            }

            html = '<div lang="' + s.lang + '" class="mbsc-' + s.theme + (s.baseTheme ? ' mbsc-' + s.baseTheme : '') + ' dw-' + s.display + ' ' + (s.cssClass || '') + (that._isLiquid ? ' dw-liq' : '') + (isOldAndroid ? ' mbsc-old' : '') + (hasButtons ? '' : ' dw-nobtn') + '">' + '<div class="dw-persp">' + (isModal ? '<div class="dwo"></div>' : '') + '<div' + (isModal ? ' role="dialog" tabindex="-1"' : '') + ' class="dw' + (s.rtl ? ' dw-rtl' : ' dw-ltr') + '">' + (s.display === 'bubble' ? '<div class="dw-arrw"><div class="dw-arrw-i"><div class="dw-arr"></div></div></div>' : '') + '<div class="dwwr">' + '<div aria-live="assertive" class="dw-aria dw-hidden"></div>' + (s.headerText ? '<div class="dwv">' + (isString(s.headerText) ? s.headerText : '') + '</div>' : '') + '<div class="dwcc">';

            html += that._generateContent();

            html += '</div>';

            if (hasButtons) {
                html += '<div class="dwbc">';
                $.each(buttons, function (i, b) {
                    b = isString(b) ? that.buttons[b] : b;

                    if (b.handler === 'set') {
                        b.parentClass = 'dwb-s';
                    }

                    if (b.handler === 'cancel') {
                        b.parentClass = 'dwb-c';
                    }

                    html += '<div' + (s.btnWidth ? ' style="width:' + 100 / buttons.length + '%"' : '') + ' class="dwbw ' + (b.parentClass || '') + '"><div tabindex="0" role="button" class="dwb' + i + ' dwb-e ' + (b.cssClass === undefined ? s.btnClass : b.cssClass) + (b.icon ? ' mbsc-ic mbsc-ic-' + b.icon : '') + '">' + (b.text || '') + '</div></div>';
                });
                html += '</div>';
            }
            html += '</div></div></div></div>';

            $markup = $(html);
            $persp = $('.dw-persp', $markup);
            $overlay = $('.dwo', $markup);
            $wrapper = $('.dwwr', $markup);
            $header = $('.dwv', $markup);
            $popup = $('.dw', $markup);
            $ariaDiv = $('.dw-aria', $markup);

            that._markup = $markup;
            that._header = $header;
            that._isVisible = true;

            posEvents = 'orientationchange resize';

            that._markupReady($markup);

            event('onMarkupReady', [$markup]);

            if (isModal) {
                $(window).on('keydown', onWndKeyDown);

                if (s.scrollLock) {
                    $markup.on('touchmove mousewheel wheel', function (ev) {
                        if (scrollLock) {
                            ev.preventDefault();
                        }
                    });
                }

                if (pr !== 'Moz') {
                    $('input,select,button', $ctx).each(function () {
                        if (!this.disabled) {
                            $(this).addClass('dwtd').prop('disabled', true);
                        }
                    });
                }

                if (ms.activeInstance) {
                    ms.activeInstance.hide();
                }

                posEvents += ' scroll';

                ms.activeInstance = that;

                $markup.appendTo($ctx);

                if (s.focusTrap) {
                    $wnd.on('focusin', onFocus);
                }

                if (has3d && doAnim && !prevAnim) {
                    $markup.addClass('dw-in dw-trans').on(animEnd, function () {
                        $markup.off(animEnd).removeClass('dw-in dw-trans').find('.dw').removeClass('dw-' + doAnim);
                        onShow(prevFocus);
                    }).find('.dw').addClass('dw-' + doAnim);
                }
            } else if ($elm.is('div') && !that._hasContent) {
                $elm.html($markup);
            } else {
                $markup.insertAfter($elm);
            }

            that._markupInserted($markup);

            event('onMarkupInserted', [$markup]);

            that.position();

            $wnd.on(posEvents, onPosition);

            $markup.on('selectstart mousedown', prevdef).on('click', '.dwb-e', prevdef).on('keydown', '.dwb-e', function (ev) {
                if (ev.keyCode == 32) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    $(this).click();
                }
            }).on('keydown', function (ev) {
                if (ev.keyCode == 32) {
                    ev.preventDefault();
                } else if (ev.keyCode == 9 && isModal && s.focusTrap) {
                    var $focusable = $markup.find('[tabindex="0"]').filter(function () {
                        return this.offsetWidth > 0 || this.offsetHeight > 0;
                    }),
                        index = $focusable.index($(':focus', $markup)),
                        i = $focusable.length - 1,
                        target = 0;

                    if (ev.shiftKey) {
                        i = 0;
                        target = -1;
                    }

                    if (index === i) {
                        $focusable.eq(target).focus();
                        ev.preventDefault();
                    }
                }
            });

            $('input,select,textarea', $markup).on('selectstart mousedown', function (ev) {
                ev.stopPropagation();
            }).on('keydown', function (ev) {
                if (ev.keyCode == 32) {
                    ev.stopPropagation();
                }
            });

            $.each(buttons, function (i, b) {
                that.tap($('.dwb' + i, $markup), function (ev) {
                    b = isString(b) ? that.buttons[b] : b;
                    (isString(b.handler) ? that.handlers[b.handler] : b.handler).call(this, ev, that);
                }, true);
            });

            if (s.closeOnOverlay) {
                that.tap($overlay, function () {
                    that.cancel();
                });
            }

            if (isModal && !doAnim) {
                onShow(prevFocus);
            }

            $markup.on('touchstart mousedown pointerdown', '.dwb-e', onBtnStart).on('touchend', '.dwb-e', onBtnEnd);

            that._attachEvents($markup);


            event('onShow', [$markup, that._tempValue]);
        };

        that.hide = function (prevAnim, btn, force, callback) {
            if (!that._isVisible || !force && !that._isValid && btn == 'set' || !force && event('onBeforeClose', [that._tempValue, btn]) === false) {
                return false;
            }

            if ($markup) {
                if (pr !== 'Moz') {
                    $('.dwtd', $ctx).each(function () {
                        $(this).prop('disabled', false).removeClass('dwtd');
                    });
                }

                if (has3d && isModal && doAnim && !prevAnim && !$markup.hasClass('dw-trans')) {
                    $markup.addClass('dw-out dw-trans').on(animEnd, function () {
                        onHide(prevAnim);
                    }).find('.dw').addClass('dw-' + doAnim);
                } else {
                    onHide(prevAnim);
                }

                $wnd.off(posEvents, onPosition).off('focusin', onFocus);
            }

            if (isModal) {
                $ctx.removeClass('mbsc-fr-lock');
                $(window).off('keydown', onWndKeyDown);
                delete ms.activeInstance;
            }

            if (callback) {
                callback();
            }

            event('onClosed', [that._value]);
        };

        that.ariaMessage = function (txt) {
            $ariaDiv.html('');
            setTimeout(function () {
                $ariaDiv.html(txt);
            }, 100);
        };

        that.isVisible = function () {
            return that._isVisible;
        };

        that.setVal = empty;

        that.getVal = empty;

        that._generateContent = empty;

        that._attachEvents = empty;

        that._readValue = empty;

        that._fillValue = empty;

        that._markupReady = empty;

        that._markupInserted = empty;

        that._markupRemove = empty;

        that._processSettings = empty;

        that._presetLoad = function (s) {
            s.buttons = s.buttons || (s.display !== 'inline' ? ['set', 'cancel'] : []);

            s.headerText = s.headerText === undefined ? s.display !== 'inline' ? '{value}' : false : s.headerText;
        };

        that.destroy = function () {
            that.hide(true, false, true);

            $.each(elmList, function (i, v) {
                v.el.off('.dw').prop('readonly', v.readOnly);
            });

            that._destroy();
        };

        that.init = function (ss) {
            if (ss.onClose) {
                ss.onBeforeClose = ss.onClose;
            }


            that._init(ss);

            that._isLiquid = (s.layout || (/top|bottom/.test(s.display) ? 'liquid' : '')) === 'liquid';

            that._processSettings();

            $elm.off('.dw');

            buttons = s.buttons || [];
            isModal = s.display !== 'inline';
            setReadOnly = s.showOnFocus || s.showOnTap;

            that._window = $wnd = $(s.context == 'body' ? window : s.context);
            that._context = $ctx = $(s.context);

            that.live = true;

            $.each(buttons, function (i, b) {
                if (b == 'ok' || b == 'set' || b.handler == 'set') {
                    that.live = false;
                    return false;
                }
            });

            that.buttons.set = {
                text: s.setText,
                handler: 'set'
            };

            that.buttons.cancel = {
                text: that.live ? s.closeText : s.cancelText,
                handler: 'cancel'
            };

            that.buttons.clear = {
                text: s.clearText,
                handler: 'clear'
            };

            that._isInput = $elm.is('input');

            hasButtons = buttons.length > 0;

            if (that._isVisible) {
                that.hide(true, false, true);
            }

            event('onInit', []);

            if (isModal) {
                that._readValue();
                if (!that._hasContent) {
                    that.attachShow($elm);
                }
            } else {
                that.show();
            }

            $elm.on('change.dw', function () {
                if (!that._preventChange) {
                    that.setVal($elm.val(), true, false);
                }
                that._preventChange = false;
            });
        };

        that.buttons = {};
        that.handlers = {
            set: that.select,
            cancel: that.cancel,
            clear: that.clear
        };

        that._value = null;

        that._isValid = true;
        that._isVisible = false;

        s = that.settings;
        event = that.trigger;

        if (!inherit) {
            that.init(settings);
        }
    };

    ms.classes.Frame.prototype._defaults = {
        lang: 'en',
        setText: 'Set',
        selectedText: '{count} selected',
        closeText: 'Close',
        cancelText: 'Cancel',
        clearText: 'Clear',

        disabled: false,
        closeOnOverlay: true,
        showOnFocus: false,
        showOnTap: true,
        display: 'modal',
        scrollLock: true,
        tap: true,
        btnClass: 'dwb',
        btnWidth: true,
        focusTrap: true,
        focusOnClose: !isIOS8 };

    ms.themes.frame.mobiscroll = {
        rows: 5,
        showLabel: false,
        headerText: false,
        btnWidth: false,
        selectedLineHeight: true,
        selectedLineBorder: 1,
        dateOrder: 'MMddyy',
        weekDays: 'min',
        checkIcon: 'ion-ios7-checkmark-empty',
        btnPlusClass: 'mbsc-ic mbsc-ic-arrow-down5',
        btnMinusClass: 'mbsc-ic mbsc-ic-arrow-up5',
        btnCalPrevClass: 'mbsc-ic mbsc-ic-arrow-left5',
        btnCalNextClass: 'mbsc-ic mbsc-ic-arrow-right5'
    };

    $(window).on('focus', function () {
        if ($activeElm) {
            preventShow = true;
        }
    });
})(jQuery, window, document);

/***/ }),
/* 301 */
/***/ (function(module, exports) {

(function ($) {
    $.mobiscroll.i18n.zh = {
        setText: '确定',
        cancelText: '取消',
        clearText: '明确',
        selectedText: '{count} 选',

        dateFormat: 'yy/mm/dd',
        dateOrder: 'yymmdd',
        dayNames: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
        dayNamesShort: ['日', '一', '二', '三', '四', '五', '六'],
        dayNamesMin: ['日', '一', '二', '三', '四', '五', '六'],
        dayText: '日',
        hourText: '时',
        minuteText: '分',
        monthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        monthNamesShort: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'],
        monthText: '月',
        secText: '秒',
        timeFormat: 'HH:ii',
        timeWheels: 'HHii',
        yearText: '年',
        nowText: '当前',
        pmText: '下午',
        amText: '上午',

        dateText: '日',
        timeText: '时间',
        calendarText: '日历',
        closeText: '关闭',

        fromText: '开始时间',
        toText: '结束时间',

        wholeText: '合计',
        fractionText: '分数',
        unitText: '单位',

        labels: ['年', '月', '日', '小时', '分钟', '秒', ''],
        labelsShort: ['年', '月', '日', '点', '分', '秒', ''],

        startText: '开始',
        stopText: '停止',
        resetText: '重置',
        lapText: '圈',
        hideText: '隐藏',

        backText: '背部',
        undoText: '复原',

        offText: '关闭',
        onText: '开启',

        decimalSeparator: ',',
        thousandsSeparator: ' '
    };
})(jQuery);

/***/ }),
/* 302 */
/***/ (function(module, exports) {

(function ($, undefined) {
    var ms = $.mobiscroll,
        defaults = {
        invalid: [],
        showInput: true,
        inputClass: ''
    };

    ms.presets.scroller.list = function (inst) {
        var orig = $.extend({}, inst.settings),
            s = $.extend(inst.settings, defaults, orig),
            layout = s.layout || (/top|bottom/.test(s.display) ? 'liquid' : ''),
            isLiquid = layout == 'liquid',
            origReadOnly = s.readonly,
            elm = $(this),
            input,
            prevent,
            id = this.id + '_dummy',
            lvl = 0,
            ilvl = 0,
            timer = {},
            currLevel,
            currWheelVector = [],
            wa = s.wheelArray || createWheelArray(elm),
            labels = generateLabels(lvl),
            fwv = firstWheelVector(wa),
            w = generateWheelsFromVector(fwv, lvl);

        function setDisabled(dw, nrWheels, whArray, whVector) {
            var j,
                i = 0;

            while (i < nrWheels) {
                var currWh = $('.dwwl' + i, dw),
                    inv = getInvalidKeys(whVector, i, whArray);

                for (j = 0; j < inv.length; j++) {
                    $('.dw-li[data-val="' + inv[j] + '"]', currWh).removeClass('dw-v');
                }
                i++;
            }
        }

        function getInvalidKeys(whVector, index, whArray) {
            var i = 0,
                n,
                whObjA = whArray,
                invalids = [];

            while (i < index) {
                var ii = whVector[i];

                for (n in whObjA) {
                    if (whObjA[n].key == ii) {
                        whObjA = whObjA[n].children;
                        break;
                    }
                }
                i++;
            }
            i = 0;
            while (i < whObjA.length) {
                if (whObjA[i].invalid) {
                    invalids.push(whObjA[i].key);
                }
                i++;
            }
            return invalids;
        }

        function createROVector(n, i) {
            var a = [];
            while (n) {
                a[--n] = true;
            }
            a[i] = false;
            return a;
        }

        function generateLabels(l) {
            var a = [],
                i;
            for (i = 0; i < l; i++) {
                a[i] = s.labels && s.labels[i] ? s.labels[i] : i;
            }
            return a;
        }

        function generateWheelsFromVector(wv, l, index) {
            var i = 0,
                j,
                obj,
                chInd,
                w = [[]],
                wtObjA = wa;

            if (l) {
                for (j = 0; j < l; j++) {
                    if (isLiquid) {
                        w[0][j] = {};
                    } else {
                        w[j] = [{}];
                    }
                }
            }
            while (i < wv.length) {
                if (isLiquid) {
                    w[0][i] = getWheelFromObjA(wtObjA, labels[i]);
                } else {
                    w[i] = [getWheelFromObjA(wtObjA, labels[i])];
                }

                j = 0;
                chInd = undefined;

                while (j < wtObjA.length && chInd === undefined) {
                    if (wtObjA[j].key == wv[i] && (index !== undefined && i <= index || index === undefined)) {
                        chInd = j;
                    }
                    j++;
                }

                if (chInd !== undefined && wtObjA[chInd].children) {
                    i++;
                    wtObjA = wtObjA[chInd].children;
                } else if ((obj = getFirstValidItemObjOrInd(wtObjA)) && obj.children) {
                    i++;
                    wtObjA = obj.children;
                } else {
                    return w;
                }
            }
            return w;
        }

        function getFirstValidItemObjOrInd(wtObjA, getInd) {
            if (!wtObjA) {
                return false;
            }

            var i = 0,
                obj;

            while (i < wtObjA.length) {
                if (!(obj = wtObjA[i++]).invalid) {
                    return getInd ? i - 1 : obj;
                }
            }
            return false;
        }

        function getWheelFromObjA(objA, lbl) {
            var wheel = {
                keys: [],
                values: [],
                label: lbl
            },
                j = 0;

            while (j < objA.length) {
                wheel.values.push(objA[j].value);
                wheel.keys.push(objA[j].key);
                j++;
            }
            return wheel;
        }

        function hideWheels(dw, i) {
            $('.dwfl', dw).css('display', '').slice(i).hide();
        }

        function firstWheelVector(wa) {
            var t = [],
                ndObjA = wa,
                obj,
                ok = true,
                i = 0;

            while (ok) {
                obj = getFirstValidItemObjOrInd(ndObjA);
                t[i++] = obj.key;
                ok = obj.children;
                if (ok) {
                    ndObjA = ok;
                }
            }
            return t;
        }

        function calcLevelOfVector2(wv, index) {
            var t = [],
                ndObjA = wa,
                lvl = 0,
                next = false,
                i,
                childName,
                chInd;

            if (wv[lvl] !== undefined && lvl <= index) {
                i = 0;

                childName = wv[lvl];
                chInd = undefined;

                while (i < ndObjA.length && chInd === undefined) {
                    if (ndObjA[i].key == wv[lvl] && !ndObjA[i].invalid) {
                        chInd = i;
                    }
                    i++;
                }
            } else {
                chInd = getFirstValidItemObjOrInd(ndObjA, true);
                childName = ndObjA[chInd].key;
            }

            next = chInd !== undefined ? ndObjA[chInd].children : false;

            t[lvl] = childName;

            while (next) {
                ndObjA = ndObjA[chInd].children;
                lvl++;
                next = false;
                chInd = undefined;

                if (wv[lvl] !== undefined && lvl <= index) {
                    i = 0;

                    childName = wv[lvl];
                    chInd = undefined;

                    while (i < ndObjA.length && chInd === undefined) {
                        if (ndObjA[i].key == wv[lvl] && !ndObjA[i].invalid) {
                            chInd = i;
                        }
                        i++;
                    }
                } else {
                    chInd = getFirstValidItemObjOrInd(ndObjA, true);
                    chInd = chInd === false ? undefined : chInd;
                    childName = ndObjA[chInd].key;
                }
                next = chInd !== undefined && getFirstValidItemObjOrInd(ndObjA[chInd].children) ? ndObjA[chInd].children : false;
                t[lvl] = childName;
            }
            return {
                lvl: lvl + 1,
                nVector: t
            };
        }

        function createWheelArray(ul) {
            var wheelArray = [];

            lvl = lvl > ilvl++ ? lvl : ilvl;

            ul.children('li').each(function (index) {
                var that = $(this),
                    c = that.clone();

                c.children('ul,ol').remove();

                var v = inst._processMarkup ? inst._processMarkup(c) : c.html().replace(/^\s\s*/, '').replace(/\s\s*$/, ''),
                    inv = that.attr('data-invalid') ? true : false,
                    wheelObj = {
                    key: that.attr('data-val') === undefined || that.attr('data-val') === null ? index : that.attr('data-val'),
                    value: v,
                    invalid: inv,
                    children: null
                },
                    nest = that.children('ul,ol');

                if (nest.length) {
                    wheelObj.children = createWheelArray(nest);
                }

                wheelArray.push(wheelObj);
            });

            ilvl--;
            return wheelArray;
        }

        $('#' + id).remove();

        if (s.showInput) {
            input = $('<input type="text" id="' + id + '" value="" class="' + s.inputClass + '" placeholder="' + (s.placeholder || '') + '" readonly />').insertBefore(elm);
            s.anchor = input;
            inst.attachShow(input);
        }

        if (!s.wheelArray) {
            elm.hide().closest('.ui-field-contain').trigger('create');
        }

        return {
            width: 50,
            wheels: w,
            layout: layout,
            headerText: false,
            formatValue: function formatValue(d) {
                if (currLevel === undefined) {
                    currLevel = calcLevelOfVector2(d, d.length).lvl;
                }
                return d.slice(0, currLevel).join(' ');
            },
            parseValue: function parseValue(value) {
                return value ? (value + '').split(' ') : (s.defaultValue || fwv).slice(0);
            },
            onBeforeShow: function onBeforeShow() {
                var t = inst.getArrayVal(true);
                currWheelVector = t.slice(0);
                s.wheels = generateWheelsFromVector(t, lvl, lvl);
                prevent = true;
            },
            onValueFill: function onValueFill(v) {
                currLevel = undefined;
                if (input) {
                    input.val(v);
                }
            },
            onShow: function onShow(dw) {
                $('.dwwl', dw).on('mousedown touchstart', function () {
                    clearTimeout(timer[$('.dwwl', dw).index(this)]);
                });
            },
            onDestroy: function onDestroy() {
                if (input) {
                    input.remove();
                }
                elm.show();
            },
            validate: function validate(dw, index, time) {
                var args = [],
                    t = inst.getArrayVal(true),
                    i = (index || 0) + 1,
                    j,
                    o;

                if (index !== undefined && currWheelVector[index] != t[index] || index === undefined && !prevent) {
                    s.wheels = generateWheelsFromVector(t, null, index);
                    o = calcLevelOfVector2(t, index === undefined ? t.length : index);
                    currLevel = o.lvl;

                    for (j = 0; j < t.length; j++) {
                        t[j] = o.nVector[j] || 0;
                    }

                    while (i < o.lvl) {
                        args.push(i++);
                    }

                    if (args.length) {
                        s.readonly = createROVector(lvl, index);
                        clearTimeout(timer[index]);
                        timer[index] = setTimeout(function () {
                            prevent = true;
                            hideWheels(dw, o.lvl);
                            currWheelVector = t.slice(0);
                            inst.changeWheel(args, index === undefined ? time : 0, index !== undefined);
                            s.readonly = origReadOnly;
                        }, index === undefined ? 0 : time * 1000);
                        return false;
                    }
                } else {
                    o = calcLevelOfVector2(t, t.length);
                    currLevel = o.lvl;
                }

                currWheelVector = t.slice(0);
                setDisabled(dw, o.lvl, wa, t);
                hideWheels(dw, o.lvl);

                prevent = false;
            }
        };
    };
})(jQuery);

/***/ }),
/* 303 */
/***/ (function(module, exports) {

(function ($, window, document, undefined) {

    var ms = $.mobiscroll,
        classes = ms.classes,
        Utils = ms.Utils,
        pr = Utils.jsPrefix,
        has3d = Utils.has3d,
        hasFlex = Utils.hasFlex,
        getCoord = Utils.getCoord,
        constrain = Utils.constrain,
        testTouch = Utils.testTouch;

    ms.presetShort('scroller', 'Scroller', false);

    classes.Scroller = function (el, settings, inherit) {
        var $markup,
            btn,
            isScrollable,
            itemHeight,
            multiple,
            pixels,
            s,
            scrollDebounce,
            trigger,
            click,
            moved,
            start,
            startTime,
            stop,
            p,
            min,
            max,
            target,
            index,
            lines,
            timer,
            that = this,
            $elm = $(el),
            iv = {},
            pos = {},
            wheels = [];

        function onStart(ev) {
            if (testTouch(ev, this) && !target && !click && !btn && !isReadOnly(this)) {
                ev.preventDefault();

                ev.stopPropagation();

                isScrollable = s.mode != 'clickpick';
                target = $('.dw-ul', this);
                setGlobals(target);
                moved = iv[index] !== undefined;
                p = moved ? getCurrentPosition(target) : pos[index];
                start = getCoord(ev, 'Y', true);
                startTime = new Date();
                stop = start;
                scroll(target, index, p, 0.001);

                if (isScrollable) {
                    target.closest('.dwwl').addClass('dwa');
                }

                if (ev.type === 'mousedown') {
                    $(document).on('mousemove', onMove).on('mouseup', onEnd);
                }
            }
        }

        function onMove(ev) {
            if (target) {
                if (isScrollable) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    stop = getCoord(ev, 'Y', true);
                    if (Math.abs(stop - start) > 3 || moved) {
                        scroll(target, index, constrain(p + (start - stop) / itemHeight, min - 1, max + 1));
                        moved = true;
                    }
                }
            }
        }

        function onEnd(ev) {
            if (target) {
                var time = new Date() - startTime,
                    curr = constrain(Math.round(p + (start - stop) / itemHeight), min - 1, max + 1),
                    val = curr,
                    speed,
                    dist,
                    ttop = target.offset().top;

                ev.stopPropagation();

                if (ev.type === 'mouseup') {
                    $(document).off('mousemove', onMove).off('mouseup', onEnd);
                }

                if (has3d && time < 300) {
                    speed = (stop - start) / time;
                    dist = speed * speed / s.speedUnit;
                    if (stop - start < 0) {
                        dist = -dist;
                    }
                } else {
                    dist = stop - start;
                }

                if (!moved) {
                    var idx = Math.floor((stop - ttop) / itemHeight),
                        li = $($('.dw-li', target)[idx]),
                        valid = li.hasClass('dw-v'),
                        hl = isScrollable;

                    time = 0.1;

                    if (trigger('onValueTap', [li]) !== false && valid) {
                        val = idx;
                    } else {
                        hl = true;
                    }

                    if (hl && valid) {
                        li.addClass('dw-hl');
                        setTimeout(function () {
                            li.removeClass('dw-hl');
                        }, 100);
                    }

                    if (!multiple && (s.confirmOnTap === true || s.confirmOnTap[index]) && li.hasClass('dw-sel')) {
                        that.select();
                        target = false;
                        return;
                    }
                } else {
                    val = constrain(Math.round(p - dist / itemHeight), min, max);
                    time = speed ? Math.max(0.1, Math.abs((val - curr) / speed) * s.timeUnit) : 0.1;
                }

                if (isScrollable) {
                    calc(target, index, val, 0, time, true);
                }

                target = false;
            }
        }

        function onBtnStart(ev) {
            btn = $(this);

            if (testTouch(ev, this)) {
                step(ev, btn.closest('.dwwl'), btn.hasClass('dwwbp') ? plus : minus);
            }
            if (ev.type === 'mousedown') {
                $(document).on('mouseup', onBtnEnd);
            }
        }

        function onBtnEnd(ev) {
            btn = null;
            if (click) {
                clearInterval(timer);
                click = false;
            }
            if (ev.type === 'mouseup') {
                $(document).off('mouseup', onBtnEnd);
            }
        }

        function onKeyDown(ev) {
            if (ev.keyCode == 38) {
                step(ev, $(this), minus);
            } else if (ev.keyCode == 40) {
                step(ev, $(this), plus);
            }
        }

        function onKeyUp() {
            if (click) {
                clearInterval(timer);
                click = false;
            }
        }

        function onScroll(ev) {
            if (!isReadOnly(this)) {
                ev.preventDefault();
                ev = ev.originalEvent || ev;

                var delta = ev.deltaY || ev.wheelDelta || ev.detail,
                    t = $('.dw-ul', this);

                setGlobals(t);

                scroll(t, index, constrain(((delta < 0 ? -20 : 20) - pixels[index]) / itemHeight, min - 1, max + 1));

                clearTimeout(scrollDebounce);
                scrollDebounce = setTimeout(function () {
                    calc(t, index, Math.round(pos[index]), delta > 0 ? 1 : 2, 0.1);
                }, 200);
            }
        }

        function step(ev, w, func) {
            ev.stopPropagation();
            ev.preventDefault();
            if (!click && !isReadOnly(w) && !w.hasClass('dwa')) {
                click = true;

                var t = w.find('.dw-ul');

                setGlobals(t);
                clearInterval(timer);
                timer = setInterval(function () {
                    func(t);
                }, s.delay);
                func(t);
            }
        }

        function isReadOnly(wh) {
            if ($.isArray(s.readonly)) {
                var i = $('.dwwl', $markup).index(wh);
                return s.readonly[i];
            }
            return s.readonly;
        }

        function generateWheelItems(i) {
            var html = '<div class="dw-bf">',
                w = wheels[i],
                l = 1,
                labels = w.labels || [],
                values = w.values || [],
                keys = w.keys || values;

            $.each(values, function (j, v) {
                if (l % 20 === 0) {
                    html += '</div><div class="dw-bf">';
                }
                html += '<div role="option" aria-selected="false" class="dw-li dw-v" data-val="' + keys[j] + '"' + (labels[j] ? ' aria-label="' + labels[j] + '"' : '') + ' style="height:' + itemHeight + 'px;line-height:' + itemHeight + 'px;">' + '<div class="dw-i"' + (lines > 1 ? ' style="line-height:' + Math.round(itemHeight / lines) + 'px;font-size:' + Math.round(itemHeight / lines * 0.8) + 'px;"' : '') + '>' + v + '</div></div>';
                l++;
            });

            html += '</div>';
            return html;
        }

        function setGlobals(t) {
            multiple = t.closest('.dwwl').hasClass('dwwms');
            min = $('.dw-li', t).index($(multiple ? '.dw-li' : '.dw-v', t).eq(0));
            max = Math.max(min, $('.dw-li', t).index($(multiple ? '.dw-li' : '.dw-v', t).eq(-1)) - (multiple ? s.rows - (s.mode == 'scroller' ? 1 : 3) : 0));
            index = $('.dw-ul', $markup).index(t);
        }

        function formatHeader(v) {
            var t = s.headerText;
            return t ? typeof t === 'function' ? t.call(el, v) : t.replace(/\{value\}/i, v) : '';
        }

        function getCurrentPosition(t) {
            return Math.round(-Utils.getPosition(t, true) / itemHeight);
        }

        function ready(t, i) {
            clearTimeout(iv[i]);
            delete iv[i];
            t.closest('.dwwl').removeClass('dwa');
        }

        function scroll(t, index, val, time, active) {
            var px = -val * itemHeight,
                style = t[0].style;

            if (px == pixels[index] && iv[index]) {
                return;
            }

            pixels[index] = px;

            if (has3d) {
                style[pr + 'Transition'] = Utils.prefix + 'transform ' + (time ? time.toFixed(3) : 0) + 's ease-out';
                style[pr + 'Transform'] = 'translate3d(0,' + px + 'px,0)';
            } else {
                style.top = px + 'px';
            }

            if (iv[index]) {
                ready(t, index);
            }

            if (time && active) {
                t.closest('.dwwl').addClass('dwa');
                iv[index] = setTimeout(function () {
                    ready(t, index);
                }, time * 1000);
            }

            pos[index] = val;
        }

        function getValid(val, t, dir, multiple, select) {
            var selected,
                cell = $('.dw-li[data-val="' + val + '"]', t),
                cells = $('.dw-li', t),
                v = cells.index(cell),
                l = cells.length;

            if (multiple) {
                setGlobals(t);
            } else if (!cell.hasClass('dw-v')) {
                var cell1 = cell,
                    cell2 = cell,
                    dist1 = 0,
                    dist2 = 0;

                while (v - dist1 >= 0 && !cell1.hasClass('dw-v')) {
                    dist1++;
                    cell1 = cells.eq(v - dist1);
                }

                while (v + dist2 < l && !cell2.hasClass('dw-v')) {
                    dist2++;
                    cell2 = cells.eq(v + dist2);
                }

                if ((dist2 < dist1 && dist2 && dir !== 2 || !dist1 || v - dist1 < 0 || dir == 1) && cell2.hasClass('dw-v')) {
                    cell = cell2;
                    v = v + dist2;
                } else {
                    cell = cell1;
                    v = v - dist1;
                }
            }

            selected = cell.hasClass('dw-sel');

            if (select) {
                if (!multiple) {
                    $('.dw-sel', t).removeAttr('aria-selected');
                    cell.attr('aria-selected', 'true');
                }

                $('.dw-sel', t).removeClass('dw-sel');
                cell.addClass('dw-sel');
            }

            return {
                selected: selected,
                v: multiple ? constrain(v, min, max) : v,
                val: cell.hasClass('dw-v') || multiple ? cell.attr('data-val') : null
            };
        }

        function scrollToPos(time, index, manual, dir, active) {
            if (trigger('validate', [$markup, index, time, dir]) !== false) {
                $('.dw-ul', $markup).each(function (i) {
                    var t = $(this),
                        multiple = t.closest('.dwwl').hasClass('dwwms'),
                        sc = i == index || index === undefined,
                        res = getValid(that._tempWheelArray[i], t, dir, multiple, true),
                        selected = res.selected;

                    if (!selected || sc) {
                        that._tempWheelArray[i] = res.val;

                        scroll(t, i, res.v, sc ? time : 0.1, sc ? active : false);
                    }
                });

                trigger('onValidated', [index]);

                that._tempValue = s.formatValue(that._tempWheelArray, that);

                if (that.live) {
                    that._hasValue = manual || that._hasValue;
                    setValue(manual, manual, 0, true);
                }

                that._header.html(formatHeader(that._tempValue));

                if (manual) {
                    trigger('onChange', [that._tempValue]);
                }
            }
        }

        function calc(t, idx, val, dir, time, active) {
            val = constrain(val, min, max);

            that._tempWheelArray[idx] = $('.dw-li', t).eq(val).attr('data-val');

            scroll(t, idx, val, time, active);

            setTimeout(function () {
                scrollToPos(time, idx, true, dir, active);
            }, 10);
        }

        function plus(t) {
            var val = pos[index] + 1;
            calc(t, index, val > max ? min : val, 1, 0.1);
        }

        function minus(t) {
            var val = pos[index] - 1;
            calc(t, index, val < min ? max : val, 2, 0.1);
        }

        function setValue(fill, change, time, noscroll, temp) {
            if (that._isVisible && !noscroll) {
                scrollToPos(time);
            }

            that._tempValue = s.formatValue(that._tempWheelArray, that);

            if (!temp) {
                that._wheelArray = that._tempWheelArray.slice(0);
                that._value = that._hasValue ? that._tempValue : null;
            }

            if (fill) {

                trigger('onValueFill', [that._hasValue ? that._tempValue : '', change]);

                if (that._isInput) {
                    $elm.val(that._hasValue ? that._tempValue : '');
                }

                if (change) {
                    that._preventChange = true;
                    $elm.change();
                }
            }
        }

        classes.Frame.call(this, el, settings, true);

        that.setVal = that._setVal = function (val, fill, change, temp, time) {
            that._hasValue = val !== null && val !== undefined;
            that._tempWheelArray = $.isArray(val) ? val.slice(0) : s.parseValue.call(el, val, that) || [];
            setValue(fill, change === undefined ? fill : change, time, false, temp);
        };

        that.getVal = that._getVal = function (temp) {
            var val = that._hasValue || temp ? that[temp ? '_tempValue' : '_value'] : null;
            return Utils.isNumeric(val) ? +val : val;
        };

        that.setArrayVal = that.setVal;

        that.getArrayVal = function (temp) {
            return temp ? that._tempWheelArray : that._wheelArray;
        };

        that.setValue = function (val, fill, time, temp, change) {
            that.setVal(val, fill, change, temp, time);
        };

        that.getValue = that.getArrayVal;

        that.changeWheel = function (idx, time, manual) {
            if ($markup) {
                var i = 0,
                    nr = idx.length;

                $.each(s.wheels, function (j, wg) {
                    $.each(wg, function (k, w) {
                        if ($.inArray(i, idx) > -1) {
                            wheels[i] = w;
                            $('.dw-ul', $markup).eq(i).html(generateWheelItems(i));
                            nr--;
                            if (!nr) {
                                that.position();
                                scrollToPos(time, undefined, manual);
                                return false;
                            }
                        }
                        i++;
                    });
                    if (!nr) {
                        return false;
                    }
                });
            }
        };

        that.getValidCell = getValid;

        that.scroll = scroll;

        that._generateContent = function () {
            var lbl,
                html = '',
                l = 0;

            $.each(s.wheels, function (i, wg) {
                html += '<div class="mbsc-w-p dwc' + (s.mode != 'scroller' ? ' dwpm' : ' dwsc') + (s.showLabel ? '' : ' dwhl') + '">' + '<div class="dwwc"' + (s.maxWidth ? '' : ' style="max-width:600px;"') + '>' + (hasFlex ? '' : '<table class="dw-tbl" cellpadding="0" cellspacing="0"><tr>');

                $.each(wg, function (j, w) {
                    wheels[l] = w;
                    lbl = w.label !== undefined ? w.label : j;
                    html += '<' + (hasFlex ? 'div' : 'td') + ' class="dwfl"' + ' style="' + (s.fixedWidth ? 'width:' + (s.fixedWidth[l] || s.fixedWidth) + 'px;' : (s.minWidth ? 'min-width:' + (s.minWidth[l] || s.minWidth) + 'px;' : 'min-width:' + s.width + 'px;') + (s.maxWidth ? 'max-width:' + (s.maxWidth[l] || s.maxWidth) + 'px;' : '')) + '">' + '<div class="dwwl dwwl' + l + (w.multiple ? ' dwwms' : '') + '">' + (s.mode != 'scroller' ? '<div class="dwb-e dwwb dwwbp ' + (s.btnPlusClass || '') + '" style="height:' + itemHeight + 'px;line-height:' + itemHeight + 'px;"><span>+</span></div>' + '<div class="dwb-e dwwb dwwbm ' + (s.btnMinusClass || '') + '" style="height:' + itemHeight + 'px;line-height:' + itemHeight + 'px;"><span>&ndash;</span></div>' : '') + '<div class="dwl">' + lbl + '</div>' + '<div tabindex="0" aria-live="off" aria-label="' + lbl + '" role="listbox" class="dwww">' + '<div class="dww" style="height:' + s.rows * itemHeight + 'px;">' + '<div class="dw-ul" style="margin-top:' + (w.multiple ? s.mode == 'scroller' ? 0 : itemHeight : s.rows / 2 * itemHeight - itemHeight / 2) + 'px;">';

                    html += generateWheelItems(l) + '</div></div><div class="dwwo"></div></div><div class="dwwol"' + (s.selectedLineHeight ? ' style="height:' + itemHeight + 'px;margin-top:-' + (itemHeight / 2 + (s.selectedLineBorder || 0)) + 'px;"' : '') + '></div></div>' + (hasFlex ? '</div>' : '</td>');

                    l++;
                });

                html += (hasFlex ? '' : '</tr></table>') + '</div></div>';
            });

            return html;
        };

        that._attachEvents = function ($markup) {
            $markup.on('keydown', '.dwwl', onKeyDown).on('keyup', '.dwwl', onKeyUp).on('touchstart mousedown', '.dwwl', onStart).on('touchmove', '.dwwl', onMove).on('touchend', '.dwwl', onEnd).on('touchstart mousedown', '.dwwb', onBtnStart).on('touchend touchcancel', '.dwwb', onBtnEnd);

            if (s.mousewheel) {
                $markup.on('wheel mousewheel', '.dwwl', onScroll);
            }
        };

        that._markupReady = function ($m) {
            $markup = $m;
            pixels = {};
            scrollToPos();
        };

        that._fillValue = function () {
            that._hasValue = true;
            setValue(true, true, 0, true);
        };

        that._readValue = function () {
            var v = $elm.val() || '';

            if (v !== '') {
                that._hasValue = true;
            }

            that._tempWheelArray = that._hasValue && that._wheelArray ? that._wheelArray.slice(0) : s.parseValue.call(el, v, that) || [];
            setValue();
        };

        that._processSettings = function () {
            s = that.settings;
            trigger = that.trigger;
            itemHeight = s.height;
            lines = s.multiline;

            that._isLiquid = (s.layout || (/top|bottom/.test(s.display) && s.wheels.length == 1 ? 'liquid' : '')) === 'liquid';

            if (s.formatResult) {
                s.formatValue = s.formatResult;
            }


            if (lines > 1) {
                s.cssClass = (s.cssClass || '') + ' dw-ml';
            }

            if (s.mode != 'scroller') {
                s.rows = Math.max(3, s.rows);
            }
        };

        that._selectedValues = {};

        if (!inherit) {
            that.init(settings);
        }
    };

    classes.Scroller.prototype = {
        _hasDef: true,
        _hasTheme: true,
        _hasLang: true,
        _hasPreset: true,
        _class: 'scroller',
        _defaults: $.extend({}, classes.Frame.prototype._defaults, {
            minWidth: 80,
            height: 40,
            rows: 3,
            multiline: 1,
            delay: 300,
            readonly: false,
            showLabel: true,
            confirmOnTap: true,
            wheels: [],
            mode: 'scroller',
            preset: '',
            speedUnit: 0.0012,
            timeUnit: 0.08,
            formatValue: function formatValue(d) {
                return d.join(' ');
            },
            parseValue: function parseValue(value, inst) {
                var val = [],
                    ret = [],
                    i = 0,
                    found,
                    keys;

                if (value !== null && value !== undefined) {
                    val = (value + '').split(' ');
                }

                $.each(inst.settings.wheels, function (j, wg) {
                    $.each(wg, function (k, w) {
                        keys = w.keys || w.values;
                        found = keys[0];
                        $.each(keys, function (l, key) {
                            if (val[i] == key) {
                                found = key;
                                return false;
                            }
                        });
                        ret.push(found);
                        i++;
                    });
                });
                return ret;
            }
        })
    };

    ms.themes.scroller = ms.themes.frame;
})(jQuery, window, document);

/***/ }),
/* 304 */
/***/ (function(module, exports) {

(function ($) {
    var ms = $.mobiscroll,
        presets = ms.presets.scroller;

    presets.treelist = presets.list;

    ms.presetShort('list');
    ms.presetShort('treelist');
})(jQuery);

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

if (!window.jQuery) {

    var jQuery = Zepto;

    (function ($) {

        ['width', 'height'].forEach(function (dimension) {
            $.fn[dimension] = function (value) {
                var offset,
                    body = document.body,
                    html = document.documentElement,
                    Dimension = dimension.replace(/./, function (m) {
                    return m[0].toUpperCase();
                });
                if (value === undefined) {
                    return this[0] == window ? html['client' + Dimension] : this[0] == document ? Math.max(body['scroll' + Dimension], body['offset' + Dimension], html['client' + Dimension], html['scroll' + Dimension], html['offset' + Dimension]) : (offset = this.offset()) && offset[dimension];
                } else {
                    return this.each(function (idx) {
                        $(this).css(dimension, value);
                    });
                }
            };
        });

        ['width', 'height'].forEach(function (dimension) {
            var offset,
                Dimension = dimension.replace(/./, function (m) {
                return m[0].toUpperCase();
            });
            $.fn['outer' + Dimension] = function (margin) {
                var elem = this;
                if (elem) {
                    var size = elem[0]['offset' + Dimension],
                        sides = { 'width': ['left', 'right'], 'height': ['top', 'bottom'] };
                    sides[dimension].forEach(function (side) {
                        if (margin) {
                            size += parseInt(elem.css('margin-' + side), 10);
                        }
                    });
                    return size;
                } else {
                    return null;
                }
            };
        });

        ['width', 'height'].forEach(function (dimension) {
            var offset,
                Dimension = dimension.replace(/./, function (m) {
                return m[0].toUpperCase();
            });
            $.fn['inner' + Dimension] = function () {
                var elem = this;
                if (elem[0]['inner' + Dimension]) {
                    return elem[0]['inner' + Dimension];
                } else {
                    var size = elem[0]['offset' + Dimension],
                        sides = { 'width': ['left', 'right'], 'height': ['top', 'bottom'] };
                    sides[dimension].forEach(function (side) {
                        size -= parseInt(elem.css('border-' + side + '-width'), 10);
                    });

                    return size;
                }
            };
        });

        ["Left", "Top"].forEach(function (name, i) {
            var method = "scroll" + name;

            function isWindow(obj) {
                return obj && (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj)) === "object" && "setInterval" in obj;
            }

            function getWindow(elem) {
                return isWindow(elem) ? elem : elem.nodeType === 9 ? elem.defaultView || elem.parentWindow : false;
            }

            $.fn[method] = function (val) {
                var elem, win;
                if (val === undefined) {
                    elem = this[0];
                    if (!elem) {
                        return null;
                    }
                    win = getWindow(elem);

                    return win ? "pageXOffset" in win ? win[i ? "pageYOffset" : "pageXOffset"] : win.document.documentElement[method] || win.document.body[method] : elem[method];
                }

                this.each(function () {
                    win = getWindow(this);
                    if (win) {
                        var xCoord = !i ? val : $(win).scrollLeft(),
                            yCoord = i ? val : $(win).scrollTop();
                        win.scrollTo(xCoord, yCoord);
                    } else {
                        this[method] = val;
                    }
                });
            };
        });

        $.fn.prevUntil = function (selector) {
            var n = this,
                array = [];

            while (n.length && !$(n).filter(selector).length) {
                array.push(n[0]);
                n = n.prev();
            }

            return $(array);
        };

        $.fn.nextUntil = function (selector) {
            var n = this,
                array = [];

            while (n.length && !n.filter(selector).length) {
                array.push(n[0]);
                n = n.next();
            }

            return $(array);
        };

        $._extend = $.extend;
        $.extend = function () {
            arguments[0] = arguments[0] || {};
            return $._extend.apply(this, arguments);
        };
    })(jQuery);
}

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Index__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_claimDetail__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_claimDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_claimDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ClaimFlow__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ClaimFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ClaimFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ClaimList__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ClaimList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ClaimList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ClaimStep1__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ClaimStep1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ClaimStep1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ClaimStep2__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ClaimStep2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_ClaimStep2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ClaimSuccess__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ClaimSuccess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_ClaimSuccess__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_create__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_createSuccess__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_createSuccess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_createSuccess__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_docs__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_docs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_docs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_protocol__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_protocol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_protocol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_protocolIos__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_protocolIos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_protocolIos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_protocolIvvi__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_protocolIvvi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_protocolIvvi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_protocolA0009__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_protocolA0009___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_protocolA0009__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_range__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_rangeIos__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_rangeIos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_rangeIos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_rangeIvvi__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_rangeIvvi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_rangeIvvi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_rangeA0009__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_rangeA0009___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_rangeA0009__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__lib_Utils_trace_js__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_home__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__views_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_createStore__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_createStore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__views_createStore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_createSuccess__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_createSuccess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__views_createSuccess__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_detail__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__views_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_insureDetail__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_insureDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__views_insureDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_wifiSelect_index__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_wifiSelect_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__views_wifiSelect_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_range__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__views_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_rangePersonal__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_rangePersonal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__views_rangePersonal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_claimStep1__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_claimStep1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__views_claimStep1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_claimStep2__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_claimStep2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__views_claimStep2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_claimSuccess__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_claimSuccess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__views_claimSuccess__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_docs__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_docs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__views_docs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_claimFlow__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_claimFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__views_claimFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_claimList__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_claimList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__views_claimList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_claimDetail__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_claimDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__views_claimDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_protocol__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_protocol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__views_protocol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__views_protocolIos__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__views_protocolIos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__views_protocolIos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__views_docs_findMac__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__views_docs_findMac___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__views_docs_findMac__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__views_docs_isShare__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__views_docs_isShare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__views_docs_isShare__);










































var bucket = '/new';

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'index',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Index___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = 'WiFi安全险';
      __WEBPACK_IMPORTED_MODULE_20__lib_Utils_trace_js__["enterTrace"]({ page: 1 });
      __WEBPACK_IMPORTED_MODULE_20__lib_Utils_trace_js__["enterTrace"]({ page: 2 });
      next();
    }
  }, {
    path: '/index',
    name: 'index',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Index___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = 'WiFi安全险';
      __WEBPACK_IMPORTED_MODULE_20__lib_Utils_trace_js__["enterTrace"]({ page: 1 });
      __WEBPACK_IMPORTED_MODULE_20__lib_Utils_trace_js__["enterTrace"]({ page: 2 });
      next();
    }
  }, {
    path: '/claimDetail',
    name: 'claimDetail',
    component: __WEBPACK_IMPORTED_MODULE_3__components_claimDetail___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = '索赔详情';
      __WEBPACK_IMPORTED_MODULE_20__lib_Utils_trace_js__["enterTrace"]({ page: 3 });
      next();
    }
  }, {
    path: '/claimFlow',
    name: 'claimFlow',
    component: __WEBPACK_IMPORTED_MODULE_4__components_ClaimFlow___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = '索赔流程';
      next();
    }
  }, {
    path: '/claimList',
    name: 'claimList',
    component: __WEBPACK_IMPORTED_MODULE_5__components_ClaimList___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = '索赔记录';
      __WEBPACK_IMPORTED_MODULE_20__lib_Utils_trace_js__["enterTrace"]({ page: 8 });
      next();
    }
  }, {
    path: '/claimStep1',
    name: 'claimStep1',
    component: __WEBPACK_IMPORTED_MODULE_6__components_ClaimStep1___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = '用户索赔登记';
      __WEBPACK_IMPORTED_MODULE_20__lib_Utils_trace_js__["enterTrace"]({ page: 7, step: 1 });
      next();
    }
  }, {
    path: '/claimStep2',
    name: 'claimStep2',
    component: __WEBPACK_IMPORTED_MODULE_7__components_ClaimStep2___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = '用户索赔登记', __WEBPACK_IMPORTED_MODULE_20__lib_Utils_trace_js__["enterTrace"]({ page: 7, step: 2 });
      next();
    }
  }, {
    path: '/claimSuccess',
    name: 'claimSuccess',
    component: __WEBPACK_IMPORTED_MODULE_8__components_ClaimSuccess___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = '索赔登记成功';
      next();
    }
  }, {
    path: '/create',
    name: 'create',
    component: __WEBPACK_IMPORTED_MODULE_9__components_create___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = '个人参保';
      __WEBPACK_IMPORTED_MODULE_20__lib_Utils_trace_js__["enterTrace"]({ page: 4 });
      next();
    }
  }, {
    path: '/createSuccess',
    name: 'createSuccess',
    component: __WEBPACK_IMPORTED_MODULE_10__components_createSuccess___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = '参保成功';
      next();
    }
  }, {
    path: '/docs',
    name: 'docs',
    component: __WEBPACK_IMPORTED_MODULE_11__components_docs___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = '索赔所需资料';
      next();
    }
  }, {
    path: '/protocol',
    name: 'protocol',
    component: __WEBPACK_IMPORTED_MODULE_12__components_protocol___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = 'WiFi万能钥匙用户安全保险协议';
      __WEBPACK_IMPORTED_MODULE_20__lib_Utils_trace_js__["enterTrace"]({ page: 5, type: 'protocol' });
      next();
    }
  }, {
    path: '/protocolIos',
    name: 'protocolIos',
    component: __WEBPACK_IMPORTED_MODULE_13__components_protocolIos___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = 'WiFi万能钥匙用户安全保险协议';
      __WEBPACK_IMPORTED_MODULE_20__lib_Utils_trace_js__["enterTrace"]({ page: 5, type: 'protocolIos' });
      next();
    }
  }, {
    path: '/protocolIvvi',
    name: 'protocolIvvi',
    component: __WEBPACK_IMPORTED_MODULE_14__components_protocolIvvi___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = 'WiFi万能钥匙用户安全保险协议';
      __WEBPACK_IMPORTED_MODULE_20__lib_Utils_trace_js__["enterTrace"]({ page: 5, type: 'protocolIvvi' });
      next();
    }
  }, {
    path: '/protocolA0009',
    name: 'protocolA0009',
    component: __WEBPACK_IMPORTED_MODULE_15__components_protocolA0009___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = 'WiFi万能钥匙用户安全保险协议';
      __WEBPACK_IMPORTED_MODULE_20__lib_Utils_trace_js__["enterTrace"]({ page: 5, type: 'protocolA0009' });
      next();
    }
  }, {
    path: '/range',
    name: 'range',
    component: __WEBPACK_IMPORTED_MODULE_16__components_range___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = '保障范围';
      __WEBPACK_IMPORTED_MODULE_20__lib_Utils_trace_js__["enterTrace"]({ page: 6, type: 'range' });
      next();
    }
  }, {
    path: '/rangeIos',
    name: 'rangeIos',
    component: __WEBPACK_IMPORTED_MODULE_17__components_rangeIos___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = '保障范围';
      __WEBPACK_IMPORTED_MODULE_20__lib_Utils_trace_js__["enterTrace"]({ page: 6, type: 'rangeIos' });
      next();
    }
  }, {
    path: '/rangeIvvi',
    name: 'rangeIvvi',
    component: __WEBPACK_IMPORTED_MODULE_18__components_rangeIvvi___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = '保障范围';
      __WEBPACK_IMPORTED_MODULE_20__lib_Utils_trace_js__["enterTrace"]({ page: 6, type: 'rangeIvvi' });
      next();
    }
  }, {
    path: '/rangeA0009',
    name: 'rangeA0009',
    component: __WEBPACK_IMPORTED_MODULE_19__components_rangeA0009___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = '保障范围';
      __WEBPACK_IMPORTED_MODULE_20__lib_Utils_trace_js__["enterTrace"]({ page: 6, type: 'rangeA0009' });
      next();
    }
  }, {
    path: '' + bucket,
    name: '' + bucket,
    component: __WEBPACK_IMPORTED_MODULE_21__views_home___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = 'WiFi安全险';
      next();
    }
  }, {
    path: bucket + '/home',
    name: bucket + '/home',
    component: __WEBPACK_IMPORTED_MODULE_21__views_home___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = 'WiFi安全险';
      next();
    }
  }, {
    path: bucket + '/createStore',
    name: bucket + '/createStore',
    meta: {
      keepAlive: true },
    component: __WEBPACK_IMPORTED_MODULE_22__views_createStore___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = '商户参保';
      next();
    }
  }, {
    path: bucket + '/wifiSelect',
    name: bucket + '/wifiSelect',
    component: __WEBPACK_IMPORTED_MODULE_26__views_wifiSelect_index___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = '选择WiFi';
      next();
    }
  }, {
    path: bucket + '/detail',
    name: bucket + '/detail',
    component: __WEBPACK_IMPORTED_MODULE_24__views_detail___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = '投保详情';
      next();
    }
  }, {
    path: bucket + '/insureDetail',
    name: bucket + '/insureDetail',
    component: __WEBPACK_IMPORTED_MODULE_25__views_insureDetail___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = '投保详情';
      next();
    }
  }, {
    path: bucket + '/createSuccess',
    name: bucket + '/createSuccess',
    component: __WEBPACK_IMPORTED_MODULE_23__views_createSuccess___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = '参保成功';
      next();
    }
  }, {
    path: bucket + '/range',
    name: bucket + '/range',
    component: __WEBPACK_IMPORTED_MODULE_27__views_range___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = '保障范围';
      next();
    }
  }, {
    path: bucket + '/rangePersonal',
    name: bucket + 'rangePersonal',
    component: __WEBPACK_IMPORTED_MODULE_28__views_rangePersonal___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = '保障范围';
      next();
    }
  }, {
    path: bucket + '/claimStep1',
    name: bucket + '/claimStep1',
    component: __WEBPACK_IMPORTED_MODULE_29__views_claimStep1___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = '用户索赔登记';
      next();
    }
  }, {
    path: bucket + '/claimStep2',
    name: bucket + '/claimStep2',
    component: __WEBPACK_IMPORTED_MODULE_30__views_claimStep2___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = '用户索赔登记';
      next();
    }
  }, {
    path: bucket + '/claimSuccess',
    name: bucket + '/claimSuccess',
    component: __WEBPACK_IMPORTED_MODULE_31__views_claimSuccess___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = '索赔登记成功';
      next();
    }
  }, {
    path: bucket + '/claimFlow',
    name: bucket + '/claimFlow',
    component: __WEBPACK_IMPORTED_MODULE_33__views_claimFlow___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = '索赔流程';
      next();
    }
  }, {
    path: bucket + '/docs',
    name: bucket + '/docs',
    component: __WEBPACK_IMPORTED_MODULE_32__views_docs___default.a
  }, {
    path: bucket + '/claimList',
    name: bucket + '/claimList',
    component: __WEBPACK_IMPORTED_MODULE_34__views_claimList___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = '索赔记录';
      next();
    }
  }, {
    path: bucket + '/claimDetail',
    name: bucket + '/claimDetail',
    component: __WEBPACK_IMPORTED_MODULE_35__views_claimDetail___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = '索赔详情';
      next();
    }
  }, {
    path: bucket + '/protocol',
    name: bucket + '/protocol',
    component: __WEBPACK_IMPORTED_MODULE_36__views_protocol___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = 'WiFi万能钥匙用户安全保险协议';
      next();
    }
  }, {
    path: bucket + '/protocolIos',
    name: bucket + '/protocolIos',
    component: __WEBPACK_IMPORTED_MODULE_37__views_protocolIos___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = 'WiFi万能钥匙用户安全保险协议';
      next();
    }
  }, {
    path: bucket + '/findMac',
    name: bucket + '/findMac',
    component: __WEBPACK_IMPORTED_MODULE_38__views_docs_findMac___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = '如何找到MAC地址';
      next();
    }
  }, {
    path: bucket + '/isShare',
    name: bucket + '/isShare',
    component: __WEBPACK_IMPORTED_MODULE_39__views_docs_isShare___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      document.title = '如何查看是否分享';
      next();
    }
  }]
}));

/***/ }),
/* 307 */
/***/ (function(module, exports) {


(function () {
    var getURLParams = function getURLParams(paramName) {
        var o = {},
            url = window.location.href,
            search_str = [].concat(url.match(/\?.*/))[0] || '',
            params_str = search_str.replace('?', '');
        var params_arr = params_str.split('&');
        for (var i = 0; i < params_arr.length; i++) {
            var arr = params_arr[i].split('=');
            o[arr[0]] = arr[1];
        }
        if (paramName) {
            return o[paramName];
        }
        return o;
    };
    var appid = getURLParams('appid');
    var color = getURLParams('color');
    if (color) localStorage.setItem('color', color);
    if (appid) localStorage.setItem('appid', appid);
    var class_name = color || localStorage.getItem('color') || appid || localStorage.getItem('appid');
    $('body').addClass(class_name).show();

    var channelTracker = function channelTracker() {
        var r = window.location.search.substr(1).match(new RegExp("(^|&)channel=([^&]*)(&|$)"));
        if (r !== null) {
            var channel = unescape(r[2]);
        }
        localStorage.setItem('channel', channel);
    },
        model = function model(opt) {
        $('.model .foot').show();
        $('.model .btns').hide();
        if (opt == 'hide') {
            $('.model').hide();
        } else {
            $('.model .title').html(opt.title);
            $('.model .content').html(opt.content);
            $('.model .foot').html(opt.foot);
            $('.model').show();
        }
    },
        confirm = function confirm(opt) {
        $('.model .foot').hide();
        $('.model .btns').show();
        $('.model .confirm').unbind('click').bind('click', function () {
            opt.callback();
        });
        $('.model .title').html(opt.title);
        $('.model .content').html(opt.content);
        $('.model').show();
    },
        bindEvent = function bindEvent() {
        $('.model .foot').bind('click', function () {
            model('hide');
        });
        $('.model .cancel').bind('click', function () {
            $('.model').hide();
        });
    };
    window.safe = {
        model: model,
        confirm: confirm,
        bindModelEvent: bindEvent,
        channelTracker: channelTracker
    };
})();

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wifikey_wkt__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wifikey_wkt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__wifikey_wkt__);


function send() {
  var eventId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var query = params;

  if (eventId) {
    var traceV2 = {
      f: eventId,
      b: query
    };
    __WEBPACK_IMPORTED_MODULE_0__wifikey_wkt___default.a.send({
      data: traceV2
    });

    console.log('【WKT】', { f: eventId, b: query });
  } else {
    console.log('【WKT】', { f: eventId, b: query });
  }
}

/***/ }),
/* 309 */,
/* 310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(624)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(810),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 312 */,
/* 313 */
/***/ (function(module, exports, __webpack_require__) {


/* !
* upload-image-sdk
* upload-image v0.1.1
* updated date 2020-9-22
*/
!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports["upload-image"]=t():e["upload-image"]=t()}(window,(function(){return function(e){var t={};function r(n){if(t[n])return t[n].exports;var o=t[n]={i:n,l:!1,exports:{}};return e[n].call(o.exports,o,o.exports,r),o.l=!0,o.exports}return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)r.d(n,o,function(t){return e[t]}.bind(null,o));return n},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=1)}([function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.WIFIKEY_BUCKET="/fs/uploadImg.action",t.QINIU_BASE64_bUCKET="/putb64/-1",t.regionUphostMap={z0:{srcUphost:"up.qiniup.com",cdnUphost:"upload.qiniup.com"},z1:{srcUphost:"up-z1.qiniup.com",cdnUphost:"upload-z1.qiniup.com"},z2:{srcUphost:"up-z2.qiniup.com",cdnUphost:"upload-z2.qiniup.com"},na0:{srcUphost:"up-na0.qiniup.com",cdnUphost:"upload-na0.qiniup.com"},as0:{srcUphost:"up-as0.qiniup.com",cdnUphost:"upload-as0.qiniup.com"},wifi:{srcUphost:"fs.51y5.net",cdnUphost:"fs.51y5.net"}},t.region={z0:"z0",z1:"z1",z2:"z2",na0:"na0",as0:"as0",wifi:"wifi"}},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.getUploadUrl=void 0;var n=r(2);Object.defineProperty(t,"getUploadUrl",{enumerable:!0,get:function(){return n.getUploadUrl}}),t.uploadFile=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:a.QINIU,r=e.config||{};return r.region=r.upHost||r.upHost||"wifikey"!=t?null:"wifi",new Promise((function(s,f){(0,n.getUploadUrl)(r,e.token).then((function(){var r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",n=a.QINIU===t,d=a.QINIU_BASE64===t,p=a.WIFIKEY===t;e.base64=(0,o.isArray)(e.file)?e.file:null,n?(0,o.isFileList)(e.file)||(0,o.isArray)(e.file)?s(c(r,e)):(0,o.isFile)(e.file)||(0,o.isBlob)(e.file)?(e.file=[e.file],s(c(r,e))):s(u(""+r+i.QINIU_BASE64_bUCKET,e)):d?s(u(""+r+i.QINIU_BASE64_bUCKET,e)):p?s(function(e,t){var r=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.file;((0,o.isFile)(e.file)||(0,o.isBlob)(e.file))&&(t=[e.file]);var r=new FormData;Object.keys(e).map((function(t){"token"!=t?"file"==t||r.append(t,e[t]):r.append("sign",e[t])}));try{for(var n=[],i=0;i<t.length;i++)r.append("imgFile",t[i]),n.push(r);return n}catch(e){return[]}}(t);return Promise.all(r.map((function(t){return l(e,t)})))}(""+r+i.WIFIKEY_BUCKET,e)):f("Request type error")}))}))},t.uploadBase64=u,t.sendRequest=l;var o=r(4),i=r(0),a={WIFIKEY:"wifikey",QINIU:"qiniu",QINIU_BASE64:"qiniu_base64"};function u(e,t){return t.base64?(0,n.requestBase64)(e,t):(((0,o.isFile)(t.file)||(0,o.isBlob)(t.file))&&(t.file=[t.file]),(0,n.readFileBase64)(t.file).then((function(r){return t.base64=r,(0,n.requestBase64)(e,t)})).catch((function(e){})))}function c(e){for(var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.file||[],n=[],o=0;o<r.length;o++){var i=r[o];t.file=i;var a=t;n.push(s(a))}try{return Promise.all(n.map((function(t){return l(e,t)})))}catch(e){throw e}}function s(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=new FormData;t.append("file",e.file),t.append("token",e.token),null!=e.key&&t.append("key",e.key);var r=e.putExtra||{};return r.fname&&t.append("fname",e.putExtra.fname),(0,n.filterParams)(r.params).forEach((function(e){return t.append(e[0],e[1])})),t}function l(e,t){return new Promise((function(r,o){var i=[];return(0,n.request)(e,{method:"POST",body:t,onProgress:function(e){},onCreate:function(e){return i.push(e)}}).then((function(e){r(e)}))}))}},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.readFileBase64=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"base64";return Promise.all(Object.values(e).map((function(e){return new Promise((function(r,n){if("file"!==t){var o=new FileReader;o.onload=function(e){r(e.target.result)},"base64"===t?o.readAsDataURL(e):"text"===t&&o.readAsText(e)}else n()}))})))},t.isChunkExpired=function(e){var t=e+864e5;return(new Date).getTime()>t},t.updateDirectProgress=function(e,t){return{total:function(e,t){return{loaded:e,size:t,percent:e/t*100}}(e,t+1)}},t.request=i,t.requestBase64=function(e,t){var r=t.token;return Promise.all(t.base64.map((function(t,n){return new Promise((function(o,i){var a=t.replace(/data\:image\/png\;base64\,/g,"").replace(/data\:image\/jpeg\;base64\,/g,"").replace(/data\:image\/gif\;base64\,/g,""),u=new XMLHttpRequest;u.onreadystatechange=function(){4===u.readyState&&o({postImage:u.responseText,index:n})},u.open("POST",e,!0),u.setRequestHeader("Content-Type","application/octet-stream"),u.setRequestHeader("Authorization","UpToken "+r),u.send(a)}))})))},t.filterParams=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return Object.keys(e).filter((function(e){return e.startsWith("x:")})).map((function(t){return[t,e[t].toString()]}))},t.createXHR=a,t.getUploadUrl=function(e,t){var r=Object.assign({useCdnDomain:!0,disableStatisticsReport:!1,retryCount:3,checkByMD5:!1,upHost:null,upPath:"",forceDirect:!1,concurrentRequestLimit:3,region:null},e),a=u();if(null!=r.upHost)return Promise.resolve(a+"//"+r.upHost+r.upPath);if(null!=r.region){var c=o.regionUphostMap[r.region],s=r.useCdnDomain?c.cdnUphost:c.srcUphost;return Promise.resolve(a+"//"+s+r.upPath)}return function(e){try{var t=function(e){var t=e.split(":"),r=t[0],o=JSON.parse((0,n.urlSafeBase64Decode)(t[2]));return o.ak=r,o.bucket=o.scope.split(":")[0],o}(e);return i(u()+"//api.qiniu.com/v2/query?ak="+t.ak+"&bucket="+t.bucket,{method:"GET"})}catch(e){return Promise.reject(e)}}(t).then((function(e){var t=e.data.up.acc.main;return a+"//"+t[0]+r.upPath})).catch((function(e){}))};var n=r(3),o=r(0);function i(e,t){return new Promise((function(r,n){var o=a();o.open(t.method,e),t.onCreate&&t.onCreate(o),t.headers&&Object.keys(t.headers).forEach((function(e){return o.setRequestHeader(e,t.headers[e])})),o.onreadystatechange=function(){var e=o.responseText;if(4===o.readyState){if(200!==o.status){var t="xhr request failed, code: "+o.status+";";return e&&(t=t+" response: "+e),void n({code:o.status,message:t,reqId:reqId,isRequestError:!0})}try{r({data:JSON.parse(e)})}catch(e){n(e)}}},o.send(t.body)}))}function a(){return window.XMLHttpRequest?new XMLHttpRequest:new window.ActiveXObject("Microsoft.XMLHTTP")}function u(){return"http:"===window.location.protocol?"http:":"https:"}},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.urlSafeBase64Encode=function(e){return(e=function(e){var t="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",r=void 0,n=void 0,o=void 0,i=void 0,a=void 0,u=0,c=0,s="",l=[];if(!e)return e;e=function(e){if(null==e)return"";var t,r=e+"",n="",o=void 0,i=void 0;o=i=0,t=r.length;for(var a=0;a<t;a++){var u=r.charCodeAt(a),c=null;if(u<128)i++;else if(u>127&&u<2048)c=String.fromCharCode(u>>6|192,63&u|128);else if(63488&u^!0)c=String.fromCharCode(u>>12|224,u>>6&63|128,63&u|128);else{if(64512&u^!0)throw new RangeError("Unmatched trail surrogate at "+a);var s=r.charCodeAt(++a);if(64512&s^!0)throw new RangeError("Unmatched lead surrogate at "+(a-1));u=((1023&u)<<10)+(1023&s)+65536,c=String.fromCharCode(u>>18|240,u>>12&63|128,u>>6&63|128,63&u|128)}null!==c&&(i>o&&(n+=r.slice(o,i)),n+=c,o=i=a+1)}return i>o&&(n+=r.slice(o,t)),n}(e+"");do{r=(a=e.charCodeAt(u++)<<16|e.charCodeAt(u++)<<8|e.charCodeAt(u++))>>18&63,n=a>>12&63,o=a>>6&63,i=63&a,l[c++]=t.charAt(r)+t.charAt(n)+t.charAt(o)+t.charAt(i)}while(u<e.length);switch(s=l.join(""),e.length%3){case 1:s=s.slice(0,-2)+"==";break;case 2:s=s.slice(0,-1)+"="}return s}(e)).replace(/\//g,"_").replace(/\+/g,"-")},t.urlSafeBase64Decode=function(e){return function(e){var t="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",r=void 0,n=void 0,o=void 0,i=void 0,a=void 0,u=void 0,c=0,s=0,l=[];if(!e)return e;e+="";do{r=(u=t.indexOf(e.charAt(c++))<<18|t.indexOf(e.charAt(c++))<<12|(i=t.indexOf(e.charAt(c++)))<<6|(a=t.indexOf(e.charAt(c++))))>>16&255,n=u>>8&255,o=255&u,l[s++]=64===i?String.fromCharCode(r):64===a?String.fromCharCode(r,n):String.fromCharCode(r,n,o)}while(c<e.length);return l.join("")}(e=e.replace(/_/g,"/").replace(/-/g,"+"))}},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.isFileList=function(e){return"[object FileList]"===n.call(e)},t.isFile=function(e){return"[object File]"===n.call(e)},t.isObject=function(e){return"[object Object]"===n.call(e)},t.isBlob=function(e){return"[object Blob]"===n.call(e)},t.isArray=function(e){return"[object Array]"===n.call(e)};var n=Object.prototype.toString}])}));

/***/ }),
/* 314 */,
/* 315 */,
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    watch: {
        '$route': function $route(to, from) {
            var _self = this;
            if (_self.routeList.length === 0) _self.routeList.push(from.name);
            if (_self.routeList.length > 1 && to.name === _self.routeList[_self.routeList.length - 2]) {
                _self.transitionName = 'prev';
                _self.routeList.splice(_self.routeList.length - 1, 1);
                return;
            }
            if (_self.routeList.length > 2 && to.name === _self.routeList[_self.routeList.length - 3]) {
                _self.transitionName = 'prev';
                _self.routeList.splice(_self.routeList.length - 2, 2);
                return;
            }
            _self.transitionName = 'next';
            _self.routeList.push(to.name);
        }
    },
    data: function data() {
        return {
            transitionName: 'next',
            routeList: []
        };
    }
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClaimFlow',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



var AES = __webpack_require__(29).default;
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'claimList',
    data: function data() {
        return {
            list: '',
            uhid: '',
            loading: false
        };
    },

    mounted: function mounted() {
        var _self = this;
        Utils.Bridge.call('getAppInfo', {
            success: function success(o) {
                _self.uhid = o.uhid;

                _self.loading = true;
                var data = {
                    "dhid": o.dhid,
                    "uhid": o.uhid,
                    "vcode": o.vcode
                };
                var ed = AES.Encrypt(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), AES.obj());

                _self.$http.post("https://insurance.lianwifi.com" + '/safe/get_list', {
                    ed: ed
                }, {
                    emulateJSON: true
                }).then(function (response) {
                    _self.loading = false;
                    var json = response.body;
                    if (json.c == '0000') {
                        _self.list = json.m;
                    } else {
                        safe.model({
                            title: '温馨提示',
                            content: json.m,
                            foot: '我知道了'
                        });
                        safe.bindModelEvent();
                    }
                });
            }
        });
        _self.$trace.enterTraceDone({ page: 8 });
    }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);




var AES = __webpack_require__(29).default;
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ClaimStep1',
    mounted: function mounted() {
        var _self = this;
        Utils.Bridge.call('getAppInfo', {
            success: function success(o) {
                _self.appinfo = o;

                _self.loading = true;
                var data = {
                    "dhid": o.dhid,
                    "uhid": o.uhid,
                    "vcode": o.vcode
                };
                var ed = AES.Encrypt(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data), AES.obj());
                _self.$http.post("https://insurance.lianwifi.com" + '/safe/get_order', {
                    ed: ed
                }, {
                    emulateJSON: true
                }).then(function (response) {
                    _self.loading = false;
                    var json = response.body;
                    if (json.m.has_list === true) {
                        var list = json.m.list;
                        for (var att in list) {
                            var value = list[att];
                            if (value == '2') {
                                $('.main .check[data-index=' + att + ']').addClass('checked');
                            }
                        }
                    }
                });
            }
        });
        $('.main .doc_text').bind('click', function () {
            $(this).find('.check').toggleClass('checked');
        });

        _self.$trace.enterTraceDone({ page: 7, step: 1 });
    },
    data: function data() {
        return {
            appinfo: '',
            loading: false
        };
    },

    methods: {
        claimStep1: function claimStep1() {
            var _self = this;
            _self.$trace.trace('ins_claim_confirm', { step: 1, type: 'ind' });
            var params = {
                "dhid": _self.appinfo.dhid,
                "uhid": _self.appinfo.uhid,
                "vcode": _self.appinfo.vcode
            };
            var hasSelect = false;
            var traceObj = {};
            $('.main .check').each(function (index, ele) {
                var dataId = $(ele).attr('data-index');
                if ($(ele).hasClass('checked')) {
                    params[dataId] = '2';
                    traceObj[dataId] = '2';
                    hasSelect = true;
                } else {
                    params[dataId] = '1';
                }
            });
            _self.$trace.trace('ins_claim_btn', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, traceObj, { type: 'ind' }));
            console.log('\u70B9\u6211\u8981\u7D22\u8D54\u7B49\u7EA7');

            if (!hasSelect) {
                safe.model({
                    title: '温馨提示',
                    content: '请选择索赔范围',
                    foot: '我知道了'
                });
                safe.bindModelEvent();
                return;
            }

            console.log('\u70B9\u786E\u8BA4\u767B\u8BB0');
            var ed = AES.Encrypt(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(params), AES.obj());
            this.$http.post("https://insurance.lianwifi.com" + '/safe/order_first', { ed: ed }, {
                emulateJSON: true
            }).then(function (response) {
                var json = response.body;
                if (json.c == '0000') {
                    _self.$router.push("/claimStep2?order_sn=" + json.m.order_sn);
                } else {
                    safe.model({
                        title: '温馨提示',
                        content: json.m,
                        foot: '我知道了'
                    });
                    safe.bindModelEvent();
                }
            });
        }
    }
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toast__ = __webpack_require__(80);




var AES = __webpack_require__(29).default;

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ClaimStep2',
    mounted: function mounted() {
        var _self = this;
        _self.order_sn = this.$route.query.order_sn, Utils.Bridge.call('getAppInfo', {
            success: function success(o) {
                _self.appinfo = o;
                _self.loadCardPics();
                _self.loadPricePics();
                _self.bindEvent();
            }
        });

        _self.$trace.enterTraceDone({ page: 7, step: 2 });
    },
    data: function data() {
        return {
            appinfo: '',
            order_sn: '',
            loading: false
        };
    },

    methods: {
        claimStep2: function claimStep2() {
            var _self = this;
            _self.$trace.trace('ins_claim_confirm', { step: 2, type: 'ind' });
            var params = {
                "dhid": _self.appinfo.dhid,
                "uhid": _self.appinfo.uhid,
                "vcode": _self.appinfo.vcode
            };
            var error = false,
                msg = '';
            params.order_sn = _self.order_sn;

            $('.upload .item').each(function (index, ele) {
                if ($(ele).data('upload') + '' != 'true') {
                    error = true;
                    switch (index) {
                        case 0:
                            msg = '身份证正面';
                            break;
                        case 1:
                            msg = '身份证反面';
                            break;
                        case 2:
                            msg = '被盗信息截屏';
                            break;
                    }
                    return false;
                }
            });
            if (error) {
                safe.model({
                    title: '温馨提示',
                    content: msg + '未上传完成',
                    foot: '我知道了'
                });
                safe.bindModelEvent();
                return;
            }

            var ed = AES.Encrypt(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params), AES.obj());
            this.$http.post("https://insurance.lianwifi.com" + '/safe/order_sec', { ed: ed }, {
                emulateJSON: true
            }).then(function (response) {
                var json = response.body;
                if (json.c == '0000') {
                    _self.$router.push("/claimSuccess");
                } else {
                    safe.model({
                        title: '温馨提示',
                        content: json.m,
                        foot: '我知道了'
                    });
                    safe.bindModelEvent();
                }
            });
        },
        loadCardPics: function loadCardPics() {
            var _self = this;
            _self.loading = true;

            var data = {
                "dhid": _self.appinfo.dhid,
                "uhid": _self.appinfo.uhid,
                "vcode": _self.appinfo.vcode
            };
            var ed = AES.Encrypt(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), AES.obj());

            this.$http.post("https://insurance.lianwifi.com" + '/user/get', {
                ed: ed
            }, {
                emulateJSON: true
            }).then(function (response) {
                _self.loading = false;
                var json = response.body;
                if (json.c == '0000') {
                    var picUrlFront = json.m.u_card_front_thumb,
                        picUrlback = json.m.u_card_back_thumb;
                    if (picUrlFront) {
                        $('.upload .item1').data('upload', 'true');
                        $('.upload .item1').addClass('uploaded');
                    }
                    if (picUrlback) {
                        $('.upload .item2').data('upload', 'true');
                        $('.upload .item2').addClass('uploaded');
                    }
                } else {
                    safe.model({
                        title: '温馨提示',
                        content: json.m,
                        foot: '我知道了'
                    });
                    safe.bindModelEvent();
                }
            });
        },
        loadPricePics: function loadPricePics(first, second) {
            var _self = this;
            _self.loading = true;

            var data = {
                "id": _self.order_sn,
                "uhid": _self.appinfo.uhid
            };
            var ed = AES.Encrypt(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), AES.obj());
            this.$http.post("https://insurance.lianwifi.com" + '/safe/get_one', {
                ed: ed
            }, {
                emulateJSON: true
            }).then(function (response) {
                _self.loading = false;
                var json = response.body;
                if (json.c == '0000') {
                    var picUrlPrice = json.m.price_info_thumb;
                    if (picUrlPrice) {
                        $('.screenShot').data('upload', 'true');
                        $('.screenShot').addClass('uploaded');
                        $('.screenShot').addClass('screen');
                    }
                } else {
                    safe.model({
                        title: '温馨提示',
                        content: json.m,
                        foot: '我知道了'
                    });
                    safe.bindModelEvent();
                }
            });
        },
        bindEvent: function bindEvent() {
            var _self = this;
            var params = 'uhid=' + _self.appinfo.uhid + '&order_sn=' + _self.order_sn;
            document.getElementById('uploadIDFront').onchange = function () {
                _self.applyAjaxFileUpload("uploadIDFront", params + '&file_id=uploadIDFront&type=front');
            };
            document.getElementById('uploadIDBack').onchange = function () {
                _self.applyAjaxFileUpload("uploadIDBack", params + '&file_id=uploadIDBack&type=back');
            };
            document.getElementById('uploadPrice').onchange = function () {
                _self.applyAjaxFileUpload("uploadPrice", params + '&file_id=uploadPrice&type=price');
            };
        },
        applyAjaxFileUpload: function applyAjaxFileUpload(element, params) {
            try {
                var obj = document.getElementById(element).files[0];
                console.log('1234567', obj.type);
                var str = obj.type;
                if (str.indexOf('image') < 0) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_toast__["a" /* default */])('上传的格式不正确');
                    console.log("照片上传：文件类型必须是JPG、JPEG、PNG或GIF!");
                    return;
                }
            } catch (e) {
                return;
                console.log("", e);
            }

            var _self = this;
            _self.loading = true;
            var url = "https://insurance.lianwifi.com" + '/inc/upload_img?' + params;

            $.ajaxFileUpload({
                url: url,
                secureuri: false,
                fileElementId: element,
                dataType: 'json',
                success: function success(response) {
                    if (element == "uploadPrice") {
                        setTimeout(function () {
                            _self.loadPricePics();
                        }, 3000);
                    } else {
                        setTimeout(function () {
                            _self.loadCardPics();
                        }, 3000);
                    }
                    _self.bindEvent();
                }
            });
        }
    }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClaimSuccess',
  mounted: function mounted() {}
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_qa__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_qa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_qa__);





var AES = __webpack_require__(29).default;
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'index',
    components: {
        qa: __WEBPACK_IMPORTED_MODULE_1__components_qa___default.a
    },
    mounted: function mounted() {
        var _self = this;
        Utils.Bridge.call('getAppInfo', {
            success: function success(o) {
                _self.appinfo = o;

                Utils.Bridge.call('checkLogin', {
                    success: function success(bool) {
                        if (bool) {
                            _self.checkStatus();
                            _self.$trace.enterTraceDone({ page: 1, login: 'have_login' });
                        } else {
                            _self.$trace.enterTraceDone({ page: 1, login: 'no_login' });
                            _self.pageStatus = 1;
                        }
                    }
                });
            }
        });

        Utils.Bridge.call('hideOptionMenu');
        setTimeout(function (_) {
            Utils.Bridge.call('hideOptionMenu');
        }, 2000);
    },
    data: function data() {
        return {
            msg: 'tests',
            obj: '',
            appinfo: '',
            createBtn: 1,
            pageStatus: 0,
            loading: false,
            claimList: false,
            appid: this.$route.query.appid
        };
    },

    methods: {
        range: function range() {},

        toRange: function toRange() {
            if (this.appinfo.chanid == 'ivvi') {
                this.$router.push("/rangeIvvi");
                this.$trace.trace('ins_detail', { type: 'rangeIvvi' });
            } else if (this.appinfo.appid == 'A0009') {
                this.$router.push("/rangeA0009");
                this.$trace.trace('ins_detail', { type: 'rangeA0009' });
            } else if (this.appinfo.appid == 'I0010') {
                this.$router.push("/rangeIos");
                this.$trace.trace('ins_detail', { type: 'rangeIos' });
            } else {
                this.$router.push("/range");
                this.$trace.trace('ins_detail', { type: 'range' });
            }
            console.log('\u67E5\u770B\u4FDD\u9669\u8BE6\u60C5');
        },
        clickRange: function clickRange() {
            this.$trace.trace('ins_mine_detail', 'ind');
            console.log('\u70B9\u4FDD\u969C\u8303\u56F4');
        },
        clickClaimList: function clickClaimList() {
            this.$trace.trace('ins_mine_record', 'ind');
            console.log('\u70B9\u7D22\u8D54\u8BB0\u5F55');
        },

        goCreate: function goCreate() {
            this.$trace.trace('ins_join', 'have_login');
            console.log('\u53C2\u4FDD\uFF1A\u5DF2\u767B\u5F55');
            sessionStorage.removeItem('PERSONAL_INFO');
            this.$router.push("/create");
        },
        goClaim: function goClaim() {
            this.$trace.trace('ins_mine_claim');
            console.log('\u6211\u8981\u7D22\u8D54');
            if (this.obj.status == 2) {
                safe.model({
                    title: '温馨提示',
                    content: '您有一笔保单正在索赔中，不能提交新的索赔',
                    foot: '我知道了'
                });
                safe.bindModelEvent();
                return;
            } else {
                this.$router.push('/claimStep1');
            }
        },
        checkStatus: function checkStatus() {
            var _self = this;
            _self.loading = true;

            var data = {
                "dhid": _self.appinfo.dhid,
                "uhid": _self.appinfo.uhid,
                "vcode": _self.appinfo.vcode
            };
            var ed = AES.Encrypt(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), AES.obj());

            this.$http.post("https://insurance.lianwifi.com" + '/user/get', {
                ed: ed
            }, {
                emulateJSON: true
            }).then(function (response) {
                _self.loading = false;
                var json = response.body;
                if (json.c == '0000') {
                    document.title = '我的保障';

                    _self.pageStatus = 2;
                    _self.$trace.enterTraceDone({ page: 2 });
                    _self.obj = json.m;
                    _self.obj.end_time = _self.obj.end_time || '2023年9月15日24时';
                    var status = json.m.status,
                        hasList = json.m.has_list;
                    if (status == '2') {
                        $('body').addClass('claim');
                    }
                    if (hasList == '2') {
                        $('.bottom_btn').css('width', '50%');
                        _self.claimList = true;
                    }
                } else {
                    _self.pageStatus = 1;
                    _self.createBtn = 2;
                }
            });
        },
        login: function login() {
            var _self = this;
            var trackerB = '';
            if ($(this).attr('id') == 'createBtn') {
                trackerB = 'ins_freepro_login';
            } else {
                trackerB = 'ins_mypro';
            }

            _self.$trace.trace('ins_join', 'no_login');
            console.log('\u53C2\u4FDD\uFF1A\u672A\u767B\u5F55');

            Utils.Bridge.call("login", {
                fromSource: "app_insurance",
                loginMode: 0,
                success: function success(ok) {
                    if (ok || _self.$wkb.isWKBrowser === "ios") {
                        Utils.Bridge.call('getAppInfo', {
                            success: function success(o) {
                                _self.appinfo = o;

                                var data = {
                                    "dhid": _self.appinfo.dhid,
                                    "uhid": _self.appinfo.uhid,
                                    "vcode": _self.appinfo.vcode
                                };
                                var ed = AES.Encrypt(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), AES.obj());

                                _self.$http.post("https://insurance.lianwifi.com" + '/user/get', {
                                    ed: ed
                                }, {
                                    emulateJSON: true
                                }).then(function (response) {
                                    _self.loading = false;
                                    var json = response.body;
                                    if (json.c == '0000') {
                                        document.title = '我的保障';

                                        _self.pageStatus = 2;
                                        _self.obj = json.m;
                                        _self.obj.end_time = _self.obj.end_time || '2023年9月15日24时';
                                        var status = json.m.status,
                                            hasList = json.m.has_list;
                                        if (status == '2') {
                                            $('body').addClass('claim');
                                        }
                                        if (hasList == '2') {
                                            $('.bottom_btn').css('width', '50%');
                                            _self.claimList = true;
                                        }
                                    } else {
                                        sessionStorage.removeItem('PERSONAL_INFO');
                                        _self.$router.push("/create");
                                    }
                                });
                            }
                        });
                    }
                }
            });
        },
        noCreate: function noCreate() {
            safe.model({
                title: '温馨提示',
                content: '抱歉，您暂时还未参保，请先点击免费参保',
                foot: '我知道了'
            });
            safe.bindModelEvent();
        }
    }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vant__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_common__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_index__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_image__ = __webpack_require__(362);












var imageCacheMap = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "wk-single-image-upload",
  model: {
    prop: "value",
    event: "change"
  },

  watch: {
    value: function value() {
      this.setPreviewSrcFromCache();
    }
  },

  created: function created() {
    this.setPreviewSrcFromCache();
  },


  props: {
    value: {
      type: String,
      default: ""
    },

    dest: {
      type: String,
      default: "qiniu",
      validator: function validator(value) {
        return ["qiniu", "wifikey"].includes(value);
      }
    },

    limit: {
      type: Number,
      default: 20
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      loading: false,
      previewSrc: ''
    };
  },

  computed: {
    innerDisabled: function innerDisabled() {
      return this.disabled || this.loading;
    },
    limitByte: function limitByte() {
      return this.limit * 1024 * 1024;
    }
  },

  methods: {
    hanldeFileChange: function hanldeFileChange(evt) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var files, _evt$target$files, file, errorMessage, ossKey;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                files = evt.target.files;
                _evt$target$files = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(evt.target.files, 1), file = _evt$target$files[0];

                if (files.length) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                errorMessage = _this.validate(file);

                if (!errorMessage) {
                  _context2.next = 9;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_3_vant__["b" /* Toast */].fail(errorMessage);
                _this.$refs.fileInput.value = "";
                return _context2.abrupt("return");

              case 9:
                ossKey = void 0;

                _this.previewSrc = '';

                _context2.next = 13;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_image__["a" /* compressor */])(file, {
                  quality: 0.8,
                  minWidth: 200,
                  minHeight: 200,
                  convertSize: 5000000
                }).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res) {
                    var uploadedSrc;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            console.log("=====", res);
                            _context.prev = 1;

                            _this.loading = true;

                            if (!(_this.dest === "qiniu")) {
                              _context.next = 7;
                              break;
                            }

                            _context.next = 6;
                            return _this.uploadFileToQiniu(res.file);

                          case 6:
                            ossKey = _context.sent;

                          case 7:
                            if (!(_this.dest === "wifikey")) {
                              _context.next = 11;
                              break;
                            }

                            _context.next = 10;
                            return _this.uploadFileToWifikey(res.file);

                          case 10:
                            ossKey = _context.sent;

                          case 11:
                            uploadedSrc = _this.getUploadedSrc(ossKey);


                            _this.$emit('change', uploadedSrc);

                            imageCacheMap[uploadedSrc] = res.content;
                            _this.previewSrc = res.content;

                            _context.next = 23;
                            break;

                          case 17:
                            _context.prev = 17;
                            _context.t0 = _context["catch"](1);

                            _this.$emit('change', '');
                            __WEBPACK_IMPORTED_MODULE_3_vant__["b" /* Toast */].fail("上传图片失败，请稍候重试");
                            console.log("error", _context.t0);
                            return _context.abrupt("return");

                          case 23:
                            _context.prev = 23;

                            _this.loading = false;

                            _this.$refs.fileInput.value = '';
                            return _context.finish(23);

                          case 27:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, _this, [[1, 17, 23, 27]]);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    getUploadedSrc: function getUploadedSrc(ossKey) {
      var HOST_MAP = {
        qiniu: "https://filex.51y5.net/",
        wifikey: ""
      };
      return ossKey ? "" + HOST_MAP[this.dest] + ossKey : "";
    },
    validate: function validate(file) {
      if (file.size > this.limitByte) {
        return "\u56FE\u7247\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7 " + this.limit + "MB";
      }

      return false;
    },
    uploadFileToQiniu: function uploadFileToQiniu(file) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref2, uploadToken, requestParams, imageList, img, _ref3, key;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__services_common__["c" /* getQiniuUploadImageToken */])({});

              case 2:
                _ref2 = _context3.sent;
                uploadToken = _ref2.data.uploadToken;
                requestParams = {
                  file: file,
                  token: uploadToken
                };
                _context3.next = 7;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__index__["uploadFile"])(requestParams);

              case 7:
                imageList = _context3.sent;
                img = imageList[0] || {};
                _ref3 = img && img.data, key = _ref3.key;
                return _context3.abrupt("return", key);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    uploadFileToWifikey: function uploadFileToWifikey(file) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var bizId, _ref4, uploadToken, requestParams, imgList, img;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                bizId = "M_PRODUCT";
                _context4.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__services_common__["c" /* getQiniuUploadImageToken */])({ bizId: bizId });

              case 3:
                _ref4 = _context4.sent;
                uploadToken = _ref4.data.uploadToken;
                requestParams = { file: file, token: uploadToken, bizId: "wk_0012" };
                _context4.next = 8;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__index__["uploadFile"])(requestParams, "wifikey");

              case 8:
                imgList = _context4.sent;
                img = imgList[0] && imgList[0].data;
                return _context4.abrupt("return", img.url);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    setPreviewSrcFromCache: function setPreviewSrcFromCache() {
      var imageCache = imageCacheMap[this.value];
      var isCacheHitted = Boolean(imageCache);
      this.previewSrc = isCacheHitted ? imageCache : this.hanldeImageUrl();
      return isCacheHitted;
    },
    hanldeImageUrl: function hanldeImageUrl() {
      var HOST_MAP = {
        qiniu: "",
        wifikey: "https://local.51y5.net/region/fastdfs/img.do?url="
      };
      return this.value ? "" + HOST_MAP[this.dest] + this.value : "";
    }
  }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



var AES = __webpack_require__(29).default;
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'claimDetail',
    mounted: function mounted() {
        var _self = this;
        var orderId = this.$route.query.order_id,
            uhid = this.$route.query.uhid;

        _self.loading = true;

        var data = {
            "id": orderId,
            "uhid": uhid
        };
        var ed = AES.Encrypt(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), AES.obj());

        this.$http.post("https://insurance.lianwifi.com" + '/safe/get_one', {
            ed: ed
        }, {
            emulateJSON: true
        }).then(function (response) {
            _self.loading = false;
            var json = response.body;
            if (json.c == '0000') {
                _self.obj = json.m;
                console.log(_self.obj);
            } else {
                safe.model({
                    title: '温馨提示',
                    content: json.m,
                    foot: '我知道了'
                });
                safe.bindModelEvent();
            }
        });
        _self.$trace.enterTraceDone({ page: 3 });
    },
    data: function data() {
        return {
            obj: '',
            loading: false
        };
    }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_qa__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_qa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_qa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clipboard__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toast__ = __webpack_require__(80);





var AES = __webpack_require__(29).default;



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'create',
    components: {
        qa: __WEBPACK_IMPORTED_MODULE_1__components_qa___default.a
    },
    created: function created() {
        try {
            this.formData = JSON.parse(sessionStorage.getItem('PERSONAL_INFO' || null)) || {};
        } catch (error) {}
    },

    mounted: function mounted() {
        var _self = this;
        Utils.Bridge.call('getAppInfo', {
            success: function success(o) {
                _self.appinfo = o;
                _self.bindEvent();

                if (o.chanid == 'ivvi') {
                    _self.protocol = 'protocolIvvi';
                } else if (o.appid == 'A0009') {
                    _self.protocol = 'protocolA0009';
                } else if (o.appid == 'I0010') {
                    _self.protocol = 'protocolIos';
                } else {
                    _self.protocol = 'protocol';
                }

                var provinceIndex = $('#provinceIndex').val(),
                    cityIndex = $('#cityIndex').val();
                if (provinceIndex >= 0 && cityIndex >= 0) {
                    _self.setSelectValue([provinceIndex, cityIndex]);
                }
            }
        });
        _self.$trace.enterTraceDone({ page: 4 });
    },
    data: function data() {
        return {
            protocol: 'protocol',
            appinfo: '',
            showAlertModel: false,
            modelContent: '',
            loading: false,
            formData: {
                name: '',
                card: ''
            }
        };
    },

    methods: {
        bindEvent: function bindEvent() {
            var _self = this;

            $('.main input').bind({
                focus: function focus() {
                    if ($(this).parent('p').hasClass('error')) {
                        $(this).parent('p').removeClass('error');
                        $(this).val('');
                    }
                }
            });
            $('.protocol .checkbox').bind('click', function () {
                $(this).toggleClass('checked');
            });
            _self.formData.user_mobile = _self.appinfo.ph || _self.appinfo.mobile;
        },
        create: function create() {
            var _self = this;
            _self.$trace.trace('ins_join_btn', 'ind');
            console.log('\u586B\u5199\u9875\u9762\uFF0C\u70B9\u53C2\u4FDD\u6309\u94AE');
            if (!_self.hasEmpty() && _self.checkName() && _self.checkIDCard()) {
                if ($('.protocol .checkbox').hasClass('checked')) {
                    $('.errorMsg').hide();

                    safe.confirm({
                        title: '温馨提示',
                        content: '众安保险提醒您:请确保您的信息真实有效，以保障您后期的索赔权益，否则将失去索赔权益',
                        callback: function callback() {
                            _self.saveUserInfo();
                        }
                    });
                } else {
                    safe.model({
                        title: '温馨提示',
                        content: '同意WiFi万能钥匙理赔服务协议才能参保',
                        foot: '我知道了'
                    });
                }
            }
            safe.bindModelEvent();
        },
        saveUserInfo: function saveUserInfo() {
            var _self = this;


            var data = {
                "dhid": _self.appinfo.dhid,
                "uhid": _self.appinfo.uhid,
                "vcode": _self.appinfo.vcode,
                "user_name": _self.formData.name,
                "user_card": _self.formData.card
            };
            var ed = AES.Encrypt(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), AES.obj());
            _self.loading = true;
            this.$http.post("https://insurance.lianwifi.com" + '/user/save', {
                ed: ed
            }, {
                emulateJSON: true
            }).then(function (response) {
                _self.loading = false;
                var json = response.body;
                if (json.c == '0000') {
                    $('.model').hide();
                    _self.$router.push("/createSuccess");
                    Utils.Bridge.call('notifyAction', {
                        event: 'insurance'
                    });
                } else if (json.c == '2012') {
                    $('.model').hide();
                    this.showAlertModel = true;
                    this.modelContent = json.m;
                } else {
                    $('.model').hide();
                    safe.model({
                        title: '温馨提示',
                        content: json.m,
                        foot: '我知道了'
                    });

                    safe.bindModelEvent();
                }
            });
        },
        hasEmpty: function hasEmpty() {
            for (var key in this.formData) {
                if (this.formData[key] === '') {
                    safe.model({
                        title: '温馨提示',
                        content: '请填写完整再提交保单',
                        foot: '我知道了'
                    });
                    return true;
                }
            }
            return false;
        },
        copyQq: function copyQq(val) {
            var _this = this;

            var clipboard = new __WEBPACK_IMPORTED_MODULE_2_clipboard___default.a('.copy-qq', {
                text: function text() {
                    return val;
                }
            });
            clipboard.on('success', function (e) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__toast__["a" /* default */])('复制成功');
                _this.cancel();
                console.info('触发的方式（复制还是剪切）', e.text);
            });
        },

        checkIDCard: function checkIDCard() {
            var idcard = this.formData.card;
            var _id = this.parseID(idcard);
            if (isNaN(_id.substr(0, 17))) {
                safe.model({
                    title: '温馨提示',
                    content: '身份证号码格式有误',
                    foot: '我知道了'
                });
                return false;
            }
            return true;
        },
        checkName: function checkName() {
            var reg = /^([\uFF0E\uFF07\uFF0F\.\•\·\uFF0D\u4E00-\u9FA5\uF900-\uFA2D\uB0A1-\uF7FE]{2,15})$/,
                username = this.formData.name;
            if (!reg.test(username)) {
                safe.model({
                    title: '温馨提示',
                    content: '姓名格式不正确',
                    foot: '我知道了'
                });
            } else {
                return true;
            }
        },
        eidtName: function eidtName() {
            this.$trace.trace('ins_join_name', 'ind');
        },
        eidtCard: function eidtCard() {
            this.$trace.trace('ins_join_id', 'ind');
            console.log('\u8EAB\u4EFD\u8BC1\u53F7\u8F93\u5165\u6846');
        },
        clickProtocol: function clickProtocol(val) {
            this.$trace.trace('ins_join_agreement', val);
            sessionStorage.setItem('PERSONAL_INFO', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.formData));
            console.log('Protocol');
            this.$router.push(val);
        },
        cancel: function cancel() {
            this.showAlertModel = false;
        },

        parseID: function parseID(pId) {
            var arrVerifyCode = [1, 0, "x", 9, 8, 7, 6, 5, 4, 3, 2];
            var wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
            if (pId.length != 15 && pId.length != 18) {
                return "身份证号码只能是15位或18位!";
            }
            var ai = pId.length == 18 ? pId.substr(0, 17) : pId.substr(0, 6) + "19" + pId.substr(6);
            if (!/^\d+$/.test(ai)) {
                return "身份证除最后一位外，必须为数字！";
            }
            var yyyy = ai.substr(6, 4),
                mm = ai.substr(10, 2) - 1,
                dd = ai.substr(12, 2);
            var d = new Date(yyyy, mm, dd),
                year = d.getFullYear(),
                mon = d.getMonth(),
                day = d.getDate(),
                now = new Date();
            if (year != yyyy || mon != mm || day != dd || d > now || now.getFullYear() - year > 140) {
                return "身份证出生年月日输入错误！";
            }
            for (var i = 0, ret = 0; i < 17; i++) {
                ret += ai.charAt(i) * wi[i];
            }
            ai += arrVerifyCode[ret %= 11];
            return pId.length == 18 && pId.toLowerCase() != ai ? "身份证输入错误，正确的为\n" + ai + "！" : ai;
        }
    }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'createSuccess',
    mounted: function mounted() {
        if (WiFikey && WiFikey.startComponent) {
            WiFikey.startComponent(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                aciton: 'wifi.intent.action.WIFI_INSURANCE_ACTIVATED',
                type: 2,
                ext: '1'
            }));
        }
        if (localStorage.channel && localStorage.channel == 'tj_freepro') {} else {}
    },
    methods: {
        toindex: function toindex() {
            this.$router.push("/index");
        }
    }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    mounted: function mounted() {
        this.$trace.enterTraceDone({ page: 5, type: 'protocol' });
    }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    mounted: function mounted() {
        this.$trace.enterTraceDone({ page: 5, type: 'protocolA0009' });
    }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    mounted: function mounted() {
        this.$trace.enterTraceDone({ page: 5, type: 'protocolIos' });
    }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    mounted: function mounted() {
        this.$trace.enterTraceDone({ page: 5, type: 'protocolIvvi' });
    }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'qa',
    props: ['type'],
    data: function data() {
        return {
            obj: [{
                question: '保险会收取费用吗？',
                anwser: 'WiFi安全险是完全免费的。是为了WiFi万能钥匙用户的上网安全提供的一份专属免费保障。',
                isopened: false
            }, {
                question: '什么WiFi安全险？',
                anwser: 'WiFi安全险包含用户安全险和热点商户联盟安全险。WiFi万能钥匙用户因使用WiFi万能钥匙连接了恶意热点而导致本人银行账户及合法的第三方支付机构实名账户中的资金遭受直接损失，用户可按照WiFi万能钥匙保险计划的有关规则申请索赔。商户通过WiFi万能钥匙分享WiFi后，因黑客篡改WiFi密码、劫持商户收银、盗刷商户账户内资金等恶意行为导致商户产生损失的，商户可以依据本保险计划的有关规则申请理赔。',
                isopened: false
            }, {
                question: '如何参保？',
                anwser: '点击底部［免费参保］按钮，完成简单的信息填写即可成功投保。',
                isopened: false
            }, {
                question: '保险是哪家公司发行的？',
                anwser: 'WiFi安全险由WiFi万能钥匙联合众安保险推行。众安在线财产保险股份有限公司（港交所：6060）简称众安保险，是全国名列前茅的联网保险公司。',
                isopened: false
            }, {
                question: '最高能赔多少钱？',
                anwser: '每人年度累计最高可以赔付10万元，单日/单次最高可以赔付2万元。',
                isopened: false
            }],
            obj2: [{
                question: '如何申请理赔？',
                anwser: '用户完成参保后使用WiFi万能钥匙连接网络发生了WiFi安全险保障范围内的情形，打开WiFi万能钥匙，进入WiFi安全险页面，点击申请理赔。',
                isopened: false
            }, {
                question: '申请理赔需要注意些什么？',
                anwser: '使用WiFi万能钥匙连接网络遭受损失后，应立即采取相关证据保全措施，不应自行刷机、清理手机垃圾、删除WiFi万能钥匙客户端、历史短信或历史访问网址记录，或自行删除交易过程中与交易对方的聊天记录及所下载的软件，以免导致相关证据无法保全。',
                isopened: false
            }, {
                question: 'WiFi安全险保障的范围是什么？',
                anwser: '通过WiFi万能钥匙连接的热点网络环境下发生了WiFi热点恶意行为，导致用户本人在银行账户内的资产，以及在合法运营的第三方支付机构所设本人实名账户中的资产遭受直接损失。',
                isopened: false
            }],
            obj3: [{
                question: '为什么要填写我的信息？',
                anwser: 'WiFi安全险是一款保险产品，投保时需要您提供准确的信息，以便获得后续的保险服务。',
                isopened: false
            }, {
                question: '我的信息会泄漏吗？',
                anwser: '不会。您填写的信息仅用于WiFi安全险的参保和申请理赔时确认身份用途，并不会用于其他商业用途',
                isopened: false
            }, {
                question: '提示身份证号码已占用，怎么办？',
                anwser: '如身份证号码曾提交过参保信息，绑定的手机号码已停用，请联系官方客服电话:4000358000，同时提供身份证正反面以及手持身份证的上半身照片，由官方客服进行处理。',
                isopened: false
            }],
            obj4: [{
                question: '为什么要填写并提交商户信息？',
                anwser: 'WiFi万能钥匙和众安保险达成合作，将为每个商户提供免费WiFi安全险，如商户因分享WiFi而产生财产非正常损失，可向众安保险提出理赔申请，最高可获10万元保险理赔金。您所提交的商户信息仅用于投保使用。',
                isopened: false
            }, {
                question: '我的信息会泄露吗？',
                anwser: '不会。您填写的信息仅用于WiFi安全险的参保和申请理赔时确认身份用途，并不会用于其他商业用途。',
                isopened: false
            }, {
                question: '如何确认WiFi已被分享？',
                anwser: 'WiFi万能钥匙商户热点安全险仅针对在WiFi万能钥匙内已分享的热点，需要您提交准确的热点名称和Mac地址，才能参保。请在WiFi万能钥匙App连接列表，确认WiFi已分享，即WiFi带有蓝色小钥匙；如未显示，请先分享此热点。需输入的热点名称，是在WiFi万能钥匙内显示的名称，请注意字母大小写、符号。',
                event: '（点击此处查看操作图示）',
                path: '/new/isShare',
                isopened: false
            }, {
                question: '如何查看MAC地址？',
                anwser: '路由器背面的铭牌上有明确标注“MAC”。MAC长度是12位，由0-9之间的数字和a-f之间的字母组成。填写的时候只需要填写字母和数字部分，不需要填写“:”，“-”。',
                event: '（点击此处查看操作图示）',
                path: '/new/findMac',
                isopened: false
            }, {
                question: '更换路由器、热点名称怎么办？',
                anwser: 'WiFi万能钥匙会在保险有效期内，保护参保商户基于提交的已分享的热点信息进行权益保护，一旦路由器更换，或热点名称修改，请联系官方客服电话:4000358000，同时提供身份证正反面以及手持身份证的上半身照片，新的Mac地址或热点信息，由官方客服进行处理。',
                isopened: false
            }, {
                question: '提示身份证号码已占用，怎么办？',
                anwser: '如身份证号码曾提交过参保信息，绑定的手机号码已停用，请联系官方客服电话:4000358000，同时提供身份证正反面以及手持身份证的上半身照片，由官方客服进行处理。',
                isopened: false
            }, {
                question: '提示热点被他人投保，怎么办？',
                anwser: 'WiFi万能钥匙商户热点安全险参保人必须是商户赖以执行参保的设备持有者，如提示热点被他人参保占用，请联系官方客服电话:4000358000，根据要求提供热点证明相关资料，由官方客服进行处理。',
                isopened: false
            }],
            obj5: [{
                question: '如何申请理赔？',
                anwser: '商户完成参保，通过WiFi万能钥匙分享WiFi后，发生了因黑客篡改WiFi密码、劫持商户收银、盗刷商户账户内资金等恶意行为导致商户产生损失的情形，打开WiFi万能钥匙，进入WiFi安全险页面，点击申请理赔。',
                isopened: false
            }, {
                question: '申请理赔需要注意些什么？',
                anwser: '商户在使用WiFi万能钥匙分享热点后，发现账户资金遭受损失的，应立即采取相关证据保全措施，不应自行刷机、清理交易设备缓存、删除WiFi万能钥匙客户端、历史短信或历史访问网址记录，或自行删除交易过程中与交易对方的聊天记录及所下载的软件，以免导致相关证据无法保全。',
                isopened: false
            }, {
                question: 'WiFi商户热点安全险保障的范围是什么？',
                anwser: '商户通过WiFi万能钥匙分享WiFi后，因黑客篡改WiFi密码、劫持商户收银、盗刷商户账户内资金等恶意行为，导致商户在银行账户内的资产，及商户在合法运营的第三方支付机构所设本商户实名账户中的资产遭受直接损失。',
                isopened: false
            }]
        };
    },

    methods: {
        toggle: function toggle(index) {
            if (this.type == 1) this.obj[index].isopened = !this.obj[index].isopened;
            if (this.type == 2) this.obj2[index].isopened = !this.obj2[index].isopened;
            if (this.type == 3) this.obj3[index].isopened = !this.obj3[index].isopened;
            if (this.type == 4) this.obj4[index].isopened = !this.obj4[index].isopened;
            if (this.type == 5) this.obj5[index].isopened = !this.obj5[index].isopened;
        },
        handle: function handle(val) {
            this.$router.push(val);
        }
    }
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'range',
  mounted: function mounted() {
    this.$trace.enterTraceDone({ page: 6, type: 'range' });
  }
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rangeA0009',
  mounted: function mounted() {
    this.$trace.enterTraceDone({ page: 6, type: 'rangeA0009' });
  }
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rangeIos',
  mounted: function mounted() {
    this.$trace.enterTraceDone({ page: 6, type: 'rangeIos' });
  }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rangeIvvi',
  mounted: function mounted() {
    this.$trace.enterTraceDone({ page: 6, type: 'rangeIvvi' });
  }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Toast',
  data: function data() {
    return {
      visible: false,
      mask: true,
      closed: false,
      timer: null,
      duration: 1e3,
      content: '',
      position: '',
      customClass: ''
    };
  },

  watch: {
    closed: function closed(newVal, oldVal) {
      if (newVal) {
        this.visible = false;
        this.$el.addEventListener('transitionend', this.destroyElement);
      }
    }
  },
  mounted: function mounted() {
    this.startTimer();
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    startTimer: function startTimer() {
      var _this = this;

      if (this.duration > 0) {
        this.timer = setTimeout(function () {
          if (!_this.closed) _this.close();
        }, this.duration);
      }
    },
    clearTimer: function clearTimer() {
      clearTimeout(this.timer);
    },
    close: function close() {
      this.closed = true;
    },
    destroyElement: function destroyElement() {
      this.$el.removeEventListener('transitionend', this.destroyElement);
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    }
  }
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var AES = __webpack_require__(29).default;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "newclaimDetail",
  data: function data() {
    return {
      obj: {},
      loading: false
    };
  },
  mounted: function mounted() {
    this.obj = this.$route.query;
    console.log("=====", this.obj);
  }
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'newclaimFlow',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_common_index__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vant__ = __webpack_require__(81);



var AES = __webpack_require__(29).default;


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "newclaimList",
  data: function data() {
    return {
      list: [],
      loading: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__services_common_index__["a" /* commitClamList */])().then(function (res) {
      var data = res.data,
          retCd = res.retCd,
          msg = res.msg;

      _this.list = data;
      console.log("commitClamList", __WEBPACK_IMPORTED_MODULE_1__services_common_index__["a" /* commitClamList */]);
    }).catch(function (err) {
      var retCd = err.retCd,
          msg = err.msg;

      _this.$toast('请求失败，请稍后重试');
    });
  },

  methods: {
    goDetail: function goDetail(val) {
      this.$router.push({
        path: "/new/claimDetail",
        query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, val)
      });
    }
  }
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'newclaimStep1',
  mounted: function mounted() {
    $(".main .doc_text").bind("click", function () {
      $(this).find(".check").toggleClass("checked");
    });
    this.$trace.enterTraceDone({ page: 7, step: 1 });
  },
  data: function data() {
    return {
      appinfo: "",
      loading: false
    };
  },

  methods: {
    claimStep1: function claimStep1() {
      this.$trace.trace('ins_claim_confirm', { step: 1, type: 'sup' });
      var params = {};
      var hasSelect = false;
      var traceObj = {};
      $(".main .check").each(function (index, ele) {
        var dataId = $(ele).attr("data-index");
        if ($(ele).hasClass("checked")) {
          params[dataId] = "2";
          traceObj[dataId] = "2";
          hasSelect = true;
        } else {
          params[dataId] = "1";
        }
      });
      this.$trace.trace("ins_claim_btn", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, traceObj, { type: 'sup' }));
      console.log("\u70B9\u6211\u8981\u7D22\u8D54\u7B49\u7EA7");

      if (!hasSelect) {
        safe.model({
          title: "温馨提示",
          content: "请选择索赔范围",
          foot: "我知道了"
        });
        safe.bindModelEvent();
        return;
      }
      console.log("\u70B9\u786E\u8BA4\u767B\u8BB0", params);
      var array = [params.question1, params.question2, params.question3, params.question4, params.question5];
      this.$router.push("/new/claimStep2?params=" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(array));
    }
  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toast__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SingleImageUpload__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SingleImageUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_SingleImageUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_common_index__ = __webpack_require__(82);





var AES = __webpack_require__(29).default;



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'newclaimStep2',
  components: {
    wkSingleImageUpload: __WEBPACK_IMPORTED_MODULE_3__components_SingleImageUpload___default.a
  },
  data: function data() {
    return {
      appinfo: "",
      disabled: false,
      order_sn: "",
      loading: false,
      question: [],
      formData: {
        photoStolenEvidence: "",
        photoIdCardEvidenceFront: "",
        photoIdCardEvidenceReverse: ""
      }
    };
  },
  created: function created() {
    this.question = this.$route.query.params;
    console.log("===", this.question);
  },
  mounted: function mounted() {},


  methods: {
    getIdCardFront: function getIdCardFront() {},
    claimStep2: function claimStep2() {
      var _this = this;

      this.$trace.trace('ins_claim_confirm', { step: 2, type: 'sup' });
      var error = void 0;
      if (!this.formData.photoIdCardEvidenceFront) {
        error = "身份证正面";
      } else if (!this.formData.photoIdCardEvidenceReverse) {
        error = "身份证反面";
      } else if (!this.formData.photoStolenEvidence) {
        error = "被盗信息截屏";
      }

      if (error) {
        safe.model({
          title: "温馨提示",
          content: error + "未上传完成",
          foot: "我知道了"
        });
        safe.bindModelEvent();
        return;
      }

      var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.formData, {
        stolenState: this.question,
        photoStolenEvidence: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.formData.photoStolenEvidence]) || []
      });

      console.log("=====", params.photoStolenEvidence);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__services_common_index__["b" /* commitClam */])(params).then(function (res) {
        var retCd = res.retCd,
            msg = res.msg;

        if (retCd === '0') {
          _this.$router.push("/new/claimSuccess");
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_toast__["a" /* default */])(msg);
        }
      }).catch(function (err) {
        var retCd = err.retCd,
            msg = err.msg;

        if (retCd === "T.XQA.2013") {
          _this.$toast(msg);
        }
      });
    }
  }
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'newclaimSuccess',
  data: function data() {
    return {
      pageUrl: ''
    };
  },
  mounted: function mounted() {}
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vant__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_qa__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_qa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_qa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_common_index__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_clipboard__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SingleImageUpload__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SingleImageUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_SingleImageUpload__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: "newcreateStore",
  components: {
    qa: __WEBPACK_IMPORTED_MODULE_4__components_qa___default.a,
    wkSingleImageUpload: __WEBPACK_IMPORTED_MODULE_7__components_SingleImageUpload___default.a,
    "van-picker": __WEBPACK_IMPORTED_MODULE_3_vant__["c" /* Picker */],
    "van-popup": __WEBPACK_IMPORTED_MODULE_3_vant__["d" /* Popup */]
  },
  data: function data() {
    return {
      clear: null,
      from: "home",
      columns: [{ text: "餐饮美食", id: 0 }, { text: "休闲娱乐(网吧、影院)", id: 1 }, { text: "生活服务(小区超市、美甲店等便民设施)", id: 2 }, { text: "宾馆酒店", id: 3 }, { text: "购物（购物广场）", id: 4 }],
      protocol: "protocol",
      showAlertModel: false,
      modelContent: "",
      loading: false,
      disabled: false,
      showPopup: false,
      selectWifiItem: {},
      selectNo: null,
      formData: {
        userName: "",
        idCard: "",
        businessLicense: "",
        apInfoList: []
      },
      isFirstClickMac: true,
      apItem: {
        bssid: "",
        ssid: "",
        hotspotEvidence: "",
        merchantType: "",
        bssidList: [{ title: "", title1: "" }, { title: "", title1: "" }, { title: "", title1: "" }, { title: "", title1: "" }, { title: "", title1: "" }, { title: "", title1: "" }]
      },
      isIOS: false,
      checked: false,
      isFromWifiList: false,
      isToEdit: true
    };
  },
  created: function created() {
    this.formData.apInfoList.push(this.apItem);
    this.handlePageQuery();
    this.initInfo();
  },
  activated: function activated() {
    this.handlePageQuery();
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.isFromWifiList = false;

      if (from.name === "/new/wifiSelect") {
        vm.isFromWifiList = true;
        console.log("vm=====", vm.isToEdit);
        if (vm.isToEdit) {
          vm.initInfo();
        } else {
          if (vm.isFromWifiList) {
            vm.handleWifiaaaaa();
          }
        }
      } else if (from.name === "/new/protocol") {} else if (from.name === "/new/createSuccess") {
        vm.initInfo();
        vm.checked = true;
      } else {
        vm.formData = {
          apInfoList: []
        };
        vm.formData.apInfoList.push(vm.apItem);
      }
    });
  },
  mounted: function mounted() {
    this.$trace.enterTraceDone({ page: 4 });
  },

  methods: {
    handlePageQuery: function handlePageQuery() {
      this.clear = this.$route.query.clear;
      this.from = this.$route.query.from;
      if (this.$wkb.isWKBrowser === "ios") {
        this.isIOS = true;
      }
    },
    changeText: function changeText(val, key) {},
    initInfo: function initInfo() {
      var _this = this;

      this.isToEdit = false;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__services_common_index__["e" /* getInsuranceQueryInfo */])().then(function (res) {
        var data = res.data,
            retCd = res.retCd;

        _this.formData = data;
        console.log("===", res);
        if (_this.from == "home" && retCd == "0") {
          var state = data.state;
          if (state == 0 || state == 1) {
            _this.$router.replace("/new/insureDetail");
          } else if (state == 2) {
            _this.$router.replace("/new/createSuccess?state=0");
          } else if (state == 3) {
            _this.$router.replace("/new/createSuccess?state=1");
          }
        }
        _this.handleBssid();
        if (_this.isFromWifiList) {
          _this.handleWifiaaaaa();
        }
      }).catch(function (err) {
        _this.handleWifiaaaaa();
      });
    },
    handleWifiaaaaa: function handleWifiaaaaa() {
      var selectWifi = JSON.parse(sessionStorage.getItem("SELECT_WIFI") || null);
      var array = selectWifi.bssid && selectWifi.bssid.split(":") || [];
      if (!selectWifi) return;
      var bssidList = [];

      array.map(function (res, index) {
        var obj = {
          title: res.slice(0, 1),
          title1: res.slice(1, 2)
        };
        bssidList.push(obj);
      });
      this.formData.apInfoList[selectWifi.key].bssidList = bssidList;
      this.$trace.trace("ins_join_mac_fill");
      var apInfo = this.formData.apInfoList[selectWifi.key] || {};
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(apInfo, selectWifi);
      this.$trace.trace("ins_join_ssid_fill");
      delete apInfo["key"];
      this.formData.apInfoList[selectWifi.key] = apInfo;
      console.log("======", apInfo, this.formData);
    },
    handleBssid: function handleBssid() {
      var _this2 = this;

      var apInfoList = this.formData.apInfoList;
      apInfoList && apInfoList.map(function (res, key) {
        console.log("this.columns[res.merchantType]", _this2.columns[res.merchantType]);
        res = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, res, _this2.columns[res.merchantType]);
        var array = res.bssid && res.bssid.split(":") || [];
        var bssidList = [];

        array.map(function (res, index) {
          var obj = {
            title: res.slice(0, 1),
            title1: res.slice(1, 2)
          };
          bssidList.push(obj);
        });

        _this2.formData.apInfoList[key] = res;
        _this2.formData.apInfoList[key].bssidList = bssidList;
      });
    },
    create: function create() {
      var _this3 = this;

      console.log("from=====", this.formData);
      console.log("\u586B\u5199\u9875\u9762\uFF0C\u70B9\u53C2\u4FDD\u6309\u94AE");
      this.$trace.trace('ins_join_btn', "sup");

      if (this.checkName() && this.checkIDCard() && !this.hasEmpty()) {
        if (this.checked) {
          safe.confirm({
            title: "温馨提示",
            content: "众安保险提醒您:请确保您的信息真实有效，以保障您后期的索赔权益，否则将失去索赔权益",
            callback: function callback() {
              $(".model").hide();
              _this3.saveUserInfo();
            }
          });
        } else {
          safe.model({
            title: "温馨提示",
            content: "同意《WiFi万能钥匙商户热点安全保险协议》才能参保",
            foot: "我知道了"
          });
        }
      }
      safe.bindModelEvent();
    },
    selectWifi: function selectWifi(val) {
      this.$trace.trace("ins_join_ssid_nearby");
      this.$router.push({
        path: "/new/wifiSelect",
        query: {
          key: val
        }
      });
    },
    onConfirm: function onConfirm(value) {
      this.handleParams(value, "apInfoList");
      this.showPopup = false;
    },
    onChange: function onChange(e, value) {
      this.handleParams(value, "apInfoList");
    },
    handleParams: function handleParams(val, type) {
      if (type === "apInfoList") {
        var apInfoList = this.formData.apInfoList;

        var apInfoItem = apInfoList[this.selectNo];
        apInfoItem.merchantType = apInfoItem.id;
        console.log("apInfoItem====", apInfoItem);
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(apInfoItem, val);
        this.formData.apInfoList[this.selectNo] = apInfoItem;
      } else {
        console.log("apInfoItem====", val);
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.formData, val);
      }
    },
    onCancel: function onCancel() {
      this.showPopup = false;
    },
    saveUserInfo: function saveUserInfo() {
      var _this4 = this;

      this.loading = true;


      var apInfoList = this.formData.apInfoList;
      var array = [];
      apInfoList.map(function (res) {
        res.merchantType = res.id;
        var bssidArray = '';
        res.bssidList.map(function (obj, index) {
          if (index < 5) {
            bssidArray = "" + bssidArray + obj.title + obj.title1 + ":";
          } else {
            bssidArray = "" + bssidArray + obj.title + obj.title1;
          }
        });
        res.bssid = bssidArray;
        array.push(res);
      });
      this.formData.apInfoList = array;

      if (this.checkParams()) {
        return;
      }

      var apInfoListString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.formData.apInfoList);
      var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.formData, {
        apInfoList: apInfoListString
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__services_common_index__["f" /* commitInsurance */])(params).then(function (res) {
        var retCd = res.retCd,
            msg = res.msg;

        _this4.loading = false;
        _this4.callNotifyAction();
        _this4.$router.replace({
          path: "/new/createSuccess"
        });
      }).catch(function (err) {
        var retCd = err.retCd,
            msg = err.msg;

        if (retCd === "-1") {
          _this4.$toast(msg);
        } else {
          _this4.$toast(msg);
        }
        _this4.loading = false;
      });
    },
    callNotifyAction: function callNotifyAction() {
      Utils.Bridge.call('notifyAction', {
        event: 'insurance'
      });
    },
    checkParams: function checkParams() {
      var apInfoList = this.formData.apInfoList;
      apInfoList.map(function (res) {
        for (var key in res) {
          console.log("======", res);
          if (res['bssid'] === "" || res['ssid'] === "" || res['hotspotEvidence'] === "" || res['merchantType'] === "") {
            safe.model({
              title: "温馨提示",
              content: "请填写完整再提交保单",
              foot: "我知道了"
            });
            return true;
          }
        }
      });
      return false;
    },
    getHotspotEvidence: function getHotspotEvidence() {
      this.$trace.trace("ins_join_certif");
    },
    getBusinessLicense: function getBusinessLicense() {
      this.$trace.trace("ins_join_blis");
    },
    hasEmpty: function hasEmpty() {
      for (var key in this.formData) {
        if (this.formData[key] === "") {
          safe.model({
            title: "温馨提示",
            content: "请填写完整再提交保单",
            foot: "我知道了"
          });
          return true;
        }
      }
      if (!this.formData.businessLicense) {
        safe.model({
          title: "温馨提示",
          content: "请填写完整再提交保单",
          foot: "我知道了"
        });
        return true;
      }
      return false;
    },
    handleShopType: function handleShopType(key) {
      this.$trace.trace("ins_join_type");
      this.showPopup = true;
      this.selectNo = key;
    },
    copyQq: function copyQq(val) {
      var _this5 = this;

      var clipboard = new __WEBPACK_IMPORTED_MODULE_6_clipboard___default.a(".copy-qq", {
        text: function text() {
          return val;
        }
      });
      clipboard.on("success", function (e) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vant__["b" /* Toast */])("复制成功");
        _this5.cancel();
        console.info("触发的方式（复制还是剪切）", e.text);
      });
    },
    checkIDCard: function checkIDCard() {
      var idcard = this.formData.idCard;
      var _id = this.parseID(idcard);
      if (isNaN(_id.substr(0, 17))) {
        safe.model({
          title: "温馨提示",
          content: "身份证号码格式有误",
          foot: "我知道了"
        });
        return false;
      }
      return true;
    },
    handleWifi: function handleWifi(type, key) {
      if (type === "add") {
        this.$trace.trace("ins_join_ssid_add");
        if (this.formData.apInfoList.length >= 3) {
          this.$toast("最多可添加三个热点");
          return;
        }
        this.$toast("添加热点成功");
        var obj = {
          bssid: "",
          ssid: "",
          hotspotEvidence: "",
          merchantType: "",
          bssidList: [{ title: "", title1: "" }, { title: "", title1: "" }, { title: "", title1: "" }, { title: "", title1: "" }, { title: "", title1: "" }, { title: "", title1: "" }]
        };
        this.formData.apInfoList.push(obj);
      } else {
        this.$toast("删除热点成功");
        this.$trace.trace("ins_join_ssid_del");
        var array = [];
        this.formData.apInfoList.map(function (res, i) {
          if (key !== i) {
            array.push(res);
          }
        });
        this.formData.apInfoList = array;
      }
    },
    checkName: function checkName() {
      var reg = /^([\uFF0E\uFF07\uFF0F\.\•\·\uFF0D\u4E00-\u9FA5\uF900-\uFA2D\uB0A1-\uF7FE]{2,15})$/,
          username = this.formData.userName;
      if (!reg.test(username)) {
        safe.model({
          title: "温馨提示",
          content: "姓名格式不正确",
          foot: "我知道了"
        });
      } else {
        return true;
      }
    },
    eidtSsid: function eidtSsid(val) {
      console.log("val======", val);
      this.$trace.trace("ins_join_ssid");
    },
    eidtMac: function eidtMac() {
      if (this.isFirstClickMac) {
        this.isFirstClickMac = false;
        this.$trace.trace("ins_join_mac");
      }
    },
    eidtName: function eidtName() {
      this.$trace.trace("ins_join_name", "sup");
    },
    eidtCard: function eidtCard() {
      this.$trace.trace("ins_join_id", "sup");
      console.log("\u8EAB\u4EFD\u8BC1\u53F7\u8F93\u5165\u6846");
    },
    changeCheck: function changeCheck(val) {
      this.$trace.trace("ins_join_agreement", "sup");
    },
    clickProtocol: function clickProtocol(val) {},
    cancel: function cancel() {
      this.showAlertModel = false;
    },


    parseID: function parseID(pId) {
      var arrVerifyCode = [1, 0, "x", 9, 8, 7, 6, 5, 4, 3, 2];
      var wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      if (pId.length != 15 && pId.length != 18) {
        return "身份证号码只能是15位或18位!";
      }
      var ai = pId.length == 18 ? pId.substr(0, 17) : pId.substr(0, 6) + "19" + pId.substr(6);
      if (!/^\d+$/.test(ai)) {
        return "身份证除最后一位外，必须为数字！";
      }
      var yyyy = ai.substr(6, 4),
          mm = ai.substr(10, 2) - 1,
          dd = ai.substr(12, 2);
      var d = new Date(yyyy, mm, dd),
          year = d.getFullYear(),
          mon = d.getMonth(),
          day = d.getDate(),
          now = new Date();
      if (year != yyyy || mon != mm || day != dd || d > now || now.getFullYear() - year > 140) {
        return "身份证出生年月日输入错误！";
      }
      for (var i = 0, ret = 0; i < 17; i++) {
        ret += ai.charAt(i) * wi[i];
      }
      ai += arrVerifyCode[ret %= 11];
      return pId.length == 18 && pId.toLowerCase() != ai ? "身份证输入错误，正确的为\n" + ai + "！" : ai;
    }
  }
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "newcreateSuccess",

  created: function created() {
    this.state = parseInt(this.$route.query.state) || 0;
  },
  data: function data() {
    return {
      state: 0,
      item: [{
        name: "参保审核中…",
        src: __webpack_require__(673),
        tip: [{
          title: "1、参保人须为商户经营者或法定代表人，和营业执照保持一致；"
        }, { title: "2、提交的商户信息均需为有效信息；" }]
      }, {
        name: "审核拒绝",
        src: __webpack_require__(672),
        tip: [{
          title: "1、参保人须为商户经营者或法定代表人，和营业执照保持一致；"
        }, { title: "2、提交的商户信息均需为有效信息；" }]
      }, {
        name: "参保成功",
        desc: "WiFi安全险保障中",
        src: __webpack_require__(674)
      }]
    };
  },

  mounted: function mounted() {
    if (WiFikey && WiFikey.startComponent) {
      WiFikey.startComponent(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        aciton: "wifi.intent.action.WIFI_INSURANCE_ACTIVATED",
        type: 2,
        ext: "1"
      }));
    }
  },
  methods: {
    edit: function edit() {
      this.$router.push("/new/createStore?from=edit");
    },
    toindex: function toindex() {
      this.$router.push("/new/insureDetail");
    }
  }
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_qa__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_qa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_qa__);





var AES = __webpack_require__(29).default;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "newdetail",
  components: {
    qa: __WEBPACK_IMPORTED_MODULE_1__components_qa___default.a
  },
  mounted: function mounted() {
    var _self = this;
    Utils.Bridge.call("getAppInfo", {
      success: function success(o) {
        _self.appinfo = o;
        _self.checkStatus();
        _self.$trace.enterTraceDone({ page: 1, login: "have_login" });
      }
    });
  },
  data: function data() {
    return {
      msg: "tests",
      obj: "",
      appinfo: "",
      createBtn: 1,
      loading: false,
      claimList: false,
      appid: this.$route.query.appid
    };
  },

  methods: {
    toRange: function toRange() {
      if (this.appinfo.chanid == "ivvi") {
        this.$router.push("/rangeIvvi");
        this.$trace.trace("ins_detail", { type: "rangeIvvi" });
      } else if (this.appinfo.appid == "A0009") {
        this.$router.push("/rangeA0009");
        this.$trace.trace("ins_detail", { type: "rangeA0009" });
      } else if (this.appinfo.appid == "I0010") {
        this.$router.push("/rangeIos");
        this.$trace.trace("ins_detail", { type: "rangeIos" });
      } else {
        this.$router.push("/range");
        this.$trace.trace("ins_detail", { type: "range" });
      }
      console.log("\u67E5\u770B\u4FDD\u9669\u8BE6\u60C5");
    },
    clickRange: function clickRange() {
      this.$trace.trace("ins_mine_detail", 'ind');
      console.log("\u70B9\u4FDD\u969C\u8303\u56F4");
    },
    clickClaimList: function clickClaimList() {
      this.$trace.trace("ins_mine_record", 'ind');
      console.log("\u70B9\u7D22\u8D54\u8BB0\u5F55");
    },
    range: function range() {},

    goCreate: function goCreate() {

      this.$trace.trace("ins_join", "have_login");
      console.log("\u53C2\u4FDD\uFF1A\u5DF2\u767B\u5F55");

      this.$router.push("/create");
    },
    goClaim: function goClaim() {
      this.$trace.trace("ins_mine_claim", 'ind');
      console.log("\u6211\u8981\u7D22\u8D54");
      if (this.obj.status == 2) {
        safe.model({
          title: "温馨提示",
          content: "您有一笔保单正在索赔中，不能提交新的索赔",
          foot: "我知道了"
        });
        safe.bindModelEvent();
        return;
      } else {
        this.$router.push("/claimStep1");
      }
    },
    checkStatus: function checkStatus() {
      var _self = this;
      _self.loading = true;

      var data = {
        dhid: _self.appinfo.dhid,
        uhid: _self.appinfo.uhid,
        vcode: _self.appinfo.vcode
      };
      var ed = AES.Encrypt(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), AES.obj());

      this.$http.post("https://insurance.lianwifi.com" + "/user/get", {
        ed: ed
      }, {
        emulateJSON: true
      }).then(function (response) {
        _self.loading = false;
        var json = response.body;
        if (json.c == "0000") {
          document.title = "我的保障";

          _self.$trace.enterTraceDone({ page: 2 });
          _self.obj = json.m;
          _self.obj.end_time = _self.obj.end_time || "2023年9月15日24时";
          var status = json.m.status,
              hasList = json.m.has_list;
          if (status == "2") {
            $("body").addClass("claim");
          }
          if (hasList == "2") {
            $(".bottom_btn").css("width", "50%");
            _self.claimList = true;
          }
        } else {
          _self.createBtn = 2;
        }
      });
    },

    noCreate: function noCreate() {
      safe.model({
        title: "温馨提示",
        content: "抱歉，您暂时还未参保，请先点击免费参保",
        foot: "我知道了"
      });
      safe.bindModelEvent();
    }
  }
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'newdocs'
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'newfindMac'
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'newisShare'
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_qa__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_qa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_qa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_common_index__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vant__ = __webpack_require__(81);







var AES = __webpack_require__(29).default;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "newHome",
  components: {
    qa: __WEBPACK_IMPORTED_MODULE_1__components_qa___default.a
  },

  data: function data() {
    return {
      msg: "tests",
      obj: "",
      shopObj: null,
      isFirst: true,
      appinfo: "",
      clickBtnName: "",
      isLogin: false,
      isDatail: false,
      isShopDatail: false,
      loading: false,
      appid: this.$route.query.appid
    };
  },
  created: function created() {
    this.$trace.trace('ins_join_show');
  },
  mounted: function mounted() {
    var _this = this;

    this.$trace.trace('ins_join_load');

    Utils.Bridge.call("getAppInfo", {
      success: function success(o) {
        _this.appinfo = o;
        Utils.Bridge.call("checkLogin", {
          success: function success(bool) {
            if (bool) {
              _this.isLogin = true;
              _this.isFirst = true;
              _this.checkShopStatus();
              _this.checkPersonalStatus();
              _this.$trace.enterTraceDone({ page: 1, login: "have_login" });
            } else {
              _this.isLogin = false;
              _this.$trace.enterTraceDone({ page: 1, login: "no_login" });
            }
          }
        });
      }
    });

    Utils.Bridge.call("hideOptionMenu");
    setTimeout(function (_) {
      Utils.Bridge.call("hideOptionMenu");
    }, 2000);
  },

  methods: {
    toRange: function toRange() {
      this.$router.push("/new/rangePersonal");
      console.log("\u67E5\u770B\u4FDD\u9669\u8BE6\u60C5");
    },
    goCreate: function goCreate(val) {
      var _this2 = this;

      this.clickBtnName = val;
      console.log("====", this.isLogin, this.isDatail, this.isShopDatail);

      if (!this.isLogin) {
        Utils.Bridge.call("login", {
          fromSource: "app_insurance",
          loginMode: 0,
          success: function success(ok) {
            if (ok || _this2.$wkb.isWKBrowser === "ios") {
              _this2.isLogin = true;
              _this2.login();
              _this2.loginShop();
            }
          }
        });
      } else {
        this.$trace.trace("ins_join", "have_login");
        console.log("\u53C2\u4FDD\uFF1A\u5DF2\u767B\u5F55");
        if (val === "personal") {
          this.$trace.trace('ins_join_ind');
          if (this.isDatail) {
            this.goDetail(val);
            return;
          }
          sessionStorage.removeItem('PERSONAL_INFO');
          this.$router.push("/create");
        } else if (val === "store") {
          this.$trace.trace('ins_join_sup');
          var shopObj = this.shopObj;
          if (!shopObj) {
            this.$router.push("/new/createStore?clear=true&from=home");
          } else {
            this.handleStatePage();
          }
        }
      }
    },

    goDetail: function goDetail(val) {
      this.$router.push("/new/detail");
    },

    handleStatePage: function handleStatePage() {
      var state = this.shopObj.state;
      if (state == 0 || state == 1) {
        this.$router.push("/new/insureDetail");
      } else if (state == 2) {
        this.$router.push("/new/createSuccess?state=0");
      } else if (state == 3) {
        this.$router.push("/new/createSuccess?state=1");
      }
    },
    checkShopStatus: function checkShopStatus(val) {
      var _this3 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__services_common_index__["d" /* getInsuranceInfo */])({}).then(function (res) {
        var data = res.data;

        _this3.shopObj = data;
        _this3.isShopDatail = true;
        if (_this3.isFirst === "first") {} else {
          if (_this3.clickBtnName === "store") {
            _this3.handleStatePage();
          }
        }
      }).catch(function (err) {
        var retCd = err.retCd,
            msg = err.msg;

        if (retCd === "T.XQA.2005") {
          if (_this3.clickBtnName === "store") {
            _this3.$router.push("/new/createStore");
          }
        }
      });
    },
    checkPersonalStatus: function checkPersonalStatus(type) {
      var _self = this;
      _self.loading = true;

      var data = {
        dhid: _self.appinfo.dhid,
        uhid: _self.appinfo.uhid,
        vcode: _self.appinfo.vcode
      };
      var ed = AES.Encrypt(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), AES.obj());

      this.$http.post("https://insurance.lianwifi.com" + "/user/get", {
        ed: ed
      }, {
        emulateJSON: true
      }).then(function (response) {
        _self.loading = false;
        var json = response.body;
        if (json.c == "0000") {
          document.title = "WiFi安全险";
          this.isDatail = true;
          if (this.isFirst === "first") {} else {
            if (this.clickBtnName === "personal") {
              this.$router.push("/new/detail");
            }
          }

          if (!type) {
            _self.$trace.enterTraceDone({ page: 2 });
          }
          _self.$trace.enterTraceDone({ page: 2 });
          _self.obj = json.m;
          _self.obj.end_time = _self.obj.end_time || "2023年9月15日24时";
          var status = json.m.status,
              hasList = json.m.has_list;
          if (status == "2") {
            $("body").addClass("claim");
          }
        } else {
          if (this.isFirst === "first") {} else {
            if (this.clickBtnName === "personal") {
              sessionStorage.removeItem('PERSONAL_INFO');
              _self.$router.push("/create");
            }
          }
        }
      });
    },
    loginShop: function loginShop() {
      console.log("\u5546\u5BB6\u53C2\u4FDD\uFF1A\u672A\u767B\u5F55");
      this.checkShopStatus("login");
    },
    login: function login() {
      var _this4 = this;

      var trackerB = "";
      if ($(this).attr("id") == "createBtn") {
        trackerB = "ins_freepro_login";
      } else {
        trackerB = "ins_mypro";
      }
      this.$trace.trace("ins_join", "no_login");
      console.log("\u53C2\u4FDD\uFF1A\u672A\u767B\u5F55");

      Utils.Bridge.call("getAppInfo", {
        success: function success(o) {
          _this4.appinfo = o;
          _this4.checkPersonalStatus("login");
        }
      });
    }
  }
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_qa__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_qa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_qa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_common_index__ = __webpack_require__(82);




var AES = __webpack_require__(29).default;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "newinsureDetail",
  components: {
    qa: __WEBPACK_IMPORTED_MODULE_0__components_qa___default.a
  },

  data: function data() {
    return {
      msg: "tests",
      obj: {},
      appinfo: "",
      createBtn: 1,
      pageStatus: 0,
      loading: false,
      isClaim: false,
      appid: this.$route.query.appid
    };
  },
  mounted: function mounted() {
    var _this = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__services_common_index__["d" /* getInsuranceInfo */])({}).then(function (res) {
      var _res$data = res.data,
          data = _res$data === undefined ? {} : _res$data;

      _this.obj = data;
      console.log("ssss", res);
    }).catch(function (err) {
      var retCd = err.retCd,
          msg = err.msg;

      if (retCd === "-1") {
        _this.$toast(msg);
      }
      console.log("err", retCd, msg);
    });

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__services_common_index__["a" /* commitClamList */])().then(function (res) {
      var data = res.data,
          retCd = res.retCd,
          msg = res.msg;

      if (retCd === '0' && data && data.length > 0) {
        _this.isClaim = true;
      }
      console.log("commitClamList", __WEBPACK_IMPORTED_MODULE_1__services_common_index__["a" /* commitClamList */]);
    }).catch(function (err) {
      var data = err.data,
          retCd = err.retCd,
          msg = err.msg;
    });
  },

  methods: {
    clickRange: function clickRange() {
      this.$trace.trace("ins_mine_detail", 'sup');
      this.$router.push({ path: '/new/range' });
      console.log("\u70B9\u4FDD\u969C\u8303\u56F4");
    },
    range: function range() {},
    clickClaimList: function clickClaimList() {
      this.$trace.trace("ins_mine_record", 'sup');
      console.log("\u70B9\u7D22\u8D54\u8BB0\u5F55");
    },
    goClaim: function goClaim() {
      this.$trace.trace("ins_mine_claim", 'sup');
      console.log("\u6211\u8981\u7D22\u8D54", this.obj.status);
      if (this.obj.state == 1) {
        safe.model({
          title: "温馨提示",
          content: "您有一笔保单正在索赔中，不能提交新的索赔",
          foot: "我知道了"
        });
        safe.bindModelEvent();
        return;
      } else {
        this.$router.push("/new/claimStep1");
      }
    }
  }
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'newprotocol',
    mounted: function mounted() {
        this.$trace.enterTraceDone({ page: 5, type: 'protocol' });
    }
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'newprotocolIos',
    mounted: function mounted() {
        this.$trace.enterTraceDone({ page: 5, type: 'protocol' });
    }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'newrange',
  mounted: function mounted() {
    this.$trace.enterTraceDone({ page: 6, type: 'range' });
  }
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'newrangePersonal',
  mounted: function mounted() {
    this.$trace.enterTraceDone({ page: 10, type: 'rangePersonal' });
  }
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    ssid: String,
    item: {
      type: Object,
      default: {}
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WifiItem__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WifiItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_WifiItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_toast__ = __webpack_require__(80);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'newwifiSelect',
  components: {
    "wifi-item": __WEBPACK_IMPORTED_MODULE_2__components_WifiItem___default.a
  },

  data: function data() {
    return {
      loading: false,
      wifiList: [],
      isShowEmpty: false,
      key: null,
      refresh: false
    };
  },
  created: function created() {
    this.init();
    this.key = this.$route.query.key;
  },


  methods: {
    init: function init() {
      var _this = this;

      this.$wkb.call("getWiFiList", {
        success: function success(res) {
          console.log();
          if ((res.length === 0 || !res) && _this.refresh) {
            _this.$toast('请确认位置权限已开启');
            return;
          }
          if (res.length === 0) {
            _this.isShowEmpty = true;
          }
          _this.wifiList = res;
          if (_this.refresh) {
            _this.$toast('刷新成功');_this.refresh = false;
          }
        }
      });
    },
    refreshList: function refreshList() {
      this.refresh = true;
      this.init();
    },
    handleWifiItemClick: function handleWifiItemClick() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.$trace.trace('ins_join_ssid_listcli');
      sessionStorage.setItem('SELECT_WIFI', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, val, { key: this.key })));
      this.$router.back();
      console.log("wifi item click", val);
    }
  }
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _handle = function _handle(name, args) {
	if (window.console) {
		window.console[name].apply(console, args);
	}
};

var Log = function Log() {
	var log = function log() {
		var args = log.prefix ? [].concat.apply(['(' + log.prefix + ')'], arguments) : arguments;
		_handle('log', args);
	};
	log.prefix = '';
	return log;
};

/* harmony default export */ __webpack_exports__["a"] = (Log);

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vant__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_Utils_trace_js__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_toast__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_tracker__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_Utils_index__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_jquery_1_9_1_min_js__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_ajaxfileupload_js__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_ajaxfileupload_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__lib_ajaxfileupload_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__scripts_safe_js__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__scripts_safe_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__scripts_safe_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mobiscroll_js_mobiscroll_zepto_js__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mobiscroll_js_mobiscroll_core_js__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mobiscroll_js_mobiscroll_frame_js__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mobiscroll_js_mobiscroll_frame_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__mobiscroll_js_mobiscroll_frame_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mobiscroll_js_mobiscroll_scroller_js__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mobiscroll_js_mobiscroll_scroller_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__mobiscroll_js_mobiscroll_scroller_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mobiscroll_js_mobiscroll_listbase_js__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mobiscroll_js_mobiscroll_listbase_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__mobiscroll_js_mobiscroll_listbase_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mobiscroll_js_mobiscroll_treelist_js__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mobiscroll_js_mobiscroll_treelist_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__mobiscroll_js_mobiscroll_treelist_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mobiscroll_js_mobiscroll_frame_android_holo_js__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mobiscroll_js_mobiscroll_frame_android_holo_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__mobiscroll_js_mobiscroll_frame_android_holo_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__mobiscroll_js_mobiscroll_android_holo_light_js__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__mobiscroll_js_mobiscroll_android_holo_light_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__mobiscroll_js_mobiscroll_android_holo_light_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__mobiscroll_js_mobiscroll_i18n_zh_js__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__mobiscroll_js_mobiscroll_i18n_zh_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__mobiscroll_js_mobiscroll_i18n_zh_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__wifikey_wkb__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__wifikey_wkb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__wifikey_wkb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vant_lib_index_css__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vant_lib_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vant_lib_index_css__);


























__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vant__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$trace = __WEBPACK_IMPORTED_MODULE_5__lib_Utils_trace_js__;
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$toast = __WEBPACK_IMPORTED_MODULE_7__components_toast__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$wkb = __WEBPACK_IMPORTED_MODULE_22__wifikey_wkb___default.a;

__WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].afterEach(function () {
  window.scrollTo(0, 0);
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_QINIU_IMAGE_UPLOAD_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COMMIT_INSURANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_INSURANCE_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COMMIT_CLAIM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return COMMIT_CLAIM_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_INSURANCE_QUERY_INFO; });

var GET_QINIU_IMAGE_UPLOAD_TOKEN = '03500242';

var COMMIT_INSURANCE = '66646101';
var GET_INSURANCE_INFO = '66646102';
var COMMIT_CLAIM = '66646103';
var COMMIT_CLAIM_LIST = '66646104';
var GET_INSURANCE_QUERY_INFO = '66646105';

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getToken */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pids__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_request__ = __webpack_require__(193);




function getToken(params) {
  var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ pid: __WEBPACK_IMPORTED_MODULE_1__pids__["a" /* GET_QINIU_TOKEN */] }, params);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_request__["a" /* default */])(query).then(function (response) {
    var d = response.data;
    if (d == null) {
      d = [];
    }
    return d;
  }, function () {
    return [];
  });
}

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_QINIU_TOKEN; });

var GET_QINIU_TOKEN = '66633011';

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compressor;
/* unused harmony export readFileBase64 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_compressorjs__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_compressorjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_compressorjs__);




function compressor(file) {
  var rule = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var obj = new __WEBPACK_IMPORTED_MODULE_2_compressorjs___default.a(file, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rule, {
      success: function success(res) {
        console.log('【compressor image】success', res);

        readFileBase64(res).then(function (content) {
          var result = {
            file: res,
            content: content,
            status: file.status
          };
          resolve(result);
        });
      },
      error: function error(err) {
        reject(err);
        console.error('【compressor image】fail', err.message);
      }
    }));
  });
}

function readFileBase64(file) {
  var resultType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'base64';

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    if (resultType === 'file') {
      resolve();
      return;
    }

    var reader = new FileReader();
    reader.onload = function (event) {
      resolve(event.target.result);
      console.log('\u3010image base64\u3011', event);
    };

    if (resultType === 'base64') {
      reader.readAsDataURL(file);
    } else if (resultType === 'text') {
      reader.readAsText(file);
    }
  });
}

/***/ }),
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 623 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 624 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 625 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 626 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 627 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 628 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 629 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 630 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 631 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 632 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 634 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 635 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 638 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 639 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 640 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 641 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 642 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 643 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 644 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 648 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 649 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 650 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 651 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 652 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 653 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 654 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 655 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 656 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 657 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 658 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 659 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 660 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 661 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 662 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 663 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 670 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAqCAYAAACpxZteAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABWWlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS40LjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyI+CiAgICAgICAgIDx0aWZmOk9yaWVudGF0aW9uPjE8L3RpZmY6T3JpZW50YXRpb24+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgpMwidZAAABi0lEQVRIDbXXvU7DMBQFYN8rBFOyMTKAikDqwGMgNlgYgSdgZkMslJkngJUFMfEISOwMSEWssLZiAImYHCpXbhK3zs21pTb/50tiy7Gpf2eXX4fji8LYE1MWNnSz1cvOXw7pB9tdCy1djgaFLc78IDL0uJ7lB8NT+vb3S9a5sPa4eqE1du99PLrvXduV6rG22xy6QAthJrpNiTAqFO88FcJoLajQVAi5O0eFomLx7t2+6lLSuqYAwlIgM0AKpAZoI42AJhIEtJC5gAayEOiKRAFdkGhAirQCJEhrIBYxht5W1/IdERCLEPGTGPCQh7KD3MV2rRD9Br9otZOFO8SA1/M23315Q2X3/ix6RV548NvhKrn1E8SE48O0keX9zyP6avUEseH+mCoakISjXUQB0vAooEv4QqBr+FxAIzwIaIU3AprhNUA7fAZIET4FUoUDYMzRUgx6EY7CmABqj6gn0ZP/xjmaO0EyXHfXumWwu9YIB9I4R9MK/wcwR2PiK0P0gR/WtzfzfY05MoA/Qd+TTOSf3csAAAAASUVORK5CYII="

/***/ }),
/* 671 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/refause.1fbd9e8.png";

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/waiting.b508fb0.png";

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/chenggong.a757154.png";

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/topbanner.79c6ddd.png";

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.f79b17b.jpeg";

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.bc28179.png";

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.17ce9f7.png";

/***/ }),
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(639)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(825),
  /* scopeId */
  "data-v-4fd2ed5c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(655)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(841),
  /* scopeId */
  "data-v-a157fe7c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(642)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(828),
  /* scopeId */
  "data-v-5752001e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(641)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(827),
  /* scopeId */
  "data-v-5735d11c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(643)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(829),
  /* scopeId */
  "data-v-57bf7de2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(632)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(818),
  /* scopeId */
  "data-v-2d68c69a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(640)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(826),
  /* scopeId */
  "data-v-5132ac15",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(633)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(819),
  /* scopeId */
  "data-v-30927b44",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(631)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(817),
  /* scopeId */
  "data-v-2d3d3ecf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(635)

var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(821),
  /* scopeId */
  "data-v-3a90f103",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(638)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(824),
  /* scopeId */
  "data-v-42e48ee0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(652)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(838),
  /* scopeId */
  "data-v-8b825bcc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(627)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(813),
  /* scopeId */
  "data-v-289d1a86",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(622)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(808),
  /* scopeId */
  "data-v-0505c3a0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(653)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(839),
  /* scopeId */
  "data-v-8d68ecb6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(636)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(822),
  /* scopeId */
  "data-v-3f4eca75",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(662)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(848),
  /* scopeId */
  "data-v-f4ec7450",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(659)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(845),
  /* scopeId */
  "data-v-b3905836",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(646)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(832),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(634)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(820),
  /* scopeId */
  "data-v-3975818a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(623)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(809),
  /* scopeId */
  "data-v-08407e18",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(637)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(823),
  /* scopeId */
  "data-v-410414f0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(658)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(844),
  /* scopeId */
  "data-v-ad28b82a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(657)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(843),
  /* scopeId */
  "data-v-ad0c8928",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(654)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(840),
  /* scopeId */
  "data-v-92c862ee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(650)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(836),
  /* scopeId */
  "data-v-7d206e5a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(663)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(849),
  /* scopeId */
  "data-v-f610bf16",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(630)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(816),
  /* scopeId */
  "data-v-2baccd33",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(625)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(811),
  /* scopeId */
  "data-v-18e0fc9d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(628)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(814),
  /* scopeId */
  "data-v-28bf59e4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(656)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(842),
  /* scopeId */
  "data-v-a497e33a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(649)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(835),
  /* scopeId */
  "data-v-6e9e457e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(648)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(834),
  /* scopeId */
  "data-v-6d2d6fe6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(626)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(812),
  /* scopeId */
  "data-v-1cb13d7a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(651)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(837),
  /* scopeId */
  "data-v-7dc405e3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(660)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(846),
  /* scopeId */
  "data-v-b6061d6a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(661)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(847),
  /* scopeId */
  "data-v-d01e2eaa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(644)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(830),
  /* scopeId */
  "data-v-591bf8c8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(645)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(831),
  /* scopeId */
  "data-v-5c0d5896",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 808 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "protocolIvvi"
  }, [_c('div', {
    staticClass: "main",
    staticStyle: {
      "padding": "0 6% 15px 6%"
    }
  }, [_c('p', {
    staticClass: "title",
    staticStyle: {
      "text-align": "center",
      "margin-top": "10px",
      "margin-bottom": "3px",
      "background": "rgba(255,255,255,0)"
    }
  }, [_vm._v("免费WiFi用户安全保险协议")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("本协议为免费WiFi用户（即同意并接受了《免费WiFi服务协议》的用户，以下简称“用户”）与南京尚网网络科技有限公司（以下简称“免费WiFi”或“本公司”）关于免费WiFi安全保险事宜所订立的协议。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("——本公司在此依法做出特别声明如下：")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("本公司采取合理的方式提请用户注意的义务将通过如下方式实现：在本协议中本公司以明确的足以引起用户注意的加重字体、斜体、下划线、颜色标记等合理方式提醒用户注意相关条款（需要强调的是，还包括用户应特别注意任何未明确标记的含有“不承担”、“免责”“不得”等形式用语的条款），该等条款的确认将导致用户在特定情况下的被动、不便、损失，请用户在确认同意本协议之前再次阅读上述条款。双方确认上述条款非属于《合同法》第40条规定的“免除其责任、加重对方责任、排除对方主要权利的”的条款。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("鉴于本公司已依法明确了上述条款、履行了格式条款制订方的义务，用户点击同意或下一步，将被视为且应当被视为用户已经完全注意并同意了本协议所有条款尤其是提醒用户注意的条款的合法性及有效性，用户不应当以本公司未对格式条款以合理方式提醒用户注意，或未根据用户要求尽到说明义务为理由而声称或要求法院或其它任何第三方确认相关条款非法或无效。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("——本协议可由本公司随时更新，更新后的协议条款一旦公布即代替原来的协议条款，用户可在软件客户端查阅最新版协议条款。如用户不同意本协议中的任一规定及/或本公司对本协议作出的任何修改，可以选择不参加本保险计划；一旦用户发起索赔申请，即视为用户已经了解并完全同意本协议各项条款及本公司对本协议及保险计划随时作出的修改。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("一、协议总则")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("免费WiFi用户安全保险计划：是指本公司用户在使用免费WiFi连接网络的过程中，因在通过免费WiFi连接的热点网络环境下发生了本协议中列明的WiFi热点恶意行为，导致用户本人在银行账户内的资产，及用户在合法运营的第三方支付机构所设本人实名账户中的资产遭受直接损失，用户可按照本保险计划的有关规则申请索赔。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("本公司已通过众安在线财产保险股份有限公司（以下简称“保险公司”）为免费WiFi的安全性进行投保。免费WiFi用户安全保险计划（以下简称“保险计划”） 旨在为用户营造一个安全、可信的网络环境，让用户更放心地使用本公司提供的服务。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("二、定义")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("在本协议中，除非另有明确约定，提及的词语应具有如下含义：")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("WiFi热点：本协议中所述WiFi热点特指通过WLAN无线协议将网络连接进行延伸的无线接入点,为方便用户理解和辨识，本协议中将WiFi热点特分为有钥匙热点和无钥匙热点；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("有钥匙热点：用户通过点击免费WiFi客户端中的“一键查询”功能，成功查询附近热点后，在热点上标识有蓝色钥匙的热点；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("无钥匙热点：用户通过点击免费WiFi客户端中的“一键查询”功能，成功查询附近热点后，在热点上未标识蓝色钥匙的热点；钓鱼热点：本协议中所述钓鱼热点特指利用WiFi热点开放的特性，模拟正规合法的WiFi热点，以窃取用户私有信息、盗取用户财产等为目的而私自架设的热点。其形式上和正规合法的WiFi热点没有区别，一般公众很难区分；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("钓鱼网站：指不法分子在互联网上建立的通过模仿合法、正规购物平台的网址或页面内容，利用发布虚假消息，搜集客户资料，骗取客户账户（登录ID）、密码、口令等信息进而达到非法窃取客户财物的目的非法网站；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("木马病毒：指不法分子通过各种网络技术手段来篡改用户交易信息或者劫持用户交易过程等方式来达到盗取用户资金目的的恶意程序；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("恶意软件：\"恶意软件\"用作一个集合名词，来指代故意在计算机系统恶意软件上执行恶意任务的蠕虫、木马病毒或其他病毒；在恶意软件未被发现的这段时间，用户上网过程中的所有个人资料都有可能被盗走，比如银行账户信息，信用卡密码等；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("DNS /DNS劫持：本协议中所述DNS是指网络定义的一种协议,为域名和IP地址相互映射，能够使用户更方便地访问互联网,DNS劫持是指恶意攻击者通过中间人攻击篡改域名和IP的对应关系,从而导致用户访问一些虚假的网站；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("热点劫持：本协议中所述热点劫持是指恶意攻击者通过恶意攻击劫持原有WiFi热点，从而捕捉通过热点中的所有用户个人信息及其他信息；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("账户资金：用户本人在银行账户内的资产，及用户在合法运营的第三方支付机构所设本人实名账户中的资产；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("直接损失：因符合理赔范围的情形而被盗取的账户资金。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("三、索赔条件及理赔范围")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("用户应同时具备以下（一）至（五）款列明的各项条件，方可根据本公司用户安全理赔规则申请索赔:")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（一）索赔的前提条件")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.用户必须是免费WiFi的手机注册用户，且其安装并使用的免费WiFi手机客户端中必须已发布施行了本保险计划（即用户必须安装安卓版免费WiFi 4.1.8以上版本及此后发布的更新版本）。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.用户在使用免费WiFi连接网络的过程中，因在通过免费WiFi连接的热点网络环境下发生了本协议中列明的WiFi热点恶意行为，导致用户账户资金被恶意第三方盗取。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.因用户使用免费WiFi导致账户资金被盗，应首次发生于本用户安全保险计划生效日之后；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.用户同意，在使用免费WiFi时向本公司提供其真实有效信息，且上述信息应与用户提交的索赔申请材料中的信息一致，即与本公司订立本协议的用户与实际使用免费WiFi遭受损失并前来申请索赔的用户必须为同一自然人用户；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.用户使用免费WiFi连接的热点是有钥匙热点；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("6.用户自使用免费WiFi连接特定无线网络开始至断开该无线网络的过程中，发生本协议第三条第（二）款中的情形而遭受了直接损失；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("7.用户按照本条第（五）款索赔流程的规定向公安机关报案并向保险公司提交了符合索赔要求的材料。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("8.用户因使用免费WiFi导致用户银行账户资金和有资质的第三方支付软件中的资金遭受损失的事件必须发生在中华人民共和国大陆地区（不包括香港、澳门和台湾地区）。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（二）属于理赔范围的情形")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.用户欲前往特定合法网络购物网站、网络银行网站或第三方支付网站（以上简称“合法网站”）进行购物、转账等操作时，用户在支付交易过程中DNS被钓鱼热点进行了信息篡改，从而导致用户账户资金被盗的；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.用户欲前往合法网站进行购物、转账等操作时，钓鱼热点已对该网站进行了DNS劫持，从而使用户连接上了一个钓鱼网站，导致了用户账户资金被盗的；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.用户在合法网站正常操作购物、转账等操作的过程中，钓鱼热点非法获取了用户录入及传递的个人信息，导致用户信息泄露继而造成账户资金被盗；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.用户欲下载特定应用软件，用户连接的热点被劫持后，用户实际下载了仿冒恶意软件，且一般用户无法判断该软件的真伪。用户在仿冒恶意软件中录入个人信息，或仿冒软件将劫持的用户短信等个人信息发送至恶意第三方，从而导致用户账户资金遭受损失。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（三）不属于理赔范围的情形")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("用户因以下情形产生的经济损失或其他损失，不属于理赔范围，无权向本公司或保险公司申请索赔：")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("1.用户不具备本协议第三条第（一）款中列明的索赔前提条件；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("2.用户使用免费WiFi连接的热点是无钥匙热点；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("3.用户不能根据本保险计划规定提供证据及/或其他索赔材料的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("4.用户未依据本协议第三条第（五）款中的规定进行报案和/或进行证据保全的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("5.自使用免费WiFi遭受直接经济损失之日起15个自然日内，用户未依据本协议第三条第（五）款中的规定向保险公司提交索赔材料的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("6.用户使用免费WiFi连接网络的行为与用户遭受的财产损失不具有直接因果关系；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("7.钓鱼热点、钓鱼网站及网络木马病毒、恶意软件的相关欺诈和/或劫持行为与用户所遭受的财产损失不具有直接因果关系；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("8.虚假诈骗广告信息植入在某个特定热点中，用户连接该热点后，轻信了该虚假广告信息，从而遭受了财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("9.虚假诈骗广告信息或恶意软件下载链接是植入在普通网站中的，用户使用免费WiFi连接网络后，在正常浏览网页的过程中因上述虚假广告或恶意软件遭受了财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("10.在用户使用免费WiFi连接网络并上网的过程中，因用户故意或重大过失导致下列情形的财产损失：")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（1）用户主动向他人账号划转资金或主动为他人发送的代付链接付款的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（2）用户通过网上交易购买机票或火车票时，向不具有在线销售资质的且收款人账号非为公司账号的网站划转资金或付款；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（3）用户主动泄露网上银行账号、密码、支付短信的交易验证码或其他可能导致财产损失的信息，或主动允许他人远程协助的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（4）网上银行账号、密码已被他人知悉，或丢失了数字证书载体后，用户未立即变更账号、密码或通知银行冻结网上银行账户的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（5）其他因用户故意或重大过失导致的财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("11. 用户网购过程中，因商家违背诚信经营原则导致下列情形的财产损失：")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（1）与商家因交易纠纷造成的损失，包括但不限于电子商务商家账号被盗等引起的一切财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（2）由于商家不诚信问题造成的损失，包括但不限于商品或服务的描述与实际不符，商品或服务的质量、价格、售后服务等引发消费纠纷而引起的一切财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（3）虽经网页链接跳转，但用户系在正规网站进行正常交易行为时，由于商家违背诚信经营原则而遭受的财产损失。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("12.用户网购过程中，因其所购买标的物之特殊性导致的下列情形的财产损失：")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（1）用户在网络游戏私服中进行的交易或充值行为；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（2）以虚拟物品为交易对象的，包括但不限于虚拟财产（如虚拟游戏装备、虚拟货币、虚拟道具等）、游戏人物、游戏辅助物品的，或用户在网络游戏中直接交换物品的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（3）用户购买药品、保健品的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（4）涉及盗版及仿制品、走私、非法销售物品的交易；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（5）涉及网络赌博、博彩类交易（包括但不限于“赌球”、“21点”、“押大小”、“购买彩票”等）；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（6）其他涉嫌购买国家法律禁止销售或者交易的物品的任何交易。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("13.网站经营者或任何第三方已赔偿或补偿了用户经济损失，或用户经免费WiFi协助已挽回经济损失，或用户已通过免费WiFi的其他理赔/保障计划获得赔偿的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("14.财产损失超出本协议第三条第（四）款中索赔限额的部分；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("15.用户故意骗保，或在未发生理赔情形或未遭受任何财产损失的前提下谎称发生了理赔情形或伪造损失证据的，或用户因从事非法行为而遭受的任何损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("16.用户有损害本公司商誉、扰乱本公司正常经营秩序言行的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("17.针对同一索赔事件，保险公司向用户进行理赔后，用户又追加索赔申请的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("18.免费WiFi或保险公司工作人员依照本协议的约定联系用户时，自首次尝试联系用户起72小时内仍无法与用户取得联系的，或用户不履行本协议约定的配合义务的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("19.用户遭受的直接经济损失以外的一切间接损失、预期利益、精神损害或其他损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("20.其他根据免费WiFi用户安全保险计划不属于理赔范围的情形。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（四）索赔限额")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('table', {
    attrs: {
      "width": "100%",
      "border": "1",
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tr', [_c('td', [_vm._v("保险责任")]), _vm._v(" "), _c('td', [_vm._v("每一用户单日/单次索赔限额")]), _vm._v(" "), _c('td', [_vm._v("每一用户累计索赔限额")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("免费WiFi在提供服务的过程中造成了用户损失")]), _vm._v(" "), _c('td', [_vm._v("人民币壹万元整")]), _vm._v(" "), _c('td', [_vm._v("人民币壹拾万元整")])])])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("单次事故赔偿限额：人民币壹佰万元整")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("（单次事故：指因同一或基本相同的风险原因导致的一系列索赔事件（即群体性事件），视为一起事故，前述风险原因的认定以本公司技术部门的判定结果作为标准）")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（五）索赔流程")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.证据保全：用户在使用免费WiFi连接网络的过程中，发现账户资金遭受损失的，应立即采取相关证据保全措施，不应自行刷机、清理手机垃圾、删除免费WiFi客户端、历史短信或历史访问网址记录，或自行删除交易过程中与交易对方的聊天记录及所下载的软件，以免导致相关证据无法保全；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.报案：用户在使用免费WiFi连接网络的过程中，发现账户资金遭受损失的，应立即拨打保险公司电话进行报案，并应于10个自然日内前往具有管辖权的公安机关进行报案，并取得案件受理通知书等相关证明材料；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.准备索赔资料：用户应自账户资金遭受经济损失之日起15个自然日内免费WiFi官网或者客户端索赔界面的提示准备索赔资料，并听从工作人员的操作指导，积极配合工作人员的工作，并配合提供相关损失证明文件，以便有效追查被盗情况并保全证据；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.提交索赔资料：用户应根据保险公司工作人员的指示提交索赔资料，并确保其所提交的资料的真实性，否则，本公司及保险公司有权拒绝受理或赔付用户的索赔申请；用户知悉并了解，该等资料中的相关信息包括但不限于用户身份证号码、银行卡号、手机号码、详细住址等个人信息，用户在此同意并授权本公司及保险公司为实现本协议项下的索赔目的对用户的该等个人信息予以采集和使用；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("用户应通过线下快递方式递交如下索赔资料：")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("身份证正反面彩色复印件（非中华人民共和国公民请提交有效护照彩色复印件）")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("向公安机关报案的相关证明（报案或立案证明）")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("非本人授权交易补偿申请表")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("索赔人被盗账户信息截屏")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("被盗账户对账单截屏（须标记盗刷交易明细信息：交易日期、交易商户、交易币种、交易金额、入账币种、入账金额）")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("被盗账户挂失证明（信息截屏，包含挂失日期等）")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("索赔人出险期间手机设备在公安机关的备案数据")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("被盗账户近半年交易数据（如有）")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("涉及诉讼、仲裁的，递交相关司法文书、对方提交的证据副本等（如有）")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("其他本公司或保险公司认为对向用户提供理赔服务所必须的材料。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.保险公司根据用户提交的材料将认定最终理赔结果，如最终确认属于理赔责任范围内的情形，由保险公司向用户支付赔款，最终理赔额在人民币3000元（含3000元）以下的案件由保险公司在确认最终理赔结果后的5个工作日之内支付赔款；最终理赔额在人民币3000元以上的案件由保险公司在确认最终理赔结果后的10个工作日之内支付赔款。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("四、用户的权利与义务")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.用户使用免费WiFi过程中用户账户资金遭受直接经济损失的，用户有权向保险公司提起索赔申请，经本公司及保险公司认定情况属实并符合索赔条件及范围的，保险公司将依据理赔规则给予用户理赔。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.用户向保险公司提起索赔申请，应按照本公司用户安全理赔规则提交所有相关索赔材料。用户保证，其所提交的一切索赔材料、所作出的任何陈述或保证均真实准确且合法有效，并应独立承担因违反上述保证所引发的一切法律责任。用户未充分履行上述义务或违反上述保证的，本公司及保险公司有权不予理赔；保险公司已经向该用户支付理赔金的，有权向该用户追回，并要求用户赔偿本公司及保险公司因此遭受的一切损失。同时，本公司及保险公司将向有关机关报案，追究该用户骗保的刑事责任。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.用户应保证其连接网络及上网过程中的行为不触犯任何法律、行政法规、相关政策且不侵犯任何第三人的合法权益。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.用户应向保险公司提供真实有效的收款账户信息，因用户原因导致提供的收款信息错误而无法收到理赔额的情况，本公司及保险公司不承担任何责任。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.用户向保险公司或本公司发起索赔申请，即表明用户已同意严格遵守本公司发布的针对免费WiFi安全保险计划的所有规则，并同意以最新的规则作为认定最终理赔结果的依据。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("6.用户承诺：未经本公司书面许可，不得将最终理赔结果向任何第三方披露。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("五、本公司的权利与义务")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.用户知悉并完全同意本公司有权随时修改、更新、暂停或永久终止保险计划，无需对用户承担任何法律责任。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.本公司有权依据理赔规则对用户向保险公司的索赔申请进行审核以确定是否向其提供理赔服务，用户同意本公司有完全的权利同意或拒绝用户的申请。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.本公司对本协议项下的理赔义务承担有限责任，在任何情形下，用户同意保险公司向其支付的理赔金的最高上限依照本协议第（四）条之规定执行。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.如免费WiFi及保险公司在审查用户所提交的索赔申请时发现重大刑事案件线索的，本公司及保险公司有权在通知用户后以用户索赔资料为基础向警方提供案件侦查线索或向相关司法机关检举；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.用户因使用免费WiFi所遭受的经济损失，通过第三方获得赔付或司法程序或其他合法程序得以追缴或退赔的，若保险公司已根据本保险计划向用户进行赔付的，则有权在其对用户的赔付范围内要求用户进行返还；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("6.本公司承诺：未经用户允许，除为实现本协议项下的理赔目的及法律法规隐私保护政策另有规定的情形外，不对外披露或向第三方提供用户的任何信息。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("六、其他")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("1.本公司郑重提醒用户注意本协议中免除本公司责任和加重用户义务的条款，请用户仔细阅读，自主考虑风险。未成年人应在法定监护人的陪同下阅读本协议。 以上各项条款内容的最终解释权及修改权归本公司所有。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.本协议所定的任何条款的部分或全部无效者，不影响其它条款的效力。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("3.本协议签订地为上海市浦东新区。本协议的解释、效力及纠纷的解决，适用于中华人民共和国法律。若用户和本公司之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，用户在此完全同意双方将纠纷或争议提交上海市浦东新区的人民法院通过诉讼方式解决。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.本协议的版权由本公司所有，本公司保留对上述条例的最终解释权。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.本免费WiFi用户安全保险计划自2016年4月18日起生效施行。")])])])
}]}

/***/ }),
/* 809 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ClaimFlow"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('p', {
    staticClass: "title2"
  }, [_vm._v("商户通过WiFi万能钥匙分享WiFi后，因黑客篡改WiFi密码、劫持商户收银、盗刷商户账户内资金等恶意行为，导致商户在银行账户内的资产，及商户在合法运营的第三方支付机构所设本商户实名账户中的资产遭受损失，应立即采取以下措施：")]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v("1.证据保全")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("商户在使用WiFi万能钥匙分享热点后，发现账户资金遭受损失的，应立即采取相关证据保全措施，不应自行刷机、清理交易设备缓存、删除WiFi万能钥匙客户端、历史短信或历史访问网址记录，或自行删除交易过程中与交易对方的聊天记录及所下载的软件，以免导致相关证据无法保全；")]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v("2.报案")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("商户在使用WiFi万能钥匙分享热点后，发现账户资金遭受损失的，应立即拨打保险公司电话进行报案，并应于10个自然日内前往具有管辖权的公安机关进行报案，并取得案件受理通知书等相关证明材料；")]), _vm._v(" "), _c('p', {
    staticClass: "text highlight"
  }, [_vm._v("众安保险客服电话:400-999-9595")]), _vm._v(" "), _c('p', {
    staticClass: "text highlight"
  }, [_vm._v("(7×24小时统一客服热线)")]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v("3.准备索赔资料")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("商户应自账户资金遭受经济损失之日起15个自然日内根据WiFi万能钥匙客户端索赔界面的提示准备索赔资料，并听从工作人员的操作指导，积极配合工作人员的工作，并配合提供相关损失证明文件，以便有效追查被盗情况并保全证据；")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("若保险公司或WiFi万能钥匙的工作人员联系用户时，首次尝试联系商户起72小时内仍无法与商户取得联系的，或商户不履行本协议约定的配合义务的，将视商户自动放弃索赔。")]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v("4.提交索赔资料")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("商户应根据保险公司工作人员的指示提交索赔资料，并确保其所提交的资料的真实性，否则，本公司及保险公司有权拒绝受理或赔付商户的索赔申请；商户知悉并了解，该等资料中的相关信息包括但不限于商户身份证号码、银行卡号、手机号码、详细住址等个人信息，商户在此同意并授权本公司及保险公司为实现本协议项下的索赔目的对商户的该等个人信息予以采集和使用；")]), _vm._v(" "), _c('p', [_vm._v("商户应通过线下快递方式递交如下索赔资料（不接受快递到付）：")]), _vm._v(" "), _c('p', {
    staticClass: "text highlight"
  }, [_vm._v("\n        收件人：WiFi万能钥匙商户安全理赔项目组"), _c('br'), _vm._v("\n        快递联系电话：400-035-8000"), _c('br'), _vm._v("\n        寄送地址：上海市浦东新区张衡路666弄1号楼7楼\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v("5.理赔结果")]), _vm._v(" "), _c('p', {
    staticClass: "text last"
  }, [_vm._v("保险公司根据商户提交的材料将认定最终理赔结果，如最终确认属于理赔责任范围内的情形，由保险公司向商户指定的个人收款账户支付赔款，最终理赔额在人民币3000元（含3000元）以下的案件由保险公司在确认最终理赔结果后的5个工作日之内支付赔款；最终理赔额在人民币3000元以上的案件由保险公司在确认最终理赔结果后的10个工作日之内支付赔款。")])])])
}]}

/***/ }),
/* 810 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view', {
    staticClass: "view"
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view', {
    staticClass: "view"
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 811 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new-docs"
  }, [_c('h4', {
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_vm._v("必须提供的索赔资料：")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("1、营业执照彩色复印件")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("2、法定代表人身份证复印件（非中华人民共和国公民请提交有效护照彩色复印件）")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("3、授权委托书和代理人身份证复印件和非商户授权交易补偿申请表（商户办理理赔事务的代理人非为营业执照所载的法定代表人时需要提供）")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("4、向公安机关报案的相关证明（报案或立案证明）")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("5、索赔人出险期间手机设备在公安机关的备案数据")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("6、索赔人被盗账户信息截屏")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("7、被盗账户对账单截屏（须标记盗刷交易明细信息：交易日期、付款人信息、交易币种、交易金额、入账币种、入账金额）")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("8、被盗账户挂失证明（信息截屏，包含挂失日期等）")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("9、其他本公司或保险公司认为对向商户提供理赔服务所必须的材料。")]), _vm._v(" "), _c('h4', [_vm._v("如有可提供的索赔资料：")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("1、被盗账户近半年交易数据（如有）")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("2、涉及诉讼、仲裁的，递交相关司法文书、对方提交的证据副本等（如有）")])])
}]}

/***/ }),
/* 812 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "protocol"
  }, [_c('div', {
    staticClass: "main",
    staticStyle: {
      "padding": "0 6% 15px 6%"
    }
  }, [_c('p', {
    staticClass: "title",
    staticStyle: {
      "text-align": "center",
      "margin-top": "10px",
      "margin-bottom": "3px",
      "background": "rgba(255,255,255,0)"
    }
  }, [_vm._v("WiFi万能钥匙商户热点安全保险协议")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("本协议为WiFi万能钥匙商户用户（即同意并接受了《WiFi万能钥匙服务协议》及《WiFi万能钥匙隐私权政策》的商户用户，以下简称“商户”）与南京尚网网络科技有限公司（以下简称“WiFi万能钥匙”或“本公司”）关于WiFi万能钥匙安全保险事宜所订立的协议。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("——本公司在此依法做出特别提示如下：")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1、"), _c('b', [_vm._v("【审慎阅读】请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。")]), _vm._v(" 针对前述条款，本协议已以明确的足以引起您注意的包括但不限于加重字体、斜体、下划线、颜色标记等合理方式提醒您注意相关条款（需要强调的是，还包括您应特别注意任何未明确标记的含有“不承担”、“免责”、“不得”以及“无关”等形式用语的条款），该等条款的确认将导致您在特定情况下的被动、不便和/或造成损失，请您在确认同意本协议之前再次阅读上述条款。 除非您已审慎阅读、充分理解并同意本协议所有条款，您将放弃参加本保险计划。 ")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2、"), _c('b', [_vm._v("本协议签署后，您如有任何需要本公司说明条款的要求，请立即停止参加本保险计划，同时立即致电或发送邮件至本公司客服，若您未致电或未发送有说明条款要求的邮件至本公司，即表示您选择同意该协议的所有条款。")]), _vm._v(" 双方在此确认本公司已依法履行了根据您要求对相关条款进行说明的法定义务，本公司已给予您充足的时间与充分的选择权来决定是否缔结本协议。 ")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3、"), _c('b', [_vm._v("【协议的确认和接受】鉴于本公司已依法明确了上述条款，您点击“同意”或“下一步”，将被视为且应当被视为您已经完全注意并“同意”了本协议所有条款尤其是提醒您注意的条款的合法性及有效性，您不应当以本公司未对相关条款以合理方式提醒您注意，或未根据您要求尽到说明义务为理由而声称或要求法院或其它任何第三方确认相关条款非法或无效。 如果您不同意本协议的任何内容，点击“不同意”，视为您选择放弃参加本保险计划。")])]), _vm._v(" "), _c('p', [_vm._v("4、【协议的修改】 本协议可由本公司适时更新，更新后的协议条款一经公布即替代原协议条款，您可在软件客户端查阅最新版协议。 "), _c('b', [_vm._v("在本公司修改协议并公布后，如果您不接受修改后的协议，请立即停止参加本保险计划，您一旦发起索赔申请将被视为已接受修改后的协议。")])]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("一、协议总则")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("WiFi万能钥匙热点商户联盟安全理赔计划（亦简称“本保险计划”）是指商户通过WiFi万能钥匙分享WiFi热点（以下亦简称“热点”）后，因发生黑客篡改WiFi密码、劫持商户收银、盗刷商户账户内资金等恶意行为导致商户产生损失的，商户可以依据本协议的有关规则申请理赔。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("本公司已通过众安在线财产保险股份有限公司（以下简称“保险公司”）为WiFi万能钥匙的安全性进行投保。WiFi万能钥匙商户安全保险计划（以下简称“保险计划”）旨在为商户营造一个安全、可信的网络环境，让商户更放心地提供WiFi热点分享。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("二、定义")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("在本协议中，除非另有明确约定，提及的词语应具有如下含义：")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("WiFi热点：本协议中所述WiFi热点特指通过WLAN无线协议将网络连接进行延伸的无线接入点,有连接网络需求的用户（以下称为“用户”）可通过WiFi万能钥匙进行相应操作实现网络连接并上网；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("有钥匙热点：商户通过WiFi万能钥匙客户端或其他渠道已向本公司分享的WiFi热点，商户的WiFi热点信息将会以有钥匙热点（用户通过点击WiFi万能钥匙客户端中的“一键查询”功能或下拉连接页面发起“一键查询”功能，成功查询附近热点后，在热点上有蓝色钥匙标识的热点）的形式呈现在进入该热点覆盖范围的用户设备的网络信息中；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("钓鱼网站：指不法分子在互联网上建立的通过模仿合法、正规购物平台的网址或页面内容，利用发布虚假消息，搜集客户资料，骗取客户账户（登录ID）、密码、口令等信息进而达到非法窃取客户财物的目的非法网站；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("木马病毒：指不法分子通过各种网络技术手段来篡改商户交易信息或者劫持商户收银系统等方式来达到盗取商户资金目的的恶意程序；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("勒索病毒：是一种新型计算机病毒，主要以邮件、程序木马、网页挂马的形式进行传播。这种病毒利用各种加密算法对文件进行加密，被感染者一般无法解密，必须交付赎金，拿到解密的私钥才有可能破解；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("恶意软件：\"恶意软件\"用作一个集合名词，来指代故意在计算机系统恶意软件上执行恶意任务的蠕虫、木马病毒或其他病毒；在恶意软件未被发现的这段时间，商户上网过程中的所有个人资料都有可能被盗走，比如银行账户信息，信用卡密码等；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("DNS /DNS劫持：本协议中所述DNS是指网络定义的一种协议,为域名和IP地址相互映射，能够使商户更方便地访问互联网,DNS劫持是指恶意攻击者通过中间人攻击篡改域名和IP的对应关系,从而导致商户访问一些虚假的网站；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("热点劫持：本协议中所述热点劫持是指恶意攻击者通过恶意攻击劫持原有WiFi热点，从而捕捉通过热点中的所有商户个人信息及其他信息；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("账户资金：商户在银行账户内的资产，及商户在合法运营的第三方支付机构所设本商户实名账户中的资产；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("直接损失：因符合理赔范围的情形而被盗取的账户资金。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("三、索赔条件及理赔范围")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("商户应同时具备以下（一）至（五）款列明的各项条件，方可根据本公司商户安全理赔规则申请索赔:")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（一）索赔的前提条件")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.商户赖以执行参保的设备持有者必须是WiFi万能钥匙的手机注册用户，且其安装并使用的WiFi万能钥匙手机客户端中必须已发布施行了本保险计划（即该用户必须安装WiFi万能钥匙安卓版4.0或者iOS版3.3.5以上版本及此后发布的更新版本）。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.商户因分享热点，被恶意利用，发生本协议所列明的劫持攻击，导致勒索病毒造成资金损失的情形。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.因商户分享热点导致账户资金被盗，并发生本协议第三条第（二）款中的情形而遭受了直接损失，应首次发生于本商户安全保险计划生效日之后。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.商户同意，在通过WiFi万能钥匙参保时向本公司提供其真实有效信息，且上述信息应与商户提交的索赔申请材料中的信息一致，即与本公司订立本协议的商户与实际因分享热点遭受损失并前来申请索赔的商户必须为同一商户。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.商户分享的热点属于有钥匙热点，商户必须是热点主人。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("6.商户按照本条第（五）款索赔流程的规定向公安机关报案并向保险公司提交了符合索赔要求的材料。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("7.商户因分享热点导致其银行账户资金和有资质的第三方支付软件中的资金遭受损失的事件必须发生在中华人民共和国大陆地区（不包括香港、澳门和台湾地区）。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（二）属于理赔范围的情形")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.商户欲前往特定合法网络购物网站、网络银行网站或第三方支付网站（以上简称“合法网站”）进行销售、购物、转账等操作时，商户在支付交易过程中DNS被钓鱼热点进行了信息篡改，从而导致商户账户资金被盗的；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.商户欲前往合法网站进行销售、购物、转账等操作时，钓鱼热点已对该网站进行了DNS劫持，从而使商户连接上了一个钓鱼网站，导致了商户账户资金被盗的；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.商户在合法网站正常操作销售、购物、转账等操作的过程中，钓鱼热点非法获取了商户录入及传递的交易信息，导致商户信息泄露继而造成账户资金被盗；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.商户欲下载特定应用软件，商户连接的热点被劫持后，商户实际下载了仿冒恶意软件，且一般商户无法判断该软件的真伪。商户在仿冒恶意软件中录入交易信息，或仿冒软件将劫持的商户短信等个人信息发送至恶意第三方，从而导致商户账户资金遭受损失。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.商户连接该热点并用于执行销售、购物、转账等操作的电子设备，被劫持（DNS、ARP）攻击，植入勒索病毒，导致生产中断或者其他直接损失。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（三）不属于理赔范围的情形")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("商户因以下情形产生的经济损失或其他损失，不属于理赔范围，无权向本公司或保险公司申请索赔：")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("1.商户不具备本协议第三条第（一）款中列明的索赔全部前提条件；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("2.商户不能根据本保险计划规定提供证据及/或其他索赔材料的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("3.商户未依据本协议第三条第（五）款中的规定进行报案和/或进行证据保全的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("4.自直接经济损失发生之日起15个自然日内，商户未依据本协议第三条第（五）款中的规定向保险公司提交索赔材料的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("5.商户使用WiFi万能钥匙分享热点的行为与商户遭受的财产损失不具有直接因果关系；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("6.商户主动接受虚假诈骗广告信息植入在其所分享的特定热点中，用户连接该热点后，轻信了该虚假广告信息而遭受了财产损失，商户就该损失进行了赔偿的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("7.在商户使用WiFi万能钥匙分享热点后，因商户故意或重大过失导致下列情形的财产损失：")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（1）商户主动向他人账号划转资金或主动为他人发送的代付链接付款的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（2）商户主动泄露WiFi密码、网上银行账号、密码、支付短信的交易验证码或其他可能导致财产损失的信息，或主动允许他人远程协助的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（3）WiFi密码、网上银行账号、密码已被他人知悉，或丢失了数字证书载体后，商户未立即变更账号、密码或通知银行冻结网上银行账户的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（4）商户对其WiFi网络信息，收银系统以及账户资金安全管理不善，因其雇员或管理执行人篡改WiFi密码、劫持盗用收银系统，盗取账户资金而导致损失的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（5）其他因商户故意或重大过失导致的财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("8. 商户在网上交易过程中，因买家违背诚信经营原则导致下列情形的财产损失：")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（1）与买家因交易纠纷造成的损失，包括但不限于电子商务买家账号被盗等引起的一切财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（2）由于买家不诚信问题造成的损失，包括但不限于迟延付款、拒绝付款等引发消费纠纷而引起的一切财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（3）虽经网页链接跳转，但商户系在正规网站进行正常交易行为时，由于买家违背诚信经营原则而遭受的财产损失。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("9.商户网购过程中，因其所购买标的物之特殊性导致的下列情形的财产损失：")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（1）商户在网络游戏私服中进行的交易或充值行为；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（2）以虚拟物品为交易对象的，包括但不限于虚拟财产（如虚拟游戏装备、虚拟货币、虚拟道具等）、游戏人物、游戏辅助物品的，或用户在网络游戏中直接交换物品的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（3）商户购买药品、保健品的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（4）涉及盗版及仿制品、走私、非法销售物品的交易；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（5）涉及网络赌博、博彩类交易（包括但不限于“赌球”、“21点”、“押大小”、“购买彩票”等）；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（6）其他涉嫌购买国家法律禁止销售或者交易的物品的任何交易。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("10.网站经营者或任何第三方已赔偿或补偿了商户经济损失，或商户经WiFi万能钥匙协助已挽回经济损失，或商户已通过WiFi万能钥匙的其他理赔/保障计划获得赔偿的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("11.财产损失超出本协议第三条第（四）款中索赔限额的部分；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("12.商户故意骗保，或在未发生理赔情形或未遭受任何财产损失的前提下谎称发生了理赔情形或伪造损失证据的，或商户因从事非法行为而遭受的任何损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("13.商户有损害本公司商誉、扰乱本公司正常经营秩序言行的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("14.针对同一索赔事件，保险公司向商户进行理赔后，商户又追加索赔申请的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("15.WiFi万能钥匙或保险公司工作人员依照本协议的约定联系商户时，自首次尝试联系商户起72小时内仍无法与商户取得联系的，或商户不履行本协议约定的配合义务的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("16.商户遭受的直接经济损失以外的一切间接损失、预期利益、精神损害或其他损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("17.其他根据WiFi万能钥匙商户安全保险计划不属于理赔范围的情形。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（四）索赔限额")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('table', {
    attrs: {
      "width": "100%",
      "border": "1",
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tr', [_c('td', [_vm._v("保险责任")]), _vm._v(" "), _c('td', [_vm._v("每一商户单日/单次索赔限额")]), _vm._v(" "), _c('td', [_vm._v("每一商户累计索赔限额")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("WiFi万能钥匙在提供服务的过程中造成了商户损失")]), _vm._v(" "), _c('td', [_vm._v("人民币贰万元整")]), _vm._v(" "), _c('td', [_vm._v("人民币壹拾万元整")])])])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("单次事故赔偿限额：人民币壹拾万元整")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("（单次事故：指因同一或基本相同的风险原因导致的一系列索赔事件（即群体性事件），视为一起事故，前述风险原因的认定以本公司技术部门的判定结果作为标准）")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（五）索赔流程")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.证据保全：商户在使用WiFi万能钥匙分享热点后，发现账户资金遭受损失的，应立即采取相关证据保全措施，不应自行刷机、清理交易设备缓存、删除WiFi万能钥匙客户端、历史短信或历史访问网址记录，或自行删除交易过程中与交易对方的聊天记录及所下载的软件，以免导致相关证据无法保全；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.报案：商户在使用WiFi万能钥匙分享热点后，发现账户资金遭受损失的，应立即拨打保险公司电话进行报案，并应于10个自然日内前往具有管辖权的公安机关进行报案，并取得案件受理通知书等相关证明材料；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.准备索赔资料：商户应自账户资金遭受经济损失之日起15个自然日内根据WiFi万能钥匙客户端索赔界面的提示准备索赔资料，并听从工作人员的操作指导，积极配合工作人员的工作，并配合提供相关损失证明文件，以便有效追查被盗情况并保全证据；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.提交索赔资料：商户应根据保险公司工作人员的指示提交索赔资料，并确保其所提交的资料的真实性，否则，本公司及保险公司有权拒绝受理或赔付商户的索赔申请；商户知悉并了解，该等资料中的相关信息包括但不限于商户身份证号码、银行卡号、手机号码、详细住址等个人信息，商户在此同意并授权本公司及保险公司为实现本协议项下的索赔目的对商户的该等个人信息予以采集和使用；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("商户应通过线下快递方式递交如下索赔资料：")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('b', [_vm._v("营业执照彩色复印件")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('b', [_vm._v("法定代表人身份证复印件")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('b', [_vm._v("授权委托书和代理人身份证复印件（商户办理理赔事务的代理人非为营业执照所载的法定代表人时需要提供）")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("向公安机关报案的相关证明（报案或立案证明）")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("非商户授权交易补偿申请表")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('b', [_vm._v("索赔人被盗账户信息截屏")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('b', [_vm._v("被盗账户对账单截屏（须标记盗刷交易明细信息：交易日期、付款人信息、交易币种、交易金额、入账币种、入账金额）")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('b', [_vm._v("被盗账户挂失证明（信息截屏，包含挂失日期等）")])]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("索赔人出险期间手机设备在公安机关的备案数据")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("被盗账户近半年交易数据（如有）")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("涉及诉讼、仲裁的，递交相关司法文书、对方提交的证据副本等（如有）")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("其他本公司或保险公司认为对向商户提供理赔服务所必须的材料。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.理赔结果：保险公司根据商户提交的材料将认定最终理赔结果，如最终确认属于理赔责任范围内的情形，由保险公司向商户指定的个人收款账户支付赔款，最终理赔额在人民币3000元（含3000元）以下的案件由保险公司在确认最终理赔结果后的5个工作日之内支付赔款；最终理赔额在人民币3000元以上的案件由保险公司在确认最终理赔结果后的10个工作日之内支付赔款。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("四、商户的权利与义务")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.商户使用WiFi万能钥匙分享热点后商户账户资金遭受直接经济损失的，商户有权向保险公司提起索赔申请，经本公司及保险公司认定情况属实并符合索赔条件及范围的，保险公司将依据理赔规则给予商户理赔。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.商户向保险公司提起索赔申请，应按照本公司商户安全理赔规则提交所有相关索赔材料。商户保证，其所提交的一切索赔材料、所作出的任何陈述或保证均真实准确且合法有效，并应独立承担因违反上述保证所引发的一切法律责任。商户未充分履行上述义务或违反上述保证的，本公司及保险公司有权不予理赔；保险公司已经向该商户支付理赔金的，有权向该商户追回，并要求商户赔偿本公司及保险公司因此遭受的一切损失。同时，本公司及保险公司将向有关机关报案，追究该商户骗保的刑事责任。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.商户应保证其热点分享及支持用户连接网络的行为不触犯任何法律、行政法规、相关政策且不侵犯任何第三人的合法权益。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.商户应向保险公司提供真实有效的收款账户信息，因商户原因导致提供的收款信息错误而无法收到理赔额的情况，本公司及保险公司不承担任何责任。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.商户向保险公司或本公司发起索赔申请，即表明商户已同意严格遵守本公司发布的针对WiFi万能钥匙安全保险计划的所有规则，并同意以最新的规则作为认定最终理赔结果的依据。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("6.商户承诺：未经本公司书面许可，不得将最终理赔结果向任何第三方披露。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("五、本公司的权利与义务")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.商户知悉并完全同意本公司有权随时修改、更新、暂停或永久终止保险计划，无需因此对商户承担法律责任。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.本公司有权依据理赔规则对商户向保险公司的索赔申请进行审核以确定是否向其提供理赔服务，本公司有完全的权利同意或拒绝商户的申请。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.本公司对本协议项下的理赔义务承担有限责任，在任何情形下，商户同意保险公司向其支付的理赔金的最高上限依照本协议第（四）条之规定执行。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.如WiFi万能钥匙及保险公司在审查商户所提交的索赔申请时发现重大刑事案件线索的，本公司及保险公司有权在通知商户后以商户索赔资料为基础向警方提供案件侦查线索或向相关司法机关检举。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.商户因使用WiFi万能钥匙所遭受的经济损失，通过第三方获得赔付或司法程序或其他合法程序得以追缴或退赔的，若保险公司已根据本保险计划向商户进行赔付的，则有权在其对商户的赔付范围内要求商户进行返还。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("6.本公司承诺：未经商户允许，除为实现本协议项下的理赔目的及法律法规隐私保护政策另有规定的情形外，不对外披露或向第三方提供商户的任何信息。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("六、其他")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_c('b', [_vm._v("1.本公司郑重提醒商户注意本协议中免除或限制责任的条款，请商户仔细阅读，自主考虑风险。")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.本协议所定的任何条款的部分或全部无效者，不影响其它条款的效力。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("3."), _c('b', [_vm._v("本协议的解释、效力及纠纷的解决，适用于中华人民共和国法律。若商户和本公司之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，商户在此完全同意双方将纠纷或争议提交本公司所在地人民法院通过诉讼方式解决。")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.本WiFi万能钥匙商户安全保险计划自2020年9月16日起生效施行。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.若您对本协议及本保险计划有任何意见，欢迎垂询本公司客服中心400-035-8000。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("南京尚网网络科技有限公司")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2020年9月16日")])])])
}]}

/***/ }),
/* 813 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "protocolIos"
  }, [_c('div', {
    staticClass: "main",
    staticStyle: {
      "padding": "0 6% 15px 6%"
    }
  }, [_c('p', {
    staticClass: "title",
    staticStyle: {
      "text-align": "center",
      "margin-top": "10px",
      "margin-bottom": "3px",
      "background": "rgba(255,255,255,0)"
    }
  }, [_vm._v("WiFi万能钥匙用户安全保险协议")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("本协议为WiFi万能钥匙用户（即同意并接受了《WiFi万能钥匙服务协议》及《WiFi万能钥匙隐私权政策》的用户，以下简称“用户”）与南京尚网网络科技有限公司（以下简称“WiFi万能钥匙”或“本公司”）关于WiFi万能钥匙安全保险事宜所订立的协议。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("——本公司在此依法做出特别提示如下：")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1、"), _c('b', [_vm._v("【审慎阅读】请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。")]), _vm._v(" 针对前述条款，本协议已以明确的足以引起您注意的包括但不限于加重字体、斜体、下划线、颜色标记等合理方式提醒您注意相关条款（需要强调的是，还包括您应特别注意任何未明确标记的含有“不承担”、“免责”、“不得”以及“无关”等形式用语的条款），该等条款的确认将导致您在特定情况下的被动、不便和/或造成损失，请您在确认同意本协议之前再次阅读上述条款。 除非您已审慎阅读、充分理解并同意本协议所有条款，您将放弃参加本保险计划。 ")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2、"), _c('b', [_vm._v("本协议签署后，您如有任何需要本公司说明条款的要求，请立即停止参加本保险计划，同时立即致电或发送邮件至本公司客服，若您未致电或未发送有说明条款要求的邮件至本公司，即表示您选择同意该协议的所有条款。")]), _vm._v(" 双方在此确认本公司已依法履行了根据您要求对相关条款进行说明的法定义务，本公司已给予您充足的时间与充分的选择权来决定是否缔结本协议。 ")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3、"), _c('b', [_vm._v("【协议的确认和接受】鉴于本公司已依法明确了上述条款，您点击“同意”或“下一步”，将被视为且应当被视为您已经完全注意并“同意”了本协议所有条款尤其是提醒您注意的条款的合法性及有效性，您不应当以本公司未对相关条款以合理方式提醒您注意，或未根据您要求尽到说明义务为理由而声称或要求法院或其它任何第三方确认相关条款非法或无效。 如果您不同意本协议的任何内容，点击“不同意”，视为您选择放弃参加本保险计划。")])]), _vm._v(" "), _c('p', [_vm._v("4、"), _c('b', [_vm._v("如果您未满18周岁，请在法定监护人的陪同下阅读本协议条款。")])]), _vm._v(" "), _c('p', [_vm._v("5、【协议的修改】 本协议可由本公司适时更新，更新后的协议条款一经公布即替代原协议条款，您可在软件客户端查阅最新版协议。 "), _c('b', [_vm._v("在本公司修改协议并公布后，如果您不接受修改后的协议，请立即停止参加本保险计划，您一旦发起索赔申请将被视为已接受修改后的协议。")])]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("一、协议总则")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("WiFi万能钥匙用户安全保险计划：是指本公司用户在使用WiFi万能钥匙连接网络的过程中，因在通过WiFi万能钥匙连接的热点网络环境下发生了本协议中列明的WiFi热点恶意行为，导致用户本人在银行账户内的资产，及用户在合法运营的第三方支付机构所设本人实名账户中的资产遭受直接损失，用户可按照本保险计划的有关规则申请索赔。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("本公司已通过众安在线财产保险股份有限公司（以下简称“保险公司”）为WiFi万能钥匙的安全性进行投保。WiFi万能钥匙用户安全保险计划（以下简称“保险计划”） 旨在为用户营造一个安全、可信的网络环境，让用户更放心地使用本公司提供的服务。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("二、定义")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("在本协议中，除非另有明确约定，提及的词语应具有如下含义：")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("WiFi热点：本协议中所述WiFi热点特指通过WLAN无线协议将网络连接进行延伸的无线接入点,为方便用户理解和辨识，本协议中将WiFi热点特分为共享热点和非共享热点；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("共享热点：用户通过点击WiFi万能钥匙客户端中的“一键查询”功能或下拉连接页面发起“一键查询”功能，成功查询附近热点后，在热点上有蓝色钥匙标识的热点；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("非共享热点：用户通过点击WiFi万能钥匙客户端中的“一键查询”功能或下拉连接页面发起“一键查询”功能，成功查询附近热点后，在热点上无蓝色钥匙标识的热点；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("钓鱼热点：本协议中所述钓鱼热点特指利用WiFi热点开放的特性，模拟正规合法的WiFi热点，以窃取用户私有信息、盗取用户财产等为目的而私自架设的热点。其形式上和正规合法的WiFi热点没有区别，一般公众很难区分；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("钓鱼网站：指不法分子在互联网上建立的通过模仿合法、正规购物平台的网址或页面内容，利用发布虚假消息，搜集客户资料，骗取客户账户（登录ID）、密码、口令等信息进而达到非法窃取客户财物的目的非法网站；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("木马病毒：指不法分子通过各种网络技术手段来篡改用户交易信息或者劫持用户交易过程等方式来达到盗取用户资金目的的恶意程序；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("恶意软件：\"恶意软件\"用作一个集合名词，来指代故意在计算机系统恶意软件上执行恶意任务的蠕虫、木马病毒或其他病毒；在恶意软件未被发现的这段时间，用户上网过程中的所有个人资料都有可能被盗走，比如银行账户信息，信用卡密码等；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("DNS /DNS劫持：本协议中所述DNS是指网络定义的一种协议,为域名和IP地址相互映射，能够使用户更方便地访问互联网,DNS劫持是指恶意攻击者通过中间人攻击篡改域名和IP的对应关系,从而导致用户访问一些虚假的网站；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("热点劫持：本协议中所述热点劫持是指恶意攻击者通过恶意攻击劫持原有WiFi热点，从而捕捉通过热点中的所有用户个人信息及其他信息；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("账户资金：用户本人在银行账户内的资产，及用户在合法运营的第三方支付机构所设本人实名账户中的资产；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("直接损失：因符合理赔范围的情形而被盗取的账户资金。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("三、索赔条件及理赔范围")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("用户应同时具备以下（一）至（五）款列明的各项条件，方可根据本公司用户安全理赔规则申请索赔:")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（一）索赔的前提条件")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.用户必须是WiFi万能钥匙的手机注册用户，且其安装并使用的WiFi万能钥匙手机客户端中必须已发布施行了本保险计划（即用户必须安装WiFi万能钥匙安卓版4.0或iOS版3.3.5以上版本及此后发布的更新版本）。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.用户在使用WiFi万能钥匙连接网络的过程中，因在通过WiFi万能钥匙连接的热点网络环境下发生了本协议中列明的WiFi热点恶意行为，导致用户账户资金被恶意第三方盗取。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.因用户使用WiFi万能钥匙导致账户资金被盗，应首次发生于本用户安全保险计划生效日之后。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.用户同意，在使用WiFi万能钥匙时向本公司提供其真实有效信息，且上述信息应与用户提交的索赔申请材料中的信息一致，即与本公司订立本协议的用户与实际使用WiFi万能钥匙遭受损失并前来申请索赔的用户必须为同一自然人用户。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.用户使用WiFi万能钥匙连接的热点是共享热点。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("6.用户自使用WiFi万能钥匙连接特定无线网络开始至断开该无线网络的过程中，发生本协议第三条第（二）款中的情形而遭受了直接损失。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("7.用户按照本条第（五）款索赔流程的规定向公安机关报案并向保险公司提交了符合索赔要求的材料。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("8.用户因使用WiFi万能钥匙导致用户银行账户资金和有资质的第三方支付软件中的资金遭受损失的事件必须发生在中华人民共和国大陆地区（不包括香港、澳门和台湾地区）。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（二）属于理赔范围的情形")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.用户欲前往特定合法网络购物网站、网络银行网站或第三方支付网站（以上简称“合法网站”）进行购物、转账等操作时，用户在支付交易过程中DNS被钓鱼热点进行了信息篡改，从而导致用户账户资金被盗的；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.用户欲前往合法网站进行购物、转账等操作时，钓鱼热点已对该网站进行了DNS劫持，从而使用户连接上了一个钓鱼网站，导致了用户账户资金被盗的；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.用户在合法网站正常操作购物、转账等操作的过程中，钓鱼热点非法获取了用户录入及传递的个人信息，导致用户信息泄露继而造成账户资金被盗；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.用户欲下载特定应用软件，用户连接的热点被劫持后，用户实际下载了仿冒恶意软件，且一般用户无法判断该软件的真伪。用户在仿冒恶意软件中录入个人信息，或仿冒软件将劫持的用户短信等个人信息发送至恶意第三方，从而导致用户账户资金遭受损失。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（三）不属于理赔范围的情形")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("用户因以下情形产生的经济损失或其他损失，不属于理赔范围，无权向本公司或保险公司申请索赔：")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("1.用户不具备本协议第三条第（一）款中列明的索赔前提条件；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("2.用户使用WiFi万能钥匙连接的热点是非共享热点；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("3.用户不能根据本保险计划规定提供证据及/或其他索赔材料的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("4.用户未依据本协议第三条第（五）款中的规定进行报案和/或进行证据保全的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("5.自使用WiFi万能钥匙遭受直接经济损失之日起15个自然日内，用户未依据本协议第三条第（五）款中的规定向保险公司提交索赔材料的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("6.用户使用WiFi万能钥匙连接网络的行为与用户遭受的财产损失不具有直接因果关系；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("7.钓鱼热点、钓鱼网站及网络木马病毒、恶意软件的相关欺诈和/或劫持行为与用户所遭受的财产损失不具有直接因果关系；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("8.虚假诈骗广告信息植入在某个特定热点中，用户连接该热点后，轻信了该虚假广告信息，从而遭受了财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("9.虚假诈骗广告信息或恶意软件下载链接是植入在普通网站中的，用户使用WiFi万能钥匙连接网络后，在正常浏览网页的过程中因上述虚假广告或恶意软件遭受了财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("10.在用户使用WiFi万能钥匙连接网络并上网的过程中，因用户故意或重大过失导致下列情形的财产损失：")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（1）用户主动向他人账号划转资金或主动为他人发送的代付链接付款的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（2）用户通过网上交易购买机票或火车票时，向不具有在线销售资质的且收款人账号非为公司账号的网站划转资金或付款；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（3）用户主动泄露网上银行账号、密码、支付短信的交易验证码或其他可能导致财产损失的信息，或主动允许他人远程协助的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（4）网上银行账号、密码已被他人知悉，或丢失了数字证书载体后，用户未立即变更账号、密码或通知银行冻结网上银行账户的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（5）其他因用户故意或重大过失导致的财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("11. 用户网购过程中，因商家违背诚信经营原则导致下列情形的财产损失：")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（1）与商家因交易纠纷造成的损失，包括但不限于电子商务商家账号被盗等引起的一切财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（2）由于商家不诚信问题造成的损失，包括但不限于商品或服务的描述与实际不符，商品或服务的质量、价格、售后服务等引发消费纠纷而引起的一切财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（3）虽经网页链接跳转，但用户系在正规网站进行正常交易行为时，由于商家违背诚信经营原则而遭受的财产损失。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("12.用户网购过程中，因其所购买标的物之特殊性导致的下列情形的财产损失：")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（1）用户在网络游戏私服中进行的交易或充值行为；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（2）以虚拟物品为交易对象的，包括但不限于虚拟财产（如虚拟游戏装备、虚拟货币、虚拟道具等）、游戏人物、游戏辅助物品的，或用户在网络游戏中直接交换物品的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（3）用户购买药品、保健品的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（4）涉及盗版及仿制品、走私、非法销售物品的交易；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（5）涉及网络赌博、博彩类交易（包括但不限于“赌球”、“21点”、“押大小”、“购买彩票”等）；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（6）其他涉嫌购买国家法律禁止销售或者交易的物品的任何交易。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("13.网站经营者或任何第三方已赔偿或补偿了用户经济损失，或用户经WiFi万能钥匙协助已挽回经济损失，或用户已通过WiFi万能钥匙的其他理赔/保障计划获得赔偿的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("14.财产损失超出本协议第三条第（四）款中索赔限额的部分；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("15.用户故意骗保，或在未发生理赔情形或未遭受任何财产损失的前提下谎称发生了理赔情形或伪造损失证据的，或用户因从事非法行为而遭受的任何损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("16.用户有损害本公司商誉、扰乱本公司正常经营秩序言行的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("17.针对同一索赔事件，保险公司向用户进行理赔后，用户又追加索赔申请的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("18.WiFi万能钥匙或保险公司工作人员依照本协议的约定联系用户时，自首次尝试联系用户起72小时内仍无法与用户取得联系的，或用户不履行本协议约定的配合义务的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("19.用户遭受的直接经济损失以外的一切间接损失、预期利益、精神损害或其他损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("20.其他根据WiFi万能钥匙用户安全保险计划不属于理赔范围的情形。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（四）索赔限额")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('table', {
    attrs: {
      "width": "100%",
      "border": "1",
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tr', [_c('td', [_vm._v("保险责任")]), _vm._v(" "), _c('td', [_vm._v("每一用户单日/单次索赔限额")]), _vm._v(" "), _c('td', [_vm._v("每一用户累计索赔限额")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("WiFi万能钥匙在提供服务的过程中造成了用户损失")]), _vm._v(" "), _c('td', [_vm._v("人民币贰万元整")]), _vm._v(" "), _c('td', [_vm._v("人民币壹拾万元整")])])])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("单次事故赔偿限额：人民币壹佰万元整")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("（单次事故：指因同一或基本相同的风险原因导致的一系列索赔事件（即群体性事件），视为一起事故，前述风险原因的认定以本公司技术部门的判定结果作为标准）")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（五）索赔流程")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.证据保全：用户在使用WiFi万能钥匙连接网络的过程中，发现账户资金遭受损失的，应立即采取相关证据保全措施，不应自行刷机、清理手机垃圾、删除WiFi万能钥匙客户端、历史短信或历史访问网址记录，或自行删除交易过程中与交易对方的聊天记录及所下载的软件，以免导致相关证据无法保全；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.报案：用户在使用WiFi万能钥匙连接网络的过程中，发现账户资金遭受损失的，应立即拨打保险公司电话进行报案，并应于10个自然日内前往具有管辖权的公安机关进行报案，并取得案件受理通知书等相关证明材料；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.准备索赔资料：用户应自账户资金遭受经济损失之日起15个自然日内根据WiFi万能钥匙客户端索赔界面的提示准备索赔资料，并听从工作人员的操作指导，积极配合工作人员的工作，并配合提供相关损失证明文件，以便有效追查被盗情况并保全证据；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.提交索赔资料：用户应根据保险公司工作人员的指示提交索赔资料，并确保其所提交的资料的真实性，否则，本公司及保险公司有权拒绝受理或赔付用户的索赔申请；用户知悉并了解，该等资料中的相关信息包括但不限于用户身份证号码、银行卡号、手机号码、详细住址等个人信息，用户在此同意并授权本公司及保险公司为实现本协议项下的索赔目的对用户的该等个人信息予以采集和使用；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("用户应通过线下快递方式递交如下索赔资料：")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('b', [_vm._v("身份证正反面彩色复印件（非中华人民共和国公民请提交有效护照彩色复印件）")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("向公安机关报案的相关证明（报案或立案证明）")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("非本人授权交易补偿申请表")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('b', [_vm._v("索赔人被盗账户信息截屏")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('b', [_vm._v("被盗账户对账单截屏（须标记盗刷交易明细信息：交易日期、交易商户、交易币种、交易金额、入账币种、入账金额）")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('b', [_vm._v("被盗账户挂失证明（信息截屏，包含挂失日期等）")])]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("索赔人出险期间手机设备在公安机关的备案数据")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("被盗账户近半年交易数据（如有）")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("涉及诉讼、仲裁的，递交相关司法文书、对方提交的证据副本等（如有）")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("其他本公司或保险公司认为对向用户提供理赔服务所必须的材料。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.理赔结果：保险公司根据用户提交的材料将认定最终理赔结果，如最终确认属于理赔责任范围内的情形，由保险公司向用户支付赔款，最终理赔额在人民币3000元（含3000元）以下的案件由保险公司在确认最终理赔结果后的5个工作日之内支付赔款；最终理赔额在人民币3000元以上的案件由保险公司在确认最终理赔结果后的10个工作日之内支付赔款。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("四、用户的权利与义务")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.用户使用WiFi万能钥匙过程中用户账户资金遭受直接经济损失的，用户有权向保险公司提起索赔申请，经本公司及保险公司认定情况属实并符合索赔条件及范围的，保险公司将依据理赔规则给予用户理赔。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.用户向保险公司提起索赔申请，应按照本公司用户安全理赔规则提交所有相关索赔材料。用户保证，其所提交的一切索赔材料、所作出的任何陈述或保证均真实准确且合法有效，并应独立承担因违反上述保证所引发的一切法律责任。用户未充分履行上述义务或违反上述保证的，本公司及保险公司有权不予理赔；保险公司已经向该用户支付理赔金的，有权向该用户追回，并要求用户赔偿本公司及保险公司因此遭受的一切损失。同时，本公司及保险公司将向有关机关报案，追究该用户骗保的刑事责任。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.用户应保证其连接网络及上网过程中的行为不触犯任何法律、行政法规、相关政策且不侵犯任何第三人的合法权益。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.用户应向保险公司提供真实有效的收款账户信息，因用户原因导致提供的收款信息错误而无法收到理赔额的情况，本公司及保险公司不承担任何责任。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.用户向保险公司或本公司发起索赔申请，即表明用户已同意严格遵守本公司发布的针对WiFi万能钥匙安全保险计划的所有规则，并同意以最新的规则作为认定最终理赔结果的依据。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("6.用户承诺：未经本公司书面许可，不得将最终理赔结果向任何第三方披露。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("五、本公司的权利与义务")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.用户知悉并完全同意本公司有权随时修改、更新、暂停或永久终止保险计划，无需因此对用户承担法律责任。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.本公司有权依据理赔规则对用户向保险公司的索赔申请进行审核以确定是否向其提供理赔服务，本公司有完全的权利同意或拒绝用户的申请。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.本公司对本协议项下的理赔义务承担有限责任，在任何情形下，用户同意保险公司向其支付的理赔金的最高上限依照本协议第（四）条之规定执行。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.如WiFi万能钥匙及保险公司在审查用户所提交的索赔申请时发现重大刑事案件线索的，本公司及保险公司有权在通知用户后以用户索赔资料为基础向警方提供案件侦查线索或向相关司法机关检举。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.用户因使用WiFi万能钥匙所遭受的经济损失，通过第三方获得赔付或司法程序或其他合法程序得以追缴或退赔的，若保险公司已根据本保险计划向用户进行赔付的，则有权在其对用户的赔付范围内要求用户进行返还。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("6.本公司承诺：未经用户允许，除为实现本协议项下的理赔目的及法律法规隐私保护政策另有规定的情形外，不对外披露或向第三方提供用户的任何信息。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("六、其他")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_c('b', [_vm._v("1.本公司郑重提醒用户注意本协议中免除或限制责任的条款，请用户仔细阅读，自主考虑风险。未成年人应在法定监护人的陪同下阅读本协议。")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.本协议所定的任何条款的部分或全部无效者，不影响其它条款的效力。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("3."), _c('b', [_vm._v("本协议的解释、效力及纠纷的解决，适用于中华人民共和国法律。若用户和本公司之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，用户在此完全同意双方将纠纷或争议提交本公司所在地人民法院通过诉讼方式解决。")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.本WiFi万能钥匙用户安全保险计划自2019年3月4日起生效施行。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.若您对本协议及本保险计划有任何意见，欢迎垂询本公司客服中心400-035-8000。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("南京尚网网络科技有限公司")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2019年10月17日")])])])
}]}

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "margin": "0 auto",
      "width": "0px",
      "height": "0px",
      "overflow": "hidden"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(176),
      "width": "700"
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "pc_device",
    attrs: {
      "id": "activity-detail"
    }
  }, [_c('div', {
    staticClass: "page-bizinfo"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h1', {
    attrs: {
      "id": "activity-name"
    }
  }, [_vm._v("如何查看MAC地址")])])]), _vm._v(" "), _c('div', {
    staticClass: "page-content",
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_c('p', [_c('span', {
    staticStyle: {
      "color": "rgb(255, 0, 0)"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("MAC地址一般有2个地方可以找到：")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "rgb(255, 0, 0)"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "color": "rgb(255, 0, 0)",
      "font-size": "16px"
    }
  }, [_vm._v("a、路由器背面的铭牌上，会明确标注“MAC”，如下图：")])])])]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": __webpack_require__(677)
    }
  }), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "rgb(255, 0, 0)"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("b、路由器的控制界面，如下图：")])])])]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": __webpack_require__(678)
    }
  })])])])])])
}]}

/***/ }),
/* 815 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail clearfix",
    staticStyle: {
      "padding-bottom": "24px"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.obj), function(item, index) {
    return (_vm.type == 1) ? _c('div', [_c('div', {
      staticClass: "qa-item"
    }, [_c('p', [_vm._v(_vm._s(item.question))]), _vm._v(" "), _c('div', {
      staticClass: "icon",
      class: {
        icon2: item.isopened
      },
      on: {
        "click": function($event) {
          return _vm.toggle(index)
        }
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.isopened),
        expression: "item.isopened"
      }],
      staticClass: "qa-content"
    }, [_vm._v("\n            " + _vm._s(item.anwser) + "\n        ")]), _vm._v(" "), (index != 4 && !item.isopened) ? _c('div', {
      staticClass: "qa-line"
    }) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.obj2), function(item, index) {
    return (_vm.type == 2) ? _c('div', [_c('div', {
      staticClass: "qa-item"
    }, [_c('p', [_vm._v(_vm._s(item.question))]), _vm._v(" "), _c('div', {
      staticClass: "icon",
      class: {
        icon2: item.isopened
      },
      on: {
        "click": function($event) {
          return _vm.toggle(index)
        }
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.isopened),
        expression: "item.isopened"
      }],
      staticClass: "qa-content"
    }, [_vm._v("\n            " + _vm._s(item.anwser) + "\n        ")]), _vm._v(" "), (index != 2 && !item.isopened) ? _c('div', {
      staticClass: "qa-line"
    }) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.obj3), function(item, index) {
    return (_vm.type == 3) ? _c('div', [_c('div', {
      staticClass: "qa-item"
    }, [_c('p', [_vm._v(_vm._s(item.question))]), _vm._v(" "), _c('div', {
      staticClass: "icon",
      class: {
        icon2: item.isopened
      },
      on: {
        "click": function($event) {
          return _vm.toggle(index)
        }
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.isopened),
        expression: "item.isopened"
      }],
      staticClass: "qa-content"
    }, [_vm._v("\n            " + _vm._s(item.anwser) + "\n        ")]), _vm._v(" "), (index != 1 && !item.isopened) ? _c('div', {
      staticClass: "qa-line"
    }) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (_vm.type == 4) ? _vm._l((_vm.obj4), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "qa-item"
    }, [_c('p', [_vm._v(_vm._s(item.question))]), _vm._v(" "), _c('div', {
      staticClass: "icon",
      class: {
        icon2: item.isopened
      },
      on: {
        "click": function($event) {
          return _vm.toggle(index)
        }
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.isopened),
        expression: "item.isopened"
      }],
      staticClass: "qa-content"
    }, [_c('span', [_vm._v(_vm._s(item.anwser))]), _c('span', {
      staticStyle: {
        "color": "#0285f0"
      },
      on: {
        "click": function($event) {
          return _vm.handle(item)
        }
      }
    }, [_vm._v(_vm._s(item.event))])]), _vm._v(" "), (index != 1 && !item.isopened) ? _c('div', {
      staticClass: "qa-line"
    }) : _vm._e()])
  }) : _vm._e(), _vm._v(" "), (_vm.type == 5) ? _vm._l((_vm.obj5), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "qa-item"
    }, [_c('p', [_vm._v(_vm._s(item.question))]), _vm._v(" "), _c('div', {
      staticClass: "icon",
      class: {
        icon2: item.isopened
      },
      on: {
        "click": function($event) {
          return _vm.toggle(index)
        }
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.isopened),
        expression: "item.isopened"
      }],
      staticClass: "qa-content"
    }, [_vm._v("\n            " + _vm._s(item.anwser) + "\n        ")]), _vm._v(" "), (index != 1 && !item.isopened) ? _c('div', {
      staticClass: "qa-line"
    }) : _vm._e()])
  }) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "protect"
  }, [_c('p', [_vm._v("常见问题")]), _vm._v(" "), _c('div', {
    staticClass: "line left"
  }), _vm._v(" "), _c('div', {
    staticClass: "line right"
  })])
}]}

/***/ }),
/* 816 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading",
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "main",
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "id": "voucherPage"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('p', {
    staticClass: "zhongan"
  }, [_vm._v("WiFi安全险")]), _vm._v(" "), (_vm.obj.status == 1) ? _c('div', {
    staticClass: "already"
  }, [_vm._v("已参保")]) : _vm._e(), _vm._v(" "), (_vm.obj.status == 2) ? _c('div', {
    staticClass: "already",
    staticStyle: {
      "color": "#0285F0"
    }
  }, [_vm._v("处理中")]) : _vm._e(), _vm._v(" "), (_vm.obj.status == 1) ? _c('p', {
    staticClass: "status"
  }) : _vm._e(), _vm._v(" "), (_vm.obj.status == 2) ? _c('p', {
    staticClass: "status"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "al-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("保障期限")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.obj.start_time) + "至2023年9月15日")])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "al-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("保险详细")]), _vm._v(" "), _c('a', {
    staticClass: "right a",
    attrs: {
      "href": "#/range"
    },
    on: {
      "click": _vm.clickRange
    }
  }, [_vm._v("保障范围")])]), _vm._v(" "), _c('div', {
    staticClass: "al-item",
    staticStyle: {
      "padding-bottom": "24px"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("服务热线")]), _vm._v(" "), _c('a', {
    staticClass: "right a",
    attrs: {
      "href": "tel:4009999595"
    },
    on: {
      "click": _vm.range
    }
  }, [_vm._v("400-999-9595")])])]), _vm._v(" "), _c('qa', {
    attrs: {
      "type": 2
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-image"
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("南京尚网网络科技有限公司对以上信息保留最终解释权")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "bottom": "0",
      "width": "100%",
      "margin-top": "15px",
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "bottom_btn",
    class: {
      halfwidth: _vm.claimList
    },
    attrs: {
      "id": "btn_claim"
    },
    on: {
      "click": _vm.goClaim
    }
  }, [_vm._v("我要索赔")]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.claimList),
      expression: "claimList"
    }],
    staticClass: "bottom_btn claimList",
    class: {
      halfwidth: _vm.claimList
    },
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "to": "/claimList"
    }
  }, [_c('div', {
    on: {
      "click": _vm.clickClaimList
    }
  }, [_vm._v("索赔记录")])])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "model"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "title"
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }), _vm._v(" "), _c('p', {
    staticClass: "btns",
    staticStyle: {
      "display": "none"
    }
  }, [_c('span', {
    staticClass: "cancel"
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "confirm"
  }, [_vm._v("确定")])]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "al-item",
    staticStyle: {
      "margin-top": "16px"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("累计最高赔付人民币")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("￥100000元")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "al-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("单日/单次最高赔付人民币")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("￥20000元")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "al-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("支付金额")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("￥0.00元")])])
}]}

/***/ }),
/* 817 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "createSuccess"
  }, [_c('div', {
    staticClass: "main"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.toindex()
      }
    }
  }, [_vm._v("\n          查看我的保单\n      ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "success"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('p', {
    staticClass: "msg"
  }, [_vm._v("参保成功")]), _vm._v(" "), _c('p', {
    staticClass: "msg2"
  }, [_vm._v("WiFi安全险保障中")])])
}]}

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading",
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), (_vm.pageStatus == 1) ? _c('div', {
    staticClass: "main",
    attrs: {
      "id": "indexPage"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(250),
      "alt": "",
      "width": "100%"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "detail clearfix"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.toRange()
      }
    }
  }, [_vm._v("查看保险详情")])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('qa', {
    attrs: {
      "type": 1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-image"
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("南京尚网网络科技有限公司对以上信息保留最终解释权")]), _vm._v(" "), (_vm.createBtn == 1) ? _c('p', {
    staticClass: "button",
    staticStyle: {
      "position": "fixed",
      "bottom": "0"
    },
    attrs: {
      "id": "createBtn"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("免费参保")]) : _vm._e(), _vm._v(" "), (_vm.createBtn == 2) ? _c('p', {
    staticClass: "button",
    staticStyle: {
      "position": "fixed",
      "bottom": "0"
    },
    attrs: {
      "id": "createBtn"
    },
    on: {
      "click": _vm.goCreate
    }
  }, [_vm._v("免费参保")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.pageStatus == 2) ? _c('div', {
    staticClass: "main",
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "id": "voucherPage"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('p', {
    staticClass: "zhongan"
  }, [_vm._v("WiFi安全险")]), _vm._v(" "), (_vm.obj.status == 1) ? _c('div', {
    staticClass: "already"
  }, [_vm._v("已参保")]) : _vm._e(), _vm._v(" "), (_vm.obj.status == 2) ? _c('div', {
    staticClass: "already",
    staticStyle: {
      "color": "#0285F0"
    }
  }, [_vm._v("处理中")]) : _vm._e(), _vm._v(" "), (_vm.obj.status == 1) ? _c('p', {
    staticClass: "status"
  }) : _vm._e(), _vm._v(" "), (_vm.obj.status == 2) ? _c('p', {
    staticClass: "status"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "al-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("保障期限")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.obj.start_time) + "至2023年9月15日")])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "al-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("保险详细")]), _vm._v(" "), _c('a', {
    staticClass: "right a",
    attrs: {
      "href": "#/range"
    },
    on: {
      "click": _vm.clickRange
    }
  }, [_vm._v("保障范围")])]), _vm._v(" "), _c('div', {
    staticClass: "al-item",
    staticStyle: {
      "padding-bottom": "24px"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("服务热线")]), _vm._v(" "), _c('a', {
    staticClass: "right a",
    attrs: {
      "href": "tel:4009999595"
    },
    on: {
      "click": _vm.range
    }
  }, [_vm._v("400-999-9595")])])]), _vm._v(" "), _c('qa', {
    attrs: {
      "type": 2
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-image"
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("南京尚网网络科技有限公司对以上信息保留最终解释权")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "bottom": "0",
      "width": "100%",
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "bottom_btn",
    class: {
      halfwidth: _vm.claimList
    },
    attrs: {
      "id": "btn_claim"
    },
    on: {
      "click": _vm.goClaim
    }
  }, [_vm._v("我要索赔")]), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.claimList),
      expression: "claimList"
    }],
    staticClass: "bottom_btn claimList",
    class: {
      halfwidth: _vm.claimList
    },
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "to": "/claimList"
    }
  }, [_c('div', {
    on: {
      "click": _vm.clickClaimList
    }
  }, [_vm._v("索赔记录")])])], 1)], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "model"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "title"
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }), _vm._v(" "), _c('p', {
    staticClass: "btns",
    staticStyle: {
      "display": "none"
    }
  }, [_c('span', {
    staticClass: "cancel"
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "confirm"
  }, [_vm._v("确定")])]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(251),
      "width": "31.733%"
    }
  }), _vm._v(" "), _c('p', [_vm._v("一键连WiFi，一直有保障")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "protect"
  }, [_c('p', [_vm._v("保障清单")]), _vm._v(" "), _c('div', {
    staticClass: "line left"
  }), _vm._v(" "), _c('div', {
    staticClass: "line right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("连WiFi意外损失累计最高赔付")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("￥"), _c('span', {
    staticClass: "big"
  }, [_vm._v("100,000")]), _vm._v("元")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("连WiFi意外损失单次最高赔付")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("￥"), _c('span', {
    staticClass: "big"
  }, [_vm._v("20,000")]), _vm._v("元")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("保障期限")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("一年")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("参保费用")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("￥"), _c('span', {
    staticClass: "big"
  }, [_vm._v("0.00")]), _vm._v("元")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail clearfix"
  }, [_c('div', {
    staticClass: "protect"
  }, [_c('p', [_vm._v("专属特色")]), _vm._v(" "), _c('div', {
    staticClass: "line left"
  }), _vm._v(" "), _c('div', {
    staticClass: "line right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "left-panel"
  }, [_c('div', {
    staticClass: "icon icon1"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#333333"
    }
  }, [_vm._v("全方位保障")]), _vm._v(" "), _c('p', [_vm._v("所有通过WiFi万能钥匙")]), _vm._v(" "), _c('p', [_vm._v("连WiFi的上网行为")])]), _vm._v(" "), _c('div', {
    staticClass: "right-panel"
  }, [_c('div', {
    staticClass: "icon icon2"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#333333"
    }
  }, [_vm._v("官方VIP通道")]), _vm._v(" "), _c('p', [_vm._v("极速处理您的WiFi安全")]), _vm._v(" "), _c('p', [_vm._v("险理赔需求")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "al-item",
    staticStyle: {
      "margin-top": "16px"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("累计最高赔付人民币")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("￥100000元")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "al-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("单日/单次最高赔付人民币")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("￥20000元")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "al-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("支付金额")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("￥0.00元")])])
}]}

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "create"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading",
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(675),
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "info"
  }, [_vm._v("填写参保人信息")]), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('p', {
    staticClass: "label bb clearfix"
  }, [_c('label', {
    attrs: {
      "for": "user_name"
    }
  }, [_vm._v("姓名：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.name),
      expression: "formData.name"
    }],
    attrs: {
      "type": "text",
      "id": "user_name",
      "maxlength": "15",
      "placeholder": "请输入真实姓名",
      "value": ""
    },
    domProps: {
      "value": (_vm.formData.name)
    },
    on: {
      "focus": _vm.eidtName,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "label bb clearfix"
  }, [_c('label', {
    attrs: {
      "for": "user_card"
    }
  }, [_vm._v("身份证号：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.card),
      expression: "formData.card"
    }],
    attrs: {
      "type": "text",
      "id": "user_card",
      "placeholder": "请输入身份证号",
      "maxlength": "18"
    },
    domProps: {
      "value": (_vm.formData.card)
    },
    on: {
      "focus": _vm.eidtCard,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "card", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "notice"
  }, [_vm._v("信息保护声明")]), _vm._v(" "), _c('div', {
    staticClass: "noticeInfo"
  }, [_vm._v("以上信息只供WiFi安全险登记及理赔用途，并不会用于其他商业用途。")])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('p', {
    staticClass: "protocol"
  }, [_c('span', {
    staticClass: "checkbox checked"
  }), _vm._v("本人同意并接受\n            "), (_vm.protocol == 'protocol') ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.clickProtocol(_vm.protocol)
      }
    }
  }, [_vm._v("《WiFi万能钥匙理赔服务协议》")]) : _vm._e(), _vm._v(" "), (_vm.protocol == 'protocolIos') ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.clickProtocol(_vm.protocol)
      }
    }
  }, [_vm._v("《WiFi万能钥匙理赔服务协议》")]) : _vm._e(), _vm._v(" "), (_vm.protocol == 'protocolIvvi') ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.clickProtocol(_vm.protocol)
      }
    }
  }, [_vm._v("《免费WiFi理赔服务协议》")]) : _vm._e(), _vm._v(" "), (_vm.protocol == 'protocolA0009') ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.clickProtocol(_vm.protocol)
      }
    }
  }, [_vm._v("《免费WiFi理赔服务协议》")]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "errorMsg"
  }), _vm._v(" "), _c('p', {
    staticClass: "buttons"
  }, [_c('a', {
    staticClass: "button btn",
    on: {
      "click": _vm.create
    }
  }, [_vm._v("参保安心上网")])])]), _vm._v(" "), _c('qa', {
    attrs: {
      "type": 3
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-image"
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright",
    staticStyle: {
      "padding-bottom": "12px"
    }
  }, [_vm._v("南京尚网网络科技有限公司对以上信息保留最终解释权")]), _vm._v(" "), (_vm.showAlertModel) ? _c('div', {
    staticClass: "alert-model"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("温馨提示")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.modelContent))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "description",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("客服电话："), _c('a', {
    attrs: {
      "href": "tel:4000358000"
    }
  }, [_vm._v("4000358000")]), _c('span', {
    staticClass: "copy-qq",
    on: {
      "click": function($event) {
        return _vm.copyQq(4000358000)
      }
    }
  }, [_vm._v("复制")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "foot",
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("我知道了")])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "model"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "title"
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }), _vm._v(" "), _c('p', {
    staticClass: "btns",
    staticStyle: {
      "display": "none"
    }
  }, [_c('span', {
    staticClass: "cancel"
  }, [_vm._v("取消")]), _c('span', {
    staticClass: "confirm"
  }, [_vm._v("确定")])]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    staticStyle: {
      "display": "block"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "description"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(249)
    }
  }), _vm._v("如手机号码有更换，请联系官方客服")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "btns",
    staticStyle: {
      "display": "none"
    }
  }, [_c('span', {
    staticClass: "cancel"
  }, [_vm._v("取消")]), _c('span', {
    staticClass: "confirm"
  }, [_vm._v("确定")])])
}]}

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "claimDetail"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading",
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "main claim"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._m(0), _vm._v(" "), (_vm.obj.claimState == 0) ? _c('div', {
    staticClass: "logo"
  }) : _vm._e(), _vm._v(" "), (_vm.obj.claimState == 2) ? _c('div', {
    staticClass: "logo_success"
  }) : _vm._e(), _vm._v(" "), (_vm.obj.claimState == 1) ? _c('div', {
    staticClass: "logo_failed"
  }) : _vm._e()])]), _vm._v(" "), (_vm.obj.claimState == 0) ? _c('div', {
    attrs: {
      "id": "claimPage"
    }
  }, [_c('p', {
    staticClass: "limit"
  }, [_vm._v("参保用户赔偿额度")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    staticClass: "bb"
  }, [_vm._v("\n        索赔流程:\n        "), _c('router-link', {
    attrs: {
      "to": "/new/claimFlow"
    }
  }, [_vm._v("查看详情")])], 1), _vm._v(" "), _c('p', {
    staticClass: "bb"
  }, [_vm._v("\n        索赔资料:\n        "), _c('router-link', {
    attrs: {
      "to": "/new/docs"
    }
  }, [_vm._v("查看详情")])], 1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.obj.claimState == 2) ? _c('div', {
    attrs: {
      "id": "claimSuccessPage"
    }
  }, [_c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    staticClass: "bb"
  }, [_vm._v("\n        索赔人:\n        "), _c('span', {
    attrs: {
      "id": "username"
    }
  }, [_vm._v(_vm._s(_vm.obj.userName))])]), _vm._v(" "), _c('p', {
    staticClass: "bb"
  }, [_vm._v("\n        索赔金额:\n        "), _c('span', {
    attrs: {
      "id": "price"
    }
  }, [_vm._v("￥" + _vm._s(_vm.obj.claimMoney))])]), _vm._v(" "), _c('p', [_vm._v("\n        银行卡号:\n        "), _c('span', {
    attrs: {
      "id": "bankCard"
    }
  }, [_vm._v(_vm._s(_vm.obj.blankCard))])])]), _vm._v(" "), _c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    staticClass: "bb"
  }, [_vm._v("\n        索赔开始时间:\n        "), _c('span', {
    attrs: {
      "id": "startDate"
    }
  }, [_vm._v(_vm._s(_vm.obj.startDate))])]), _vm._v(" "), _c('p', [_vm._v("\n        索赔结束时间:\n        "), _c('span', {
    attrs: {
      "id": "endDate"
    }
  }, [_vm._v(_vm._s(_vm.obj.endDate))])])]), _vm._v(" "), _c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    attrs: {
      "id": "reason"
    }
  }, [_c('span', {
    staticStyle: {
      "position": "static"
    }
  }, [_vm._v("备注:" + _vm._s(_vm.obj.dec))])])])]) : _vm._e(), _vm._v(" "), (_vm.obj.claimState == 1) ? _c('div', {
    attrs: {
      "id": "claimFailedPage"
    }
  }, [_c('div', {
    staticClass: "block clearfix"
  }, [_c('p', [_vm._v("\n        索赔人:\n        "), _c('span', {
    attrs: {
      "id": "username"
    }
  }, [_vm._v(_vm._s(_vm.obj.userName))])])]), _vm._v(" "), _c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    staticClass: "bb"
  }, [_vm._v("\n        索赔开始时间:\n        "), _c('span', {
    attrs: {
      "id": "startDate"
    }
  }, [_vm._v(_vm._s(_vm.obj.startDate))])]), _vm._v(" "), _c('p', [_vm._v("\n        索赔结束时间:\n        "), _c('span', {
    attrs: {
      "id": "endDate"
    }
  }, [_vm._v(_vm._s(_vm.obj.endDate))])])]), _vm._v(" "), _c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    attrs: {
      "id": "reason"
    }
  }, [_c('span', {
    staticStyle: {
      "position": "static"
    }
  }, [_vm._v("备注:" + _vm._s(_vm.obj.dec))])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "zhongan"
  }, [_vm._v("\n        WiFi安全险\n        "), _c('img', {
    attrs: {
      "src": __webpack_require__(254),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    staticClass: "bb"
  }, [_vm._v("\n        每一用户单日/单次索赔限额：\n        "), _c('span', [_vm._v("￥20,000元")])]), _vm._v(" "), _c('p', [_vm._v("\n        每一用户累计最高可赔：\n        "), _c('span', [_vm._v("￥100,000元")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        服务热线:\n        "), _c('a', {
    attrs: {
      "href": "tel:4009999595"
    }
  }, [_vm._v("400-999-9595")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    staticClass: "bb"
  }, [_vm._v("\n        索赔资料收件人:\n        "), _c('span', {
    staticClass: "small_font"
  }, [_vm._v("WiFi万能钥匙商户安全理赔项目组")])]), _vm._v(" "), _c('p', {
    staticClass: "bb"
  }, [_vm._v("\n        寄送地址:\n        "), _c('span', {
    staticClass: "small_font"
  }, [_vm._v("上海市浦东新区张衡路666弄1号楼7楼")])]), _vm._v(" "), _c('p', [_vm._v("\n        快递联系电话:\n        "), _c('span', [_vm._v("400-035-8000")])])])
}]}

/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "docs"
  }, [_c('p', {
    staticClass: "doc_text",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_vm._v("1.理赔申请表，包括事件发生的经过的描述等")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("2.用户有效身份证正反面彩色复印件")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("3.用户向公关机关报案的相关证明（报案或立案证明）")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("4.非本人授权交易补偿申请表")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("5.用户被盗账户的信息截屏")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("6.被盗账户对账单截屏（已标记盗刷交易明细信息：交易日期，交易商户，交易币种，交易金额，入帐币种，入账金额）")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("7.被盗账户挂失证明（信息截屏，包含挂失日期）")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("8.出险期间用户手机或其他终端设备在公关机关的备案数据")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("9.其他本公司或保险公司认为对向用户提供理赔服务所必须的材料")])])
}]}

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rangeA0009"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "src": __webpack_require__(91),
      "alt": "",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "doc_title"
  }, [_vm._v("WiFi万能钥匙用户安全理赔计划")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("WiFi万能钥匙用户安全理赔计划是指WiFi万能钥匙用户在使用WiFi网络时，网上银行或第三方支付工具的账户发生财产非正常损失，若因WiFi万能钥匙导致，用户可以依据本保险计划的有关规则申请理赔。")]), _vm._v(" "), _c('p', {
    staticClass: "doc_title"
  }, [_vm._v("提供保障")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("每人单日/单次最高赔付20000元"), _c('br'), _vm._v("每人累计最高赔付100000元")]), _vm._v(" "), _c('p', {
    staticClass: "doc_title"
  }, [_vm._v("重要提示")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("1.用户必须是WiFi万能钥匙的手机注册用户，且其安装并使用的WiFi万能钥匙手机客户端中必须已发布施行了本保险计划（即用户必须安装WiFi万能钥匙女生版安卓版1.0.0以上版本及此后发布的更新版本）。")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("2.向WiFi万能钥匙提供真实有效的信息，且该信息与受保障的实名账户持有人信息一致。")])])
}]}

/***/ }),
/* 823 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "claimList"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading",
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [(_vm.list.length > 0) ? _vm._l((_vm.list), function(item) {
    return _c('div', {
      key: item.order_id,
      staticClass: "claim-item",
      on: {
        "click": function($event) {
          return _vm.goDetail(item)
        }
      }
    }, [_c('p', {
      staticClass: "claim-no"
    }, [_vm._v("索赔登记号：" + _vm._s(item.claimNumber))]), _vm._v(" "), (item.claimState == 0) ? _c('p', {
      staticClass: "claim-status"
    }, [_vm._v("索赔受理中")]) : _vm._e(), _vm._v(" "), (item.claimState == 1) ? _c('p', {
      staticClass: "claim-status"
    }, [_vm._v("索赔失败")]) : _vm._e(), _vm._v(" "), (item.claimState == 2) ? _c('p', {
      staticClass: "claim-status"
    }, [_vm._v("索赔成功")]) : _vm._e(), _vm._v(" "), (item.claimState == 0) ? _c('div', {
      staticClass: "claim-icon"
    }) : _vm._e(), _vm._v(" "), (item.claimState == 1) ? _c('div', {
      staticClass: "claim-icon-failed"
    }) : _vm._e(), _vm._v(" "), (item.claimState == 2) ? _c('div', {
      staticClass: "claim-icon-success"
    }) : _vm._e()])
  }) : _vm._e(), _vm._v(" "), (_vm.list.length == 0) ? _c('div', {
    staticClass: "empty"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('p', {
    staticClass: "empty-text"
  }, [_vm._v("您还没有进行任何索赔")])]) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 824 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "protocol"
  }, [_c('div', {
    staticClass: "main",
    staticStyle: {
      "padding": "0 6% 15px 6%"
    }
  }, [_c('p', {
    staticClass: "title",
    staticStyle: {
      "text-align": "center",
      "margin-top": "10px",
      "margin-bottom": "3px",
      "background": "rgba(255,255,255,0)"
    }
  }, [_vm._v("WiFi万能钥匙用户安全保险协议")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("本协议为WiFi万能钥匙用户（即同意并接受了《WiFi万能钥匙服务协议》及《WiFi万能钥匙隐私权政策》的用户，以下简称“用户”）与南京尚网网络科技有限公司（以下简称“WiFi万能钥匙”或“本公司”）关于WiFi万能钥匙安全保险事宜所订立的协议。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("——本公司在此依法做出特别提示如下：")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1、"), _c('b', [_vm._v("【审慎阅读】请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。")]), _vm._v(" 针对前述条款，本协议已以明确的足以引起您注意的包括但不限于加重字体、斜体、下划线、颜色标记等合理方式提醒您注意相关条款（需要强调的是，还包括您应特别注意任何未明确标记的含有“不承担”、“免责”、“不得”以及“无关”等形式用语的条款），该等条款的确认将导致您在特定情况下的被动、不便和/或造成损失，请您在确认同意本协议之前再次阅读上述条款。 除非您已审慎阅读、充分理解并同意本协议所有条款，您将放弃参加本保险计划。 ")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2、"), _c('b', [_vm._v("本协议签署后，您如有任何需要本公司说明条款的要求，请立即停止参加本保险计划，同时立即致电或发送邮件至本公司客服，若您未致电或未发送有说明条款要求的邮件至本公司，即表示您选择同意该协议的所有条款。")]), _vm._v(" 双方在此确认本公司已依法履行了根据您要求对相关条款进行说明的法定义务，本公司已给予您充足的时间与充分的选择权来决定是否缔结本协议。 ")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3、"), _c('b', [_vm._v("【协议的确认和接受】鉴于本公司已依法明确了上述条款，您点击“同意”或“下一步”，将被视为且应当被视为您已经完全注意并“同意”了本协议所有条款尤其是提醒您注意的条款的合法性及有效性，您不应当以本公司未对相关条款以合理方式提醒您注意，或未根据您要求尽到说明义务为理由而声称或要求法院或其它任何第三方确认相关条款非法或无效。 如果您不同意本协议的任何内容，点击“不同意”，视为您选择放弃参加本保险计划。")])]), _vm._v(" "), _c('p', [_vm._v("4、"), _c('b', [_vm._v("如果您未满18周岁，请在法定监护人的陪同下阅读本协议条款。")])]), _vm._v(" "), _c('p', [_vm._v("5、【协议的修改】 本协议可由本公司适时更新，更新后的协议条款一经公布即替代原协议条款，您可在软件客户端查阅最新版协议。 "), _c('b', [_vm._v("在本公司修改协议并公布后，如果您不接受修改后的协议，请立即停止参加本保险计划，您一旦发起索赔申请将被视为已接受修改后的协议。")])]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("一、协议总则")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("WiFi万能钥匙用户安全保险计划：是指本公司用户在使用WiFi万能钥匙连接网络的过程中，因在通过WiFi万能钥匙连接的热点网络环境下发生了本协议中列明的WiFi热点恶意行为，导致用户本人在银行账户内的资产，及用户在合法运营的第三方支付机构所设本人实名账户中的资产遭受直接损失，用户可按照本保险计划的有关规则申请索赔。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("本公司已通过众安在线财产保险股份有限公司（以下简称“保险公司”）为WiFi万能钥匙的安全性进行投保。WiFi万能钥匙用户安全保险计划（以下简称“保险计划”） 旨在为用户营造一个安全、可信的网络环境，让用户更放心地使用本公司提供的服务。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("二、定义")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("在本协议中，除非另有明确约定，提及的词语应具有如下含义：")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("WiFi热点：本协议中所述WiFi热点特指通过WLAN无线协议将网络连接进行延伸的无线接入点,为方便用户理解和辨识，本协议中将WiFi热点特分为有钥匙热点和无钥匙热点；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("有钥匙热点：用户通过点击WiFi万能钥匙客户端中的“一键查询”功能或下拉连接页面发起“一键查询”功能，成功查询附近热点后，在热点上标识有蓝色钥匙的热点；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("无钥匙热点：用户通过点击WiFi万能钥匙客户端中的“一键查询”功能或下拉连接页面发起“一键查询”功能，成功查询附近热点后，在热点上未标识蓝色钥匙的热点；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("钓鱼热点：本协议中所述钓鱼热点特指利用WiFi热点开放的特性，模拟正规合法的WiFi热点，以窃取用户私有信息、盗取用户财产等为目的而私自架设的热点。其形式上和正规合法的WiFi热点没有区别，一般公众很难区分；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("钓鱼网站：指不法分子在互联网上建立的通过模仿合法、正规购物平台的网址或页面内容，利用发布虚假消息，搜集客户资料，骗取客户账户（登录ID）、密码、口令等信息进而达到非法窃取客户财物的目的非法网站；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("木马病毒：指不法分子通过各种网络技术手段来篡改用户交易信息或者劫持用户交易过程等方式来达到盗取用户资金目的的恶意程序；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("恶意软件：\"恶意软件\"用作一个集合名词，来指代故意在计算机系统恶意软件上执行恶意任务的蠕虫、木马病毒或其他病毒；在恶意软件未被发现的这段时间，用户上网过程中的所有个人资料都有可能被盗走，比如银行账户信息，信用卡密码等；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("DNS /DNS劫持：本协议中所述DNS是指网络定义的一种协议,为域名和IP地址相互映射，能够使用户更方便地访问互联网,DNS劫持是指恶意攻击者通过中间人攻击篡改域名和IP的对应关系,从而导致用户访问一些虚假的网站；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("热点劫持：本协议中所述热点劫持是指恶意攻击者通过恶意攻击劫持原有WiFi热点，从而捕捉通过热点中的所有用户个人信息及其他信息；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("账户资金：用户本人在银行账户内的资产，及用户在合法运营的第三方支付机构所设本人实名账户中的资产；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("直接损失：因符合理赔范围的情形而被盗取的账户资金。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("三、索赔条件及理赔范围")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("用户应同时具备以下（一）至（五）款列明的各项条件，方可根据本公司用户安全理赔规则申请索赔:")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（一）索赔的前提条件")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.用户必须是WiFi万能钥匙的手机注册用户，且其安装并使用的WiFi万能钥匙手机客户端中必须已发布施行了本保险计划（即用户必须安装WiFi万能钥匙安卓版4.0或iOS版3.3.5以上版本及此后发布的更新版本）。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.用户在使用WiFi万能钥匙连接网络的过程中，因在通过WiFi万能钥匙连接的热点网络环境下发生了本协议中列明的WiFi热点恶意行为，导致用户账户资金被恶意第三方盗取。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.因用户使用WiFi万能钥匙导致账户资金被盗，应首次发生于本用户安全保险计划生效日之后。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.用户同意，在使用WiFi万能钥匙时向本公司提供其真实有效信息，且上述信息应与用户提交的索赔申请材料中的信息一致，即与本公司订立本协议的用户与实际使用WiFi万能钥匙遭受损失并前来申请索赔的用户必须为同一自然人用户。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.用户使用WiFi万能钥匙连接的热点是有钥匙热点。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("6.用户自使用WiFi万能钥匙连接特定无线网络开始至断开该无线网络的过程中，发生本协议第三条第（二）款中的情形而遭受了直接损失。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("7.用户按照本条第（五）款索赔流程的规定向公安机关报案并向保险公司提交了符合索赔要求的材料。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("8.用户因使用WiFi万能钥匙导致用户银行账户资金和有资质的第三方支付软件中的资金遭受损失的事件必须发生在中华人民共和国大陆地区（不包括香港、澳门和台湾地区）。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（二）属于理赔范围的情形")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.用户欲前往特定合法网络购物网站、网络银行网站或第三方支付网站（以上简称“合法网站”）进行购物、转账等操作时，用户在支付交易过程中DNS被钓鱼热点进行了信息篡改，从而导致用户账户资金被盗的；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.用户欲前往合法网站进行购物、转账等操作时，钓鱼热点已对该网站进行了DNS劫持，从而使用户连接上了一个钓鱼网站，导致了用户账户资金被盗的；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.用户在合法网站正常操作购物、转账等操作的过程中，钓鱼热点非法获取了用户录入及传递的个人信息，导致用户信息泄露继而造成账户资金被盗；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.用户欲下载特定应用软件，用户连接的热点被劫持后，用户实际下载了仿冒恶意软件，且一般用户无法判断该软件的真伪。用户在仿冒恶意软件中录入个人信息，或仿冒软件将劫持的用户短信等个人信息发送至恶意第三方，从而导致用户账户资金遭受损失。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（三）不属于理赔范围的情形")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("用户因以下情形产生的经济损失或其他损失，不属于理赔范围，无权向本公司或保险公司申请索赔：")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("1.用户不具备本协议第三条第（一）款中列明的索赔前提条件；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("2.用户使用WiFi万能钥匙连接的热点是无钥匙热点；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("3.用户不能根据本保险计划规定提供证据及/或其他索赔材料的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("4.用户未依据本协议第三条第（五）款中的规定进行报案和/或进行证据保全的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("5.自使用WiFi万能钥匙遭受直接经济损失之日起15个自然日内，用户未依据本协议第三条第（五）款中的规定向保险公司提交索赔材料的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("6.用户使用WiFi万能钥匙连接网络的行为与用户遭受的财产损失不具有直接因果关系；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("7.钓鱼热点、钓鱼网站及网络木马病毒、恶意软件的相关欺诈和/或劫持行为与用户所遭受的财产损失不具有直接因果关系；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("8.虚假诈骗广告信息植入在某个特定热点中，用户连接该热点后，轻信了该虚假广告信息，从而遭受了财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("9.虚假诈骗广告信息或恶意软件下载链接是植入在普通网站中的，用户使用WiFi万能钥匙连接网络后，在正常浏览网页的过程中因上述虚假广告或恶意软件遭受了财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("10.在用户使用WiFi万能钥匙连接网络并上网的过程中，因用户故意或重大过失导致下列情形的财产损失：")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（1）用户主动向他人账号划转资金或主动为他人发送的代付链接付款的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（2）用户通过网上交易购买机票或火车票时，向不具有在线销售资质的且收款人账号非为公司账号的网站划转资金或付款；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（3）用户主动泄露网上银行账号、密码、支付短信的交易验证码或其他可能导致财产损失的信息，或主动允许他人远程协助的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（4）网上银行账号、密码已被他人知悉，或丢失了数字证书载体后，用户未立即变更账号、密码或通知银行冻结网上银行账户的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（5）其他因用户故意或重大过失导致的财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("11. 用户网购过程中，因商家违背诚信经营原则导致下列情形的财产损失：")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（1）与商家因交易纠纷造成的损失，包括但不限于电子商务商家账号被盗等引起的一切财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（2）由于商家不诚信问题造成的损失，包括但不限于商品或服务的描述与实际不符，商品或服务的质量、价格、售后服务等引发消费纠纷而引起的一切财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（3）虽经网页链接跳转，但用户系在正规网站进行正常交易行为时，由于商家违背诚信经营原则而遭受的财产损失。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("12.用户网购过程中，因其所购买标的物之特殊性导致的下列情形的财产损失：")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（1）用户在网络游戏私服中进行的交易或充值行为；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（2）以虚拟物品为交易对象的，包括但不限于虚拟财产（如虚拟游戏装备、虚拟货币、虚拟道具等）、游戏人物、游戏辅助物品的，或用户在网络游戏中直接交换物品的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（3）用户购买药品、保健品的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（4）涉及盗版及仿制品、走私、非法销售物品的交易；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（5）涉及网络赌博、博彩类交易（包括但不限于“赌球”、“21点”、“押大小”、“购买彩票”等）；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（6）其他涉嫌购买国家法律禁止销售或者交易的物品的任何交易。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("13.网站经营者或任何第三方已赔偿或补偿了用户经济损失，或用户经WiFi万能钥匙协助已挽回经济损失，或用户已通过WiFi万能钥匙的其他理赔/保障计划获得赔偿的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("14.财产损失超出本协议第三条第（四）款中索赔限额的部分；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("15.用户故意骗保，或在未发生理赔情形或未遭受任何财产损失的前提下谎称发生了理赔情形或伪造损失证据的，或用户因从事非法行为而遭受的任何损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("16.用户有损害本公司商誉、扰乱本公司正常经营秩序言行的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("17.针对同一索赔事件，保险公司向用户进行理赔后，用户又追加索赔申请的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("18.WiFi万能钥匙或保险公司工作人员依照本协议的约定联系用户时，自首次尝试联系用户起72小时内仍无法与用户取得联系的，或用户不履行本协议约定的配合义务的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("19.用户遭受的直接经济损失以外的一切间接损失、预期利益、精神损害或其他损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("20.其他根据WiFi万能钥匙用户安全保险计划不属于理赔范围的情形。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（四）索赔限额")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('table', {
    attrs: {
      "width": "100%",
      "border": "1",
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tr', [_c('td', [_vm._v("保险责任")]), _vm._v(" "), _c('td', [_vm._v("每一用户单日/单次索赔限额")]), _vm._v(" "), _c('td', [_vm._v("每一用户累计索赔限额")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("WiFi万能钥匙在提供服务的过程中造成了用户损失")]), _vm._v(" "), _c('td', [_vm._v("人民币贰万元整")]), _vm._v(" "), _c('td', [_vm._v("人民币壹拾万元整")])])])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("单次事故赔偿限额：人民币壹佰万元整")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("（单次事故：指因同一或基本相同的风险原因导致的一系列索赔事件（即群体性事件），视为一起事故，前述风险原因的认定以本公司技术部门的判定结果作为标准）")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（五）索赔流程")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.证据保全：用户在使用WiFi万能钥匙连接网络的过程中，发现账户资金遭受损失的，应立即采取相关证据保全措施，不应自行刷机、清理手机垃圾、删除WiFi万能钥匙客户端、历史短信或历史访问网址记录，或自行删除交易过程中与交易对方的聊天记录及所下载的软件，以免导致相关证据无法保全；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.报案：用户在使用WiFi万能钥匙连接网络的过程中，发现账户资金遭受损失的，应立即拨打保险公司电话进行报案，并应于10个自然日内前往具有管辖权的公安机关进行报案，并取得案件受理通知书等相关证明材料；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.准备索赔资料：用户应自账户资金遭受经济损失之日起15个自然日内根据WiFi万能钥匙客户端索赔界面的提示准备索赔资料，并听从工作人员的操作指导，积极配合工作人员的工作，并配合提供相关损失证明文件，以便有效追查被盗情况并保全证据；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.提交索赔资料：用户应根据保险公司工作人员的指示提交索赔资料，并确保其所提交的资料的真实性，否则，本公司及保险公司有权拒绝受理或赔付用户的索赔申请；用户知悉并了解，该等资料中的相关信息包括但不限于用户身份证号码、银行卡号、手机号码、详细住址等个人信息，用户在此同意并授权本公司及保险公司为实现本协议项下的索赔目的对用户的该等个人信息予以采集和使用；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("用户应通过线下快递方式递交如下索赔资料：")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('b', [_vm._v("身份证正反面彩色复印件（非中华人民共和国公民请提交有效护照彩色复印件）")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("向公安机关报案的相关证明（报案或立案证明）")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("非本人授权交易补偿申请表")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('b', [_vm._v("索赔人被盗账户信息截屏")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('b', [_vm._v("被盗账户对账单截屏（须标记盗刷交易明细信息：交易日期、交易商户、交易币种、交易金额、入账币种、入账金额）")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('b', [_vm._v("被盗账户挂失证明（信息截屏，包含挂失日期等）")])]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("索赔人出险期间手机设备在公安机关的备案数据")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("被盗账户近半年交易数据（如有）")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("涉及诉讼、仲裁的，递交相关司法文书、对方提交的证据副本等（如有）")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("其他本公司或保险公司认为对向用户提供理赔服务所必须的材料。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.理赔结果：保险公司根据用户提交的材料将认定最终理赔结果，如最终确认属于理赔责任范围内的情形，由保险公司向用户支付赔款，最终理赔额在人民币3000元（含3000元）以下的案件由保险公司在确认最终理赔结果后的5个工作日之内支付赔款；最终理赔额在人民币3000元以上的案件由保险公司在确认最终理赔结果后的10个工作日之内支付赔款。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("四、用户的权利与义务")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.用户使用WiFi万能钥匙过程中用户账户资金遭受直接经济损失的，用户有权向保险公司提起索赔申请，经本公司及保险公司认定情况属实并符合索赔条件及范围的，保险公司将依据理赔规则给予用户理赔。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.用户向保险公司提起索赔申请，应按照本公司用户安全理赔规则提交所有相关索赔材料。用户保证，其所提交的一切索赔材料、所作出的任何陈述或保证均真实准确且合法有效，并应独立承担因违反上述保证所引发的一切法律责任。用户未充分履行上述义务或违反上述保证的，本公司及保险公司有权不予理赔；保险公司已经向该用户支付理赔金的，有权向该用户追回，并要求用户赔偿本公司及保险公司因此遭受的一切损失。同时，本公司及保险公司将向有关机关报案，追究该用户骗保的刑事责任。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.用户应保证其连接网络及上网过程中的行为不触犯任何法律、行政法规、相关政策且不侵犯任何第三人的合法权益。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.用户应向保险公司提供真实有效的收款账户信息，因用户原因导致提供的收款信息错误而无法收到理赔额的情况，本公司及保险公司不承担任何责任。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.用户向保险公司或本公司发起索赔申请，即表明用户已同意严格遵守本公司发布的针对WiFi万能钥匙安全保险计划的所有规则，并同意以最新的规则作为认定最终理赔结果的依据。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("6.用户承诺：未经本公司书面许可，不得将最终理赔结果向任何第三方披露。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("五、本公司的权利与义务")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.用户知悉并完全同意本公司有权随时修改、更新、暂停或永久终止保险计划，无需因此对用户承担法律责任。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.本公司有权依据理赔规则对用户向保险公司的索赔申请进行审核以确定是否向其提供理赔服务，本公司有完全的权利同意或拒绝用户的申请。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.本公司对本协议项下的理赔义务承担有限责任，在任何情形下，用户同意保险公司向其支付的理赔金的最高上限依照本协议第（四）条之规定执行。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.如WiFi万能钥匙及保险公司在审查用户所提交的索赔申请时发现重大刑事案件线索的，本公司及保险公司有权在通知用户后以用户索赔资料为基础向警方提供案件侦查线索或向相关司法机关检举。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.用户因使用WiFi万能钥匙所遭受的经济损失，通过第三方获得赔付或司法程序或其他合法程序得以追缴或退赔的，若保险公司已根据本保险计划向用户进行赔付的，则有权在其对用户的赔付范围内要求用户进行返还。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("6.本公司承诺：未经用户允许，除为实现本协议项下的理赔目的及法律法规隐私保护政策另有规定的情形外，不对外披露或向第三方提供用户的任何信息。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("六、其他")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_c('b', [_vm._v("1.本公司郑重提醒用户注意本协议中免除或限制责任的条款，请用户仔细阅读，自主考虑风险。未成年人应在法定监护人的陪同下阅读本协议。")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.本协议所定的任何条款的部分或全部无效者，不影响其它条款的效力。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("3."), _c('b', [_vm._v("本协议的解释、效力及纠纷的解决，适用于中华人民共和国法律。若用户和本公司之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，用户在此完全同意双方将纠纷或争议提交本公司所在地人民法院通过诉讼方式解决。")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.本WiFi万能钥匙用户安全保险计划自2019年3月4日起生效施行。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.若您对本协议及本保险计划有任何意见，欢迎垂询本公司客服中心400-035-8000。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("南京尚网网络科技有限公司")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2019年8月14日")])])])
}]}

/***/ }),
/* 825 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ClaimFlow"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('p', {
    staticClass: "title2"
  }, [_vm._v("用户在使用WiFi万能钥匙连接网络的过程中，发现银行账户资金(用户本人在银行账户内的资产，及用户在合法运营的第三方支付机构所设本人实名制账户中的资产)遭受损失，应立即采取以下措施:")]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v("1.保全证据")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("发现损失后，立即采取相关证据保全措施，不应自行刷机、清理手机垃圾、删除WiFi万能钥匙客户端、历史短信或历史访问网址记录，或自行删除交易过程中与对方的聊天记录以及所下载软件，以免导致相关证据无法保全；")]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v("2.报案")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("在保全证据后，立即拨打保险公司电话进行报案，并于10个自然日内前往用户住所地或经常居住地有管辖权的公安机关进行报案，并取得案件受理通知书等相关证明材料；")]), _vm._v(" "), _c('p', {
    staticClass: "text highlight"
  }, [_vm._v("众安保险客服电话:400-999-9595")]), _vm._v(" "), _c('p', {
    staticClass: "text highlight"
  }, [_vm._v("(7X24小时统一客服热线)")]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v("3.准备索赔资料")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("用户应自使用WiFi万能钥匙遭受直接经济损失之日起15个自然日内，根据WiFi万能钥匙官网或者手机客户端索赔界面的提示准备索赔资料。并听从工作人员的操作指导，配合提供相关损失的证明文件，以便有效核实被盗情况。")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("若保险公司或WiFi万能钥匙的工作人员联系用户时，自首次尝试联系用户起72小时内无法与用户取得联系，将视用户自动放弃索赔。")]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v("4.提交索赔资料")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("用户应自使用WiFI万能钥匙遭受直接经济损失之日起15个自然日内，根据保险公司工作人员的指示，将索赔资料快递至以下地址(不接受快递到付)，并确保其所提交资料的真实性。配合提供相关损失的证明文件，以便有效核实被盗情况。")]), _vm._v(" "), _c('p', {
    staticClass: "text highlight"
  }, [_vm._v("\n          收件人:WiFi万能钥匙用户安全理赔项目组"), _c('br'), _vm._v("\n          快递联系电话:400-035-8000"), _c('br'), _vm._v("\n          寄送地址:上海市浦东新区张衡路666弄1号楼7楼\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v("5.理赔结果")]), _vm._v(" "), _c('p', {
    staticClass: "text last"
  }, [_vm._v("保险公司根据用户提交的材料将认定最终理赔结果，如最终确认属于理赔责任范围内的情形，由保险公司向用户支付赔款，最终理赔额在人民币3000元(含3000元)以下的案件由保险公司在确认最终理赔结果后的5个工作日内支付赔款；最终理赔额在人民币3000元以上的案件由保险公司在确认最终理赔结果后的10个工作日之内支付赔款。")])])])
}]}

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "claimDetail"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading",
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "main claim"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._m(0), _vm._v(" "), (_vm.obj.status == 1) ? _c('p', {
    staticClass: "status"
  }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.obj.status == 2) ? _c('p', {
    staticClass: "status_success"
  }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.obj.status == 3) ? _c('p', {
    staticClass: "status_failed"
  }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.obj.status == 1) ? _c('div', {
    staticClass: "logo"
  }) : _vm._e(), _vm._v(" "), (_vm.obj.status == 2) ? _c('div', {
    staticClass: "logo_success"
  }) : _vm._e(), _vm._v(" "), (_vm.obj.status == 3) ? _c('div', {
    staticClass: "logo_failed"
  }) : _vm._e()])]), _vm._v(" "), (_vm.obj.status == 1) ? _c('div', {
    attrs: {
      "id": "claimPage"
    }
  }, [_c('p', {
    staticClass: "limit"
  }, [_vm._v("参保用户赔偿额度")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    staticClass: "bb"
  }, [_vm._v("索赔流程:"), _c('router-link', {
    attrs: {
      "to": "/claimFlow"
    }
  }, [_vm._v("查看详情")])], 1), _vm._v(" "), _c('p', {
    staticClass: "bb"
  }, [_vm._v("索赔资料:"), _c('router-link', {
    attrs: {
      "to": "/docs"
    }
  }, [_vm._v("查看详情")])], 1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.obj.status == 2) ? _c('div', {
    attrs: {
      "id": "claimSuccessPage"
    }
  }, [_c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    staticClass: "bb"
  }, [_vm._v("索赔人:"), _c('span', {
    attrs: {
      "id": "username"
    }
  }, [_vm._v(_vm._s(_vm.obj.u_name))])]), _vm._v(" "), _c('p', {
    staticClass: "bb"
  }, [_vm._v("索赔金额:"), _c('span', {
    attrs: {
      "id": "price"
    }
  }, [_vm._v("￥" + _vm._s(_vm.obj.price))])]), _vm._v(" "), _c('p', [_vm._v("银行卡号:"), _c('span', {
    attrs: {
      "id": "bankCard"
    }
  }, [_vm._v(_vm._s(_vm.obj.bank_card))])])]), _vm._v(" "), _c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    staticClass: "bb"
  }, [_vm._v("索赔开始时间:"), _c('span', {
    attrs: {
      "id": "startDate"
    }
  }, [_vm._v(_vm._s(_vm.obj.start_ts))])]), _vm._v(" "), _c('p', [_vm._v("索赔结束时间:"), _c('span', {
    attrs: {
      "id": "endDate"
    }
  }, [_vm._v(_vm._s(_vm.obj.end_ts))])])]), _vm._v(" "), _c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    attrs: {
      "id": "reason"
    }
  }, [_c('span', {
    staticStyle: {
      "position": "static"
    }
  }, [_vm._v("备注:" + _vm._s(_vm.obj.reason))])])])]) : _vm._e(), _vm._v(" "), (_vm.obj.status == 3) ? _c('div', {
    attrs: {
      "id": "claimFailedPage"
    }
  }, [_c('div', {
    staticClass: "block clearfix"
  }, [_c('p', [_vm._v("索赔人:"), _c('span', {
    attrs: {
      "id": "username"
    }
  }, [_vm._v(_vm._s(_vm.obj.u_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    staticClass: "bb"
  }, [_vm._v("索赔开始时间:"), _c('span', {
    attrs: {
      "id": "startDate"
    }
  }, [_vm._v(_vm._s(_vm.obj.start_ts))])]), _vm._v(" "), _c('p', [_vm._v("索赔结束时间:"), _c('span', {
    attrs: {
      "id": "endDate"
    }
  }, [_vm._v(_vm._s(_vm.obj.end_ts))])])]), _vm._v(" "), _c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    attrs: {
      "id": "reason"
    }
  }, [_c('span', {
    staticStyle: {
      "position": "static"
    }
  }, [_vm._v("备注:" + _vm._s(_vm.obj.reason))])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "zhongan"
  }, [_vm._v("WiFi安全险"), _c('img', {
    attrs: {
      "src": __webpack_require__(254),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    staticClass: "bb"
  }, [_vm._v("每一用户单日/单次索赔限额："), _c('span', [_vm._v("￥20,000元")])]), _vm._v(" "), _c('p', [_vm._v("每一用户累计最高可赔："), _c('span', [_vm._v("￥100,000元")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("服务热线:"), _c('a', {
    attrs: {
      "href": "tel:4009999595"
    }
  }, [_vm._v("400-999-9595")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    staticClass: "bb"
  }, [_vm._v("索赔资料收件人:"), _c('span', {
    staticClass: "small_font"
  }, [_vm._v("WiFi万能钥匙用户安全理赔项目组")])]), _vm._v(" "), _c('p', {
    staticClass: "bb"
  }, [_vm._v("寄送地址:"), _c('span', {
    staticClass: "small_font"
  }, [_vm._v("上海市浦东新区张衡路666弄1号楼7楼")])]), _vm._v(" "), _c('p', [_vm._v("快递联系电话:"), _c('span', [_vm._v("400-035-8000")])])])
}]}

/***/ }),
/* 827 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ClaimStep2"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading",
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "main",
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_c('p', {
    staticClass: "doc_title",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("如果您的资金不幸被盗，请按以下步骤进行索赔登记")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("1.手持身份证拍照（正反面）")]), _vm._v(" "), _c('form', {
    attrs: {
      "method": "post",
      "action": "",
      "enctype": "multipart/form-data"
    }
  }, [_vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "doc_text",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("2.被盗信息截屏")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "button",
    staticStyle: {
      "margin-top": "25px"
    },
    on: {
      "click": _vm.claimStep2
    }
  }, [_vm._v("\n          确认登记\n      ")])]), _vm._v(" "), _c('p', {
    staticClass: "doc_a",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/claimFlow"
    }
  }, [_vm._v("了解索赔流程")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "model"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "title"
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }), _vm._v(" "), _c('p', {
    staticClass: "foot"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload"
  }, [_c('div', {
    staticClass: "item item1"
  }, [_c('input', {
    staticClass: "btn_file",
    attrs: {
      "type": "file",
      "id": "uploadIDFront",
      "name": "uploadIDFront",
      "value": "",
      "accept": "image/*"
    }
  }), _c('button', [_vm._v("上传照片")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("已上传")])]), _vm._v(" "), _c('div', {
    staticClass: "item item2"
  }, [_c('input', {
    staticClass: "btn_file",
    attrs: {
      "type": "file",
      "id": "uploadIDBack",
      "name": "uploadIDBack",
      "value": "",
      "accept": "image/*"
    }
  }), _c('button', [_vm._v("上传照片")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("已上传")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload"
  }, [_c('div', {
    staticClass: "item screenShot"
  }, [_c('input', {
    staticClass: "btn_file",
    attrs: {
      "type": "file",
      "id": "uploadPrice",
      "name": "uploadPrice",
      "value": "",
      "accept": "image/*"
    }
  }), _c('button', [_vm._v("上传照片")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("已上传")])])])
}]}

/***/ }),
/* 828 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ClaimStep1"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading",
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "main",
    staticStyle: {
      "padding-bottom": "30px"
    }
  }, [_c('p', {
    staticClass: "doc_title",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("为了保障您的索赔权益，请确认你符合以下索赔范围并登记（可多选）：")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', {
    staticClass: "button",
    staticStyle: {
      "margin-top": "15px"
    },
    on: {
      "click": _vm.claimStep1
    }
  }, [_vm._v("\n          我要索赔登记\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "doc_a"
  }, [_c('router-link', {
    attrs: {
      "to": "/claimFlow"
    }
  }, [_vm._v("了解索赔流程")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "model"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "title"
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }), _vm._v(" "), _c('p', {
    staticClass: "foot"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "doc_text"
  }, [_c('span', {
    staticClass: "check",
    attrs: {
      "data-index": "question1"
    }
  }), _vm._v("用户欲前往特定合法网络购物网站、网络银行网站或第三方支付网站（以上简称“合法网站”）进行购物、转账等操作时，用户在支付交易过程中DNS被钓鱼热点进行了信息篡改，从而导致用户账户资金被盗的；")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "doc_text"
  }, [_c('span', {
    staticClass: "check",
    attrs: {
      "data-index": "question2"
    }
  }), _vm._v("用户欲前往合法网站进行购物、转账等操作时，钓鱼热点已对该网站进行了DNS劫持，从而使用户连接上了一个钓鱼网站，导致了用户账户资金被盗的；")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "doc_text"
  }, [_c('span', {
    staticClass: "check",
    attrs: {
      "data-index": "question3"
    }
  }), _vm._v("用户在合法网站正常操作购物、转账等操作的过程中，钓鱼热点非法获取了用户录入及传递的个人信息，导致用户信息泄露继而造成账户资金被盗；")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "doc_text"
  }, [_c('span', {
    staticClass: "check",
    attrs: {
      "data-index": "question4"
    }
  }), _vm._v("用户欲下载特定应用软件，用户连接的热点被劫持后，用户实际下载了仿冒恶意软件，且一般用户无法判断该软件的真伪。用户在仿冒恶意软件中录入个人信息，或仿冒软件将劫持的用户短信等个人信息发送至恶意第三方，从而导致用户账户资金遭受损失。")])
}]}

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ClaimSuccess"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(252),
      "alt": "众安保险"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "claim_success"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('p', {
    staticClass: "result"
  }, [_vm._v("索赔登记成功！")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "view"
  }, [_c('router-link', {
    attrs: {
      "to": "/docs"
    }
  }, [_vm._v("查看索赔所需资料")]), _c('router-link', {
    attrs: {
      "to": "/ClaimFlow"
    }
  }, [_vm._v("了解索赔流程")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "bottom_bg"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tips"
  }, [_vm._v("请尽快用电脑登陆 "), _c('span', [_vm._v("https://insurance.lianwifi.com/pc/index.html")]), _vm._v(" ，下载填写交易补偿申请表，并准备相关索赔资料寄送指定地址，方便理赔。")])
}]}

/***/ }),
/* 830 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    on: {
      "click": function($event) {
        return _vm.$emit('click', _vm.item)
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "ssid"
  }, [_vm._v(_vm._s(_vm.item.ssid))])])])
},staticRenderFns: []}

/***/ }),
/* 831 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    staticClass: "tip"
  }, [_vm._v("请选择要认领的热点")]), _vm._v(" "), _c('div', {
    staticClass: "list-container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._v("加载中，请稍候...")]) : _vm._l((_vm.wifiList), function(item, index) {
    return _c('wifi-item', {
      key: index,
      attrs: {
        "item": item
      },
      on: {
        "click": _vm.handleWifiItemClick
      }
    })
  }), _vm._v(" "), (_vm.isShowEmpty) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("请在设置>更多设置>权限管理中，授权WiFi万能钥匙开启定位权限，才能查找附近WiFi")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    staticClass: "refresh-button",
    attrs: {
      "type": "primary",
      "block": "",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.refreshList
    }
  }, [_vm._v("刷新列表")])])])
},staticRenderFns: []}

/***/ }),
/* 832 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "toast",
    class: _vm.position ? 'toast-' + _vm.position : 'toast-center'
  }, [(_vm.mask) ? _c('div', {
    staticClass: "toast-mask"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "toast-content"
  }, [_vm._v(_vm._s(_vm.content))])])])
},staticRenderFns: []}

/***/ }),
/* 833 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    class: _vm.innerDisabled ? 'disabled' : ''
  }, [_c('input', {
    ref: "fileInput",
    staticClass: "file-input",
    attrs: {
      "type": "file",
      "accept": "image/*",
      "disabled": _vm.innerDisabled
    },
    on: {
      "change": _vm.hanldeFileChange,
      "click": function($event) {
        return _vm.$emit('input-click', $event)
      }
    }
  }), _vm._v(" "), (_vm.loading) ? [_vm._t("loading", [_c('div', {
    staticClass: "img-loading"
  }, [_vm._v("上传中...")])])] : (_vm.previewSrc) ? [_c('img', {
    staticClass: "preview",
    attrs: {
      "src": _vm.previewSrc
    }
  })] : [_vm._t("input", [_c('div', {
    staticClass: "plus-icon"
  })])]], 2)
},staticRenderFns: []}

/***/ }),
/* 834 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading",
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "main",
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "id": "voucherPage"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('p', {
    staticClass: "zhongan"
  }, [_vm._v("WiFi安全险")]), _vm._v(" "), (_vm.obj.state == 0) ? _c('div', {
    staticClass: "already"
  }, [_vm._v("已参保")]) : _vm._e(), _vm._v(" "), (_vm.obj.state == 1) ? _c('div', {
    staticClass: "already",
    staticStyle: {
      "color": "#0285F0"
    }
  }, [_vm._v("处理中")]) : _vm._e(), _vm._v(" "), (_vm.obj.state == 2) ? _c('div', {
    staticClass: "already",
    staticStyle: {
      "color": "#0285F0"
    }
  }, [_vm._v("审核中")]) : _vm._e(), _vm._v(" "), (_vm.obj.state == 3) ? _c('div', {
    staticClass: "already",
    staticStyle: {
      "color": "#0285F0"
    }
  }, [_vm._v("审核失败")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "al-item",
    staticStyle: {
      "margin-top": "16px"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("累计最高赔付人民币")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("￥" + _vm._s(_vm.obj.allMax) + "元")])]), _vm._v(" "), _c('div', {
    staticClass: "al-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("单日/单次最高赔付人民币")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("￥" + _vm._s(_vm.obj.oneMax) + "元")])]), _vm._v(" "), _c('div', {
    staticClass: "al-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("保障期限")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.obj.startDate) + "至" + _vm._s(_vm.obj.endDate))])]), _vm._v(" "), _c('div', {
    staticClass: "al-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("支付金额")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("￥" + _vm._s(_vm.obj.pay) + "元")])]), _vm._v(" "), _c('div', {
    staticClass: "al-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("保险详细")]), _vm._v(" "), _c('a', {
    staticClass: "right a",
    on: {
      "click": _vm.clickRange
    }
  }, [_vm._v("保障范围")])]), _vm._v(" "), _c('div', {
    staticClass: "al-item",
    staticStyle: {
      "padding-bottom": "24px"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("服务热线")]), _vm._v(" "), _c('a', {
    staticClass: "right a",
    attrs: {
      "href": ("tel:" + (_vm.obj.hotLine))
    },
    on: {
      "click": _vm.range
    }
  }, [_vm._v(_vm._s(_vm.obj.hotLine))])])]), _vm._v(" "), _c('qa', {
    attrs: {
      "type": 5
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-image"
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("南京尚网网络科技有限公司对以上信息保留最终解释权")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "bottom": "0",
      "width": "100%",
      "margin-top": "15px",
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "bottom_btn halfwidth",
    attrs: {
      "id": "btn_claim"
    },
    on: {
      "click": _vm.goClaim
    }
  }, [_vm._v("我要索赔")]), _vm._v(" "), (_vm.isClaim) ? _c('router-link', {
    staticClass: "bottom_btn claimList halfwidth",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "to": "/new/claimList"
    }
  }, [_c('div', {
    on: {
      "click": _vm.clickClaimList
    }
  }, [_vm._v("索赔记录")])]) : _vm._e()], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "model"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "title"
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }), _vm._v(" "), _c('p', {
    staticClass: "btns",
    staticStyle: {
      "display": "none"
    }
  }, [_c('span', {
    staticClass: "cancel"
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "confirm"
  }, [_vm._v("确定")])]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  })])])
}]}

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading",
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "main",
    attrs: {
      "id": "indexPage"
    }
  }, [_c('van-swipe', {
    staticClass: "my-swipe",
    attrs: {
      "autoplay": 3000,
      "indicator-color": "white"
    }
  }, [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": __webpack_require__(250),
      "alt": "",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('van-swipe-item', [_c('img', {
    attrs: {
      "src": __webpack_require__(253),
      "alt": "",
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "detail clearfix"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.toRange()
      }
    }
  }, [_vm._v("查看保险详情")])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('qa', {
    attrs: {
      "type": 1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-image"
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("南京尚网网络科技有限公司对以上信息保留最终解释权")]), _vm._v(" "), _c('div', {
    staticClass: "button-fixed"
  }, [_c('p', {
    staticClass: "button-item",
    attrs: {
      "id": "createBtn"
    },
    on: {
      "click": function($event) {
        return _vm.goCreate('personal')
      }
    }
  }, [_vm._v("个人参保")]), _vm._v(" "), _c('p', {
    staticClass: "button-item",
    on: {
      "click": function($event) {
        return _vm.goCreate('store')
      }
    }
  }, [_vm._v("商户参保")])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "model"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "title"
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }), _vm._v(" "), _c('p', {
    staticClass: "btns",
    staticStyle: {
      "display": "none"
    }
  }, [_c('span', {
    staticClass: "cancel"
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "confirm"
  }, [_vm._v("确定")])]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(251),
      "width": "31.733%"
    }
  }), _vm._v(" "), _c('p', [_vm._v("一键连WiFi，一直有保障")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "protect"
  }, [_c('p', [_vm._v("保障清单")]), _vm._v(" "), _c('div', {
    staticClass: "line left"
  }), _vm._v(" "), _c('div', {
    staticClass: "line right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("连WiFi意外损失累计最高赔付")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("\n          ￥\n          "), _c('span', {
    staticClass: "big"
  }, [_vm._v("100,000")]), _vm._v("元\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("连WiFi意外损失单次最高赔付")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("\n          ￥\n          "), _c('span', {
    staticClass: "big"
  }, [_vm._v("20,000")]), _vm._v("元\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("保障期限")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("一年")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("参保费用")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("\n          ￥\n          "), _c('span', {
    staticClass: "big"
  }, [_vm._v("0.00")]), _vm._v("元\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail clearfix"
  }, [_c('div', {
    staticClass: "protect"
  }, [_c('p', [_vm._v("专属特色")]), _vm._v(" "), _c('div', {
    staticClass: "line left"
  }), _vm._v(" "), _c('div', {
    staticClass: "line right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "left-panel"
  }, [_c('div', {
    staticClass: "icon icon1"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#333333"
    }
  }, [_vm._v("全方位保障")]), _vm._v(" "), _c('p', [_vm._v("所有通过WiFi万能钥匙")]), _vm._v(" "), _c('p', [_vm._v("连WiFi的上网行为")])]), _vm._v(" "), _c('div', {
    staticClass: "right-panel"
  }, [_c('div', {
    staticClass: "icon icon2"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#333333"
    }
  }, [_vm._v("官方VIP通道")]), _vm._v(" "), _c('p', [_vm._v("极速处理您的WiFi安全")]), _vm._v(" "), _c('p', [_vm._v("险理赔需求")])])])
}]}

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "create"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading",
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(253),
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "store-form"
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('section', {
    staticClass: "label bb clearfix"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.userName),
      expression: "formData.userName"
    }],
    attrs: {
      "type": "text",
      "id": "user_name",
      "maxlength": "15",
      "placeholder": "请输入参保商家法定代表人（或经营者）",
      "value": ""
    },
    domProps: {
      "value": (_vm.formData.userName)
    },
    on: {
      "focus": _vm.eidtName,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "userName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "label bb clearfix"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.idCard),
      expression: "formData.idCard"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入身份证号",
      "maxlength": "18"
    },
    domProps: {
      "value": (_vm.formData.idCard)
    },
    on: {
      "focus": _vm.eidtCard,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "idCard", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._l((_vm.formData.apInfoList), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "wifi-body"
    }, [_c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "wifi-info"
    }, [_c('section', {
      staticClass: "label bb clearfix"
    }, [_vm._m(3, true), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.ssid),
        expression: "item.ssid"
      }],
      staticStyle: {
        "width": "220px"
      },
      attrs: {
        "type": "text",
        "placeholder": "手动输入WiFi热点名称"
      },
      domProps: {
        "value": (item.ssid)
      },
      on: {
        "focus": _vm.eidtSsid,
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "ssid", $event.target.value)
        }, function($event) {
          return _vm.changeText(item.ssid, key)
        }]
      }
    }), _vm._v(" "), (!_vm.isIOS) ? _c('div', {
      staticClass: "select-wifi",
      on: {
        "click": function($event) {
          return _vm.selectWifi(key)
        }
      }
    }, [_vm._v("\n            选择附近WiFi\n            "), _c('img', {
      staticClass: "arrow-right",
      attrs: {
        "src": __webpack_require__(670)
      }
    })]) : _vm._e()]), _vm._v(" "), _c('section', {
      staticClass: "label bb clearfix"
    }, [_vm._m(4, true), _vm._v(" "), _c('ul', {
      staticClass: "macList clearfix"
    }, _vm._l((item.bssidList), function(bssid, index) {
      return _c('li', {
        key: index
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (bssid.title),
          expression: "bssid.title"
        }],
        attrs: {
          "type": "text",
          "maxlength": "1"
        },
        domProps: {
          "value": (bssid.title)
        },
        on: {
          "focus": _vm.eidtMac,
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(bssid, "title", $event.target.value)
          }
        }
      }), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (bssid.title1),
          expression: "bssid.title1"
        }],
        attrs: {
          "type": "text",
          "maxlength": "1"
        },
        domProps: {
          "value": (bssid.title1)
        },
        on: {
          "focus": _vm.eidtMac,
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(bssid, "title1", $event.target.value)
          }
        }
      }), _vm._v(" "), (index !== (item.bssidList.length - 1)) ? _c('span', [_vm._v(":")]) : _vm._e()])
    }), 0), _vm._v(" "), _c('p', [_vm._v("MAC地址通常在路由器背面的铭牌上可以找到，由0-9之间的数字和a-f之间的字母组成")]), _vm._v(" "), _c('section', {
      staticClass: "label bb clearfix"
    }, [_vm._m(5, true), _vm._v(" "), _c('div', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleShopType(key)
        }
      }
    }, [_c('div', {
      staticClass: "arrow"
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.text),
        expression: "item.text"
      }],
      attrs: {
        "type": "text",
        "disabled": "",
        "placeholder": "选择商户类型",
        "maxlength": "18"
      },
      domProps: {
        "value": (item.text)
      },
      on: {
        "click": function () {},
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "text", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('section', {
      staticClass: "label bb clearfix"
    }, [_vm._m(6, true), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "14px",
        "color": "#666666",
        "letter-spacing": "0",
        "line-height": "26px"
      }
    }, [_vm._v("热点证明（路由器背面铭牌照片）")]), _vm._v(" "), _c('div', {
      staticClass: "upload-img"
    }, [_c('wk-single-image-upload', {
      attrs: {
        "dest": "wifikey",
        "disabled": _vm.disabled
      },
      on: {
        "change": _vm.getHotspotEvidence
      },
      model: {
        value: (item.hotspotEvidence),
        callback: function($$v) {
          _vm.$set(item, "hotspotEvidence", $$v)
        },
        expression: "item.hotspotEvidence"
      }
    }, [_c('solt', {
      staticClass: "loading",
      attrs: {
        "name": "loading"
      }
    })], 1)], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "btn-body"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.formData.apInfoList.length > 1),
        expression: "formData.apInfoList.length > 1"
      }],
      staticClass: "add",
      on: {
        "click": function($event) {
          return _vm.handleWifi('del', key)
        }
      }
    }, [_c('img', {
      staticClass: "add-img",
      attrs: {
        "src": __webpack_require__(671)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "delete-span"
    }, [_vm._v("删除热点")])]), _vm._v(" "), _c('div', {
      staticClass: "add",
      on: {
        "click": function($event) {
          return _vm.handleWifi('add', key)
        }
      }
    }, [_c('img', {
      staticClass: "add-img",
      attrs: {
        "src": __webpack_require__(669)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "add-span"
    }, [_vm._v("添加热点")])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "des"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "upload-img"
  }, [_c('wk-single-image-upload', {
    attrs: {
      "dest": "wifikey",
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.getBusinessLicense
    },
    model: {
      value: (_vm.formData.businessLicense),
      callback: function($$v) {
        _vm.$set(_vm.formData, "businessLicense", $$v)
      },
      expression: "formData.businessLicense"
    }
  }, [_c('solt', {
    staticClass: "loading",
    attrs: {
      "name": "loading"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "notice"
  }, [_vm._v("信息保护声明")]), _vm._v(" "), _c('div', {
    staticClass: "noticeInfo"
  }, [_vm._v("以上信息只供WiFi安全险登记及理赔用途，并不会用于其他商业用途。")])]), _vm._v(" "), _c('p', {
    staticClass: "protocol"
  }, [_c('van-checkbox', {
    attrs: {
      "icon-size": "16",
      "shape": "square",
      "checked-color": "#07c160"
    },
    on: {
      "change": _vm.changeCheck
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("\n        本人同意并接受\n        "), (_vm.protocol == 'protocol') ? _c('router-link', {
    attrs: {
      "to": "/new/protocol"
    },
    on: {
      "click": function($event) {
        return _vm.clickProtocol()
      }
    }
  }, [_vm._v("《WiFi万能钥匙商户热点安全保险协议》")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "errorMsg"
  }), _vm._v(" "), _c('p', {
    staticClass: "buttons"
  }, [_c('a', {
    staticClass: "button btn",
    on: {
      "click": _vm.create
    }
  }, [_vm._v("参保安心上网")])])]), _vm._v(" "), _c('qa', {
    attrs: {
      "type": 4
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-image"
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright",
    staticStyle: {
      "padding-bottom": "12px"
    }
  }, [_vm._v("南京尚网网络科技有限公司对以上信息保留最终解释权")]), _vm._v(" "), (_vm.showAlertModel) ? _c('div', {
    staticClass: "alert-model"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("温馨提示")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.modelContent))]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('p', {
    staticClass: "description",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("\n        客服电话："), _c('a', {
    attrs: {
      "href": "tel:4000358000"
    }
  }, [_vm._v("4000358000")]), _vm._v(" "), _c('span', {
    staticClass: "copy-qq",
    on: {
      "click": function($event) {
        return _vm.copyQq(4000358000)
      }
    }
  }, [_vm._v("复制")])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('p', {
    staticClass: "foot",
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("我知道了")])])]) : _vm._e(), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showPopup),
      callback: function($$v) {
        _vm.showPopup = $$v
      },
      expression: "showPopup"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "default-index": 2,
      "columns": _vm.columns
    },
    on: {
      "confirm": _vm.onConfirm,
      "change": _vm.onChange,
      "cancel": _vm.onCancel
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "model"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "title"
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }), _vm._v(" "), _c('p', {
    staticClass: "btns",
    staticStyle: {
      "display": "none"
    }
  }, [_c('span', {
    staticClass: "cancel"
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "confirm"
  }, [_vm._v("确定")])]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    staticStyle: {
      "display": "block"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "user_name"
    }
  }, [_c('span', {
    staticClass: "xing_red"
  }, [_vm._v("＊")]), _vm._v("参保人姓名：\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    staticClass: "xing_red"
  }, [_vm._v("＊")]), _vm._v("身份证号：\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "demo_treelist_dummy"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "color": "#FE2C54",
      "letter-spacing": "0",
      "line-height": "14px"
    }
  }, [_vm._v("＊")]), _vm._v("热点名称：\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "demo_treelist_dummy"
    }
  }, [_c('span', {
    staticClass: "xing_red"
  }, [_vm._v("＊")]), _vm._v("路由器MAC地址：\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "demo_treelist_dummy"
    }
  }, [_c('span', {
    staticClass: "xing_red"
  }, [_vm._v("＊")]), _vm._v("请选择商户类型：\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "demo_treelist_dummy"
    }
  }, [_c('span', {
    staticClass: "xing_red"
  }, [_vm._v("＊")]), _vm._v("请上传资质：\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {}, [_c('span', {
    staticClass: "xing_red"
  }, [_vm._v("＊")]), _vm._v("营业执照备案\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "description"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(249)
    }
  }), _vm._v("如手机号码有更换，请联系官方客服\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "btns",
    staticStyle: {
      "display": "none"
    }
  }, [_c('span', {
    staticClass: "cancel"
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "confirm"
  }, [_vm._v("确定")])])
}]}

/***/ }),
/* 837 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "protocol"
  }, [_c('div', {
    staticClass: "main",
    staticStyle: {
      "padding": "0 6% 15px 6%"
    }
  }, [_c('p', {
    staticClass: "title",
    staticStyle: {
      "text-align": "center",
      "margin-top": "10px",
      "margin-bottom": "3px",
      "background": "rgba(255,255,255,0)"
    }
  }, [_vm._v("WiFi万能钥匙商户热点安全保险协议")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("本协议为WiFi万能钥匙商户用户（即同意并接受了《WiFi万能钥匙服务协议》及《WiFi万能钥匙隐私权政策》的商户用户，以下简称“商户”）与南京尚网网络科技有限公司（以下简称“WiFi万能钥匙”或“本公司”）关于WiFi万能钥匙安全保险事宜所订立的协议。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("——本公司在此依法做出特别提示如下：")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1、"), _c('b', [_vm._v("【审慎阅读】请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。")]), _vm._v(" 针对前述条款，本协议已以明确的足以引起您注意的包括但不限于加重字体、斜体、下划线、颜色标记等合理方式提醒您注意相关条款（需要强调的是，还包括您应特别注意任何未明确标记的含有“不承担”、“免责”、“不得”以及“无关”等形式用语的条款），该等条款的确认将导致您在特定情况下的被动、不便和/或造成损失，请您在确认同意本协议之前再次阅读上述条款。 除非您已审慎阅读、充分理解并同意本协议所有条款，您将放弃参加本保险计划。 ")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2、"), _c('b', [_vm._v("本协议签署后，您如有任何需要本公司说明条款的要求，请立即停止参加本保险计划，同时立即致电或发送邮件至本公司客服，若您未致电或未发送有说明条款要求的邮件至本公司，即表示您选择同意该协议的所有条款。")]), _vm._v(" 双方在此确认本公司已依法履行了根据您要求对相关条款进行说明的法定义务，本公司已给予您充足的时间与充分的选择权来决定是否缔结本协议。 ")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3、"), _c('b', [_vm._v("【协议的确认和接受】鉴于本公司已依法明确了上述条款，您点击“同意”或“下一步”，将被视为且应当被视为您已经完全注意并“同意”了本协议所有条款尤其是提醒您注意的条款的合法性及有效性，您不应当以本公司未对相关条款以合理方式提醒您注意，或未根据您要求尽到说明义务为理由而声称或要求法院或其它任何第三方确认相关条款非法或无效。 如果您不同意本协议的任何内容，点击“不同意”，视为您选择放弃参加本保险计划。")])]), _vm._v(" "), _c('p', [_vm._v("4、【协议的修改】 本协议可由本公司适时更新，更新后的协议条款一经公布即替代原协议条款，您可在软件客户端查阅最新版协议。 "), _c('b', [_vm._v("在本公司修改协议并公布后，如果您不接受修改后的协议，请立即停止参加本保险计划，您一旦发起索赔申请将被视为已接受修改后的协议。")])]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("一、协议总则")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("WiFi万能钥匙热点商户联盟安全理赔计划（亦简称“本保险计划”）是指商户通过WiFi万能钥匙分享WiFi热点（以下亦简称“热点”）后，因发生黑客篡改WiFi密码、劫持商户收银、盗刷商户账户内资金等恶意行为导致商户产生损失的，商户可以依据本协议的有关规则申请理赔。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("本公司已通过众安在线财产保险股份有限公司（以下简称“保险公司”）为WiFi万能钥匙的安全性进行投保。WiFi万能钥匙商户安全保险计划（以下简称“保险计划”）旨在为商户营造一个安全、可信的网络环境，让商户更放心地提供WiFi热点分享。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("二、定义")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("在本协议中，除非另有明确约定，提及的词语应具有如下含义：")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("WiFi热点：本协议中所述WiFi热点特指通过WLAN无线协议将网络连接进行延伸的无线接入点,有连接网络需求的用户（以下称为“用户”）可通过WiFi万能钥匙进行相应操作实现网络连接并上网；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("有钥匙热点：商户通过WiFi万能钥匙客户端或其他渠道已向本公司分享的WiFi热点，商户的WiFi热点信息将会以有钥匙热点（用户通过点击WiFi万能钥匙客户端中的“一键查询”功能或下拉连接页面发起“一键查询”功能，成功查询附近热点后，在热点上有蓝色钥匙标识的热点）的形式呈现在进入该热点覆盖范围的用户设备的网络信息中；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("钓鱼网站：指不法分子在互联网上建立的通过模仿合法、正规购物平台的网址或页面内容，利用发布虚假消息，搜集客户资料，骗取客户账户（登录ID）、密码、口令等信息进而达到非法窃取客户财物的目的非法网站；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("木马病毒：指不法分子通过各种网络技术手段来篡改商户交易信息或者劫持商户收银系统等方式来达到盗取商户资金目的的恶意程序；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("勒索病毒：是一种新型计算机病毒，主要以邮件、程序木马、网页挂马的形式进行传播。这种病毒利用各种加密算法对文件进行加密，被感染者一般无法解密，必须交付赎金，拿到解密的私钥才有可能破解；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("恶意软件：\"恶意软件\"用作一个集合名词，来指代故意在计算机系统恶意软件上执行恶意任务的蠕虫、木马病毒或其他病毒；在恶意软件未被发现的这段时间，商户上网过程中的所有个人资料都有可能被盗走，比如银行账户信息，信用卡密码等；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("DNS /DNS劫持：本协议中所述DNS是指网络定义的一种协议,为域名和IP地址相互映射，能够使商户更方便地访问互联网,DNS劫持是指恶意攻击者通过中间人攻击篡改域名和IP的对应关系,从而导致商户访问一些虚假的网站；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("热点劫持：本协议中所述热点劫持是指恶意攻击者通过恶意攻击劫持原有WiFi热点，从而捕捉通过热点中的所有商户个人信息及其他信息；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("账户资金：商户在银行账户内的资产，及商户在合法运营的第三方支付机构所设本商户实名账户中的资产；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("直接损失：因符合理赔范围的情形而被盗取的账户资金。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("三、索赔条件及理赔范围")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("商户应同时具备以下（一）至（五）款列明的各项条件，方可根据本公司商户安全理赔规则申请索赔:")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（一）索赔的前提条件")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.商户赖以执行参保的设备持有者必须是WiFi万能钥匙的手机注册用户，且其安装并使用的WiFi万能钥匙手机客户端中必须已发布施行了本保险计划（即该用户必须安装WiFi万能钥匙安卓版4.0或者iOS版3.3.5以上版本及此后发布的更新版本）。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.商户因分享热点，被恶意利用，发生本协议所列明的劫持攻击，导致勒索病毒造成资金损失的情形。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.因商户分享热点导致账户资金被盗，并发生本协议第三条第（二）款中的情形而遭受了直接损失，应首次发生于本商户安全保险计划生效日之后。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.商户同意，在通过WiFi万能钥匙参保时向本公司提供其真实有效信息，且上述信息应与商户提交的索赔申请材料中的信息一致，即与本公司订立本协议的商户与实际因分享热点遭受损失并前来申请索赔的商户必须为同一商户。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.商户分享的热点属于有钥匙热点，商户必须是热点主人。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("6.商户按照本条第（五）款索赔流程的规定向公安机关报案并向保险公司提交了符合索赔要求的材料。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("7.商户因分享热点导致其银行账户资金和有资质的第三方支付软件中的资金遭受损失的事件必须发生在中华人民共和国大陆地区（不包括香港、澳门和台湾地区）。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（二）属于理赔范围的情形")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.商户欲前往特定合法网络购物网站、网络银行网站或第三方支付网站（以上简称“合法网站”）进行销售、购物、转账等操作时，商户在支付交易过程中DNS被钓鱼热点进行了信息篡改，从而导致商户账户资金被盗的；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.商户欲前往合法网站进行销售、购物、转账等操作时，钓鱼热点已对该网站进行了DNS劫持，从而使商户连接上了一个钓鱼网站，导致了商户账户资金被盗的；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.商户在合法网站正常操作销售、购物、转账等操作的过程中，钓鱼热点非法获取了商户录入及传递的交易信息，导致商户信息泄露继而造成账户资金被盗；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.商户欲下载特定应用软件，商户连接的热点被劫持后，商户实际下载了仿冒恶意软件，且一般商户无法判断该软件的真伪。商户在仿冒恶意软件中录入交易信息，或仿冒软件将劫持的商户短信等个人信息发送至恶意第三方，从而导致商户账户资金遭受损失。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.商户连接该热点并用于执行销售、购物、转账等操作的电子设备，被劫持（DNS、ARP）攻击，植入勒索病毒，导致生产中断或者其他直接损失。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（三）不属于理赔范围的情形")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("商户因以下情形产生的经济损失或其他损失，不属于理赔范围，无权向本公司或保险公司申请索赔：")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("1.商户不具备本协议第三条第（一）款中列明的索赔全部前提条件；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("2.商户不能根据本保险计划规定提供证据及/或其他索赔材料的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("3.商户未依据本协议第三条第（五）款中的规定进行报案和/或进行证据保全的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("4.自直接经济损失发生之日起15个自然日内，商户未依据本协议第三条第（五）款中的规定向保险公司提交索赔材料的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("5.商户使用WiFi万能钥匙分享热点的行为与商户遭受的财产损失不具有直接因果关系；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("6.商户主动接受虚假诈骗广告信息植入在其所分享的特定热点中，用户连接该热点后，轻信了该虚假广告信息而遭受了财产损失，商户就该损失进行了赔偿的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("7.在商户使用WiFi万能钥匙分享热点后，因商户故意或重大过失导致下列情形的财产损失：")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（1）商户主动向他人账号划转资金或主动为他人发送的代付链接付款的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（2）商户主动泄露WiFi密码、网上银行账号、密码、支付短信的交易验证码或其他可能导致财产损失的信息，或主动允许他人远程协助的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（3）WiFi密码、网上银行账号、密码已被他人知悉，或丢失了数字证书载体后，商户未立即变更账号、密码或通知银行冻结网上银行账户的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（4）商户对其WiFi网络信息，收银系统以及账户资金安全管理不善，因其雇员或管理执行人篡改WiFi密码、劫持盗用收银系统，盗取账户资金而导致损失的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（5）其他因商户故意或重大过失导致的财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("8. 商户在网上交易过程中，因买家违背诚信经营原则导致下列情形的财产损失：")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（1）与买家因交易纠纷造成的损失，包括但不限于电子商务买家账号被盗等引起的一切财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（2）由于买家不诚信问题造成的损失，包括但不限于迟延付款、拒绝付款等引发消费纠纷而引起的一切财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（3）虽经网页链接跳转，但商户系在正规网站进行正常交易行为时，由于买家违背诚信经营原则而遭受的财产损失。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("9.商户网购过程中，因其所购买标的物之特殊性导致的下列情形的财产损失：")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（1）商户在网络游戏私服中进行的交易或充值行为；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（2）以虚拟物品为交易对象的，包括但不限于虚拟财产（如虚拟游戏装备、虚拟货币、虚拟道具等）、游戏人物、游戏辅助物品的，或用户在网络游戏中直接交换物品的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（3）商户购买药品、保健品的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（4）涉及盗版及仿制品、走私、非法销售物品的交易；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（5）涉及网络赌博、博彩类交易（包括但不限于“赌球”、“21点”、“押大小”、“购买彩票”等）；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（6）其他涉嫌购买国家法律禁止销售或者交易的物品的任何交易。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("10.网站经营者或任何第三方已赔偿或补偿了商户经济损失，或商户经WiFi万能钥匙协助已挽回经济损失，或商户已通过WiFi万能钥匙的其他理赔/保障计划获得赔偿的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("11.财产损失超出本协议第三条第（四）款中索赔限额的部分；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("12.商户故意骗保，或在未发生理赔情形或未遭受任何财产损失的前提下谎称发生了理赔情形或伪造损失证据的，或商户因从事非法行为而遭受的任何损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("13.商户有损害本公司商誉、扰乱本公司正常经营秩序言行的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("14.针对同一索赔事件，保险公司向商户进行理赔后，商户又追加索赔申请的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("15.WiFi万能钥匙或保险公司工作人员依照本协议的约定联系商户时，自首次尝试联系商户起72小时内仍无法与商户取得联系的，或商户不履行本协议约定的配合义务的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("16.商户遭受的直接经济损失以外的一切间接损失、预期利益、精神损害或其他损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("17.其他根据WiFi万能钥匙商户安全保险计划不属于理赔范围的情形。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（四）索赔限额")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('table', {
    attrs: {
      "width": "100%",
      "border": "1",
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tr', [_c('td', [_vm._v("保险责任")]), _vm._v(" "), _c('td', [_vm._v("每一商户单日/单次索赔限额")]), _vm._v(" "), _c('td', [_vm._v("每一商户累计索赔限额")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("WiFi万能钥匙在提供服务的过程中造成了商户损失")]), _vm._v(" "), _c('td', [_vm._v("人民币贰万元整")]), _vm._v(" "), _c('td', [_vm._v("人民币壹拾万元整")])])])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("单次事故赔偿限额：人民币壹拾万元整")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("（单次事故：指因同一或基本相同的风险原因导致的一系列索赔事件（即群体性事件），视为一起事故，前述风险原因的认定以本公司技术部门的判定结果作为标准）")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（五）索赔流程")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.证据保全：商户在使用WiFi万能钥匙分享热点后，发现账户资金遭受损失的，应立即采取相关证据保全措施，不应自行刷机、清理交易设备缓存、删除WiFi万能钥匙客户端、历史短信或历史访问网址记录，或自行删除交易过程中与交易对方的聊天记录及所下载的软件，以免导致相关证据无法保全；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.报案：商户在使用WiFi万能钥匙分享热点后，发现账户资金遭受损失的，应立即拨打保险公司电话进行报案，并应于10个自然日内前往具有管辖权的公安机关进行报案，并取得案件受理通知书等相关证明材料；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.准备索赔资料：商户应自账户资金遭受经济损失之日起15个自然日内根据WiFi万能钥匙客户端索赔界面的提示准备索赔资料，并听从工作人员的操作指导，积极配合工作人员的工作，并配合提供相关损失证明文件，以便有效追查被盗情况并保全证据；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.提交索赔资料：商户应根据保险公司工作人员的指示提交索赔资料，并确保其所提交的资料的真实性，否则，本公司及保险公司有权拒绝受理或赔付商户的索赔申请；商户知悉并了解，该等资料中的相关信息包括但不限于商户身份证号码、银行卡号、手机号码、详细住址等个人信息，商户在此同意并授权本公司及保险公司为实现本协议项下的索赔目的对商户的该等个人信息予以采集和使用；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("商户应通过线下快递方式递交如下索赔资料：")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('b', [_vm._v("营业执照彩色复印件")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('b', [_vm._v("法定代表人身份证复印件")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('b', [_vm._v("授权委托书和代理人身份证复印件（商户办理理赔事务的代理人非为营业执照所载的法定代表人时需要提供）")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("向公安机关报案的相关证明（报案或立案证明）")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("非商户授权交易补偿申请表")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('b', [_vm._v("索赔人被盗账户信息截屏")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('b', [_vm._v("被盗账户对账单截屏（须标记盗刷交易明细信息：交易日期、付款人信息、交易币种、交易金额、入账币种、入账金额）")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('b', [_vm._v("被盗账户挂失证明（信息截屏，包含挂失日期等）")])]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("索赔人出险期间手机设备在公安机关的备案数据")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("被盗账户近半年交易数据（如有）")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("涉及诉讼、仲裁的，递交相关司法文书、对方提交的证据副本等（如有）")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("其他本公司或保险公司认为对向商户提供理赔服务所必须的材料。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.理赔结果：保险公司根据商户提交的材料将认定最终理赔结果，如最终确认属于理赔责任范围内的情形，由保险公司向商户指定的个人收款账户支付赔款，最终理赔额在人民币3000元（含3000元）以下的案件由保险公司在确认最终理赔结果后的5个工作日之内支付赔款；最终理赔额在人民币3000元以上的案件由保险公司在确认最终理赔结果后的10个工作日之内支付赔款。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("四、商户的权利与义务")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.商户使用WiFi万能钥匙分享热点后商户账户资金遭受直接经济损失的，商户有权向保险公司提起索赔申请，经本公司及保险公司认定情况属实并符合索赔条件及范围的，保险公司将依据理赔规则给予商户理赔。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.商户向保险公司提起索赔申请，应按照本公司商户安全理赔规则提交所有相关索赔材料。商户保证，其所提交的一切索赔材料、所作出的任何陈述或保证均真实准确且合法有效，并应独立承担因违反上述保证所引发的一切法律责任。商户未充分履行上述义务或违反上述保证的，本公司及保险公司有权不予理赔；保险公司已经向该商户支付理赔金的，有权向该商户追回，并要求商户赔偿本公司及保险公司因此遭受的一切损失。同时，本公司及保险公司将向有关机关报案，追究该商户骗保的刑事责任。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.商户应保证其热点分享及支持用户连接网络的行为不触犯任何法律、行政法规、相关政策且不侵犯任何第三人的合法权益。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.商户应向保险公司提供真实有效的收款账户信息，因商户原因导致提供的收款信息错误而无法收到理赔额的情况，本公司及保险公司不承担任何责任。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.商户向保险公司或本公司发起索赔申请，即表明商户已同意严格遵守本公司发布的针对WiFi万能钥匙安全保险计划的所有规则，并同意以最新的规则作为认定最终理赔结果的依据。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("6.商户承诺：未经本公司书面许可，不得将最终理赔结果向任何第三方披露。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("五、本公司的权利与义务")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.商户知悉并完全同意本公司有权随时修改、更新、暂停或永久终止保险计划，无需因此对商户承担法律责任。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.本公司有权依据理赔规则对商户向保险公司的索赔申请进行审核以确定是否向其提供理赔服务，本公司有完全的权利同意或拒绝商户的申请。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.本公司对本协议项下的理赔义务承担有限责任，在任何情形下，商户同意保险公司向其支付的理赔金的最高上限依照本协议第（四）条之规定执行。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.如WiFi万能钥匙及保险公司在审查商户所提交的索赔申请时发现重大刑事案件线索的，本公司及保险公司有权在通知商户后以商户索赔资料为基础向警方提供案件侦查线索或向相关司法机关检举。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.商户因使用WiFi万能钥匙所遭受的经济损失，通过第三方获得赔付或司法程序或其他合法程序得以追缴或退赔的，若保险公司已根据本保险计划向商户进行赔付的，则有权在其对商户的赔付范围内要求商户进行返还。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("6.本公司承诺：未经商户允许，除为实现本协议项下的理赔目的及法律法规隐私保护政策另有规定的情形外，不对外披露或向第三方提供商户的任何信息。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("六、其他")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_c('b', [_vm._v("1.本公司郑重提醒商户注意本协议中免除或限制责任的条款，请商户仔细阅读，自主考虑风险。")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.本协议所定的任何条款的部分或全部无效者，不影响其它条款的效力。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("3."), _c('b', [_vm._v("本协议的解释、效力及纠纷的解决，适用于中华人民共和国法律。若商户和本公司之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，商户在此完全同意双方将纠纷或争议提交本公司所在地人民法院通过诉讼方式解决。")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.本WiFi万能钥匙商户安全保险计划自2020年9月16日起生效施行。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.若您对本协议及本保险计划有任何意见，欢迎垂询本公司客服中心400-035-8000。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("南京尚网网络科技有限公司")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2020年9月16日")])])])
}]}

/***/ }),
/* 838 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "protocolA0009"
  }, [_c('div', {
    staticClass: "main",
    staticStyle: {
      "padding": "0 6% 15px 6%"
    }
  }, [_c('p', {
    staticClass: "title",
    staticStyle: {
      "text-align": "center",
      "margin-top": "10px",
      "margin-bottom": "3px",
      "background": "rgba(255,255,255,0)"
    }
  }, [_vm._v("WiFi万能钥匙用户安全保险协议")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("本协议为WiFi万能钥匙用户（即同意并接受了《WiFi万能钥匙服务协议》的用户，以下简称“用户”）与南京尚网网络科技有限公司（以下简称“WiFi万能钥匙”或“本公司”）关于WiFi万能钥匙安全保险事宜所订立的协议。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("——本公司在此依法做出特别声明如下：")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("本公司采取合理的方式提请用户注意的义务将通过如下方式实现：在本协议中本公司以明确的足以引起用户注意的加重字体、斜体、下划线、颜色标记等合理方式提醒用户注意相关条款（需要强调的是，还包括用户应特别注意任何未明确标记的含有“不承担”、“免责”“不得”等形式用语的条款），该等条款的确认将导致用户在特定情况下的被动、不便、损失，请用户在确认同意本协议之前再次阅读上述条款。双方确认上述条款非属于《合同法》第40条规定的“免除其责任、加重对方责任、排除对方主要权利的”的条款。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("鉴于本公司已依法明确了上述条款、履行了格式条款制订方的义务，用户点击同意或下一步，将被视为且应当被视为用户已经完全注意并同意了本协议所有条款尤其是提醒用户注意的条款的合法性及有效性，用户不应当以本公司未对格式条款以合理方式提醒用户注意，或未根据用户要求尽到说明义务为理由而声称或要求法院或其它任何第三方确认相关条款非法或无效。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("——本协议可由本公司随时更新，更新后的协议条款一旦公布即代替原来的协议条款，用户可在软件客户端查阅最新版协议条款。"), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "text-decoration": "underline"
    }
  }, [_vm._v("如用户不同意本协议中的任一规定及/或本公司对本协议作出的任何修改，可以选择不参加本保险计划；一旦用户发起索赔申请，即视为用户已经了解并完全同意本协议各项条款及本公司对本协议及保险计划随时作出的修改。")])]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("一、协议总则")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("WiFi万能钥匙用户安全保险计划：是指本公司用户在使用WiFi万能钥匙连接网络的过程中，因在通过WiFi万能钥匙连接的热点网络环境下发生了本协议中列明的WiFi热点恶意行为，导致用户本人在银行账户内的资产，及用户在合法运营的第三方支付机构所设本人实名账户中的资产遭受直接损失，用户可按照本保险计划的有关规则申请索赔。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("本公司已通过众安在线财产保险股份有限公司（以下简称“保险公司”）为WiFi万能钥匙的安全性进行投保。WiFi万能钥匙用户安全保险计划（以下简称“保险计划”） 旨在为用户营造一个安全、可信的网络环境，让用户更放心地使用本公司提供的服务。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("二、定义")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("在本协议中，除非另有明确约定，提及的词语应具有如下含义：")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("WiFi热点：本协议中所述WiFi热点特指通过WLAN无线协议将网络连接进行延伸的无线接入点,为方便用户理解和辨识，本协议中将WiFi热点特分为有钥匙热点和无钥匙热点；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("有钥匙热点：用户通过点击WiFi万能钥匙客户端中的“一键查询”功能，成功查询附近热点后，在热点上标识有蓝色钥匙的热点；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("无钥匙热点：用户通过点击WiFi万能钥匙客户端中的“一键查询”功能，成功查询附近热点后，在热点上未标识蓝色钥匙的热点；钓鱼热点：本协议中所述钓鱼热点特指利用WiFi热点开放的特性，模拟正规合法的WiFi热点，以窃取用户私有信息、盗取用户财产等为目的而私自架设的热点。其形式上和正规合法的WiFi热点没有区别，一般公众很难区分；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("钓鱼网站：指不法分子在互联网上建立的通过模仿合法、正规购物平台的网址或页面内容，利用发布虚假消息，搜集客户资料，骗取客户账户（登录ID）、密码、口令等信息进而达到非法窃取客户财物的目的非法网站；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("木马病毒：指不法分子通过各种网络技术手段来篡改用户交易信息或者劫持用户交易过程等方式来达到盗取用户资金目的的恶意程序；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("恶意软件：\"恶意软件\"用作一个集合名词，来指代故意在计算机系统恶意软件上执行恶意任务的蠕虫、木马病毒或其他病毒；在恶意软件未被发现的这段时间，用户上网过程中的所有个人资料都有可能被盗走，比如银行账户信息，信用卡密码等；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("DNS /DNS劫持：本协议中所述DNS是指网络定义的一种协议,为域名和IP地址相互映射，能够使用户更方便地访问互联网,DNS劫持是指恶意攻击者通过中间人攻击篡改域名和IP的对应关系,从而导致用户访问一些虚假的网站；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("热点劫持：本协议中所述热点劫持是指恶意攻击者通过恶意攻击劫持原有WiFi热点，从而捕捉通过热点中的所有用户个人信息及其他信息；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("账户资金：用户本人在银行账户内的资产，及用户在合法运营的第三方支付机构所设本人实名账户中的资产；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("直接损失：因符合理赔范围的情形而被盗取的账户资金。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("三、索赔条件及理赔范围")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("用户应同时具备以下（一）至（五）款列明的各项条件，方可根据本公司用户安全理赔规则申请索赔:")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（一）索赔的前提条件")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.用户必须是WiFi万能钥匙的手机注册用户，且其安装并使用的WiFi万能钥匙手机客户端中必须已发布施行了本保险计划（即用户必须安装WiFi万能钥匙女生版安卓版1.0.0以上版本及此后发布的更新版本）。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.用户在使用WiFi万能钥匙连接网络的过程中，因在通过WiFi万能钥匙连接的热点网络环境下发生了本协议中列明的WiFi热点恶意行为，导致用户账户资金被恶意第三方盗取。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.因用户使用WiFi万能钥匙导致账户资金被盗，应首次发生于本用户安全保险计划生效日之后。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.用户同意，在使用WiFi万能钥匙时向本公司提供其真实有效信息，且上述信息应与用户提交的索赔申请材料中的信息一致，即与本公司订立本协议的用户与实际使用WiFi万能钥匙遭受损失并前来申请索赔的用户必须为同一自然人用户。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.用户使用WiFi万能钥匙连接的热点是有钥匙热点。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("6.用户自使用WiFi万能钥匙连接特定无线网络开始至断开该无线网络的过程中，发生本协议第三条第（二）款中的情形而遭受了直接损失。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("7.用户按照本条第（五）款索赔流程的规定向公安机关报案并向保险公司提交了符合索赔要求的材料。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("8.用户因使用WiFi万能钥匙导致用户银行账户资金和有资质的第三方支付软件中的资金遭受损失的事件必须发生在中华人民共和国大陆地区（不包括香港、澳门和台湾地区）。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（二）属于理赔范围的情形")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.用户欲前往特定合法网络购物网站、网络银行网站或第三方支付网站（以上简称“合法网站”）进行购物、转账等操作时，用户在支付交易过程中DNS被钓鱼热点进行了信息篡改，从而导致用户账户资金被盗的；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.用户欲前往合法网站进行购物、转账等操作时，钓鱼热点已对该网站进行了DNS劫持，从而使用户连接上了一个钓鱼网站，导致了用户账户资金被盗的；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.用户在合法网站正常操作购物、转账等操作的过程中，钓鱼热点非法获取了用户录入及传递的个人信息，导致用户信息泄露继而造成账户资金被盗；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.用户欲下载特定应用软件，用户连接的热点被劫持后，用户实际下载了仿冒恶意软件，且一般用户无法判断该软件的真伪。用户在仿冒恶意软件中录入个人信息，或仿冒软件将劫持的用户短信等个人信息发送至恶意第三方，从而导致用户账户资金遭受损失。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（三）不属于理赔范围的情形")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("用户因以下情形产生的经济损失或其他损失，不属于理赔范围，无权向本公司或保险公司申请索赔：")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("1.用户不具备本协议第三条第（一）款中列明的索赔前提条件；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("2.用户使用WiFi万能钥匙连接的热点是无钥匙热点；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("3.用户不能根据本保险计划规定提供证据及/或其他索赔材料的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("4.用户未依据本协议第三条第（五）款中的规定进行报案和/或进行证据保全的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("5.自使用WiFi万能钥匙遭受直接经济损失之日起15个自然日内，用户未依据本协议第三条第（五）款中的规定向保险公司提交索赔材料的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("6.用户使用WiFi万能钥匙连接网络的行为与用户遭受的财产损失不具有直接因果关系；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("7.钓鱼热点、钓鱼网站及网络木马病毒、恶意软件的相关欺诈和/或劫持行为与用户所遭受的财产损失不具有直接因果关系；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("8.虚假诈骗广告信息植入在某个特定热点中，用户连接该热点后，轻信了该虚假广告信息，从而遭受了财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("9.虚假诈骗广告信息或恶意软件下载链接是植入在普通网站中的，用户使用WiFi万能钥匙连接网络后，在正常浏览网页的过程中因上述虚假广告或恶意软件遭受了财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("10.在用户使用WiFi万能钥匙连接网络并上网的过程中，因用户故意或重大过失导致下列情形的财产损失：")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（1）用户主动向他人账号划转资金或主动为他人发送的代付链接付款的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（2）用户通过网上交易购买机票或火车票时，向不具有在线销售资质的且收款人账号非为公司账号的网站划转资金或付款；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（3）用户主动泄露网上银行账号、密码、支付短信的交易验证码或其他可能导致财产损失的信息，或主动允许他人远程协助的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（4）网上银行账号、密码已被他人知悉，或丢失了数字证书载体后，用户未立即变更账号、密码或通知银行冻结网上银行账户的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（5）其他因用户故意或重大过失导致的财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("11. 用户网购过程中，因商家违背诚信经营原则导致下列情形的财产损失：")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（1）与商家因交易纠纷造成的损失，包括但不限于电子商务商家账号被盗等引起的一切财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（2）由于商家不诚信问题造成的损失，包括但不限于商品或服务的描述与实际不符，商品或服务的质量、价格、售后服务等引发消费纠纷而引起的一切财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（3）虽经网页链接跳转，但用户系在正规网站进行正常交易行为时，由于商家违背诚信经营原则而遭受的财产损失。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("12.用户网购过程中，因其所购买标的物之特殊性导致的下列情形的财产损失：")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（1）用户在网络游戏私服中进行的交易或充值行为；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（2）以虚拟物品为交易对象的，包括但不限于虚拟财产（如虚拟游戏装备、虚拟货币、虚拟道具等）、游戏人物、游戏辅助物品的，或用户在网络游戏中直接交换物品的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（3）用户购买药品、保健品的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（4）涉及盗版及仿制品、走私、非法销售物品的交易；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（5）涉及网络赌博、博彩类交易（包括但不限于“赌球”、“21点”、“押大小”、“购买彩票”等）；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（6）其他涉嫌购买国家法律禁止销售或者交易的物品的任何交易。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("13.网站经营者或任何第三方已赔偿或补偿了用户经济损失，或用户经WiFi万能钥匙协助已挽回经济损失，或用户已通过WiFi万能钥匙的其他理赔/保障计划获得赔偿的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("14.财产损失超出本协议第三条第（四）款中索赔限额的部分；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("15.用户故意骗保，或在未发生理赔情形或未遭受任何财产损失的前提下谎称发生了理赔情形或伪造损失证据的，或用户因从事非法行为而遭受的任何损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("16.用户有损害本公司商誉、扰乱本公司正常经营秩序言行的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("17.针对同一索赔事件，保险公司向用户进行理赔后，用户又追加索赔申请的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("18.WiFi万能钥匙或保险公司工作人员依照本协议的约定联系用户时，自首次尝试联系用户起72小时内仍无法与用户取得联系的，或用户不履行本协议约定的配合义务的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("19.用户遭受的直接经济损失以外的一切间接损失、预期利益、精神损害或其他损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("20.其他根据WiFi万能钥匙用户安全保险计划不属于理赔范围的情形。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（四）索赔限额")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('table', {
    attrs: {
      "width": "100%",
      "border": "1",
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tr', [_c('td', [_vm._v("保险责任")]), _vm._v(" "), _c('td', [_vm._v("每一用户单日/单次索赔限额")]), _vm._v(" "), _c('td', [_vm._v("每一用户累计索赔限额")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("WiFi万能钥匙在提供服务的过程中造成了用户损失")]), _vm._v(" "), _c('td', [_vm._v("人民币贰万元整")]), _vm._v(" "), _c('td', [_vm._v("人民币壹拾万元整")])])])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("单次事故赔偿限额：人民币壹佰万元整")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("（单次事故：指因同一或基本相同的风险原因导致的一系列索赔事件（即群体性事件），视为一起事故，前述风险原因的认定以本公司技术部门的判定结果作为标准）")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（五）索赔流程")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.证据保全：用户在使用WiFi万能钥匙连接网络的过程中，发现账户资金遭受损失的，应立即采取相关证据保全措施，不应自行刷机、清理手机垃圾、删除WiFi万能钥匙客户端、历史短信或历史访问网址记录，或自行删除交易过程中与交易对方的聊天记录及所下载的软件，以免导致相关证据无法保全；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.报案：用户在使用WiFi万能钥匙连接网络的过程中，发现账户资金遭受损失的，应立即拨打保险公司电话进行报案，并应于10个自然日内前往具有管辖权的公安机关进行报案，并取得案件受理通知书等相关证明材料；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.准备索赔资料：用户应自账户资金遭受经济损失之日起15个自然日内WiFi万能钥匙官网或者客户端索赔界面的提示准备索赔资料，并听从工作人员的操作指导，积极配合工作人员的工作，并配合提供相关损失证明文件，以便有效追查被盗情况并保全证据；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.提交索赔资料：用户应根据保险公司工作人员的指示提交索赔资料，并确保其所提交的资料的真实性，否则，本公司及保险公司有权拒绝受理或赔付用户的索赔申请；用户知悉并了解，该等资料中的相关信息包括但不限于用户身份证号码、银行卡号、手机号码、详细住址等个人信息，用户在此同意并授权本公司及保险公司为实现本协议项下的索赔目的对用户的该等个人信息予以采集和使用；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("用户应通过线下快递方式递交如下索赔资料：")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("身份证正反面彩色复印件（非中华人民共和国公民请提交有效护照彩色复印件）")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("向公安机关报案的相关证明（报案或立案证明）")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("非本人授权交易补偿申请表")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("索赔人被盗账户信息截屏")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("被盗账户对账单截屏（须标记盗刷交易明细信息：交易日期、交易商户、交易币种、交易金额、入账币种、入账金额）")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("被盗账户挂失证明（信息截屏，包含挂失日期等）")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("索赔人出险期间手机设备在公安机关的备案数据")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("被盗账户近半年交易数据（如有）")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("涉及诉讼、仲裁的，递交相关司法文书、对方提交的证据副本等（如有）")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("其他本公司或保险公司认为对向用户提供理赔服务所必须的材料。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.理赔结果：保险公司根据用户提交的材料将认定最终理赔结果，如最终确认属于理赔责任范围内的情形，由保险公司向用户支付赔款，最终理赔额在人民币3000元（含3000元）以下的案件由保险公司在确认最终理赔结果后的5个工作日之内支付赔款；最终理赔额在人民币3000元以上的案件由保险公司在确认最终理赔结果后的10个工作日之内支付赔款。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("四、用户的权利与义务")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.用户使用WiFi万能钥匙过程中用户账户资金遭受直接经济损失的，用户有权向保险公司提起索赔申请，经本公司及保险公司认定情况属实并符合索赔条件及范围的，保险公司将依据理赔规则给予用户理赔。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.用户向保险公司提起索赔申请，应按照本公司用户安全理赔规则提交所有相关索赔材料。用户保证，其所提交的一切索赔材料、所作出的任何陈述或保证均真实准确且合法有效，并应独立承担因违反上述保证所引发的一切法律责任。用户未充分履行上述义务或违反上述保证的，本公司及保险公司有权不予理赔；保险公司已经向该用户支付理赔金的，有权向该用户追回，并要求用户赔偿本公司及保险公司因此遭受的一切损失。同时，本公司及保险公司将向有关机关报案，追究该用户骗保的刑事责任。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.用户应保证其连接网络及上网过程中的行为不触犯任何法律、行政法规、相关政策且不侵犯任何第三人的合法权益。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.用户应向保险公司提供真实有效的收款账户信息，因用户原因导致提供的收款信息错误而无法收到理赔额的情况，本公司及保险公司不承担任何责任。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.用户向保险公司或本公司发起索赔申请，即表明用户已同意严格遵守本公司发布的针对WiFi万能钥匙安全保险计划的所有规则，并同意以最新的规则作为认定最终理赔结果的依据。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("6.用户承诺：未经本公司书面许可，不得将最终理赔结果向任何第三方披露。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("五、本公司的权利与义务")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.用户知悉并完全同意本公司有权随时修改、更新、暂停或永久终止保险计划，无需对用户承担任何法律责任。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.本公司有权依据理赔规则对用户向保险公司的索赔申请进行审核以确定是否向其提供理赔服务，用户同意本公司有完全的权利同意或拒绝用户的申请。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.本公司对本协议项下的理赔义务承担有限责任，在任何情形下，用户同意保险公司向其支付的理赔金的最高上限依照本协议第（四）条之规定执行。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.如WiFi万能钥匙及保险公司在审查用户所提交的索赔申请时发现重大刑事案件线索的，本公司及保险公司有权在通知用户后以用户索赔资料为基础向警方提供案件侦查线索或向相关司法机关检举。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.用户因使用WiFi万能钥匙所遭受的经济损失，通过第三方获得赔付或司法程序或其他合法程序得以追缴或退赔的，若保险公司已根据本保险计划向用户进行赔付的，则有权在其对用户的赔付范围内要求用户进行返还。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("6.本公司承诺：未经用户允许，除为实现本协议项下的理赔目的及法律法规隐私保护政策另有规定的情形外，不对外披露或向第三方提供用户的任何信息。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("六、其他")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("1.本公司郑重提醒用户注意本协议中免除本公司责任和加重用户义务的条款，请用户仔细阅读，自主考虑风险。未成年人应在法定监护人的陪同下阅读本协议。 以上各项条款内容的最终解释权及修改权归本公司所有。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.本协议所定的任何条款的部分或全部无效者，不影响其它条款的效力。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("3.本协议签订地为上海市浦东新区。本协议的解释、效力及纠纷的解决，适用于中华人民共和国法律。若用户和本公司之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，用户在此完全同意双方将纠纷或争议提交上海市浦东新区的人民法院通过诉讼方式解决。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.本协议的版权由本公司所有，本公司保留对上述条例的最终解释权。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.本WiFi万能钥匙用户安全保险计划自2016年1月8日起生效施行。")])])])
}]}

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "range"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "src": __webpack_require__(91),
      "alt": "",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "doc_title"
  }, [_vm._v("WiFi万能钥匙用户安全理赔计划")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("WiFi万能钥匙用户安全理赔计划是指WiFi万能钥匙用户在使用WiFi网络时，网上银行或第三方支付工具的账户发生财产非正常损失，若因WiFi万能钥匙导致，用户可以依据本保险计划的有关规则申请理赔。")]), _vm._v(" "), _c('p', {
    staticClass: "doc_title"
  }, [_vm._v("提供保障")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("每人单日/单次最高赔付20000元"), _c('br'), _vm._v("每人累计最高赔付100000元")]), _vm._v(" "), _c('p', {
    staticClass: "doc_title"
  }, [_vm._v("重要提示")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("1.用户必须是WiFi万能钥匙的手机注册用户，且其安装并使用的WiFi万能钥匙手机客户端中必须已发布施行了本保险计划（即用户必须安装WiFi万能钥匙安卓版4.0或iOS版3.3.5以上版本及此后发布的更新版本）。")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("2.向WiFi万能钥匙提供真实有效的信息，且该信息与受保障的实名账户持有人信息一致。")])])
}]}

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ClaimSuccess"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(252),
      "alt": "众安保险"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "claim_success"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('p', {
    staticClass: "result"
  }, [_vm._v("索赔登记成功！")]), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("请尽快用电脑登陆 "), _c('span', [_vm._v(_vm._s("https://a.lianwifi.com/insurance/static/pc/store.html"))]), _vm._v(" ，下载填写交易补偿申请表，并准备相关索赔资料寄送指定地址，方便理赔。")]), _vm._v(" "), _c('p', {
    staticClass: "view"
  }, [_c('router-link', {
    attrs: {
      "to": "/new/docs"
    }
  }, [_vm._v("查看索赔所需资料")]), _c('router-link', {
    attrs: {
      "to": "/new/claimFlow"
    }
  }, [_vm._v("了解索赔流程")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "bottom_bg"
  })])
},staticRenderFns: []}

/***/ }),
/* 841 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "claimList"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading",
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_vm._l((_vm.list), function(item) {
    return (_vm.list.length > 0) ? _c('router-link', {
      key: item.order_id,
      staticClass: "claim-item",
      attrs: {
        "to": {
          path: 'claimDetail',
          query: {
            uhid: _vm.uhid,
            order_id: item.order_id
          }
        }
      }
    }, [_c('p', {
      staticClass: "claim-no"
    }, [_vm._v("索赔登记号：" + _vm._s(item.order_id) + " ")]), _vm._v(" "), (item.status == 1) ? _c('p', {
      staticClass: "claim-status"
    }, [_vm._v("索赔受理中")]) : _vm._e(), _vm._v(" "), (item.status == 2) ? _c('p', {
      staticClass: "claim-status"
    }, [_vm._v("索赔成功")]) : _vm._e(), _vm._v(" "), (item.status == 3) ? _c('p', {
      staticClass: "claim-status"
    }, [_vm._v("索赔失败")]) : _vm._e(), _vm._v(" "), (item.status == 1) ? _c('div', {
      staticClass: "claim-icon"
    }) : _vm._e(), _vm._v(" "), (item.status == 2) ? _c('div', {
      staticClass: "claim-icon-success"
    }) : _vm._e(), _vm._v(" "), (item.status == 3) ? _c('div', {
      staticClass: "claim-icon-failed"
    }) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (_vm.list.length == 0) ? _c('div', {
    staticClass: "empty"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('p', {
    staticClass: "empty-text"
  }, [_vm._v("您还没有进行任何索赔")])]) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "margin": "0 auto",
      "width": "0px",
      "height": "0px",
      "overflow": "hidden"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(176),
      "width": "700"
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "pc_device",
    attrs: {
      "id": "activity-detail"
    }
  }, [_c('div', {
    staticClass: "page-bizinfo"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h1', {
    attrs: {
      "id": "activity-name"
    }
  }, [_vm._v("如何确认WiFi已被分享")])])]), _vm._v(" "), _c('div', {
    staticClass: "page-content",
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_c('p', [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('strong', [_vm._v("一、请确认WiFi已分享，即WiFi带有蓝色小钥匙。")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(176)
    }
  })]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("如果WiFi尚未被分享，可以点击这个WiFi，在底部弹窗点击“分享热点”。")])])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("分享热点提交信息后，请完全退出WiFi万能钥匙，然后过几分钟重新打开，查看是否是在分享的状态。")])])]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": __webpack_require__(676)
    }
  })])])])])])
}]}

/***/ }),
/* 843 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ClaimStep2"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading",
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "main",
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_c('p', {
    staticClass: "doc_title",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("如果您的资金不幸被盗，请按以下步骤进行索赔登记")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("1.手持身份证拍照（正反面）")]), _vm._v(" "), _c('div', {
    staticClass: "upload"
  }, [_c('div', {
    staticClass: "item item1"
  }, [_c('wk-single-image-upload', {
    attrs: {
      "dest": "wifikey",
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.getIdCardFront
    },
    model: {
      value: (_vm.formData.photoIdCardEvidenceFront),
      callback: function($$v) {
        _vm.$set(_vm.formData, "photoIdCardEvidenceFront", $$v)
      },
      expression: "formData.photoIdCardEvidenceFront"
    }
  }, [_c('solt', {
    staticClass: "loading",
    attrs: {
      "name": "loading"
    }
  })], 1), _vm._v(" "), _c('button', [_vm._v("上传照片")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("已上传")])], 1), _vm._v(" "), _c('div', {
    staticClass: "item item2"
  }, [_c('wk-single-image-upload', {
    attrs: {
      "dest": "wifikey",
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.getIdCardFront
    },
    model: {
      value: (_vm.formData.photoIdCardEvidenceReverse),
      callback: function($$v) {
        _vm.$set(_vm.formData, "photoIdCardEvidenceReverse", $$v)
      },
      expression: "formData.photoIdCardEvidenceReverse"
    }
  }, [_c('solt', {
    staticClass: "loading",
    attrs: {
      "name": "loading"
    }
  })], 1), _vm._v(" "), _c('button', [_vm._v("上传照片")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("已上传")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "doc_text",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("2.被盗信息截屏")]), _vm._v(" "), _c('div', {
    staticClass: "upload"
  }, [_c('div', {
    staticClass: "item screenShot"
  }, [_c('wk-single-image-upload', {
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.getIdCardFront
    },
    model: {
      value: (_vm.formData.photoStolenEvidence),
      callback: function($$v) {
        _vm.$set(_vm.formData, "photoStolenEvidence", $$v)
      },
      expression: "formData.photoStolenEvidence"
    }
  }, [_c('solt', {
    staticClass: "loading",
    attrs: {
      "name": "loading"
    }
  })], 1), _vm._v(" "), _c('button', [_vm._v("上传照片")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("已上传")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "button",
    staticStyle: {
      "margin-top": "25px"
    },
    on: {
      "click": _vm.claimStep2
    }
  }, [_vm._v("确认登记")]), _vm._v(" "), _c('p', {
    staticClass: "doc_a",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/new/claimFlow"
    }
  }, [_vm._v("了解索赔流程")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "model"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "title"
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }), _vm._v(" "), _c('p', {
    staticClass: "foot"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })])
}]}

/***/ }),
/* 844 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ClaimStep1"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading",
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "main",
    staticStyle: {
      "padding-bottom": "30px"
    }
  }, [_c('p', {
    staticClass: "doc_title",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("为了保障您的索赔权益，请确认你符合以下索赔范围并登记（可多选）：")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', {
    staticClass: "button",
    staticStyle: {
      "margin-top": "15px"
    },
    on: {
      "click": _vm.claimStep1
    }
  }, [_vm._v("我要索赔登记")]), _vm._v(" "), _c('p', {
    staticClass: "doc_a"
  }, [_c('router-link', {
    attrs: {
      "to": "/claimFlow"
    }
  }, [_vm._v("了解索赔流程")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "model"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "title"
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }), _vm._v(" "), _c('p', {
    staticClass: "foot"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "doc_text"
  }, [_c('span', {
    staticClass: "check",
    attrs: {
      "data-index": "question1"
    }
  }), _vm._v("商户欲前往特定合法网络购物网站、网络银行网站或第三方支付网站（以上简称“合法网站”）进行销售、购物、转账等操作时，商户在支付交易过程中DNS被钓鱼热点进行了信息篡改，从而导致商户账户资金被盗的；\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "doc_text"
  }, [_c('span', {
    staticClass: "check",
    attrs: {
      "data-index": "question2"
    }
  }), _vm._v("商户欲前往合法网站进行销售、购物、转账等操作时，钓鱼热点已对该网站进行了DNS劫持，从而使商户连接上了一个钓鱼网站，导致了商户账户资金被盗的；\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "doc_text"
  }, [_c('span', {
    staticClass: "check",
    attrs: {
      "data-index": "question3"
    }
  }), _vm._v("商户在合法网站正常操作销售、购物、转账等操作的过程中，钓鱼热点非法获取了商户录入及传递的交易信息，导致商户信息泄露继而造成账户资金被盗；\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "doc_text"
  }, [_c('span', {
    staticClass: "check",
    attrs: {
      "data-index": "question4"
    }
  }), _vm._v("商户欲下载特定应用软件，商户连接的热点被劫持后，商户实际下载了仿冒恶意软件，且一般商户无法判断该软件的真伪。商户在仿冒恶意软件中录入交易信息，或仿冒软件将劫持的商户短信等个人信息发送至恶意第三方，从而导致商户账户资金遭受损失。\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "doc_text"
  }, [_c('span', {
    staticClass: "check",
    attrs: {
      "data-index": "question5"
    }
  }), _vm._v("商户连接该热点并用于执行销售、购物、转账等操作的电子设备，被劫持（DNS、ARP）攻击，植入勒索病毒，导致生产中断或者其他直接损失。\n    ")])
}]}

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rangeIvvi"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "src": __webpack_require__(91),
      "alt": "",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "doc_title"
  }, [_vm._v("免费WiFi用户安全理赔计划")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("免费WiFi用户安全理赔计划是指免费WiFi用户在使用免费WiFi连接网络的过程中，因在通过免费WiFi连接的热点网络环境下发生了服务协议中列明的WiFi热点恶意行为，导致用户本人在银行账户内的资产，及用户在合法运营的第三方支付机构所设本人实名账户中的资产遭受直接损失，用户可按照本保险计划的有关规则申请索赔。")]), _vm._v(" "), _c('p', {
    staticClass: "doc_title"
  }, [_vm._v("提供保障")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("每人单次可理赔金额10000元"), _c('br'), _vm._v("每人最高可理赔金额高达100000元")]), _vm._v(" "), _c('p', {
    staticClass: "doc_title"
  }, [_vm._v("重要提示")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("1.用户必须是免费WiFi的手机注册用户，且其安装并使用的免费WiFi手机客户端中必须已发布施行了本保险计划（即用户必须安装安卓版免费WiFi 4.1.8版本及此后发布的更新版本）。")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("2.向免费WiFi提供真实有效的信息，且该信息与受保障的实名账户持有人信息一致。")])])
}]}

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "range"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "src": __webpack_require__(91),
      "alt": "",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "doc_title"
  }, [_vm._v("WiFi万能钥匙商户热点安全理赔计划")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("WiFi万能钥匙热点商户联盟安全理赔计划是指商户通过WiFi万能钥匙分享WiFi后，因黑客篡改WiFi密码、劫持商户收银、盗刷商户账户内资金等恶意行为导致商户产生损失的，商户可以依据本保险计划的有关规则申请理赔。")]), _vm._v(" "), _c('p', {
    staticClass: "doc_title"
  }, [_vm._v("提供保障")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("每商户单日/单次最高赔付20000元"), _c('br'), _vm._v("每商户累计最高赔付100000元")]), _vm._v(" "), _c('p', {
    staticClass: "doc_title"
  }, [_vm._v("重要提示")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("1.商户赖以执行参保的设备持有者必须是WiFi万能钥匙的手机注册用户，且其安装并使用的WiFi万能钥匙手机客户端中必须已发布施行了本保险计划（即该用户必须安装WiFi万能钥匙安卓版4.0或iOS版3.3.5以上版本及此后发布的更新版本）。")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("2.商户向WiFi万能钥匙提供真实有效的信息，且该信息与受保障的实名商户信息一致。")])])
}]}

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "range"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "src": __webpack_require__(91),
      "alt": "",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "doc_title"
  }, [_vm._v("WiFi万能钥匙用户安全理赔计划")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("WiFi万能钥匙用户安全理赔计划是指WiFi万能钥匙用户在使用WiFi网络时，网上银行或第三方支付工具的账户发生财产非正常损失，若因WiFi万能钥匙导致，用户可以依据本保险计划的有关规则申请理赔。")]), _vm._v(" "), _c('p', {
    staticClass: "doc_title"
  }, [_vm._v("WiFi万能钥匙商户热点安全理赔计划")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("WiFi万能钥匙热点商户联盟安全理赔计划是指商户通过WiFi万能钥匙分享WiFi后，因黑客篡改WiFi密码、劫持商户收银、盗刷商户账户内资金等恶意行为导致商户产生损失的，商户可以依据本保险计划的有关规则申请理赔。")]), _vm._v(" "), _c('p', {
    staticClass: "doc_title"
  }, [_vm._v("提供保障")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("每人单日/单次最高赔付20000元"), _c('br'), _vm._v("每人累计最高赔付100000元")]), _vm._v(" "), _c('p', {
    staticClass: "doc_title"
  }, [_vm._v("重要提示")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("1.用户（含商户赖以执行参保的设备持有者）必须是WiFi万能钥匙的手机注册用户，且其安装并使用的WiFi万能钥匙手机客户端中必须已发布施行了本保险计划（即用户必须安装WiFi万能钥匙安卓版4.0或iOS版3.3.5以上版本及此后发布的更新版本）。")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("2.向WiFi万能钥匙提供真实有效的信息，且该信息与受保障的实名账户持有人信息一致。")])])
}]}

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rangeIos"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "src": __webpack_require__(91),
      "alt": "",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "doc_title"
  }, [_vm._v("WiFi万能钥匙用户安全理赔计划")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("WiFi万能钥匙用户安全理赔计划是指WiFi万能钥匙用户在使用WiFi网络时，网上银行或第三方支付工具的账户发生财产非正常损失，若因WiFi万能钥匙导致，用户可以依据本保险计划的有关规则申请理赔。")]), _vm._v(" "), _c('p', {
    staticClass: "doc_title"
  }, [_vm._v("提供保障")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("每人单日/单次最高赔付20000元"), _c('br'), _vm._v("每人累计最高赔付100000元")]), _vm._v(" "), _c('p', {
    staticClass: "doc_title"
  }, [_vm._v("重要提示")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("1.用户必须是WiFi万能钥匙的手机注册用户，且其安装并使用的WiFi万能钥匙手机客户端中必须已发布施行了本保险计划（即用户必须安装WiFi万能钥匙iOS版1.0.0以上版本及此后发布的更新版本）。")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("2.向WiFi万能钥匙提供真实有效的信息，且该信息与受保障的实名账户持有人信息一致。")])])
}]}

/***/ }),
/* 849 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "createSuccess"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "success"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": _vm.item[_vm.state].src
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "msg"
  }, [_vm._v(_vm._s(_vm.item[_vm.state].name))]), _vm._v(" "), _c('p', {
    staticClass: "msg2"
  }, [_vm._v(_vm._s(_vm.item[_vm.state].desc))]), _vm._v(" "), _c('div', {
    staticClass: "tip-header"
  }, [_vm._v("说明")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("1、参保人须为商户经营者或法定代表人，和营业执照保持一致；")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("2、提交的商户信息均需为有效信息；")])]), _vm._v(" "), (_vm.state == 1) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.edit()
      }
    }
  }, [_vm._v("修改参保信息")]) : _vm._e(), _vm._v(" "), (_vm.state == 2) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.toindex()
      }
    }
  }, [_vm._v("查看我的保单")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 850 */,
/* 851 */,
/* 852 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
]),[358]);


// WEBPACK FOOTER //
// static/js/app.1930390024512a0e6e2d.js